const TICKET_ICON_DATA_URI = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAh0lEQVR4nO3WSwqAMAxF0S7W/W9Bh4JQMWl+jfeAU33XgjgGAAAAXp1Jth3+FBLgGRzy9r1PjIBsWQGH8CoXYEYcUCFmabQ0wjrUdPyXCMsAl/HtAyZUX55KASpbj3eJiB5vEqF5mE/Gff+MAOmvxPR3ghPI9r+AShGq8S0CskOWhwMAADR3AZsg3BRLWjWSAAAAAElFTkSuQmCC';
const TRUSTYBYTES_LOGO_DATA_URI = 'data:image/png;base64,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';

import React, { useEffect, useLayoutEffect, useState, useMemo, useRef, useCallback } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useTicketStore, Ticket, TicketHistoryItem, TicketAttachment, isTicketBackupJson, STANDARD_SUPPORT_TEAMS, normalizeTeamKey, normalizeTeamLabel, normalizeStatusName } from '../../../store/ticketStore';
import { useUnifiedSyncStore } from '../../../store/unifiedSyncStore';
import { useWorkflowStore, WorkflowTransition, normalizeStateCategory, normalizeTicketType } from '../../../store/workflowStore';
import { useEmployeeStore } from '../../../store/employeeStore';
import { useAssetStore } from '../../../store/assetStore';
import { useAssetCatalogStore } from '../../../store/assetCatalogStore';
import { useLicenseStore } from '../../../store/licenseStore';
import { useAuthStore } from '../../../store/authStore';
import { useSupportSettingsStore, TicketActionConfig, WorkflowStepAction, ExtendedWorkflow } from '../../../store/supportSettingsStore';
import { useAgentManagementStore } from '../../../store/agentManagementStore';
import { useRbacStore } from '../../../store/rbacStore';
import { isSupportAdmin, isSupportAgent, getEffectiveRoles } from '../../../utils/supportRoles';
import apiClient from '../../../lib/api';
import { cn } from '../../../lib/utils';
import { processSelectedFiles, downloadMediaFile, UploadedFileItem, formatFileSize } from '../../../utils/fileUpload';
import { UserAvatar } from '../../../components/UserAvatar';
import { getUserAvatarUrl } from '../../../utils/avatar';
import { TrustyBytesLogo } from '../../../components/TrustyBytesLogo';
import toast from 'react-hot-toast';
import { useActiveSupportSender, renderEmailCard } from '../../../store/supportSettingsStore';
import EmojiPicker, { EmojiClickData, Theme } from 'emoji-picker-react';
import {
  Search, RefreshCw, Plus, Filter, ChevronLeft, ChevronRight, Menu,
  Clock, Tag, User, Building, AlertCircle, CheckCircle2, ShieldAlert,
  MessageSquare, FileText, Send, X, ArrowLeft, ArrowRight, Layers, HelpCircle,
  ChevronDown, Edit3, UserCheck, UserX, AlertTriangle, CheckSquare,
  List, Shield, Users, Tag as TagIcon, Activity, Mail, Lock, Share2,
  ExternalLink, CornerUpRight, AlertOctagon, Box, Phone, MapPin,
  Table, LayoutGrid, Bell, Trash2, Check, SlidersHorizontal, Settings, UserPlus, Paperclip, Download, Printer, FileSpreadsheet, Info, Sparkles,
  Flag, Link, Copy, DollarSign, Ban, ArrowUp, Minus, Play, XCircle, RotateCcw, ShieldCheck, GitPullRequest, Calendar,
  MessageCircle, CornerUpLeft, Eye, EyeOff, MinusSquare, PlusSquare, ArrowDown, ArrowUpDown, Minimize2, Maximize2,
  Smile, Bold, Italic, ListOrdered, Quote, Image as LucideImage, Code as LucideCode, Code2,
  Video, Film, FileUp, UploadCloud, Cloud, File as FileIcon, PlayCircle, Star,
  MoreHorizontal,
  ChevronUp,
  Ticket as TicketIcon,
  Truck,
  Workflow,
  Pencil,
  Building2, FastForward, PauseCircle, ThumbsUp, ThumbsDown, PackageCheck, FileCheck,
  CalendarCheck, CalendarClock, Wrench, Stamp, ArrowLeftCircle, Compass, FlaskConical,
  Award, Bug, Rocket, BadgeCheck, Flame, Shuffle, GitFork, Sliders, Link2, CopyX,
  CheckCheck, GitPullRequestDraft, Undo2, BookOpen
} from 'lucide-react';

import { APP_VERSION } from '../../../version';

export const SYSTEM_APPLICATIONS = [
  {
    name: 'TeamOne Web Frontend',
    code: 'T1_UI',
    type: 'React 18 / Vite SPA',
    service: 'teamone/frontend',
    environment: 'Production',
    version: APP_VERSION,
    component: 'Shell & Design System',
  },
  {
    name: 'Support Service',
    code: 'T1_SUP',
    type: 'Node.js / Express Microservice',
    service: 'backend/services/support',
    environment: 'Production',
    version: APP_VERSION,
    component: 'Tickets & SLA Engine',
  },
  {
    name: 'API Gateway',
    code: 'T1_GW',
    type: 'Reverse Proxy & Router',
    service: 'backend/api-gateway',
    environment: 'Production',
    version: APP_VERSION,
    component: 'Auth Strip & Proxy (:3001)',
  },
  {
    name: 'Assets Service',
    code: 'T1_AST',
    type: 'Node.js Microservice',
    service: 'backend/services/assets',
    environment: 'Production',
    version: APP_VERSION,
    component: 'Hardware & License Catalog',
  },
  {
    name: 'Auth & RBAC Service',
    code: 'T1_AUTH',
    type: 'Security & Identity Microservice',
    service: 'backend/services/auth',
    environment: 'Production',
    version: APP_VERSION,
    component: 'JWT & Permissions Chain',
  },
  {
    name: 'People / HR Service',
    code: 'T1_PPL',
    type: 'Human Capital Microservice',
    service: 'backend/services/people',
    environment: 'Production',
    version: APP_VERSION,
    component: 'Attendance & Workforce',
  },
  {
    name: 'Work / Projects Service',
    code: 'T1_WRK',
    type: 'Project Management Microservice',
    service: 'backend/services/work',
    environment: 'Production',
    version: APP_VERSION,
    component: 'Projects & Tasks Engine',
  },
  {
    name: 'Money / Payroll Service',
    code: 'T1_FIN',
    type: 'Finance & Payroll Microservice',
    service: 'backend/services/money',
    environment: 'Production',
    version: APP_VERSION,
    component: 'Payroll & Invoicing',
  },
  {
    name: 'PostgreSQL Database Engine',
    code: 'T1_DB',
    type: 'Relational Database',
    service: 'postgresql:5432/team_one',
    environment: 'Production',
    version: '18.1',
    component: 'Schemas & Multi-tenant Storage',
  },
];

// Format helper for dates M/D/YYYY HH:mm
function formatDateTime(dateStr?: string) {
  if (!dateStr) return '-';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return String(dateStr);
  const m = d.getMonth() + 1;
  const day = d.getDate();
  const yr = d.getFullYear();
  const hrs = String(d.getHours()).padStart(2, '0');
  const mins = String(d.getMinutes()).padStart(2, '0');
  return `${m}/${day}/${yr}, ${hrs}:${mins}`;
}

// SLA Format helper for dates M/D/YYYY HH:mm
function formatSlaDateTime(dateInput?: string | Date) {
  if (!dateInput) return '';
  const d = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
  if (isNaN(d.getTime())) return String(dateInput);
  const m = d.getMonth() + 1;
  const day = d.getDate();
  const yr = d.getFullYear();
  const hrs = String(d.getHours()).padStart(2, '0');
  const mins = String(d.getMinutes()).padStart(2, '0');
  return `${m}/${day}/${yr} ${hrs}:${mins}`;
}

function escapeRegex(str: string) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function stripSubjectFromBody(body: string, subject?: string): string {
  if (!body) return '';
  let cleaned = body.replace(/\[EMAIL\]/gi, '').trim();
  if (!subject) return cleaned;

  // Normalize subject by stripping trailing [id] or special brackets
  const normalizedSubj = subject.replace(/\s*\[\d+\]\s*$/, '').trim();

  // Strip leading subject text
  const regexes = [
    new RegExp(`^${escapeRegex(subject)}[.:\\-–—\\s]*`, 'i'),
    new RegExp(`^${escapeRegex(normalizedSubj)}[.:\\-–—\\s]*`, 'i'),
  ];

  for (const reg of regexes) {
    if (reg.test(cleaned)) {
      cleaned = cleaned.replace(reg, '').trim();
      break;
    }
  }

  // Also check if the first line is the subject
  const lines = cleaned.split('\n');
  if (lines.length > 1) {
    const firstLine = lines[0].replace(/[.:\\-–—\s]+$/, '').trim();
    if (
      firstLine.toLowerCase() === subject.toLowerCase() ||
      firstLine.toLowerCase() === normalizedSubj.toLowerCase()
    ) {
      cleaned = lines.slice(1).join('\n').trim();
    }
  }

  return cleaned;
}

function getUserDisplayName(
  rawIdentifier?: string,
  requesterName?: string,
  client?: string,
  employeesList: Array<any> = []
): string {
  if (requesterName && !requesterName.includes('@') && requesterName.trim() !== '') {
    return requesterName.trim();
  }
  if (client && !client.includes('@') && client !== '-' && client.trim() !== '') {
    return client.trim();
  }

  if (!rawIdentifier) return 'Support User';

  if (!rawIdentifier.includes('@')) {
    return rawIdentifier;
  }

  const emailLower = rawIdentifier.trim().toLowerCase();

  const matchedEmp = employeesList.find((e) => {
    const eEmail = (e.email || e.work_email || e.workEmail || '').toLowerCase();
    return eEmail === emailLower;
  });

  if (matchedEmp) {
    const fullName = matchedEmp.name || `${matchedEmp.first_name || matchedEmp.firstName || ''} ${matchedEmp.last_name || matchedEmp.lastName || ''}`.trim();
    if (fullName) return fullName;
  }

  const username = emailLower.split('@')[0];
  const parts = username.split(/[._-]+/).filter(Boolean);
  if (parts.length > 0) {
    return parts
      .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
      .join(' ');
  }

  return rawIdentifier;
}

// Live ITSM SLA Time Left Component (Compact size matching TeamOne default scale)
function SlaTimeLeftBadge({
  createdAt,
  slaBreach,
  resolutionDueAt,
  status,
  slaHold,
  slaHoldStartedAt,
  isSystemGenerated,
  isTriggeredByOtherApp,
  firstResponseMet,
  firstRespondedAt,
}: {
  createdAt?: string;
  slaBreach?: string;
  resolutionDueAt?: string;
  status: string;
  slaHold?: boolean;
  slaHoldStartedAt?: string;
  isSystemGenerated?: boolean;
  isTriggeredByOtherApp?: boolean;
  firstResponseMet?: boolean;
  firstRespondedAt?: string;
}) {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, []);

  if (isSystemGenerated) {
    return (
      <span className="text-xs text-muted-foreground font-mono px-2 py-0.5 rounded bg-muted/40 border border-border">
        N/A
      </span>
    );
  }

  if (status === 'resolved' || status === 'closed' || status === 'fulfilled') {
    return (
      <div className="relative flex h-5 w-28 items-center justify-center rounded overflow-hidden bg-emerald-600 text-white shadow-xs border border-emerald-700 shrink-0">
        <span className="text-xs font-semibold tracking-wider truncate">
          Completed
        </span>
      </div>
    );
  }

  const isMetResponse = Boolean(
    isTriggeredByOtherApp ||
    firstResponseMet ||
    firstRespondedAt
  );

  // If first response SLA is automatically met (e.g. app-triggered),
  // track against the Resolution target (default 24h or resolutionDueAt),
  // NOT the expired 4-hour initial response window!
  const effectiveBreachIso = resolutionDueAt || (slaBreach && !isMetResponse ? slaBreach : undefined);
  const breachTime = effectiveBreachIso
    ? new Date(effectiveBreachIso).getTime()
    : (createdAt
      ? new Date(createdAt).getTime() + (isMetResponse ? 24 * 60 * 60 * 1000 : 4 * 60 * 60 * 1000)
      : Date.now() + 24 * 60 * 60 * 1000);

  // If SLA is on Hold: freeze countdown at the exact hold start time
  if (slaHold || status === 'on-hold') {
    const holdFreezeTime = slaHoldStartedAt ? new Date(slaHoldStartedAt).getTime() : now;
    const holdDiffMs = breachTime - holdFreezeTime;
    const isHoldBreached = holdDiffMs < 0;
    const absHoldDiff = Math.abs(holdDiffMs);
    const holdSecs = Math.floor(absHoldDiff / 1000);
    const holdHrs = Math.floor(holdSecs / 3600);
    const holdMins = Math.floor((holdSecs % 3600) / 60);
    const formattedHoldTime = `${isHoldBreached ? '-' : ''}${String(holdHrs).padStart(2, '0')}:${String(holdMins).padStart(2, '0')}`;

    return (
      <div
        className="relative flex h-5 w-28 items-center rounded overflow-hidden bg-amber-100 dark:bg-amber-950/60 text-amber-900 dark:text-amber-200 shadow-xs border border-amber-300 dark:border-amber-800 shrink-0"
        title="SLA clock on Hold (Timer paused)"
      >
        <span className="h-full w-2.5 bg-amber-500 shrink-0" />
        <span className="w-full text-center text-xs font-mono font-semibold tracking-wider truncate flex items-center justify-center gap-1">
          <Clock className="size-2.5 shrink-0 animate-pulse text-amber-600" />
          <span>{formattedHoldTime}</span>
        </span>
      </div>
    );
  }

  const diffMs = breachTime - now;
  const isBreached = diffMs < 0;
  const absDiff = Math.abs(diffMs);

  const totalSecs = Math.floor(absDiff / 1000);
  const hrs = Math.floor(totalSecs / 3600);
  const mins = Math.floor((totalSecs % 3600) / 60);

  const formattedTime = `${isBreached ? '-' : ''}${String(hrs).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;

  if (isBreached) {
    // High-visibility alert red bar with bold white text matching design system
    return (
      <div className="relative flex h-5 w-28 items-center justify-center rounded overflow-hidden bg-red-600 text-white shadow-xs border border-red-700 shrink-0">
        <span className="text-xs font-mono font-bold tracking-wider truncate">
          {formattedTime}
        </span>
      </div>
    );
  }

  // Silver/Gray container with solid green block on the left
  return (
    <div className="relative flex h-5 w-28 items-center rounded overflow-hidden bg-[#c5cbcf] dark:bg-slate-700 text-slate-900 dark:text-slate-100 shadow-xs border border-slate-400/40 shrink-0">
      <span className="h-full w-2.5 bg-[#008000] shrink-0" />
      <span className="w-full text-center text-xs font-mono font-semibold tracking-wider truncate">
        {formattedTime}
      </span>
    </div>
  );
}

// Helper for Dynamic Live SLA Target & Progress Track
function SlaMetricProgressTrack({ label, targetIso, isResponse }: { label: string; targetIso?: string; isResponse?: boolean }) {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, []);

  const targetTime = targetIso ? new Date(targetIso).getTime() : now + (isResponse ? 2 * 3600 * 1000 : 24 * 3600 * 1000);
  const diffMs = targetTime - now;
  const isBreached = diffMs < 0;
  const absMs = Math.abs(diffMs);
  const totalSecs = Math.floor(absMs / 1000);
  const hrs = Math.floor(totalSecs / 3600);
  const mins = Math.floor((totalSecs % 3600) / 60);
  const timeStr = `${isBreached ? '-' : ''}${String(hrs).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;

  return (
    <div className="space-y-1">
      <div className="flex justify-between items-center text-muted-foreground text-xs">
        <span>{label}</span>
        <span className="font-mono text-foreground flex items-center gap-1">
          {formatDateTime(targetIso)}
          {isBreached ? <span className="text-rose-600 font-semibold">✕</span> : <span className="text-emerald-600 font-semibold">✓</span>}
        </span>
      </div>
      <div
        className={cn(
          "relative w-full h-5 rounded overflow-hidden flex items-center justify-center font-mono text-xs font-semibold shadow-2xs transition-all",
          isBreached
            ? "bg-red-600 text-white border border-red-700"
            : "bg-slate-200 dark:bg-slate-700 text-slate-900 dark:text-white"
        )}
      >
        {!isBreached && (
          <div className="absolute left-0 top-0 bottom-0 bg-emerald-600 rounded-l" style={{ width: '65%' }} />
        )}
        <span className="relative z-10">{timeStr}</span>
      </div>
    </div>
  );
}

// Helper for Status Badge styling (SOLID OPAQUE COLORS & UNIFORM FIXED WIDTH FOR ALL STATUS PILLS)
function StatusBadge({ status }: { status: string }) {
  const norm = normalizeStatusName(status).toLowerCase();
  const baseClasses = "inline-flex h-5.5 w-[98px] shrink-0 items-center justify-center rounded-md px-1.5 text-xs font-semibold tracking-tight shadow-2xs border transition-colors select-none text-center truncate";

  switch (norm) {
    case 'new':
      return <span className={cn(baseClasses, "bg-lime-100 text-lime-900 border-lime-300 dark:bg-lime-950 dark:text-lime-200 dark:border-lime-800")}>New</span>;
    case 'draft':
      return <span className={cn(baseClasses, "bg-slate-100 text-slate-800 border-slate-300 dark:bg-slate-800 dark:text-slate-200 dark:border-slate-700")}>Draft</span>;
    case 'backlog':
      return <span className={cn(baseClasses, "bg-purple-100 text-purple-900 border-purple-300 dark:bg-purple-950 dark:text-purple-200 dark:border-purple-800")}>Backlog</span>;
    case 'open':
      return <span className={cn(baseClasses, "bg-sky-100 text-sky-900 border-sky-300 dark:bg-sky-950 dark:text-sky-200 dark:border-sky-800")}>Open</span>;
    case 'in progress':
      return <span className={cn(baseClasses, "bg-sky-100 text-sky-900 border-sky-300 dark:bg-sky-950 dark:text-sky-200 dark:border-sky-800")}>In Progress</span>;
    case 'pending':
      return <span className={cn(baseClasses, "bg-amber-100 text-amber-900 border-amber-300 dark:bg-amber-950 dark:text-amber-200 dark:border-amber-800")}>Pending</span>;
    case 'with user':
    case 'awaiting client':
      return <span className={cn(baseClasses, "bg-indigo-100 text-indigo-900 border-indigo-300 dark:bg-indigo-950 dark:text-indigo-200 dark:border-indigo-800")}>With User</span>;
    case 'with supplier':
      return <span className={cn(baseClasses, "bg-orange-100 text-orange-900 border-orange-300 dark:bg-orange-950 dark:text-orange-200 dark:border-orange-800")}>With Supplier</span>;
    case 'on hold':
      return <span className={cn(baseClasses, "bg-slate-200 text-slate-800 border-slate-300 dark:bg-slate-800 dark:text-slate-200 dark:border-slate-700")}>On Hold</span>;
    case 'awaiting approval':
    case 'pending approval':
      return <span className={cn(baseClasses, "bg-purple-100 text-purple-900 border-purple-300 dark:bg-purple-950 dark:text-purple-200 dark:border-purple-800")}>Awaiting Approval</span>;
    case 'with management':
      return <span className={cn(baseClasses, "bg-rose-100 text-rose-900 border-rose-300 dark:bg-rose-950 dark:text-rose-200 dark:border-rose-800")}>With Management</span>;
    case 'with hr':
      return <span className={cn(baseClasses, "bg-teal-100 text-teal-900 border-teal-300 dark:bg-teal-950 dark:text-teal-200 dark:border-teal-800")}>With HR</span>;
    case 'resolved':
      return <span className={cn(baseClasses, "bg-emerald-100 text-emerald-900 border-emerald-300 dark:bg-emerald-950 dark:text-emerald-200 dark:border-emerald-800")}>Resolved</span>;
    case 'closed':
      return <span className={cn(baseClasses, "bg-slate-300 text-slate-900 border-slate-400 dark:bg-slate-700 dark:text-slate-100 dark:border-slate-600")}>Closed</span>;
    default:
      return <span className={cn(baseClasses, "bg-slate-100 text-slate-800 border-slate-300 dark:bg-slate-800 dark:text-slate-200 dark:border-slate-700")}>{normalizeStatusName(status)}</span>;
  }
}

// Clean single-element Status Pill Selector with Popover
function StatusSelector({
  value,
  onChange,
}: {
  value: string;
  onChange: (newStatus: string) => void;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  const statuses = [
    { key: 'New', label: 'New' },
    { key: 'Draft', label: 'Draft' },
    { key: 'Backlog', label: 'Backlog' },
    { key: 'In Progress', label: 'In Progress' },
    { key: 'Pending', label: 'Pending' },
    { key: 'With User', label: 'With User' },
    { key: 'With Supplier', label: 'With Supplier' },
    { key: 'On Hold', label: 'On Hold' },
    { key: 'Awaiting Approval', label: 'Awaiting Approval' },
    { key: 'With Management', label: 'With Management' },
    { key: 'With HR', label: 'With HR' },
    { key: 'Resolved', label: 'Resolved' },
    { key: 'Closed', label: 'Closed' },
  ];

  return (
    <div className="relative w-full" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between rounded-md border border-border bg-card hover:bg-muted/10 px-2.5 py-1.5 text-xs transition-all cursor-pointer shadow-2xs group"
        title="Click to change ticket status"
      >
        <StatusBadge status={value} />
        <ChevronDown className={cn("size-3.5 text-muted-foreground/70 group-hover:text-foreground transition-all duration-150", isOpen && "rotate-180 opacity-100 text-foreground")} />
      </button>

      {isOpen && (
        <div className="absolute left-0 right-0 top-full mt-1.5 z-50 w-full min-w-[180px] rounded-lg border border-border bg-card p-1.5 shadow-xl text-foreground text-xs animate-in fade-in-50 zoom-in-95">
          <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground px-2 py-1 mb-1 border-b border-border">
            Change Status
          </div>
          <div className="space-y-0.5 max-h-56 overflow-y-auto custom-scrollbar">
            {statuses.map((st) => {
              const isCurrent = (value || 'new').toLowerCase().replace('_', '-') === st.key;
              return (
                <button
                  key={st.key}
                  type="button"
                  onClick={() => {
                    onChange(st.key);
                    setIsOpen(false);
                  }}
                  className={cn(
                    "w-full flex items-center justify-between px-2 py-1.5 rounded-md text-xs transition-colors text-left cursor-pointer",
                    isCurrent ? "bg-accent font-semibold text-foreground" : "hover:bg-muted text-foreground"
                  )}
                >
                  <StatusBadge status={st.key} />
                  {isCurrent && <Check className="size-3.5 text-blue-600 dark:text-blue-400 shrink-0 ml-1.5" />}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

// Helper for Priority Badge styling
function PriorityBadge({ priority }: { priority: string }) {
  const norm = (priority || 'low').toLowerCase();
  switch (norm) {
    case 'urgent':
      return <span className="text-xs font-semibold text-destructive">Urgent</span>;
    case 'high':
      return <span className="text-xs font-semibold text-amber-600 dark:text-amber-400">High</span>;
    case 'medium':
      return <span className="text-xs font-semibold text-blue-600 dark:text-blue-400">Medium</span>;
    default:
      return <span className="text-xs font-medium text-muted-foreground">Low</span>;
  }
}

type SidebarViewMode = 'team' | 'staff' | 'type' | 'status' | 'myLists' | 'all';
type ActivityLogTab = 'all' | 'notes' | 'emails' | 'audit';

interface SubFilter {
  type: 'all' | 'team' | 'teamUnassigned' | 'teamAgent' | 'staff' | 'staffUnassigned' | 'ticketType' | 'status' | 'myList';
  teamKey?: string;
  value?: string;
}

interface TableColumnHeaderProps {
  colKey: string;
  label: string;
  width: number;
  sortConfig: { column: string | null; direction: 'asc' | 'desc' | null };
  onSort: (colKey: string, direction?: 'asc' | 'desc' | null) => void;
  selectedValues?: string[];
  onFilterChange?: (colKey: string, values: string[]) => void;
  searchValue?: string;
  onSearchChange?: (colKey: string, val: string) => void;
  distinctValues?: { value: string; count: number }[];
  isOpen: boolean;
  onToggleDropdown: (colKey: string) => void;
  onCloseDropdown: () => void;
  onResize: (colKey: string, e: React.MouseEvent) => void;
  isNumericOrDate?: boolean;
  isTextSearchOnly?: boolean;
  alignRight?: boolean;
  dropdownRef?: React.RefObject<HTMLDivElement>;
}

function TableColumnHeader({
  colKey,
  label,
  width,
  sortConfig,
  onSort,
  selectedValues = [],
  onFilterChange,
  searchValue = '',
  onSearchChange,
  distinctValues = [],
  isOpen,
  onToggleDropdown,
  onCloseDropdown,
  onResize,
  isNumericOrDate = false,
  isTextSearchOnly = false,
  alignRight = false,
  dropdownRef,
}: TableColumnHeaderProps) {
  const [localSearch, setLocalSearch] = useState('');

  const isSorted = sortConfig.column === colKey;
  const sortDirection = isSorted ? sortConfig.direction : null;
  const isFiltered = selectedValues.length > 0 || searchValue.trim().length > 0;

  // Filter distinct values by the search input inside dropdown
  const filteredDistinctValues = useMemo(() => {
    if (!localSearch.trim()) return distinctValues;
    const q = localSearch.toLowerCase().trim();
    return distinctValues.filter((item) => item.value.toLowerCase().includes(q));
  }, [distinctValues, localSearch]);

  const handleToggleValue = (val: string) => {
    if (!onFilterChange) return;
    const exists = selectedValues.includes(val);
    const next = exists ? selectedValues.filter((v) => v !== val) : [...selectedValues, val];
    onFilterChange(colKey, next);
  };

  const handleSelectAll = () => {
    if (!onFilterChange) return;
    const allVals = filteredDistinctValues.map((d) => d.value);
    const merged = Array.from(new Set([...selectedValues, ...allVals]));
    onFilterChange(colKey, merged);
  };

  const handleClearSelected = () => {
    if (onFilterChange) onFilterChange(colKey, []);
    if (onSearchChange) onSearchChange(colKey, '');
    setLocalSearch('');
  };

  return (
    <th
      style={{ width: `${width}px` }}
      className={cn(
        'relative px-2.5 py-2.5 group select-none text-xs font-semibold uppercase tracking-wider transition-colors',
        isFiltered
          ? 'bg-blue-50/80 dark:bg-blue-950/30 text-blue-700 dark:text-blue-300'
          : isSorted
            ? 'bg-slate-200/70 dark:bg-slate-700/60 text-foreground'
            : 'text-muted-foreground hover:text-foreground'
      )}
    >
      <div className="flex items-center justify-between gap-1 w-full overflow-hidden">
        {/* Clickable Column Header Title (Sort toggle) */}
        <button
          type="button"
          onClick={() => onSort(colKey)}
          className="flex items-center gap-1 min-w-0 flex-1 text-left font-semibold uppercase tracking-wider hover:text-foreground truncate transition-colors"
          title={`Sort by ${label}`}
        >
          <span className="truncate">{label}</span>
          {sortDirection === 'asc' && (
            <ArrowUp className="size-3 text-blue-600 dark:text-blue-400 shrink-0 stroke-[2.5]" />
          )}
          {sortDirection === 'desc' && (
            <ArrowDown className="size-3 text-blue-600 dark:text-blue-400 shrink-0 stroke-[2.5]" />
          )}
          {!sortDirection && (
            <ArrowUpDown className="size-2.5 opacity-0 group-hover:opacity-40 shrink-0 text-muted-foreground" />
          )}
        </button>

        {/* Filter Popover Trigger Button */}
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onToggleDropdown(colKey);
          }}
          className={cn(
            'flex size-5 shrink-0 items-center justify-center rounded transition-colors relative',
            isOpen
              ? 'bg-blue-600 text-white shadow-2xs'
              : isFiltered
                ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/60 dark:text-blue-200'
                : 'opacity-0 group-hover:opacity-100 hover:bg-muted text-muted-foreground hover:text-foreground'
          )}
          title={`Filter ${label}`}
        >
          <Filter className={cn('size-2.5', isFiltered && 'fill-current')} />
          {isFiltered && !isOpen && (
            <span className="absolute -top-0.5 -right-0.5 size-1.5 rounded-full bg-blue-600 dark:bg-blue-400 ring-1 ring-background" />
          )}
        </button>
      </div>

      {/* FILTER & SORT POPOVER MENU */}
      {isOpen && (
        <div
          ref={dropdownRef}
          onClick={(e) => e.stopPropagation()}
          className={cn(
            'absolute top-full mt-1 z-50 min-w-[230px] max-w-[280px] rounded-lg border border-border bg-card p-2.5 shadow-xl text-foreground text-xs normal-case font-normal select-text',
            alignRight ? 'right-0' : 'left-0'
          )}
        >
          {/* Popover Header */}
          <div className="flex items-center justify-between pb-2 border-b border-border mb-2">
            <span className="font-semibold text-xs uppercase tracking-wider text-muted-foreground truncate">
              {label} Options
            </span>
            <button
              onClick={onCloseDropdown}
              className="size-4.5 flex items-center justify-center rounded hover:bg-muted text-muted-foreground hover:text-foreground"
              title="Close"
            >
              <X className="size-3" />
            </button>
          </div>

          {/* Quick Sort Options */}
          <div className="space-y-1 mb-2">
            <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground px-1 mb-1">
              Sort
            </div>
            <button
              type="button"
              onClick={() => onSort(colKey, 'asc')}
              className={cn(
                'flex w-full items-center gap-2 px-2 py-1.5 rounded text-xs transition-colors text-left font-medium',
                sortDirection === 'asc'
                  ? 'bg-blue-50 text-blue-700 dark:bg-blue-950 dark:text-blue-300 font-semibold'
                  : 'hover:bg-muted text-foreground'
              )}
            >
              <ArrowUp className="size-3 text-muted-foreground" />
              <span>{isNumericOrDate ? 'Oldest / Low to High' : 'Sort A to Z (Ascending)'}</span>
              {sortDirection === 'asc' && <Check className="size-3 ml-auto text-blue-600" />}
            </button>
            <button
              type="button"
              onClick={() => onSort(colKey, 'desc')}
              className={cn(
                'flex w-full items-center gap-2 px-2 py-1.5 rounded text-xs transition-colors text-left font-medium',
                sortDirection === 'desc'
                  ? 'bg-blue-50 text-blue-700 dark:bg-blue-950 dark:text-blue-300 font-semibold'
                  : 'hover:bg-muted text-foreground'
              )}
            >
              <ArrowDown className="size-3 text-muted-foreground" />
              <span>{isNumericOrDate ? 'Newest / High to Low' : 'Sort Z to A (Descending)'}</span>
              {sortDirection === 'desc' && <Check className="size-3 ml-auto text-blue-600" />}
            </button>
            {isSorted && (
              <button
                type="button"
                onClick={() => onSort(colKey, null)}
                className="flex w-full items-center gap-2 px-2 py-1 rounded text-xs text-muted-foreground hover:text-foreground hover:bg-muted transition-colors text-left"
              >
                <RotateCcw className="size-2.5" />
                <span>Clear sort</span>
              </button>
            )}
          </div>

          {/* Filter Section */}
          {(distinctValues.length > 0 || onSearchChange || onFilterChange) && (
            <>
              <hr className="border-border my-2" />
              <div className="space-y-2">
                <div className="flex items-center justify-between px-1">
                  <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
                    Filter
                  </span>
                  {isFiltered && (
                    <button
                      type="button"
                      onClick={handleClearSelected}
                      className="text-xs font-semibold text-blue-600 dark:text-blue-400 hover:underline"
                    >
                      Clear
                    </button>
                  )}
                </div>

                {/* Text search filter */}
                {(isTextSearchOnly || distinctValues.length > 4 || onSearchChange) && (
                  <div className="relative">
                    <Search className="absolute left-2 top-1/2 -translate-y-1/2 size-3 text-muted-foreground" />
                    <input
                      type="text"
                      placeholder={isTextSearchOnly ? `Search ${label}...` : 'Search values...'}
                      value={isTextSearchOnly ? searchValue : localSearch}
                      onChange={(e) => {
                        if (isTextSearchOnly && onSearchChange) {
                          onSearchChange(colKey, e.target.value);
                        } else {
                          setLocalSearch(e.target.value);
                        }
                      }}
                      className="h-7 w-full rounded-md border border-input bg-background pl-6 pr-2 text-xs placeholder:text-muted-foreground outline-none focus:ring-1 focus:ring-ring"
                    />
                  </div>
                )}

                {/* Checkbox list for distinct values */}
                {!isTextSearchOnly && distinctValues.length > 0 && (
                  <div>
                    <div className="flex items-center justify-between text-xs text-muted-foreground mb-1 px-1">
                      <button
                        type="button"
                        onClick={handleSelectAll}
                        className="hover:underline hover:text-foreground"
                      >
                        Select all ({filteredDistinctValues.length})
                      </button>
                      <button
                        type="button"
                        onClick={handleClearSelected}
                        className="hover:underline hover:text-foreground"
                      >
                        Clear
                      </button>
                    </div>

                    <div className="max-h-36 overflow-y-auto space-y-0.5 custom-scrollbar pr-1 border border-border/60 rounded-md p-1 bg-muted/20">
                      {filteredDistinctValues.length === 0 ? (
                        <div className="p-2 text-center text-xs text-muted-foreground">
                          No matching values
                        </div>
                      ) : (
                        filteredDistinctValues.map((item) => {
                          const isChecked = selectedValues.includes(item.value);
                          return (
                            <label
                              key={item.value}
                              className="flex items-center gap-2 px-1.5 py-1 rounded hover:bg-muted/60 cursor-pointer text-xs select-none"
                            >
                              <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={() => handleToggleValue(item.value)}
                                className="size-3.5 rounded border-border"
                              />
                              <span className="truncate flex-1 font-medium">{item.value}</span>
                              <span className="text-xs text-muted-foreground font-mono bg-muted px-1 py-0.5 rounded shrink-0">
                                {item.count}
                              </span>
                            </label>
                          );
                        })
                      )}
                    </div>
                  </div>
                )}
              </div>
            </>
          )}

          {/* Popover Footer */}
          <div className="mt-2.5 pt-2 border-t border-border flex items-center justify-between gap-2">
            {isFiltered ? (
              <button
                type="button"
                onClick={handleClearSelected}
                className="h-6.5 px-2 rounded border border-border text-xs text-muted-foreground hover:text-foreground hover:bg-muted font-medium"
              >
                Reset
              </button>
            ) : <div />}
            <button
              type="button"
              onClick={onCloseDropdown}
              className="h-6.5 px-3 rounded bg-primary text-primary-foreground font-semibold text-xs hover:bg-primary/90 ml-auto shadow-2xs"
            >
              Done
            </button>
          </div>
        </div>
      )}

      {/* Resize Handle */}
      <div
        onMouseDown={(e) => onResize(colKey, e)}
        className="absolute right-0 top-0 bottom-0 w-1.5 cursor-col-resize opacity-0 group-hover:opacity-100 hover:bg-black/40 bg-border transition-opacity"
      />
    </th>
  );
}

export function TicketView() {
  const activeSupportSender = useActiveSupportSender();
  const {
    tickets,
    currentTicket,
    queuesSummary,
    selectedTeamKey,
    selectedStatus,
    selectedPriority,
    selectedType,
    searchQuery,
    isLoading,
    error: ticketLoadError,
    pagination,
    fetchTickets,
    fetchTicket,
    fetchQueuesSummary,
    setSelectedTeamKey,
    setSelectedStatus,
    setSelectedPriority,
    setSelectedType,
    setSearchQuery,
    setPage,
    transitionTicket,
    addHistory,
    createTicket,
    updateTicket,
    assignTicket,
    deleteTicket,
    sendTicketResponse,
    availableActions,
    fetchAvailableActions,
    executeTicketAction,
  } = useTicketStore();

  const { workflows, getWorkflowForType, getAvailableTransitions, fetchWorkflows } = useWorkflowStore();
  const { employees, fetchEmployees } = useEmployeeStore();
  const { assets, fetchAssets, updateAsset } = useAssetStore();
  const { vendors, fetchVendors } = useAssetCatalogStore();
  const { user } = useAuthStore();
  const {
    queues: storeQueues,
    fetchQueues,
    agents: storeAgents,
    fetchAgents,
    ticketTypes,
    fetchTicketTypes,
    extendedWorkflows: storeExtendedWorkflows,
    fetchExtendedWorkflows,
    ticketActions: storeTicketActions,
    fetchTicketActions,
    ticketCategories,
    fetchCategories,
    ticketImpacts,
    fetchImpacts,
    ticketUrgencies,
    fetchUrgencies,
    endUsers,
    fetchEndUsers,
  } = useSupportSettingsStore();
  const {
    agents: mgmtAgents,
    fetchAgents: fetchMgmtAgents,
  } = useAgentManagementStore();
  const navigate = useNavigate();

  // 1. Resolve Active Logged In User Name dynamically (e.g. Alex, Girikumaran, etc.)
  const activeLoggedInName = useMemo(() => {
    const rawName = user?.name?.trim() || (user as any)?.fullName?.trim() || (user as any)?.displayName?.trim();
    if (rawName) return rawName;
    const combined = `${(user as any)?.firstName || ''} ${(user as any)?.lastName || ''}`.trim();
    if (combined) return combined;
    if (user?.email) {
      const local = user.email.split('@')[0];
      return local.charAt(0).toUpperCase() + local.slice(1);
    }
    return 'Default User';
  }, [user]);

  const currentUserName = activeLoggedInName;

  // 2. Combined End-Users from both people.employees and support.end_users table
  const combinedEndUsers = useMemo(() => {
    const map = new Map<string, { id: string; employeeId: string; userId?: string; name: string; email: string; department?: string; designation?: string; phone?: string }>();
    if (Array.isArray(employees)) {
      employees.forEach((emp) => {
        const key = String(emp.id);
        const name = emp.displayName || `${emp.firstName || ''} ${emp.lastName || ''}`.trim() || 'User';
        const userId = String((emp as any).userId || (emp as any).user_id || emp.id);
        map.set(key, {
          id: String(emp.id),
          employeeId: String(emp.id),
          userId,
          name,
          email: emp.email || '',
          department: emp.department || '',
          designation: emp.designation || '',
          phone: emp.phone || '',
        });
      });
    }
    if (Array.isArray(endUsers)) {
      endUsers.forEach((eu) => {
        const key = String(eu.employeeId || eu.id);
        if (!map.has(key)) {
          map.set(key, {
            id: String(eu.id),
            employeeId: String(eu.employeeId || eu.id),
            userId: String((eu as any).userId || eu.id),
            name: eu.name,
            email: eu.email || '',
            department: eu.department || '',
            designation: eu.designation || '',
            phone: eu.phone || '',
          });
        }
      });
    }
    return Array.from(map.values()).sort((a, b) => a.name.localeCompare(b.name));
  }, [employees, endUsers]);

  // 2.1 Dynamic All Ticket Types computed from DB (supportSettingsStore) with standard 25 fallback
  const availableTicketTypes = useMemo(() => {
    type TicketTypeOption = {
      id?: string;
      value: string;
      label: string;
      code?: string;
      tagPrefix?: string;
      defaultPrefix?: string;
      teamName?: string;
      teamKey?: string;
      workflow?: string;
      workflows?: string[];
      defaultWorkflow?: string;
      status?: string;
      enableAsset?: boolean;
      enableVendor?: boolean;
      enableSla?: boolean;
    };

    const list: TicketTypeOption[] = [];

    const STANDARD_TYPES: TicketTypeOption[] = [
      // 1. Support Team
      { value: 'sd-incident', label: 'Incident', code: 'SD_INC', tagPrefix: 'INC', defaultPrefix: 'INC#', teamName: 'Support Team', teamKey: 'support', workflow: 'Support Fault Lifecycle Workflow', workflows: ['Support Fault Lifecycle Workflow', 'Incident Management Workflow', 'Fault Fast-Track Workflow'], defaultWorkflow: 'Support Fault Lifecycle Workflow', status: 'in-progress' },
      { value: 'sd-service-request', label: 'Service Request', code: 'SD_SR', tagPrefix: 'SR', defaultPrefix: 'SR#', teamName: 'Support Team', teamKey: 'support', workflow: 'Service Request Fulfillment Workflow', workflows: ['Service Request Fulfillment Workflow', 'Service Request Workflow'], defaultWorkflow: 'Service Request Fulfillment Workflow', status: 'new' },
      { value: 'sd-request', label: 'Request', code: 'SD_REQ', tagPrefix: 'REQUEST', defaultPrefix: 'REQUEST#', teamName: 'Support Team', teamKey: 'support', workflow: 'Request', workflows: ['Request', 'Purchase Request', 'Request Fulfillment Workflow'], defaultWorkflow: 'Request', status: 'new' },
      { value: 'sd-change', label: 'Change Request', code: 'SD_CHG', tagPrefix: 'CHG', defaultPrefix: 'CHG#', teamName: 'Support Team', teamKey: 'support', workflow: 'Support Change Request Workflow', workflows: ['Support Change Request Workflow', 'Change Management Workflow'], defaultWorkflow: 'Support Change Request Workflow', status: 'draft' },
      { value: 'sd-access', label: 'Access Request', code: 'SD_ACC', tagPrefix: 'ACC', defaultPrefix: 'ACC#', teamName: 'Support Team', teamKey: 'support', workflow: 'Access Request Security Workflow', workflows: ['Access Request Security Workflow', 'Access Request Workflow'], defaultWorkflow: 'Access Request Security Workflow', status: 'new' },
      { value: 'sd-info', label: 'Information Request', code: 'SD_INFO', tagPrefix: 'INFO', defaultPrefix: 'INFO#', teamName: 'Support Team', teamKey: 'support', workflow: 'Information Enquiry Workflow', workflows: ['Information Enquiry Workflow'], defaultWorkflow: 'Information Enquiry Workflow', status: 'new' },

      // 2. Administration / Technical Team
      { value: 'td-incident', label: 'Incident (Technical)', code: 'TD_INC', tagPrefix: 'INC', defaultPrefix: 'INC#', teamName: 'Administration', teamKey: 'administration', workflow: 'Technical Incident Deep-Dive Workflow', workflows: ['Technical Incident Deep-Dive Workflow', 'Incident Management Workflow'], defaultWorkflow: 'Technical Incident Deep-Dive Workflow', status: 'in-progress' },
      { value: 'td-hardware', label: 'Hardware Fault', code: 'TD_HW', tagPrefix: 'HW', defaultPrefix: 'HW#', teamName: 'Administration', teamKey: 'administration', workflow: 'Technical Hardware Fault Lifecycle', workflows: ['Technical Hardware Fault Lifecycle'], defaultWorkflow: 'Technical Hardware Fault Lifecycle', status: 'open' },
      { value: 'td-network', label: 'Network Issue', code: 'TD_NET', tagPrefix: 'NET', defaultPrefix: 'NET#', teamName: 'Administration', teamKey: 'administration', workflow: 'Network Infrastructure Lifecycle', workflows: ['Network Infrastructure Lifecycle'], defaultWorkflow: 'Network Infrastructure Lifecycle', status: 'open' },
      { value: 'td-tsr', label: 'Technical Service Request', code: 'TD_TSR', tagPrefix: 'TSR', defaultPrefix: 'TSR#', teamName: 'Administration', teamKey: 'administration', workflow: 'Technical Service Fulfillment Workflow', workflows: ['Technical Service Fulfillment Workflow'], defaultWorkflow: 'Technical Service Fulfillment Workflow', status: 'new' },
      { value: 'td-change', label: 'Technical Change', code: 'TD_TCHG', tagPrefix: 'TCHG', defaultPrefix: 'TCHG#', teamName: 'Administration', teamKey: 'administration', workflow: 'Technical Infrastructure Change Workflow', workflows: ['Technical Infrastructure Change Workflow'], defaultWorkflow: 'Technical Infrastructure Change Workflow', status: 'draft' },

      // 3. Software Team
      { value: 'sw-bug', label: 'Bug', code: 'SW_BUG', tagPrefix: 'BUG', defaultPrefix: 'BUG#', teamName: 'Software Team', teamKey: 'software', workflow: 'Software Defect Engineering Lifecycle', workflows: ['Software Defect Engineering Lifecycle', 'Problem Management Workflow'], defaultWorkflow: 'Software Defect Engineering Lifecycle', status: 'open' },
      { value: 'sw-feature', label: 'Feature Request', code: 'SW_FEAT', tagPrefix: 'FEAT', defaultPrefix: 'FEAT#', teamName: 'Software Team', teamKey: 'software', workflow: 'Product Feature Roadmap Lifecycle', workflows: ['Product Feature Roadmap Lifecycle', 'Feature Request Workflow'], defaultWorkflow: 'Product Feature Roadmap Lifecycle', status: 'new' },
      { value: 'sw-enhancement', label: 'Enhancement', code: 'SW_ENH', tagPrefix: 'ENH', defaultPrefix: 'ENH#', teamName: 'Software Team', teamKey: 'software', workflow: 'Software Enhancement Workflow', workflows: ['Software Enhancement Workflow'], defaultWorkflow: 'Software Enhancement Workflow', status: 'new' },
      { value: 'sw-dev', label: 'Development Task', code: 'SW_DEV', tagPrefix: 'DEV', defaultPrefix: 'DEV#', teamName: 'Software Team', teamKey: 'software', workflow: 'Software Feature Task Lifecycle', workflows: ['Software Feature Task Lifecycle'], defaultWorkflow: 'Software Feature Task Lifecycle', status: 'in-progress' },
      { value: 'sw-deployment', label: 'Deployment Request', code: 'SW_DEP', tagPrefix: 'DEP', defaultPrefix: 'DEP#', teamName: 'Software Team', teamKey: 'software', workflow: 'Software Production Deployment Lifecycle', workflows: ['Software Production Deployment Lifecycle'], defaultWorkflow: 'Software Production Deployment Lifecycle', status: 'new' },

      // 4. HR Team
      { value: 'hr-enquiry', label: 'HR Enquiry', code: 'HR_HRQ', tagPrefix: 'HRQ', defaultPrefix: 'HRQ#', teamName: 'HR Team', teamKey: 'hr', workflow: 'HR Policy & General Enquiry Workflow', workflows: ['HR Policy & General Enquiry Workflow'], defaultWorkflow: 'HR Policy & General Enquiry Workflow', status: 'new', enableAsset: false, enableVendor: false, enableSla: true },
      { value: 'hr-leave', label: 'Leave Request', code: 'HR_LEAVE', tagPrefix: 'LEAVE', defaultPrefix: 'LEAVE#', teamName: 'HR Team', teamKey: 'hr', workflow: 'Employee Leave Request Workflow', workflows: ['Employee Leave Request Workflow'], defaultWorkflow: 'Employee Leave Request Workflow', status: 'new', enableAsset: false, enableVendor: false, enableSla: true },
      { value: 'hr-onboarding', label: 'Onboarding', code: 'HR_ONB', tagPrefix: 'ONB', defaultPrefix: 'ONB#', teamName: 'HR Team', teamKey: 'hr', workflow: 'Employee Onboarding Lifecycle', workflows: ['Employee Onboarding Lifecycle'], defaultWorkflow: 'Employee Onboarding Lifecycle', status: 'new', enableAsset: false, enableVendor: false, enableSla: true },
      { value: 'hr-offboarding', label: 'Offboarding', code: 'HR_OFFB', tagPrefix: 'OFFB', defaultPrefix: 'OFFB#', teamName: 'HR Team', teamKey: 'hr', workflow: 'Employee Offboarding & Asset Recovery Workflow', workflows: ['Employee Offboarding & Asset Recovery Workflow'], defaultWorkflow: 'Employee Offboarding & Asset Recovery Workflow', status: 'new', enableAsset: false, enableVendor: false, enableSla: true },

      // 5. Supplier Team
      { value: 'sup-issue', label: 'Supplier Issue', code: 'SUP_SUP', tagPrefix: 'SUP', defaultPrefix: 'SUP#', teamName: 'Supplier Team', teamKey: 'supplier', workflow: 'Supplier SLA & Contract Issue Lifecycle', workflows: ['Supplier SLA & Contract Issue Lifecycle'], defaultWorkflow: 'Supplier SLA & Contract Issue Lifecycle', status: 'open' },
      { value: 'sup-warranty', label: 'Warranty Claim', code: 'SUP_WAR', tagPrefix: 'WAR', defaultPrefix: 'WAR#', teamName: 'Supplier Team', teamKey: 'supplier', workflow: 'Warranty Claim Lifecycle', workflows: ['Warranty Claim Lifecycle'], defaultWorkflow: 'Warranty Claim Lifecycle', status: 'new' },
      { value: 'sup-replacement', label: 'Replacement Request', code: 'SUP_RPL', tagPrefix: 'RPL', defaultPrefix: 'RPL#', teamName: 'Supplier Team', teamKey: 'supplier', workflow: 'Hardware Replacement Supplier Lifecycle', workflows: ['Hardware Replacement Supplier Lifecycle'], defaultWorkflow: 'Hardware Replacement Supplier Lifecycle', status: 'new' },
      { value: 'sup-rma', label: 'RMA Request', code: 'SUP_RMA', tagPrefix: 'RMA', defaultPrefix: 'RMA#', teamName: 'Supplier Team', teamKey: 'supplier', workflow: 'Return Merchandise Authorization (RMA) Workflow', workflows: ['Return Merchandise Authorization (RMA) Workflow'], defaultWorkflow: 'Return Merchandise Authorization (RMA) Workflow', status: 'new' },

      // 6. Management Team
      { value: 'mgt-approval', label: 'Approval Request', code: 'MGT_APR', tagPrefix: 'APR', defaultPrefix: 'APR#', teamName: 'Management Team', teamKey: 'management', workflow: 'Executive Approval Matrix Lifecycle', workflows: ['Executive Approval Matrix Lifecycle'], defaultWorkflow: 'Executive Approval Matrix Lifecycle', status: 'awaiting-approval' },
      { value: 'mgt-major-incident', label: 'Major Incident', code: 'MGT_MAJ', tagPrefix: 'MAJ', defaultPrefix: 'MAJ#', teamName: 'Management Team', teamKey: 'management', workflow: 'Major Incident Emergency Response Workflow', workflows: ['Major Incident Emergency Response Workflow'], defaultWorkflow: 'Major Incident Emergency Response Workflow', status: 'in-progress' },
      { value: 'mgt-budget', label: 'Budget Request', code: 'MGT_BUD', tagPrefix: 'BUD', defaultPrefix: 'BUD#', teamName: 'Management Team', teamKey: 'management', workflow: 'Budget & Capital Expenditure Lifecycle', workflows: ['Budget & Capital Expenditure Lifecycle'], defaultWorkflow: 'Budget & Capital Expenditure Lifecycle', status: 'new' },
    ];

    if (!ticketTypes || ticketTypes.length === 0) {
      return STANDARD_TYPES;
    }

    ticketTypes.forEach((tt) => {
      const val = tt.code ? String(tt.code).toLowerCase().replace(/_/g, '-') : String(tt.name || '').toLowerCase().replace(/\s+/g, '-');
      const matchedStd = STANDARD_TYPES.find(s =>
        s.value === val ||
        (s.code && tt.code && String(s.code).toLowerCase() === String(tt.code).toLowerCase()) ||
        (s.label && tt.name && String(s.label).toLowerCase() === String(tt.name).toLowerCase())
      );
      const tagPrefix = (tt as any).tagPrefix || (tt as any).tagCode || (tt as any).prefix?.replace('#', '') || matchedStd?.tagPrefix || tt.code || 'INC';
      const rawTeam = (tt as any).teamName || (tt as any).team_name;
      const teamName = (rawTeam && rawTeam !== 'None (Team Independent)' && rawTeam !== 'All / General')
        ? rawTeam
        : (matchedStd?.teamName || 'Support Team');
      const rawTeamKey = (tt as any).teamKey || (tt as any).teamCode || matchedStd?.teamKey;
      const teamKey = normalizeTeamKey(rawTeamKey, teamName);
      const assignedWorkflows = Array.isArray((tt as any).workflows) && (tt as any).workflows.length > 0
        ? (tt as any).workflows
        : (matchedStd?.workflows || [(tt as any).defaultWorkflow || (tt as any).activeWorkflowName || matchedStd?.workflow || `${tt.name} Workflow`]);
      const defaultWf = (tt as any).defaultWorkflow || (tt as any).activeWorkflowName || matchedStd?.defaultWorkflow || assignedWorkflows[0] || `${tt.name} Workflow`;

      const isHr = teamKey === 'hr' ||
        String(teamName).toLowerCase().includes('hr') ||
        ['hr', 'leave', 'onboarding', 'offboarding', 'payroll'].some(k =>
          String(tt.name || '').toLowerCase().includes(k) ||
          String(tt.code || '').toLowerCase().startsWith(k)
        );

      const enableAsset = (tt as any).enableAsset !== undefined
        ? Boolean((tt as any).enableAsset)
        : (matchedStd?.enableAsset !== undefined ? matchedStd.enableAsset : !isHr);
      const enableVendor = (tt as any).enableVendor !== undefined
        ? Boolean((tt as any).enableVendor)
        : (matchedStd?.enableVendor !== undefined ? matchedStd.enableVendor : !isHr);
      const enableSla = (tt as any).enableSla !== undefined
        ? Boolean((tt as any).enableSla)
        : (matchedStd?.enableSla !== undefined ? matchedStd.enableSla : true);

      list.push({
        id: tt.id != null ? String(tt.id) : undefined,
        value: matchedStd ? matchedStd.value : val,
        label: tt.name,
        code: tt.code,
        tagPrefix,
        defaultPrefix: `${tagPrefix}#`,
        teamName,
        teamKey,
        workflow: defaultWf,
        workflows: assignedWorkflows,
        defaultWorkflow: defaultWf,
        status: matchedStd?.status || 'in-progress',
        enableAsset,
        enableVendor,
        enableSla,
      });
    });

    return list.length > 0 ? list : STANDARD_TYPES;
  }, [ticketTypes]);

  // 3. Match active logged in user with employees / end-users
  const activeEmployee = useMemo(() => {
    if (combinedEndUsers.length === 0) return null;
    const userEmail = (user?.email || '').toLowerCase().trim();
    const userName = currentUserName.toLowerCase().trim();
    const userId = user?.id ? String(user.id) : '';

    return combinedEndUsers.find((emp) => {
      const empEmail = (emp.email || '').toLowerCase().trim();
      const empUserId = emp.id ? String(emp.id) : '';
      const empName = emp.name.toLowerCase().trim();

      if (userEmail && empEmail && userEmail === empEmail) return true;
      if (userId && (empUserId === userId || emp.employeeId === userId)) return true;
      if (userName && (empName === userName || empName.includes(userName) || userName.includes(empName))) return true;
      return false;
    }) || null;
  }, [combinedEndUsers, user, currentUserName]);

  const userRoles = user?.roles || [];
  const rbacRoles = useRbacStore((s) => s.roles);
  const effectiveRoles = getEffectiveRoles(userRoles, rbacRoles);
  const supportAdmin = isSupportAdmin(effectiveRoles);
  const supportAgent = isSupportAgent(effectiveRoles);

  // Match the logged in user to an agent in support.agents
  const currentAgent = useMemo(() => {
    if (!storeAgents || storeAgents.length === 0) return null;
    return storeAgents.find((a) => {
      const emailMatch = a.email && user?.email && a.email.toLowerCase() === user.email.toLowerCase();
      const nameMatch = a.first_name && user?.name && user.name.toLowerCase().includes(a.first_name.toLowerCase());
      return emailMatch || nameMatch;
    });
  }, [storeAgents, user]);

  // Teams assigned to this agent by Support Admin
  const agentAssignedQueuesList = useMemo(() => {
    if (supportAdmin) return null; // Admin sees all teams
    if (supportAgent && currentAgent) {
      const q = currentAgent.assigned_queues || [];
      const t = (currentAgent as any).assigned_teams || [];
      const list = [...q, ...t].map((item) => String(item).trim());
      return list.length > 0 ? list : null;
    }
    return null;
  }, [supportAdmin, supportAgent, currentAgent]);

  // Filter queuesSummary for visible team queues
  const filteredQueuesSummary = useMemo(() => {
    const getRank = (key: string, label: string) => {
      const k = key.toLowerCase();
      const l = label.toLowerCase();
      if (k === 'support' || l.includes('support')) return 1;
      if (k === 'hr' || l.includes('hr')) return 2;
      if (k === 'administration' || l.includes('admin') || k === 'technical' || l.includes('technical')) return 3;
      if (k === 'software' || l.includes('software')) return 4;
      if (k === 'management' || l.includes('management')) return 5;
      if (k === 'supplier' || l.includes('supplier')) return 6;
      return 99;
    };

    // Combine queuesSummary with storeQueues so all configured database teams exist
    const map = new Map<string, { key: string; label: string; count: number }>();

    // 2. Merge storeQueues (configured teams from database)
    storeQueues.forEach((sq) => {
      const rawK = sq.key || sq.queue_key || sq.team_key || (sq as any).code || (sq.name ? sq.name.toLowerCase().replace(/[^a-z0-9]+/g, '-') : '');
      const rawL = sq.label || sq.queue_label || sq.team_name || sq.name || sq.key;
      const k = normalizeTeamKey(rawK, rawL);
      const l = normalizeTeamLabel(rawL);
      if (k) {
        const existing = map.get(k);
        map.set(k, {
          key: k,
          label: l || existing?.label || k,
          count: Number(sq.active_tickets ?? sq.active_tickets_count ?? existing?.count ?? 0),
        });
      }
    });

    // 3. Merge queuesSummary (active counts)
    queuesSummary.forEach((q) => {
      const k = normalizeTeamKey(q.key, q.label);
      const l = normalizeTeamLabel(q.label);
      if (k) {
        const existing = map.get(k);
        map.set(k, { key: k, label: l || existing?.label || k, count: q.count ?? existing?.count ?? 0 });
      }
    });

    let combined = Array.from(map.values());

    if (agentAssignedQueuesList && agentAssignedQueuesList.length > 0) {
      combined = combined.filter((q) =>
        agentAssignedQueuesList.some(
          (aq) =>
            aq.toLowerCase() === q.label.toLowerCase() ||
            aq.toLowerCase() === q.key.toLowerCase() ||
            aq.toLowerCase().replace(/[\s_-]+/g, '') === q.key.toLowerCase().replace(/[\s_-]+/g, '')
        )
      );
    }

    // Always sort Support Team first, followed by technical, software, hr, supplier, management
    return combined.sort((a, b) => {
      const rankA = getRank(a.key, a.label);
      const rankB = getRank(b.key, b.label);
      if (rankA !== rankB) return rankA - rankB;
      return a.label.localeCompare(b.label);
    });
  }, [queuesSummary, storeQueues, agentAssignedQueuesList]);

  const filteredStoreQueues = useMemo(() => {
    const map = new Map<string, any>();

    storeQueues.forEach((q) => {
      const rawK = q.key || q.queue_key || q.team_key || (q as any).code || (q.name ? q.name.toLowerCase().replace(/[^a-z0-9]+/g, '-') : '');
      const rawL = q.label || q.queue_label || q.team_name || q.name || q.key;
      const k = normalizeTeamKey(rawK, rawL);
      const l = normalizeTeamLabel(rawL);
      if (k) {
        map.set(k, { ...q, key: k, label: l, name: l });
      }
    });

    let list = Array.from(map.values());
    if (agentAssignedQueuesList && agentAssignedQueuesList.length > 0) {
      list = list.filter((q) =>
        agentAssignedQueuesList.some(
          (aq) =>
            aq.toLowerCase() === (q.label || '').toLowerCase() ||
            aq.toLowerCase() === (q.key || '').toLowerCase() ||
            aq.toLowerCase().replace(/[\s_-]+/g, '') === (q.key || '').toLowerCase().replace(/[\s_-]+/g, '')
        )
      );
    }

    return list.sort((a, b) => {
      const isASup = (a.key || '').toLowerCase() === 'support' || (a.label || '').toLowerCase().includes('support');
      const isBSup = (b.key || '').toLowerCase() === 'support' || (b.label || '').toLowerCase().includes('support');
      if (isASup && !isBSup) return -1;
      if (!isASup && isBSup) return 1;
      return (a.label || '').localeCompare(b.label || '');
    });
  }, [storeQueues, agentAssignedQueuesList]);

  // Helper for Status Tone & Icon Background (Matching Status Badge Tone)
  const getTicketStatusIconColor = (status?: string) => {
    const s = (status || 'new').toLowerCase().replace(/[\s_]+/g, '-');
    switch (s) {
      case 'new':
        return 'bg-emerald-600 text-white';
      case 'open':
      case 'in-progress':
        return 'bg-blue-600 text-white';
      case 'pending':
        return 'bg-amber-500 text-white';
      case 'with-user':
        return 'bg-indigo-600 text-white';
      case 'with-supplier':
      case 'supplier':
        return 'bg-orange-500 text-white';
      case 'on-hold':
        return 'bg-amber-600 text-white';
      case 'awaiting-approval':
        return 'bg-purple-600 text-white';
      case 'with-management':
        return 'bg-rose-600 text-white';
      case 'with-hr':
        return 'bg-teal-600 text-white';
      case 'resolved':
        return 'bg-emerald-600 text-white';
      case 'closed':
      case 'cancelled':
        return 'bg-slate-600 text-white';
      default:
        return 'bg-blue-600 text-white';
    }
  };

  // Helper for dynamic Action Button Icons with distinct icons and distinct icon colors
  const getActionIcon = (labelOrIcon: string = '', fallbackClass: string = "size-3.5") => {
    const norm = (labelOrIcon || '').toLowerCase().trim();

    // Specific Action & Button mappings
    if (norm.includes('ack') || norm === 'send_acknowledgement' || norm.includes('acknowledgement')) {
      return <Send className={cn(fallbackClass, "text-sky-500")} />;
    }
    if (norm.includes('review') || norm === 'start_review') {
      return <Compass className={cn(fallbackClass, "text-teal-600")} />;
    }
    if (norm.includes('invalid') || norm.includes('duplicate') || norm === 'close_invalid') {
      return <CopyX className={cn(fallbackClass, "text-rose-500")} />;
    }
    if (norm.includes('accept') || norm === 'assign_ticket' || norm === 'assign_accept' || norm.includes('assign & accept')) {
      return <UserCheck className={cn(fallbackClass, "text-blue-500")} />;
    }
    if (norm.includes('reassign') || norm.includes('assign') || norm === 'userplus') {
      return <UserPlus className={cn(fallbackClass, "text-indigo-500")} />;
    }
    if (norm.includes('resume') || norm === 'resume_work') {
      return <FastForward className={cn(fallbackClass, "text-emerald-600")} />;
    }
    if (norm.includes('start work') || norm === 'start_work') {
      return <Play className={cn(fallbackClass, "text-emerald-500")} />;
    }
    if (norm.includes('hold') || norm === 'put_on_hold' || norm === 'clock') {
      return <PauseCircle className={cn(fallbackClass, "text-amber-500")} />;
    }
    if (norm.includes('supplier') || norm.includes('rma') || norm.includes('vendor') || norm === 'log_to_supplier') {
      return <Building2 className={cn(fallbackClass, "text-indigo-600")} />;
    }
    if (norm.includes('mail') || norm.includes('email') || norm === 'email_supplier') {
      return <Mail className={cn(fallbackClass, "text-violet-500")} />;
    }
    if (norm.includes('request_info') || norm.includes('more info') || norm.includes('request info') || norm === 'helpcircle') {
      return <HelpCircle className={cn(fallbackClass, "text-cyan-500")} />;
    }
    if (norm.includes('internal') || norm.includes('note') || norm === 'add_internal_note' || norm === 'lock') {
      return <Lock className={cn(fallbackClass, "text-purple-500")} />;
    }
    if (norm.includes('comment') || norm.includes('public reply') || norm === 'add_comment') {
      return <MessageSquare className={cn(fallbackClass, "text-blue-600")} />;
    }
    if (norm.includes('fulfil') || norm.includes('fulfill') || norm === 'fulfil_request') {
      return <PackageCheck className={cn(fallbackClass, "text-teal-500")} />;
    }
    if (norm.includes('resolve') || norm === 'resolve' || norm.includes('mark resolved')) {
      return <CheckCircle2 className={cn(fallbackClass, "text-emerald-600")} />;
    }
    if (norm.includes('reopen') || norm === 'reopen' || norm.includes('rotateccw')) {
      return <RotateCcw className={cn(fallbackClass, "text-blue-500")} />;
    }
    if (norm.includes('known error') || norm === 'mark_known_error') {
      return <BookOpen className={cn(fallbackClass, "text-amber-600")} />;
    }
    if (norm.includes('fix failed') || norm === 'fix_failed') {
      return <AlertTriangle className={cn(fallbackClass, "text-red-500")} />;
    }
    if (norm.includes('approve change') || norm === 'approve_change') {
      return <CalendarCheck className={cn(fallbackClass, "text-emerald-600")} />;
    }
    if (norm.includes('approve') || norm === 'approve') {
      return <ThumbsUp className={cn(fallbackClass, "text-emerald-500")} />;
    }
    if (norm.includes('reject') || norm === 'reject') {
      return <ThumbsDown className={cn(fallbackClass, "text-rose-600")} />;
    }
    if (norm.includes('submit') || norm === 'submit_for_review') {
      return <FileCheck className={cn(fallbackClass, "text-blue-500")} />;
    }
    if (norm.includes('return') || norm === 'return_for_info') {
      return <CornerUpLeft className={cn(fallbackClass, "text-amber-500")} />;
    }
    if (norm.includes('reschedule') || norm === 'reschedule') {
      return <CalendarClock className={cn(fallbackClass, "text-indigo-500")} />;
    }
    if (norm.includes('start implementation') || norm === 'start_implementation') {
      return <Wrench className={cn(fallbackClass, "text-cyan-600")} />;
    }
    if (norm.includes('complete implementation') || norm === 'complete_implementation') {
      return <ShieldCheck className={cn(fallbackClass, "text-emerald-600")} />;
    }
    if (norm.includes('rollback') || norm === 'rollback') {
      return <Undo2 className={cn(fallbackClass, "text-orange-500")} />;
    }
    if (norm.includes('send for approval') || norm === 'send_for_approval') {
      return <Stamp className={cn(fallbackClass, "text-sky-600")} />;
    }
    if (norm.includes('withdraw') || norm === 'withdraw') {
      return <ArrowLeftCircle className={cn(fallbackClass, "text-slate-500")} />;
    }
    if (norm.includes('resubmit') || norm === 'resubmit') {
      return <RefreshCw className={cn(fallbackClass, "text-blue-600")} />;
    }
    if (norm.includes('cancel') || norm === 'cancel') {
      return <Ban className={cn(fallbackClass, "text-rose-500")} />;
    }
    if (norm.includes('close') || norm === 'close') {
      return <CheckSquare className={cn(fallbackClass, "text-slate-600")} />;
    }
    if (norm.includes('dev') || norm === 'move_to_dev') {
      return <LucideCode className={cn(fallbackClass, "text-indigo-600")} />;
    }
    if (norm.includes('testing') || norm === 'move_to_testing') {
      return <FlaskConical className={cn(fallbackClass, "text-purple-600")} />;
    }
    if (norm.includes('preview') || norm === 'move_to_preview') {
      return <Eye className={cn(fallbackClass, "text-sky-500")} />;
    }
    if (norm.includes('mark done') || norm === 'mark_done' || norm === 'done') {
      return <Award className={cn(fallbackClass, "text-emerald-600")} />;
    }
    if (norm.includes('fail qa') || norm === 'fail_qa') {
      return <Bug className={cn(fallbackClass, "text-rose-600")} />;
    }
    if (norm.includes('request changes') || norm === 'request_changes') {
      return <GitPullRequestDraft className={cn(fallbackClass, "text-orange-600")} />;
    }
    if (norm.includes('start deployment') || norm.includes('deploy') || norm === 'start_deployment') {
      return <Rocket className={cn(fallbackClass, "text-orange-500")} />;
    }
    if (norm.includes('complete deployment') || norm === 'complete_deployment') {
      return <CheckCheck className={cn(fallbackClass, "text-emerald-600")} />;
    }
    if (norm.includes('verify') || norm === 'verify_ok') {
      return <BadgeCheck className={cn(fallbackClass, "text-emerald-500")} />;
    }
    if (norm.includes('failed') || norm === 'mark_failed') {
      return <Flame className={cn(fallbackClass, "text-rose-600")} />;
    }
    if (norm.includes('type') || norm === 'change_type') {
      return <Shuffle className={cn(fallbackClass, "text-purple-500")} />;
    }
    if (norm.includes('raise change') || norm === 'raise_change') {
      return <GitFork className={cn(fallbackClass, "text-amber-600")} />;
    }
    if (norm.includes('approval') || norm === 'request_approval') {
      return <ShieldAlert className={cn(fallbackClass, "text-indigo-500")} />;
    }
    if (norm.includes('priority') || norm === 'change_priority') {
      return <Sliders className={cn(fallbackClass, "text-orange-500")} />;
    }
    if (norm.includes('link') || norm === 'link_ticket') {
      return <Link2 className={cn(fallbackClass, "text-teal-500")} />;
    }
    if (norm.includes('follow') || norm === 'follow') {
      return <Bell className={cn(fallbackClass, "text-blue-500")} />;
    }
    if (norm.includes('child') || norm.includes('sub-ticket') || norm === 'plus') {
      return <Plus className={cn(fallbackClass, "text-emerald-500")} />;
    }
    if (norm.includes('appointment') || norm.includes('calendar') || norm === 'calendar') {
      return <Calendar className={cn(fallbackClass, "text-indigo-500")} />;
    }
    if (norm.includes('investigat') || norm.includes('search')) {
      return <Search className={cn(fallbackClass, "text-sky-500")} />;
    }
    if (norm.includes('private') || norm.includes('eyeoff')) {
      return <EyeOff className={cn(fallbackClass, "text-purple-500")} />;
    }
    if (norm.includes('start') || norm.includes('play')) {
      return <Play className={cn(fallbackClass, "text-emerald-500")} />;
    }

    return <CheckCircle2 className={cn(fallbackClass, "text-primary")} />;
  };

  // Display Layout State: Table vs Tile Row List
  const [displayMode, setDisplayMode] = useState<'table' | 'tile'>('table');

  // Sidebar Mode State
  const [sidebarViewMode, setSidebarViewMode] = useState<SidebarViewMode>('team');
  const [isViewModePickerOpen, setIsViewModePickerOpen] = useState(false);
  const [isQueueSidebarCollapsed, setIsQueueSidebarCollapsed] = useState(false);
  const [expandedTeams, setExpandedTeams] = useState<Set<string>>(new Set(['support', 'hr', 'management', 'supplier']));

  // Detailed Sub-filter state
  const [subFilter, setSubFilter] = useState<SubFilter>({ type: 'all' });

  // Selected Ticket for Full ITSM View
  const [selectedTicket, setSelectedTicket] = useState<Ticket | null>(null);

  // Helper to safely navigate queues/tabs and return to list view if a ticket is currently open
  const closeTicketView = () => {
    if (selectedTicket) {
      setSelectedTicket(null);
    }
    useTicketStore.getState().setCurrentTicket(null);
  };

  const isSelectedSysGen = useMemo(() => {
    if (!selectedTicket) return false;
    return Boolean(
      selectedTicket.isSystemGenerated ||
      selectedTicket.sourceReferenceType === 'LEAVE_REQUEST' ||
      selectedTicket.type === 'System Generated' ||
      selectedTicket.ticketTypeCode === 'SYS_GEN' ||
      Number(selectedTicket.ticketTypeId) === 42 ||
      Number(selectedTicket.ticket_type_id) === 42
    );
  }, [selectedTicket]);

  // Automatically fetch full ticket details & dynamic workflow actions when a ticket is opened or status changes
  useEffect(() => {
    if (!selectedTicket) return;
    const lookupId = selectedTicket.id || selectedTicket.ticketId || selectedTicket.ticketNumber;
    if (!lookupId) return;
    fetchTicket(lookupId).catch((err) => {
      console.warn('Could not fetch full ticket details:', err);
    });
    const ticketNum = selectedTicket.ticketNumber || selectedTicket.ticketId;
    fetchAvailableActions(lookupId, ticketNum).catch(() => { });
  }, [selectedTicket?.id, selectedTicket?.ticketId, selectedTicket?.status, fetchTicket, fetchAvailableActions]);

  // Sync selectedTicket with currentTicket when full ticket details arrive from server
  useEffect(() => {
    if (
      currentTicket &&
      selectedTicket &&
      (String(currentTicket.id) === String(selectedTicket.id) ||
        String(currentTicket.ticketId) === String(selectedTicket.ticketId))
    ) {
      setSelectedTicket((prev) => {
        if (!prev) return currentTicket;
        const mergedHistory =
          currentTicket.history && currentTicket.history.length > 0
            ? currentTicket.history
            : prev.history;
        const mergedAttachments =
          currentTicket.attachments && currentTicket.attachments.length > 0
            ? currentTicket.attachments.filter((a: any) => !isTicketBackupJson(a?.name || a?.filename))
            : (prev.attachments || []).filter((a: any) => !isTicketBackupJson(a?.name || a?.filename));
        return {
          ...prev,
          ...currentTicket,
          history: mergedHistory,
          attachments: mergedAttachments,
        };
      });
    }
  }, [currentTicket]);

  // Sync selectedTicket with global ticketStore currentTicket so TopNav breadcrumb reflects active ticket
  useEffect(() => {
    useTicketStore.getState().setCurrentTicket(selectedTicket);
    return () => {
      useTicketStore.getState().setCurrentTicket(null);
    };
  }, [selectedTicket]);

  // If TopNav breadcrumb or external event clears currentTicket, close ticket view
  useEffect(() => {
    if (currentTicket === null && selectedTicket !== null) {
      setSelectedTicket(null);
    }
  }, [currentTicket, selectedTicket]);

  // Resolve asset associated with the selected ticket (either from ticket payload or assetStore)
  const ticketAsset = useMemo(() => {
    if (!selectedTicket) return null;
    const direct = selectedTicket.primaryAsset || selectedTicket.assets?.[0] || selectedTicket.asset || currentTicket?.primaryAsset || currentTicket?.assets?.[0];
    const assetList = useAssetStore.getState().assets || [];
    const code = selectedTicket.primaryAssetCode || selectedTicket.assetTag;
    const id = selectedTicket.primaryAssetId || selectedTicket.assetId;

    const fromStore = assetList.find(
      (a) => (id && String(a.id) === String(id)) || (code && code !== '-' && (a.asset_code === code || (a as any).code === code))
    );

    return {
      id: fromStore?.id || direct?.id || id,
      assetCode: fromStore?.asset_code || direct?.assetCode || direct?.assetTag || code,
      assetTag: fromStore?.asset_code || direct?.assetTag || direct?.assetCode || code,
      name: fromStore?.name || direct?.name,
      model: fromStore?.model || direct?.model,
      serialNumber: fromStore?.serial_number || direct?.serialNumber,
      status: fromStore?.status || direct?.status,
      warrantyUntil: fromStore?.warrantyUntil || direct?.warrantyUntil || direct?.warrantyEndDate,
      warrantyStart: fromStore?.warrantyStart || direct?.warrantyStart,
      vendor: selectedTicket.effectiveVendorName || selectedTicket.vendorName || fromStore?.vendor || direct?.vendor,
      vendorEmail: selectedTicket.vendorEmail || (fromStore as any)?.vendorEmail,
      vendorPhone: selectedTicket.vendorPhone,
      vendorSlaTerms: selectedTicket.vendorSlaTerms,
      supplierName: (fromStore as any)?.supplierName,
    };
  }, [selectedTicket, currentTicket]);

  // Automatically trigger warranty notification everytime visiting the ticket
  const visitedTicketRef = useRef<string | null>(null);

  useEffect(() => {
    if (vendors.length === 0) {
      fetchVendors();
    }
  }, [vendors.length, fetchVendors]);

  useEffect(() => {
    if (!selectedTicket) {
      visitedTicketRef.current = null;
      return;
    }
    const tid = String(selectedTicket.id || selectedTicket.ticketId);
    if (visitedTicketRef.current === tid) return;

    if (useAssetStore.getState().assets.length === 0) {
      useAssetStore.getState().fetchAssets();
    }
    if (useAssetCatalogStore.getState().vendors.length === 0) {
      useAssetCatalogStore.getState().fetchVendors();
    }

    const asset = ticketAsset;
    const assetCode = asset?.assetCode || selectedTicket.primaryAssetCode || selectedTicket.assetTag;
    if (!assetCode || assetCode === '-') return;

    visitedTicketRef.current = tid;

    const expiryDate = asset?.warrantyUntil ? (asset.warrantyUntil.includes('T') ? asset.warrantyUntil.slice(0, 10) : asset.warrantyUntil) : null;
    const assetLabel = `${assetCode}${asset?.name ? ` (${asset.name})` : ''}`.trim();

    if (expiryDate) {
      const clean = expiryDate.includes('T') ? expiryDate.slice(0, 10) : expiryDate;
      const [y, m, d] = clean.split('-').map(Number);
      const target = new Date(y, m - 1, d).getTime();
      const now = new Date(); now.setHours(0, 0, 0, 0);
      const days = Math.round((target - now.getTime()) / 86_400_000);

      if (days < 0) {
        toast.error(`Asset Warranty EXPIRED on ${clean} (${Math.abs(days)} days ago) for ${assetLabel}`, {
          duration: 6000,
          id: `warranty-notif-${tid}`,
        });
      } else if (days <= 60) {
        toast(`Warranty Expiring Soon: ${days} days remaining (${clean}) for ${assetLabel}`, {
          icon: '⚠️',
          duration: 6000,
          id: `warranty-notif-${tid}`,
        });
      } else {
        toast.success(`Active Warranty until ${clean} (${days} days remaining) for ${assetLabel}`, {
          duration: 5000,
          id: `warranty-notif-${tid}`,
        });
      }
    } else {
      toast(`No warranty date recorded for linked asset ${assetLabel}`, {
        duration: 4000,
        id: `warranty-notif-${tid}`,
      });
    }
  }, [selectedTicket?.id, selectedTicket?.ticketId, ticketAsset]);

  // Workflows applicable to the currently selected ticket (supports multiple workflows per ticket type)
  const workflowsForCurrentTicket = useMemo(() => {
    const list: string[] = [];
    const currentType = (selectedTicket?.type || 'incident').toLowerCase();

    // 1. From ticketTypes config in settings
    const matchedTT = ticketTypes?.find(
      (tt) =>
        (tt.name && String(tt.name).toLowerCase() === currentType) ||
        (tt.code && String(tt.code).toLowerCase() === currentType) ||
        (tt.id != null && String(tt.id).toLowerCase() === currentType) ||
        (tt.code && `tt-${String(tt.code).toLowerCase()}` === currentType)
    );
    if (matchedTT && Array.isArray((matchedTT as any).workflows) && (matchedTT as any).workflows.length > 0) {
      (matchedTT as any).workflows.forEach((w: string) => {
        if (w && !list.includes(w)) list.push(w);
      });
    }

    // 2. From storeExtendedWorkflows (where ticketType matches or allowedTicketTypes includes currentType)
    if (storeExtendedWorkflows && storeExtendedWorkflows.length > 0) {
      storeExtendedWorkflows.forEach((ew) => {
        const typeMatches = (ew.ticketType || '').toLowerCase() === currentType;
        const allowedMatches = Array.isArray(ew.allowedTicketTypes) && ew.allowedTicketTypes.some(
          (att) => att.toLowerCase() === currentType || att.toLowerCase().includes(currentType) || currentType.includes(att.toLowerCase())
        );
        if ((typeMatches || allowedMatches) && !list.includes(ew.name)) {
          list.push(ew.name);
        }
      });
    }

    // 3. From availableTicketTypes matched item
    const matchedAvail = availableTicketTypes.find(
      (at) => at.value === currentType || at.label.toLowerCase() === currentType
    );
    if (matchedAvail?.workflows) {
      matchedAvail.workflows.forEach((w) => {
        if (w && !list.includes(w)) list.push(w);
      });
    }

    // 4. If current ticket has a workflow assigned that isn't in list, add it
    if (selectedTicket?.workflow && !list.includes(selectedTicket.workflow)) {
      list.unshift(selectedTicket.workflow);
    }

    // 5. Fallback standard workflows if none found
    if (list.length === 0) {
      return [
        'Default Workflow',
        'Incident Management Workflow',
        'Service Request Workflow',
        'Change Management Workflow',
        'Problem Management Workflow',
        'Fault Fast-Track Workflow',
      ];
    }

    return list;
  }, [selectedTicket?.type, selectedTicket?.workflow, ticketTypes, storeExtendedWorkflows, availableTicketTypes]);

  // Groups ticket types by Team for the editable Ticket Type select dropdown
  const ticketTypesByTeam = useMemo(() => {
    const order = ['Support Team', 'Technical Team', 'Software Team', 'HR Team', 'Supplier Team', 'Management Team', 'Administration'];
    const groups: Record<string, typeof availableTicketTypes> = {
      'Support Team': [],
      'Technical Team': [],
      'Software Team': [],
      'HR Team': [],
      'Supplier Team': [],
      'Management Team': [],
      'Administration': [],
    };

    availableTicketTypes.forEach((tt) => {
      let team = tt.teamName || 'Support Team';
      if (team === 'None (Team Independent)' || team === 'All / General') {
        team = 'Support Team';
      }
      if (!groups[team]) groups[team] = [];
      groups[team].push(tt);
    });

    const allTeams = Array.from(new Set([...order, ...Object.keys(groups)]));
    return allTeams
      .filter((teamName) => groups[teamName] && groups[teamName].length > 0)
      .map((teamName) => ({ teamName, types: groups[teamName] }));
  }, [availableTicketTypes]);

  // Resolves the currently selected ticket's matching ticket type configuration
  const currentTicketTypeConfig = useMemo(() => {
    if (!selectedTicket) return availableTicketTypes[0];
    const rawType = String(selectedTicket.type || (selectedTicket as any).ticketTypeName || '').trim().toLowerCase();
    const rawTag = String(selectedTicket.tag || selectedTicket.tagPrefix || (selectedTicket as any).ticketTypeCode || '').trim().toUpperCase();
    const idTag = (selectedTicket.ticketNumber || selectedTicket.ticketId || '').split(/[-#]/)[0].trim().toUpperCase();
    const originMod = String(selectedTicket.originModule || '').trim().toLowerCase();
    const originRecType = String(selectedTicket.originRecordType || '').trim().toLowerCase();
    const sourceStr = String(selectedTicket.source || '').trim().toLowerCase();
    const titleStr = String((selectedTicket as any).title || selectedTicket.subject || '').trim().toLowerCase();

    // 0. Match by ticketTypeId
    if (selectedTicket.ticketTypeId) {
      const byId = availableTicketTypes.find(
        (tt) => String(tt.id) === String(selectedTicket.ticketTypeId) ||
          tt.code?.toLowerCase() === String(selectedTicket.ticketTypeId).toLowerCase() ||
          tt.value.toLowerCase() === String(selectedTicket.ticketTypeId).toLowerCase()
      );
      if (byId) return byId;
    }

    // 1. Direct match by tagPrefix or code (e.g. 'SR', 'REQUEST', 'INC', 'HW', etc.)
    if (rawTag) {
      const byTag = availableTicketTypes.find(
        (tt) => tt.tagPrefix?.toUpperCase() === rawTag || tt.code?.toUpperCase() === rawTag
      );
      if (byTag) return byTag;
    }
    if (idTag) {
      const byIdTag = availableTicketTypes.find(
        (tt) => tt.tagPrefix?.toUpperCase() === idTag || tt.code?.toUpperCase() === idTag
      );
      if (byIdTag) return byIdTag;
    }

    // 2. Direct match by value or label or code
    let found = availableTicketTypes.find(
      (tt) =>
        tt.value.toLowerCase() === rawType ||
        tt.label.toLowerCase() === rawType ||
        tt.code?.toLowerCase() === rawType
    );
    if (found) return found;

    // 3. App-triggered ticket matching (tickets triggered by other apps: assets, people, money, work, etc.)
    if (idTag === 'SR' || rawTag === 'SR' || rawType.includes('service request') || rawType.includes('service_request') || originRecType.includes('service')) {
      const sr = availableTicketTypes.find((tt) => tt.tagPrefix === 'SR' || tt.value === 'sd-service-request');
      if (sr) return sr;
    }

    if (originMod === 'assets' || sourceStr.includes('asset') || titleStr.includes('hardware service')) {
      if (rawType.includes('repair') || rawType.includes('maintenance') || titleStr.includes('service') || originRecType.includes('maintenance')) {
        const sr = availableTicketTypes.find((tt) => tt.tagPrefix === 'SR' || tt.value === 'sd-service-request');
        if (sr) return sr;
      }
      if (rawType.includes('fault') || originRecType.includes('fault') || titleStr.includes('fault')) {
        const hw = availableTicketTypes.find((tt) => tt.tagPrefix === 'HW' || tt.value === 'td-hardware');
        if (hw) return hw;
      }
      if (rawType.includes('requisition') || originRecType.includes('requisition') || idTag === 'REQUEST' || rawTag === 'REQUEST') {
        const req = availableTicketTypes.find((tt) => tt.tagPrefix === 'REQUEST' || tt.value === 'sd-request');
        if (req) return req;
      }
    }

    if (originMod === 'people' || sourceStr.includes('people') || sourceStr.includes('employee')) {
      if (rawType.includes('leave') || originRecType.includes('leave') || titleStr.includes('leave')) {
        const leave = availableTicketTypes.find((tt) => tt.tagPrefix === 'LEAVE' || tt.value === 'hr-leave');
        if (leave) return leave;
      }
      if (rawType.includes('onboard') || originRecType.includes('onboard')) {
        const onb = availableTicketTypes.find((tt) => tt.tagPrefix === 'ONB' || tt.value === 'hr-onboarding');
        if (onb) return onb;
      }
      if (rawType.includes('offboard') || originRecType.includes('offboard')) {
        const offb = availableTicketTypes.find((tt) => tt.tagPrefix === 'OFFB' || tt.value === 'hr-offboarding');
        if (offb) return offb;
      }
      const hrq = availableTicketTypes.find((tt) => tt.tagPrefix === 'SR' || tt.tagPrefix === 'HRQ' || tt.value === 'hr-enquiry');
      if (hrq) return hrq;
    }

    // 4. Keyword / prefix matches
    if (rawType.includes('bug') || rawType.includes('defect') || rawType.includes('problem')) {
      return availableTicketTypes.find((tt) => tt.tagPrefix === 'BUG') || availableTicketTypes[0];
    }
    if (rawType.includes('feat')) {
      return availableTicketTypes.find((tt) => tt.tagPrefix === 'FEAT') || availableTicketTypes[0];
    }
    if (rawType.includes('enhanc')) {
      return availableTicketTypes.find((tt) => tt.tagPrefix === 'ENH') || availableTicketTypes[0];
    }
    if (rawType.includes('hardw')) {
      return availableTicketTypes.find((tt) => tt.tagPrefix === 'HW') || availableTicketTypes[0];
    }
    if (rawType.includes('netw')) {
      return availableTicketTypes.find((tt) => tt.tagPrefix === 'NET') || availableTicketTypes[0];
    }
    if (rawType.includes('leave')) {
      return availableTicketTypes.find((tt) => tt.tagPrefix === 'LEAVE') || availableTicketTypes[0];
    }
    if (rawType.includes('onb')) {
      return availableTicketTypes.find((tt) => tt.tagPrefix === 'ONB') || availableTicketTypes[0];
    }
    if (rawType.includes('offb')) {
      return availableTicketTypes.find((tt) => tt.tagPrefix === 'OFFB') || availableTicketTypes[0];
    }
    if (rawType.includes('warran')) {
      return availableTicketTypes.find((tt) => tt.tagPrefix === 'WAR') || availableTicketTypes[0];
    }
    if (rawType.includes('supp')) {
      return availableTicketTypes.find((tt) => tt.tagPrefix === 'SUP') || availableTicketTypes[0];
    }
    if (rawType.includes('appr')) {
      return availableTicketTypes.find((tt) => tt.tagPrefix === 'APR') || availableTicketTypes[0];
    }
    if (rawType.includes('budg')) {
      return availableTicketTypes.find((tt) => tt.tagPrefix === 'BUD') || availableTicketTypes[0];
    }
    if (rawTag === 'REQUEST' || idTag === 'REQUEST' || rawType === 'request' || rawType.includes('purchas') || rawType.includes('procur')) {
      return availableTicketTypes.find((tt) => tt.tagPrefix?.toUpperCase() === 'REQUEST' || tt.value === 'sd-request') || availableTicketTypes[0];
    }
    if (rawType.includes('serv') || rawType.includes('req')) {
      return availableTicketTypes.find((tt) => tt.tagPrefix === 'SR' || tt.value === 'sd-service-request') || availableTicketTypes[0];
    }
    if (rawType.includes('chang')) {
      return availableTicketTypes.find((tt) => tt.tagPrefix === 'CHG' || tt.tagPrefix === 'TCHG') || availableTicketTypes[0];
    }
    if (rawType.includes('acc')) {
      return availableTicketTypes.find((tt) => tt.tagPrefix === 'ACC') || availableTicketTypes[0];
    }
    if (rawType.includes('info')) {
      return availableTicketTypes.find((tt) => tt.tagPrefix === 'INFO') || availableTicketTypes[0];
    }
    if (rawType.includes('inc') || rawType.includes('fault')) {
      return availableTicketTypes.find((tt) => tt.tagPrefix === 'INC' || tt.tagPrefix === 'AFLT') || availableTicketTypes[0];
    }

    return availableTicketTypes[0];
  }, [selectedTicket, availableTicketTypes]);

  // Current tag code for selected ticket (e.g. BUG, INC, SR, etc.)
  const currentTicketTag = useMemo(() => {
    if (selectedTicket?.tag) return selectedTicket.tag;
    if (selectedTicket?.tagPrefix) return selectedTicket.tagPrefix;
    if (currentTicketTypeConfig?.tagPrefix) return currentTicketTypeConfig.tagPrefix;
    if (selectedTicket?.ticketId) {
      return selectedTicket.ticketId.split(/[-#]/)[0];
    }
    return 'INC';
  }, [selectedTicket?.tag, selectedTicket?.tagPrefix, selectedTicket?.ticketId, currentTicketTypeConfig]);

  // Complete list of selectable workflows for workflow dropdown
  const allSelectableWorkflows = useMemo(() => {
    const set = new Set<string>();

    if (selectedTicket?.workflow) set.add(selectedTicket.workflow);
    if (currentTicketTypeConfig?.defaultWorkflow) set.add(currentTicketTypeConfig.defaultWorkflow);
    if (currentTicketTypeConfig?.workflow) set.add(currentTicketTypeConfig.workflow);
    if (Array.isArray(currentTicketTypeConfig?.workflows)) {
      currentTicketTypeConfig.workflows.forEach((w) => w && set.add(w));
    }
    if (Array.isArray(workflowsForCurrentTicket)) {
      workflowsForCurrentTicket.forEach((w) => w && set.add(w));
    }
    if (Array.isArray(storeExtendedWorkflows)) {
      storeExtendedWorkflows.forEach((ew) => ew?.name && set.add(ew.name));
    }
    if (Array.isArray(workflows)) {
      workflows.forEach((w: any) => {
        const name = w.name || w.workflowName;
        if (name) set.add(name);
      });
    }

    const SYSTEM_WORKFLOWS = [
      'Software Defect Engineering Lifecycle',
      'Product Feature Roadmap Lifecycle',
      'Software Enhancement Workflow',
      'Software Feature Task Lifecycle',
      'Software Production Deployment Lifecycle',
      'Support Fault Lifecycle Workflow',
      'Service Request Fulfillment Workflow',
      'Support Change Request Workflow',
      'Access Request Security Workflow',
      'Information Enquiry Workflow',
      'Technical Incident Deep-Dive Workflow',
      'Technical Hardware Fault Lifecycle',
      'Network Infrastructure Lifecycle',
      'Technical Service Fulfillment Workflow',
      'Technical Infrastructure Change Workflow',
      'HR Policy & General Enquiry Workflow',
      'Employee Leave Request Workflow',
      'Employee Onboarding Lifecycle',
      'Employee Offboarding & Asset Recovery Workflow',
      'Supplier SLA & Contract Issue Lifecycle',
      'Warranty Claim Lifecycle',
      'Hardware Replacement Supplier Lifecycle',
      'Return Merchandise Authorization (RMA) Workflow',
      'Executive Approval Matrix Lifecycle',
      'Major Incident Emergency Response Workflow',
      'Budget & Capital Expenditure Lifecycle',
    ];
    SYSTEM_WORKFLOWS.forEach((sw) => set.add(sw));

    return Array.from(set);
  }, [selectedTicket?.workflow, currentTicketTypeConfig, workflowsForCurrentTicket, storeExtendedWorkflows, workflows]);

  // Handle switching ticket type (automatically changes type, tag, ticketId prefix, and default workflow)
  const handleTicketTypeSelect = async (newVal: string) => {
    if (!selectedTicket) return;
    const targetType = availableTicketTypes.find(
      (tt) => tt.value === newVal || tt.label.toLowerCase() === newVal.toLowerCase()
    );
    if (!targetType) return;

    const newTypeName = targetType.label;
    const newTag = targetType.tagPrefix || 'INC';
    const newWorkflow = targetType.defaultWorkflow || targetType.workflow || `${newTypeName} Lifecycle`;
    const newTeamName = targetType.teamName || selectedTicket.teamName || 'Support Team';
    const newTeamKey = targetType.teamKey || selectedTicket.teamKey || 'support';

    // Compute updated ticketId with new tag prefix (e.g. SR#000008 -> BUG#000008)
    const currentNum = String(selectedTicket.ticketNumber || selectedTicket.ticketId || selectedTicket.id || '');
    const digitsMatch = currentNum.match(/(\d+)$/);
    const numPart = digitsMatch ? digitsMatch[1] : String(selectedTicket.id).padStart(6, '0');
    const delimiter = currentNum.includes('#') ? '#' : (currentNum.includes('-') ? '-' : '#');
    const newTicketId = `${newTag}${delimiter}${numPart}`;

    const prevType = selectedTicket.type || 'Unknown';
    const prevTag = currentTicketTag;

    const resolvedTypeId = targetType.id || (ticketTypes as any)?.find(
      (tt: any) => (tt.code && String(tt.code).toLowerCase() === targetType.code?.toLowerCase()) ||
        (tt.name && String(tt.name).toLowerCase() === targetType.label.toLowerCase()) ||
        (tt.tag && String(tt.tag).toLowerCase() === targetType.tagPrefix?.toLowerCase())
    )?.id;

    const patchPayload: Partial<Ticket> = {
      type: newTypeName,
      ticketTypeId: resolvedTypeId != null ? String(resolvedTypeId) : targetType.id,
      ticketId: newTicketId,
      ticketNumber: newTicketId,
      tag: newTag,
      tagCode: newTag,
      tagPrefix: newTag,
      tags: [newTag],
      workflow: newWorkflow,
      teamName: newTeamName,
      teamKey: newTeamKey,
    };

    setSelectedTicket({
      ...selectedTicket,
      ...patchPayload,
    });

    addHistory(
      selectedTicket.id,
      `Staff changed ticket type from "${prevType}" (Tag: ${prevTag}) to "${newTypeName}" (Tag: ${newTag}, Workflow: "${newWorkflow}")`,
      true,
      undefined,
      'Type Changed',
      `${currentUserName} (You)`
    );

    try {
      await updateTicket(selectedTicket.id, patchPayload);
      toast.success(`Ticket type changed to ${newTypeName} [${newTicketId}]`);
    } catch (err) {
      console.error('Failed to persist ticket type update:', err);
    }
  };

  // Handle switching workflow for current ticket
  const handleWorkflowSelect = async (newWf: string) => {
    if (!selectedTicket || !newWf || newWf === selectedTicket.workflow) return;
    const prevWf = selectedTicket.workflow || 'None';

    const patchPayload: Partial<Ticket> = {
      workflow: newWf,
    };

    setSelectedTicket({
      ...selectedTicket,
      ...patchPayload,
    });

    addHistory(
      selectedTicket.id,
      `Staff changed workflow from "${prevWf}" to "${newWf}"`,
      true,
      undefined,
      'Workflow Changed',
      `${currentUserName} (You)`
    );

    try {
      await updateTicket(selectedTicket.id, patchPayload);
      toast.success(`Workflow changed to "${newWf}"`);
    } catch (err) {
      console.error('Failed to persist workflow update:', err);
    }
  };

  const [selectedRowIds, setSelectedRowIds] = useState<Set<string | number>>(new Set());
  const [followedTickets, setFollowedTickets] = useState<Set<string | number>>(new Set());

  const toggleFollowTicket = (ticketId: string | number, e?: React.MouseEvent) => {
    if (e) e.stopPropagation();
    const isNowFollowing = !followedTickets.has(ticketId);
    setFollowedTickets(prev => {
      const next = new Set(prev);
      if (next.has(ticketId)) {
        next.delete(ticketId);
      } else {
        next.add(ticketId);
      }
      return next;
    });

    if (selectedTicket && (String(selectedTicket.id) === String(ticketId) || selectedTicket.ticketId === ticketId)) {
      const noteText = isNowFollowing
        ? `Staff is now following updates for ticket [${selectedTicket.ticketId}].`
        : `Staff unfollowed updates for ticket [${selectedTicket.ticketId}].`;
      const actionName = isNowFollowing ? 'Follow Ticket' : 'Unfollow Ticket';
      const newHistoryEntry: TicketHistoryItem = {
        id: Date.now(),
        ticketId: Number(selectedTicket.id) || 0,
        actionType: actionName,
        note: noteText,
        internal: true,
        createdAt: new Date().toISOString(),
        changedByName: `${currentUserName} (You)`,
      };

      setSelectedTicket(prev => {
        if (!prev) return null;
        return {
          ...prev,
          history: [newHistoryEntry, ...(prev.history || [])],
          updatedAt: new Date().toISOString(),
        };
      });

      addHistory(selectedTicket.id, noteText, true, undefined, actionName, `${currentUserName} (You)`);
    }

    toast.success(isNowFollowing ? 'Now following ticket updates' : 'Unfollowed ticket updates');
  };

  // Helper to map state names to ticket status enum values
  const mapToTicketStatus = (toState: string = 'in-progress'): string => {
    const cat = normalizeStateCategory(toState);
    if (cat === 'new') return 'new';
    if (cat === 'inprogress') return 'in-progress';
    if (cat === 'withuser') return 'with-user';
    if (cat === 'awaitingapproval') return 'awaiting-approval';
    if (cat === 'withsupplier') return 'with-supplier';
    if (cat === 'knownerror') return 'known-error';
    if (cat === 'scheduled') return 'scheduled';
    if (cat === 'implemented') return 'implemented';
    if (cat === 'resolved') return 'resolved';
    if (cat === 'closed') return 'closed';
    return toState.toLowerCase().replace(/[^a-z0-9]+/g, '-');
  };

  // INLINE COMPOSER STATE (MATCHING SCREENSHOTS)
  const [inlineComposerType, setInlineComposerType] = useState<string | null>(null);
  const [composerActionLabel, setComposerActionLabel] = useState<string>('Note (+Email)');
  const [activeBackendAction, setActiveBackendAction] = useState<any | null>(null);
  const [notifyRequester, setNotifyRequester] = useState<boolean>(true);
  const [notifyAssignee, setNotifyAssignee] = useState<boolean>(true);
  const [notifyTeam, setNotifyTeam] = useState<boolean>(false);
  const [isMailMode, setIsMailMode] = useState<boolean>(false);
  const [isStrictNoteOnly, setIsStrictNoteOnly] = useState<boolean>(false);
  const [toEmails, setToEmails] = useState<string[]>([]);
  const [toInput, setToInput] = useState<string>('');
  const [showFrom, setShowFrom] = useState<boolean>(false);
  const [showCc, setShowCc] = useState<boolean>(false);
  const [ccEmails, setCcEmails] = useState<string[]>([]);
  const [ccInput, setCcInput] = useState<string>('');
  const [showBcc, setShowBcc] = useState<boolean>(false);
  const [bccEmails, setBccEmails] = useState<string[]>([]);
  const [bccInput, setBccInput] = useState<string>('');
  const [replyDirectlyToMe, setReplyDirectlyToMe] = useState<boolean>(false);
  const [showThreeDotMenu, setShowThreeDotMenu] = useState<boolean>(false);
  const [isComposerUrgent, setIsComposerUrgent] = useState<boolean>(false);
  const [appointmentDateTime, setAppointmentDateTime] = useState<string>('');
  const [childTicketSubject, setChildTicketSubject] = useState<string>('');
  const [showMoreActionsMenu, setShowMoreActionsMenu] = useState<boolean>(false);
  const [composerAvatarImgError, setComposerAvatarImgError] = useState<boolean>(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState<boolean>(false);
  const composerTextareaRef = useRef<HTMLTextAreaElement>(null);

  const handleEmojiSelect = (emojiData: EmojiClickData) => {
    const emoji = emojiData.emoji;
    const textarea = composerTextareaRef.current;
    if (textarea) {
      const start = textarea.selectionStart ?? inlineComposerData.content.length;
      const end = textarea.selectionEnd ?? inlineComposerData.content.length;
      const current = inlineComposerData.content;
      const updated = current.substring(0, start) + emoji + current.substring(end);
      setInlineComposerData((prev) => ({ ...prev, content: updated }));
      setTimeout(() => {
        textarea.focus();
        textarea.setSelectionRange(start + emoji.length, start + emoji.length);
      }, 0);
    } else {
      setInlineComposerData((prev) => ({
        ...prev,
        content: prev.content + emoji,
      }));
    }
  };

  const [showHeadingMenu, setShowHeadingMenu] = useState<boolean>(false);
  const [isComposerFullscreen, setIsComposerFullscreen] = useState<boolean>(false);
  const [isComposerPreviewMode, setIsComposerPreviewMode] = useState<boolean>(false);

  // Markdown and rich text formatting engine for composer
  const applyTextFormat = (formatType: 'bold' | 'italic' | 'quote' | 'bullet' | 'number' | 'code' | 'link' | 'h1' | 'h2' | 'h3' | 'normal') => {
    const textarea = composerTextareaRef.current;
    if (!textarea) return;

    const start = textarea.selectionStart ?? 0;
    const end = textarea.selectionEnd ?? 0;
    const text = inlineComposerData.content;
    const selected = text.substring(start, end);

    const before = text.substring(0, start);
    const after = text.substring(end);
    let replacement = '';
    let newCursorStart = start;
    let newCursorEnd = end;

    switch (formatType) {
      case 'bold': {
        if (selected) {
          if (selected.startsWith('**') && selected.endsWith('**') && selected.length >= 4) {
            replacement = selected.slice(2, -2);
            newCursorStart = start;
            newCursorEnd = start + replacement.length;
          } else {
            replacement = `**${selected}**`;
            newCursorStart = start + 2;
            newCursorEnd = start + 2 + selected.length;
          }
        } else {
          replacement = '**bold text**';
          newCursorStart = start + 2;
          newCursorEnd = start + 11;
        }
        break;
      }
      case 'italic': {
        if (selected) {
          if (selected.startsWith('*') && selected.endsWith('*') && selected.length >= 2 && !selected.startsWith('**')) {
            replacement = selected.slice(1, -1);
            newCursorStart = start;
            newCursorEnd = start + replacement.length;
          } else {
            replacement = `*${selected}*`;
            newCursorStart = start + 1;
            newCursorEnd = start + 1 + selected.length;
          }
        } else {
          replacement = '*italic text*';
          newCursorStart = start + 1;
          newCursorEnd = start + 12;
        }
        break;
      }
      case 'quote': {
        const target = selected || 'Quote text';
        const lines = target.split('\n');
        const quotedLines = lines.map((l) => (l.startsWith('> ') ? l : `> ${l}`)).join('\n');
        const prefix = before.length > 0 && !before.endsWith('\n') ? '\n' : '';
        replacement = `${prefix}${quotedLines}\n`;
        newCursorStart = start + prefix.length + 2;
        newCursorEnd = start + replacement.length - 1;
        break;
      }
      case 'bullet': {
        const target = selected || 'List item';
        const lines = target.split('\n');
        const bulletLines = lines.map((l) => (l.startsWith('- ') ? l : `- ${l}`)).join('\n');
        const prefix = before.length > 0 && !before.endsWith('\n') ? '\n' : '';
        replacement = `${prefix}${bulletLines}\n`;
        newCursorStart = start + prefix.length + 2;
        newCursorEnd = start + replacement.length;
        break;
      }
      case 'number': {
        const target = selected || 'List item';
        const lines = target.split('\n');
        const numberedLines = lines.map((l, idx) => (/^\d+\.\s/.test(l) ? l : `${idx + 1}. ${l}`)).join('\n');
        const prefix = before.length > 0 && !before.endsWith('\n') ? '\n' : '';
        replacement = `${prefix}${numberedLines}\n`;
        newCursorStart = start + prefix.length + 3;
        newCursorEnd = start + replacement.length;
        break;
      }
      case 'code': {
        if (selected.includes('\n')) {
          replacement = `\n\`\`\`\n${selected || 'code here'}\n\`\`\`\n`;
          newCursorStart = start + 5;
          newCursorEnd = start + 5 + (selected || 'code here').length;
        } else {
          replacement = `\`${selected || 'code'}\``;
          newCursorStart = start + 1;
          newCursorEnd = start + 1 + (selected || 'code').length;
        }
        break;
      }
      case 'link': {
        const url = prompt('Enter URL:', 'https://') || 'https://';
        if (selected) {
          replacement = `[${selected}](${url})`;
          newCursorStart = start;
          newCursorEnd = start + replacement.length;
        } else {
          replacement = `[Link text](${url})`;
          newCursorStart = start + 1;
          newCursorEnd = start + 10;
        }
        break;
      }
      case 'h1': {
        const target = selected || 'Heading 1';
        const prefix = before.length > 0 && !before.endsWith('\n') ? '\n' : '';
        replacement = `${prefix}# ${target.replace(/^#+\s*/, '')}\n`;
        newCursorStart = start + prefix.length + 2;
        newCursorEnd = start + replacement.length - 1;
        break;
      }
      case 'h2': {
        const target = selected || 'Heading 2';
        const prefix = before.length > 0 && !before.endsWith('\n') ? '\n' : '';
        replacement = `${prefix}## ${target.replace(/^#+\s*/, '')}\n`;
        newCursorStart = start + prefix.length + 3;
        newCursorEnd = start + replacement.length - 1;
        break;
      }
      case 'h3': {
        const target = selected || 'Heading 3';
        const prefix = before.length > 0 && !before.endsWith('\n') ? '\n' : '';
        replacement = `${prefix}### ${target.replace(/^#+\s*/, '')}\n`;
        newCursorStart = start + prefix.length + 4;
        newCursorEnd = start + replacement.length - 1;
        break;
      }
      case 'normal': {
        const target = selected.replace(/^#+\s*|^>\s*|^[-*]\s*|^\d+\.\s*/gm, '');
        replacement = target;
        newCursorStart = start;
        newCursorEnd = start + replacement.length;
        break;
      }
    }

    const updated = before + replacement + after;
    setInlineComposerData((prev) => ({ ...prev, content: updated }));

    setTimeout(() => {
      textarea.focus();
      textarea.setSelectionRange(newCursorStart, newCursorEnd);
    }, 0);
  };

  const renderCurrentUserAvatar = (sizeClass: string = "size-9", textClass: string = "text-sm") => {
    const isGoogleSso = Boolean(
      user?.avatar &&
      (user.avatar.includes('googleusercontent.com') ||
        (!user.avatar.includes('ui-avatars.com') && (user.avatar.startsWith('http://') || user.avatar.startsWith('https://') || user.avatar.startsWith('data:') || user.avatar.startsWith('/'))))
    );

    const initialLetter = (currentUserName?.trim()[0] || user?.email?.trim()[0] || 'U').toUpperCase();

    return (
      <div className={cn("relative flex shrink-0 items-center justify-center rounded-full select-none", sizeClass)}>
        {isGoogleSso && !composerAvatarImgError ? (
          <img
            src={user?.avatar}
            alt={currentUserName}
            className={cn("rounded-full object-cover ring-1 ring-border shadow-xs", sizeClass)}
            onError={() => setComposerAvatarImgError(true)}
          />
        ) : (
          <div className={cn(
            "flex size-full items-center justify-center rounded-full bg-primary/10 text-primary font-semibold border border-primary/20 shadow-xs",
            textClass
          )}>
            {initialLetter}
          </div>
        )}
      </div>
    );
  };

  const [inlineComposerData, setInlineComposerData] = useState({
    to: '',
    cc: '',
    subject: '',
    content: '',
    status: 'in-progress',
    team: 'Support Team',
    staff: currentUserName,
    timeHours: '00',
    timeMinutes: '00',
    nextUpdate: '',
    issue: 'Appearance',
    issueDetail: 'Appearance > Cleanliness',
    currentAction: '',
    faultsNextAction: 'Awaiting User Response',
    assets: [] as string[],
  });

  const [composerAttachments, setComposerAttachments] = useState<UploadedFileItem[]>([]);
  const [emailPreviewData, setEmailPreviewData] = useState<{
    isOpen: boolean;
    activeTab: 'details' | 'email';
    actionLabel: string;
    topicAction?: string;
    from: string;
    to: string;
    cc: string;
    bcc: string;
    replyTo?: string;
    subject: string;
    body: string;
    status: string;
    staff: string;
    team: string;
    timeHours: string;
    timeMinutes: string;
    nextUpdate: string;
    issue: string;
    issueDetail: string;
    currentAction: string;
    assets: string[];
    attachments: UploadedFileItem[];
  } | null>(null);
  const [isSendingEmail, setIsSendingEmail] = useState(false);

  const renderedEmailPreviewHtml = useMemo(() => {
    if (!emailPreviewData?.isOpen || !selectedTicket) return '';

    const rawSubject = emailPreviewData.subject || selectedTicket.subject || 'Support Ticket';
    const cleanSubj = rawSubject
      .replace(/\s*\[(?:STD|TB|INC|REQ|CHG|[A-Z]+)#[a-z0-9_ -]+\]/gi, '')
      .replace(/^re:\s*/i, '')
      .trim() || 'Support Ticket';

    const clientName = selectedTicket.requesterName || selectedTicket.client || 'Customer';
    const currentAction = emailPreviewData.currentAction || selectedTicket.status || 'In-progress';
    const nextAction = emailPreviewData.topicAction === 'Acknowledgement'
      ? 'Escalate to Supplier'
      : (emailPreviewData.topicAction || 'Review and Resolve');

    return renderEmailCard(null, {
      ticketId: selectedTicket.ticketId || 'TB#01752',
      subject: cleanSubj,
      clientName,
      status: selectedTicket.status || 'In-progress',
      currentAction,
      nextAction,
      priority: selectedTicket.priority || 'Medium',
      body: emailPreviewData.body || '',
      agentName: emailPreviewData.staff || currentUserName || 'Team One',
      teamName: emailPreviewData.team || selectedTicket.teamName || 'Support Team',
      fromEmail: activeSupportSender.isConfigured ? activeSupportSender.email : '',
      from: activeSupportSender.isConfigured ? activeSupportSender.displayFrom : '',
      senderName: activeSupportSender.isConfigured ? activeSupportSender.displayName : 'Support Team',
      ticketLink: typeof window !== 'undefined' ? `${window.location.origin}/support/tickets/${encodeURIComponent(selectedTicket.ticketId || '')}` : '',
    });
  }, [emailPreviewData, selectedTicket, activeSupportSender, currentUserName]);
  const [isDraggingOverComposer, setIsDraggingOverComposer] = useState(false);
  const composerFileInputRef = useRef<HTMLInputElement>(null);
  const composerImageInputRef = useRef<HTMLInputElement>(null);
  const composerVideoInputRef = useRef<HTMLInputElement>(null);
  const composerContainerRef = useRef<HTMLDivElement>(null);

  // OPEN COMPOSER FOR ANY WORKFLOW / TOOLBAR ACTION
  const openComposerForAction = (actionName: string, t: Ticket, backendAct?: any) => {
    // If clicking same action while composer is already open, toggle it closed
    if (inlineComposerType && composerActionLabel?.toLowerCase() === actionName.toLowerCase()) {
      setInlineComposerType(null);
      setActiveBackendAction(null);
      return;
    }

    setSelectedTicket(t);
    setComposerActionLabel(actionName);
    setActiveBackendAction(backendAct || null);
    setShowMoreActionsMenu(false);
    setShowThreeDotMenu(false);

    const requester = t.requesterEmail || (t.client && t.client.includes('@') ? t.client : '');
    const supplier = t.supplierEmail || t.vendorEmail || ((t as any).supplier && typeof (t as any).supplier === 'string' && (t as any).supplier.includes('@') ? (t as any).supplier : '');
    const cleanSubj = (t.subject || '').replace(/\s*\[TB#\d+\]|\s*\[[A-Z0-9#_-]+\]/gi, '').replace(/^re:\s*/i, '').trim();
    const subjectPrefix = `${cleanSubj} [${t.ticketId}]`;

    // Note editor only for internal note, and private note
    const isNoteOnly = actionName === 'Internal Note' || actionName === 'Private Note';
    setIsStrictNoteOnly(isNoteOnly);

    // Initial mail active state:
    // Mail active by default for outbound email actions, or user can toggle
    const startsWithMail = ['Send Acknowledgement', 'Email User', 'Email Supplier', 'Note (+Email)'].includes(actionName) || (backendAct as any)?.sendEmail;
    setIsMailMode(!isNoteOnly && Boolean(startsWithMail));

    // Default notification checkboxes ("to notify them")
    setNotifyRequester(true);
    setNotifyAssignee(true);
    setNotifyTeam(false);

    // Set recipient chips
    if (actionName === 'Email Supplier' || actionName === 'Log to Supplier') {
      setToEmails(supplier ? [supplier] : []);
    } else {
      setToEmails(requester ? [requester] : []);
    }
    setToInput('');
    setCcEmails([]);
    setCcInput('');
    setBccEmails([]);
    setBccInput('');
    setShowFrom(false);
    setShowCc(false);
    setShowBcc(false);
    setReplyDirectlyToMe(false);

    let targetStatus = backendAct?.toStateName || (backendAct as any)?.statusAfterAction || t.status;
    if (actionName === 'Close') targetStatus = 'closed';
    else if (actionName === 'Mark as Hold') targetStatus = 'on-hold';
    else if (actionName === 'Log to Supplier' || actionName === 'Email Supplier') targetStatus = 'with-supplier';
    else if (t.status === 'new' && !backendAct) targetStatus = 'in-progress';

    let initialContent = '';
    const actLower = actionName.toLowerCase();
    if (actLower.includes('review') && actLower.includes('submit')) {
      initialContent = 'Submitted for code review.\nPR Link / Details: ';
    } else if (actLower.includes('reject')) {
      initialContent = 'Changes requested before approval:\n- ';
    } else if (actLower.includes('approve')) {
      initialContent = 'Approved code review. Ready for next phase.';
    } else if (actLower.includes('testing') && actLower.includes('send')) {
      initialContent = 'Deployment ready for testing.\nTest Instructions / URL: ';
    } else if (actLower.includes('testing') && actLower.includes('fail')) {
      initialContent = 'Testing failed.\nIssues encountered:\n- ';
    } else if (actLower.includes('testing') && actLower.includes('pass')) {
      initialContent = 'Testing passed successfully. Verification notes: ';
    } else if (actLower.includes('start dev')) {
      initialContent = 'Starting development on this defect/feature.';
    }

    const existingTeam = (storeQueues || []).find((q: any) =>
      q.label === t.teamName || q.name === t.teamName || q.key === t.teamKey
    );
    const defaultTeam = backendAct?.targetTeamName || existingTeam?.label || t.teamName || storeQueues[0]?.label || 'Support Team';

    setInlineComposerData({
      to: requester,
      cc: '',
      subject: subjectPrefix,
      content: initialContent,
      status: targetStatus,
      team: defaultTeam,
      staff: t.assigneeName || currentUserName,
      timeHours: '00',
      timeMinutes: '00',
      nextUpdate: '',
      issue: 'Appearance',
      issueDetail: 'Appearance > Cleanliness',
      currentAction: actionName,
      faultsNextAction: 'Awaiting User Response',
      assets: [t.assetTag, t.assetDetails?.tag, t.asset?.asset_code].filter(Boolean) as string[],
    });

    setInlineComposerType(actionName);
    setTimeout(() => {
      composerContainerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 80);
  };

  // Resolve active workflow for selected ticket from storeExtendedWorkflows
  const activeWorkflow = useMemo<ExtendedWorkflow | null>(() => {
    if (!selectedTicket) return null;
    const tWfId = String(selectedTicket.workflowId || (selectedTicket as any).workflow_id || '').trim();
    const tWfName = String(selectedTicket.workflowName || (selectedTicket as any).workflow_name || selectedTicket.workflow || '').trim().toLowerCase();
    const rawType = String(selectedTicket.type || '').trim().toLowerCase();
    const typeName = String((selectedTicket as any).ticketTypeName || (selectedTicket as any).ticket_type_name || currentTicketTypeConfig?.label || (currentTicketTypeConfig as any)?.name || '').trim().toLowerCase();

    // Map common slug variations to canonical names (e.g. sd-incident -> incident, sw-bug -> bug, sd-request -> service request)
    const normType = (rawType.replace(/^sd-|^sw-|^req-/, '') || rawType).replace(/[-_]/g, ' ');

    if (storeExtendedWorkflows && storeExtendedWorkflows.length > 0) {
      // 1. By direct workflow ID (database ID or code)
      if (tWfId) {
        const matchId = storeExtendedWorkflows.find(
          (w) => String(w.id ?? '').toLowerCase() === tWfId.toLowerCase() || String((w as any).dbId ?? '') === tWfId
        );
        if (matchId) return matchId;
      }

      // 2. By workflow name / code
      if (tWfName && tWfName !== 'support fault workflow v1') {
        const matchName = storeExtendedWorkflows.find(
          (w) =>
            String(w.name || '').toLowerCase() === tWfName ||
            String(w.code || '').toLowerCase() === tWfName ||
            String(w.name || '').toLowerCase().includes(tWfName) ||
            tWfName.includes(String(w.name || '').toLowerCase())
        );
        if (matchName) return matchName;
      }

      // 3. By ticket type name or type slug
      const targets = Array.from(new Set([rawType, normType, typeName].filter(Boolean)));
      const matchType = storeExtendedWorkflows.find((w) => {
        const wfType = String(w.ticketType || '').toLowerCase();
        const wfName = String(w.name || '').toLowerCase();
        const allowed = Array.isArray(w.allowedTicketTypes)
          ? w.allowedTicketTypes.map((att) => String(att).toLowerCase())
          : [];

        return targets.some((t) => {
          if (wfType === t || wfType.includes(t) || t.includes(wfType)) return true;
          if (wfName.includes(t) || t.includes(wfName)) return true;
          return allowed.some((att) => att === t || att.includes(t) || t.includes(att));
        });
      });
      if (matchType) return matchType;

      // 4. Fallback to default workflow
      return storeExtendedWorkflows.find((w) => w.isDefault) || storeExtendedWorkflows[0];
    }

    return null;
  }, [selectedTicket, storeExtendedWorkflows, currentTicketTypeConfig]);

  // Current step actions from active workflow for current ticket status
  const activeWorkflowStepActions = useMemo<WorkflowStepAction[]>(() => {
    if (!activeWorkflow || !activeWorkflow.steps || !selectedTicket) return [];
    const currentStatus = String(selectedTicket.status || '').trim().toLowerCase();
    const currentStatusSlug = currentStatus.replace(/[^a-z0-9]/g, '');
    const stateName = String((selectedTicket as any).stateName || (selectedTicket as any).state_name || '').trim().toLowerCase();
    const stateNameSlug = stateName.replace(/[^a-z0-9]/g, '');
    const targetStateId = String(selectedTicket.workflowStateId || (selectedTicket as any).state_id || (selectedTicket as any).currentStageId || '');

    // Phase 1: Exact DB stage ID match
    let step = activeWorkflow.steps.find((s) => {
      const stepIdStr = String(s.id ?? '');
      return targetStateId && stepIdStr && stepIdStr === targetStateId;
    });

    // Phase 2: Exact stage name or status slug match
    if (!step) {
      step = activeWorkflow.steps.find((s) => {
        const stepName = String(s.name || '').trim().toLowerCase();
        const stepNameSlug = stepName.replace(/[^a-z0-9]/g, '');
        return (
          stepName === currentStatus ||
          (stateName && stepName === stateName) ||
          (stepNameSlug && stepNameSlug === currentStatusSlug) ||
          (stateNameSlug && stepNameSlug === stateNameSlug)
        );
      });
    }

    // Phase 3: Keyword / synonym / category fallback
    if (!step) {
      step = activeWorkflow.steps.find((s) => {
        const stepName = String(s.name || '').trim().toLowerCase();
        if (stepName.includes(currentStatus) || currentStatus.includes(stepName)) return true;
        if (stateName && (stepName.includes(stateName) || stateName.includes(stepName))) return true;
        if ((currentStatus.includes('supplier') || stateName.includes('supplier')) && stepName.includes('supplier')) return true;
        if ((currentStatus.includes('hold') || stateName.includes('hold')) && (stepName.includes('hold') || stepName.includes('pending'))) return true;
        if (currentStatus === 'new' && (s.type === 'initial' || stepName.includes('new') || stepName.includes('triage') || stepName.includes('draft'))) return true;
        if (currentStatus === 'in progress' && (s.type === 'in_progress' || stepName.includes('progress') || stepName.includes('investigation') || stepName.includes('dev'))) return true;
        if ((currentStatus === 'pending' || currentStatus === 'on hold') && (s.type === 'pending' || stepName.includes('pending') || stepName.includes('wait') || stepName.includes('hold'))) return true;
        if ((currentStatus === 'resolved' || currentStatus === 'fulfilled' || currentStatus === 'approved') && (s.type === 'resolved' || stepName.includes('resolve') || stepName.includes('fulfilled') || stepName.includes('approved'))) return true;
        if (currentStatus === 'closed' && (s.type === 'closed' || stepName.includes('close') || stepName.includes('archived'))) return true;
        return false;
      });
    }

    if (step) return step.actions || [];
    return [];
  }, [activeWorkflow, selectedTicket?.status, (selectedTicket as any)?.workflowStateId, (selectedTicket as any)?.state_id, (selectedTicket as any)?.stateName]);

  // Dynamic Action Buttons from Settings (filtered based on workflow & ticket type)
  const settingsActionButtons = useMemo<TicketActionConfig[]>(() => {
    if (!selectedTicket || !storeTicketActions || storeTicketActions.length === 0) return [];
    const ticketTypeNorm = (selectedTicket.type || '').trim().toLowerCase();
    const wfName = String(activeWorkflow?.name || selectedTicket.workflow || '').trim().toLowerCase();
    const wfId = String(activeWorkflow?.id ?? '').trim().toLowerCase();
    const wfCode = String(activeWorkflow?.code || '').trim().toLowerCase();

    return storeTicketActions.filter((act) => {
      if (act.hideFromTicketHeader) return false;

      // Filter based on allowed workflows
      if (act.allowedWorkflows && act.allowedWorkflows.length > 0) {
        const matchesWorkflow = act.allowedWorkflows.some((w) => {
          const wNorm = w.trim().toLowerCase();
          return (
            wNorm === '*' ||
            wNorm === 'all' ||
            wNorm === '' ||
            wNorm === wfName ||
            wNorm === wfId ||
            wNorm === wfCode ||
            (wfName && (wfName.includes(wNorm) || wNorm.includes(wfName)))
          );
        });
        if (!matchesWorkflow) return false;
      }

      // Filter based on allowed ticket types
      if (act.allowedTicketTypes && act.allowedTicketTypes.length > 0) {
        const matchesType = act.allowedTicketTypes.some((t) => {
          const tNorm = t.trim().toLowerCase();
          return (
            tNorm === '*' ||
            tNorm === 'all' ||
            tNorm === '' ||
            tNorm === ticketTypeNorm ||
            (ticketTypeNorm && (ticketTypeNorm.includes(tNorm) || tNorm.includes(ticketTypeNorm)))
          );
        });
        if (!matchesType) return false;
      }

      return true;
    });
  }, [selectedTicket?.type, selectedTicket?.workflow, activeWorkflow, storeTicketActions]);

  // Partition actions into header quick actions and More Actions dropdown
  // All applicable actions for the current ticket (workflow transitions or configured step actions)
  const { stageTransitionActions, globalUtilityActions, allTicketActions } = useMemo(() => {
    if (!selectedTicket) return { stageTransitionActions: [], globalUtilityActions: [], allTicketActions: [] };

    const seenCodes = new Set<string>();
    const seenLabels = new Set<string>();
    const stageTransitionActions: any[] = [];
    const globalUtilityActions: any[] = [];

    // Separate backend actions into stage transitions and global actions
    const backendTransitions = (availableActions || []).filter(
      (a: any) => !a.isGlobal || a.kind === 'transition' || Boolean(a.toStageName || a.toStageId || a.toStateName || a.toStateId)
    );
    const backendGlobals = (availableActions || []).filter(
      (a: any) => Boolean(a.isGlobal) && a.kind !== 'transition' && !a.toStageName && !a.toStageId
    );

    // 1. Map backend stage transitions (from support.workflow_transitions)
    for (const act of backendTransitions) {
      const actionCode = String(act.actionCode || act.code || act.actionId || act.id || '').trim().toUpperCase();
      const label = String(act.actionName || act.label || act.name || act.actionCode || act.code || '').trim();
      const normLabel = label.toLowerCase().replace(/\s+/g, ' ');

      if (actionCode && seenCodes.has(actionCode)) continue;
      if (normLabel && seenLabels.has(normLabel)) continue;

      if (actionCode) seenCodes.add(actionCode);
      if (normLabel) seenLabels.add(normLabel);

      // Check if activeWorkflowStepActions has any custom styling or name for this action
      const matchingStepAction = activeWorkflowStepActions.find((sa) => {
        const saCode = String(sa.actionCode || sa.id || '').toUpperCase();
        const saName = String(sa.buttonName || sa.name || '').toLowerCase();
        return (saCode && saCode === actionCode) || saName === normLabel || normLabel.includes(saName) || saName.includes(normLabel);
      });

      const effectiveName = matchingStepAction?.buttonName || act.actionName || act.label || act.name || act.actionCode || act.code;
      const effectiveStyle = matchingStepAction?.buttonStyle || act.buttonStyle || act.style || 'secondary';

      stageTransitionActions.push({
        id: String(act.actionId || act.id || actionCode),
        actionId: act.actionId || act.id,
        actionCode: act.actionCode || act.code || actionCode,
        buttonName: effectiveName,
        name: effectiveName,
        icon: act.icon || matchingStepAction?.buttonName || effectiveName,
        buttonStyle: effectiveStyle as any,
        style: effectiveStyle,
        systemUse: act.actionCode || act.code,
        behavior: act.behavior,
        kind: 'transition',
        statusAfterAction: act.toStageName || act.toStateName || matchingStepAction?.targetStepName || '',
        targetStepName: act.toStageName || act.toStateName || matchingStepAction?.targetStepName || '',
        targetStepId: act.toStageId || act.toStateId || matchingStepAction?.targetStepId || '',
        toStageCategory: act.toStageCategory,
        toStageColor: act.toStageColor,
        requiresNote: Boolean(act.requiresNote || act.requiresComment || act.requiresReason || matchingStepAction?.requiresNote),
        requiresComment: Boolean(act.requiresNote || act.requiresComment),
        requiresReason: Boolean(act.requiresReason),
        requiresConfirm: Boolean(act.requiresConfirm),
        requiresApprover: Boolean(act.requiresApprover || matchingStepAction?.requiresApproval),
        requiredFields: act.requiredFields || [],
        fieldEffects: act.fieldEffects || {},
        isQuick: true,
        isQuickAction: true,
        isGlobal: false,
        isBackendAction: true,
        isWorkflowStepAction: true,
        actionGroup: 'Workflow Transitions',
      });
    }

    // 2. Also merge configured step actions from Support Settings (WorkflowsView table)
    for (const sa of activeWorkflowStepActions) {
      const saCode = String(sa.actionCode || sa.id || '').toUpperCase();
      const label = String(sa.buttonName || sa.name || '').trim();
      const normLabel = label.toLowerCase().replace(/\s+/g, ' ');

      if (saCode && seenCodes.has(saCode)) continue;
      if (normLabel && seenLabels.has(normLabel)) continue;

      if (saCode) seenCodes.add(saCode);
      if (normLabel) seenLabels.add(normLabel);

      const resolvedStyle = sa.buttonStyle || 'secondary';

      stageTransitionActions.push({
        id: String(sa.id || saCode || `sa-${normLabel}`),
        actionId: sa.id || saCode,
        actionCode: saCode || sa.id,
        buttonName: sa.buttonName || sa.name || 'Action',
        name: sa.buttonName || sa.name || 'Action',
        icon: sa.buttonName || sa.name,
        buttonStyle: resolvedStyle as any,
        style: resolvedStyle,
        systemUse: saCode || sa.buttonName || 'Workflow Step Action',
        behavior: 'transition',
        kind: 'transition',
        statusAfterAction: sa.targetStepName || '',
        targetStepName: sa.targetStepName || '',
        targetStepId: sa.targetStepId || '',
        toStageCategory: '',
        toStageColor: '',
        requiresNote: Boolean(sa.requiresNote),
        requiresComment: Boolean(sa.requiresNote),
        requiresReason: false,
        requiresConfirm: false,
        requiresApprover: Boolean(sa.requiresApproval),
        requiredFields: [],
        fieldEffects: {},
        isQuick: true,
        isQuickAction: true,
        isGlobal: false,
        isBackendAction: false,
        isWorkflowStepAction: true,
        actionGroup: 'Workflow Transitions',
      });
    }

    // 3. Global Utility Actions from backend (exclude duplicates and actions with dedicated header buttons like SYNC_VAULT and FOLLOW)
    for (const act of backendGlobals) {
      const actionCode = String(act.actionCode || act.code || act.actionId || act.id || '').trim().toUpperCase();
      const label = String(act.actionName || act.label || act.name || act.actionCode || act.code || '').trim();
      const normLabel = label.toLowerCase().replace(/\s+/g, ' ');

      // Skip actions that have dedicated buttons on the top right
      if (actionCode === 'SYNC_VAULT' || actionCode === 'FOLLOW' || actionCode === 'FOLLOW_UNFOLLOW') continue;
      if (actionCode && seenCodes.has(actionCode)) continue;
      if (normLabel && seenLabels.has(normLabel)) continue;

      if (actionCode) seenCodes.add(actionCode);
      if (normLabel) seenLabels.add(normLabel);

      globalUtilityActions.push({
        id: String(act.actionId || act.id),
        actionId: act.actionId || act.id,
        actionCode: act.actionCode || act.code,
        buttonName: act.actionName || act.label || act.name || act.actionCode || act.code,
        name: act.actionName || act.label || act.name || act.actionCode || act.code,
        icon: act.icon || act.actionCode || act.code,
        buttonStyle: 'secondary',
        style: 'secondary',
        systemUse: act.actionCode || act.code,
        behavior: act.behavior,
        kind: 'global',
        statusAfterAction: '',
        targetStepName: '',
        targetStepId: '',
        toStageCategory: '',
        toStageColor: '',
        requiresNote: Boolean(act.requiresNote || act.requiresComment || act.requiresReason),
        requiresComment: Boolean(act.requiresNote || act.requiresComment),
        requiresReason: Boolean(act.requiresReason),
        requiresConfirm: Boolean(act.requiresConfirm),
        requiresApprover: false,
        requiredFields: act.requiredFields || [],
        fieldEffects: act.fieldEffects || {},
        isQuick: false,
        isQuickAction: false,
        isGlobal: true,
        isBackendAction: true,
        isWorkflowStepAction: false,
        actionGroup: 'Global Actions',
      });
    }

    // Sort stage transitions:
    // - Primary transitions first (e.g. Assign & Accept, Start Work, Resolve Ticket, Resume Work, Mark Fulfilled, Move to Dev, Approve)
    // - Secondary transitions next (Send Acknowledgement, Put on Hold, Log to Supplier, Close Ticket, Reopen Ticket)
    // - Destructive transitions (Close as Invalid, Reject, Cancel)
    const sortedTransitions = stageTransitionActions.sort((a, b) => {
      const getPriority = (item: any) => {
        const code = String(item.actionCode || item.systemUse || item.buttonName || '').toUpperCase();
        if (code === 'APPROVE' || code.includes('APPROVE')) return 0;
        if (item.buttonStyle === 'primary' || item.style === 'primary') return 1;
        if (code === 'REJECT' || code.includes('REJECT') || item.buttonStyle === 'danger' || item.buttonStyle === 'destructive' || item.style === 'danger' || item.style === 'destructive') return 3;
        return 2;
      };
      return getPriority(a) - getPriority(b);
    });

    return {
      stageTransitionActions: sortedTransitions,
      globalUtilityActions,
      allTicketActions: [...sortedTransitions, ...globalUtilityActions],
    };
  }, [availableActions, activeWorkflowStepActions, selectedTicket]);

  // Dynamic 2-line measurement for stage transition buttons:
  // Stage buttons wrap across up to 2 lines in the action bar.
  // Any overflow stage buttons or global utility actions are housed in "More Actions ▾".
  const [containerWidth, setContainerWidth] = useState<number>(0);
  const [maxVisibleActions, setMaxVisibleActions] = useState<number>(100);
  const actionsContainerRef = useRef<HTMLDivElement>(null);
  const measureRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const container = actionsContainerRef.current;
    if (!container) return;

    const measure = () => {
      const width = container.clientWidth;
      if (width <= 0) return;
      setContainerWidth(width);

      const measureEl = measureRef.current;
      if (!measureEl) return;
      measureEl.style.width = `${width}px`;

      const actionItems = Array.from(measureEl.querySelectorAll<HTMLElement>('[data-measure-action="true"]'));
      if (actionItems.length === 0) {
        setMaxVisibleActions(0);
        return;
      }

      const firstTop = actionItems[0].offsetTop;
      let line2Top: number | null = null;
      let line3Index: number | null = null;

      for (let i = 0; i < actionItems.length; i++) {
        const top = actionItems[i].offsetTop;
        if (top > firstTop + 10 && line2Top === null) {
          line2Top = top;
        } else if (line2Top !== null && top > line2Top + 10) {
          line3Index = i;
          break;
        }
      }

      if (line3Index === null) {
        // All stage transition buttons fit across Line 1 and Line 2!
        setMaxVisibleActions(stageTransitionActions.length);
      } else {
        // Buttons spill onto line 3! Reserve room on line 2 for the "More Actions ▾" dropdown button
        setMaxVisibleActions(Math.max(1, line3Index - 1));
      }
    };

    measure();

    const ro = new ResizeObserver(() => {
      measure();
    });
    ro.observe(container);

    return () => ro.disconnect();
  }, [stageTransitionActions]);

  const visibleStageActions = useMemo(() => {
    return stageTransitionActions.slice(0, maxVisibleActions);
  }, [stageTransitionActions, maxVisibleActions]);

  const overflowStageActions = useMemo(() => {
    return stageTransitionActions.slice(maxVisibleActions);
  }, [stageTransitionActions, maxVisibleActions]);

  const allMoreActions = useMemo(() => {
    return [...overflowStageActions, ...globalUtilityActions];
  }, [overflowStageActions, globalUtilityActions]);

  const visibleQuickActions = visibleStageActions;
  const overflowActions = allMoreActions;

  // Unified Action Execution for Settings Action Buttons and Workflow Transitions
  const handleExecuteUnifiedAction = async (
    item: {
      id?: string;
      name?: string;
      buttonName: string;
      systemUse?: string;
      statusAfterAction?: string;
      targetStepName?: string;
      targetStepId?: string;
      buttonStyle?: string;
      requiresNote?: boolean;
      putOnSlaHold?: boolean;
      releaseFromSlaHold?: boolean;
      sendEmail?: boolean;
    },
    e?: React.MouseEvent
  ) => {
    if (e) e.stopPropagation();
    setShowMoreActionsMenu(false);
    if (!selectedTicket) return;

    const label = item.buttonName || item.name || '';
    const lowerLabel = label.toLowerCase();
    const systemUse = item.systemUse || 'None (Standard Action)';
    const targetStatus = item.targetStepName || item.statusAfterAction;

    // Check if this is a backend-driven workflow action
    const itemActionCode = String((item as any).actionCode || item.systemUse || '').trim().toUpperCase();
    const backendAct = (availableActions || []).find((a: any) =>
      a.actionId === item.id ||
      a.id === item.id ||
      (itemActionCode && (String(a.actionCode || '').toUpperCase() === itemActionCode || String(a.code || '').toUpperCase() === itemActionCode)) ||
      a.actionName?.toLowerCase() === lowerLabel ||
      a.name?.toLowerCase() === lowerLabel ||
      a.actionCode?.toLowerCase() === lowerLabel ||
      a.code?.toLowerCase() === lowerLabel ||
      (lowerLabel.includes('start work') && (a.actionCode === 'START_WORK' || a.code === 'START_WORK')) ||
      (lowerLabel.includes('resolve') && (a.actionCode === 'RESOLVE' || a.code === 'RESOLVE')) ||
      (lowerLabel.includes('assign') && (a.actionCode === 'ASSIGN_TICKET' || a.actionCode === 'ASSIGN')) ||
      (lowerLabel.includes('hold') && (a.actionCode === 'PUT_ON_HOLD' || a.code === 'PUT_ON_HOLD')) ||
      (lowerLabel.includes('resume') && (a.actionCode === 'RESUME_WORK' || a.code === 'RESUME_WORK')) ||
      (lowerLabel.includes('invalid') && (a.actionCode === 'CLOSE_INVALID' || a.code === 'CLOSE_INVALID')) ||
      (lowerLabel.includes('close') && (a.actionCode === 'CLOSE' || a.code === 'CLOSE')) ||
      (lowerLabel.includes('reopen') && (a.actionCode === 'REOPEN' || a.code === 'REOPEN')) ||
      (lowerLabel.includes('supplier') && lowerLabel.includes('log') && (a.actionCode === 'LOG_TO_SUPPLIER' || a.code === 'LOG_TO_SUPPLIER')) ||
      (lowerLabel.includes('supplier') && lowerLabel.includes('email') && (a.actionCode === 'EMAIL_SUPPLIER' || a.code === 'EMAIL_SUPPLIER')) ||
      (lowerLabel.includes('approve') && (a.actionCode === 'APPROVE' || a.code === 'APPROVE')) ||
      (lowerLabel.includes('reject') && (a.actionCode === 'REJECT' || a.code === 'REJECT')) ||
      (lowerLabel.includes('fulfil') && (a.actionCode === 'FULFIL_REQUEST' || a.code === 'FULFIL_REQUEST')) ||
      (lowerLabel.includes('dev') && (a.actionCode === 'MOVE_TO_DEV' || a.code === 'MOVE_TO_DEV'))
    );

    if (backendAct) {
      if ((backendAct.requiresConfirm || backendAct.confirmText) && !window.confirm(backendAct.confirmText || `Are you sure you want to execute "${backendAct.actionName || label}"?`)) {
        return;
      }
      if (backendAct.requiresComment || backendAct.requiresNote || (backendAct.requiredFields && backendAct.requiredFields.length > 0)) {
        openComposerForAction(label, selectedTicket, backendAct);
        return;
      }
      try {
        await executeTicketAction(selectedTicket.id, backendAct.actionCode || backendAct.code || backendAct.actionId || backendAct.id, {
          expectedStageId: selectedTicket.workflowStateId || (selectedTicket as any).state_id || (selectedTicket as any).current_stage_id,
        });
        const refreshed = await fetchTicket(selectedTicket.id);
        if (refreshed) setSelectedTicket(refreshed);
        await fetchAvailableActions(selectedTicket.id);
        return;
      } catch (e: any) {
        toast.error(e?.message || 'Failed to execute action');
        return;
      }
    }

    // 1. Check systemUse or label mapping to specific composers/actions
    if (systemUse === 'Email User' || item.sendEmail || lowerLabel.includes('email user') || lowerLabel.includes('request info') || lowerLabel.includes('clarification')) {
      openComposerForAction('Email User', selectedTicket);
      return;
    }
    if (systemUse === 'Email Supplier' || lowerLabel.includes('email supplier')) {
      openComposerForAction('Email Supplier', selectedTicket);
      return;
    }
    if (systemUse === 'Log to Supplier' || lowerLabel.includes('supplier') || lowerLabel.includes('rma') || lowerLabel.includes('vendor')) {
      openComposerForAction('Log to Supplier', selectedTicket);
      return;
    }
    if (systemUse === 'Re-assign' || systemUse === 'Email Agent' || lowerLabel.includes('reassign') || lowerLabel.includes('change assignee')) {
      openComposerForAction('Re-assign', selectedTicket);
      return;
    }
    if (systemUse === 'Create Child Ticket' || lowerLabel.includes('child')) {
      openComposerForAction('Create Child Ticket', selectedTicket);
      return;
    }
    if (systemUse === 'Create Appointment/Task' || lowerLabel.includes('appointment')) {
      openComposerForAction('Create Appointment', selectedTicket);
      return;
    }
    if (lowerLabel.includes('internal note') || lowerLabel.includes('tech note')) {
      openComposerForAction('Internal Note', selectedTicket);
      return;
    }
    if (lowerLabel.includes('private note')) {
      openComposerForAction('Private Note', selectedTicket);
      return;
    }
    if (lowerLabel.includes('ack')) {
      openComposerForAction('Send Acknowledgement', selectedTicket);
      return;
    }
    if (lowerLabel.includes('close') || lowerLabel.includes('cancel')) {
      openComposerForAction('Close', selectedTicket);
      return;
    }
    if (lowerLabel.includes('hold')) {
      openComposerForAction('Mark as Hold', selectedTicket);
      return;
    }

    // 2. If requires note is true
    if (item.requiresNote) {
      openComposerForAction(label, selectedTicket);
      return;
    }

    // 3. Direct status advance if status target is provided and differs from current status
    const currentNorm = (selectedTicket.status || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    const targetNorm = (targetStatus || '').toLowerCase().replace(/[^a-z0-9]/g, '');

    if (targetStatus && targetNorm !== currentNorm && targetNorm !== 'remain') {
      try {
        await updateTicket(selectedTicket.id, { status: targetStatus });
        await useUnifiedSyncStore.getState().syncTicketActionToModule({
          ticketId: selectedTicket.id,
          ticketStatus: targetStatus,
          resolutionNote: label,
          performedBy: currentUserName,
        });
        const noteText = `Action [${label}] applied. Ticket status updated to "${targetStatus}".`;
        await addHistory(selectedTicket.id, noteText, true, undefined, label, `${currentUserName} (You)`);
        toast.success(`Action "${label}" executed: Status is now ${targetStatus}`);
        const refreshed = useTicketStore.getState().tickets.find(
          (tk) => String(tk.id) === String(selectedTicket.id) || tk.ticketId === selectedTicket.ticketId
        );
        if (refreshed) {
          setSelectedTicket(refreshed);
        } else {
          setSelectedTicket({ ...selectedTicket, status: targetStatus });
        }
      } catch (err: any) {
        toast.error(err?.message || `Failed to execute action "${label}"`);
      }
      return;
    }

    // 4. Default: open composer for this action label
    openComposerForAction(label, selectedTicket);
  };

  // Dynamic Workflow Action Execution (Connected to Types & Workflow)
  const executeWorkflowAction = async (t: Ticket, tr: WorkflowTransition, e?: React.MouseEvent) => {
    if (e) e.stopPropagation();
    handleExecuteUnifiedAction({
      buttonName: tr.label,
      targetStepName: tr.toState,
      name: tr.label,
      systemUse: 'None (Standard Action)'
    }, e);
  };

  // Modals for Media Viewing & Document Inspection
  const [mediaLightbox, setMediaLightbox] = useState<{ isOpen: boolean; url: string; name: string } | null>(null);
  const [videoModal, setVideoModal] = useState<{ isOpen: boolean; url: string; name: string } | null>(null);
  const [docModal, setDocModal] = useState<{ isOpen: boolean; url: string; name: string; isPdf?: boolean; isDoc?: boolean } | null>(null);

  // File selection handler for composer
  const handleComposerFilesSelected = async (files: FileList | null) => {
    if (!files || files.length === 0) return;
    try {
      const ticketRef = selectedTicket?.ticketId || 'TICKET';
      const processed = await processSelectedFiles(files, 'support', `tickets/${ticketRef}`);
      setComposerAttachments((prev) => [...prev, ...processed]);
      if (processed.length > 0) {
        toast.success(`${processed.length} file(s) attached to composer!`);
      }
    } catch (e) {
      toast.error('Failed to read attached files');
    }
  };

  // Handle clipboard paste (snap & paste, screenshot paste, copied image file paste)
  const handleComposerPaste = async (e: React.ClipboardEvent | ClipboardEvent) => {
    const clipboardData = (e as React.ClipboardEvent).clipboardData || (e as ClipboardEvent).clipboardData;
    if (!clipboardData) return;

    const filesToProcess: File[] = [];
    const items = clipboardData.items;

    if (items && items.length > 0) {
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.kind === 'file') {
          const file = item.getAsFile();
          if (file) {
            let fileName = file.name;
            if (!fileName || fileName === 'image.png' || fileName === 'blob' || fileName === 'file') {
              const timeStr = new Date().toISOString().replace(/[:.]/g, '-');
              const ext = file.type.split('/')[1]?.replace('jpeg', 'jpg') || 'png';
              fileName = `snap-screenshot-${timeStr}.${ext}`;
            }
            const renamedFile = new File([file], fileName, { type: file.type });
            filesToProcess.push(renamedFile);
          }
        }
      }
    } else if (clipboardData.files && clipboardData.files.length > 0) {
      for (let i = 0; i < clipboardData.files.length; i++) {
        filesToProcess.push(clipboardData.files[i]);
      }
    }

    if (filesToProcess.length > 0) {
      if (e.cancelable) e.preventDefault();
      const ticketRef = selectedTicket?.ticketId || 'TICKET';
      try {
        const processed = await processSelectedFiles(filesToProcess, 'support', `tickets/${ticketRef}`);
        setComposerAttachments((prev) => [...prev, ...processed]);
        if (processed.length > 0) {
          toast.success(`Attached ${processed.length} pasted screenshot / image(s)!`);
        }
      } catch (err) {
        toast.error('Failed to process pasted image');
      }
    }
  };

  // Global listener for clipboard paste whenever inline composer is active
  useEffect(() => {
    if (!inlineComposerType) return;
    const onWindowPaste = (e: ClipboardEvent) => {
      const activeTag = document.activeElement?.tagName?.toLowerCase();
      // If user is typing in standard text inputs like search or subject, skip unless it's the composer textarea
      if (activeTag === 'input' && (document.activeElement as HTMLInputElement).type === 'text') {
        return;
      }
      handleComposerPaste(e);
    };
    window.addEventListener('paste', onWindowPaste);
    return () => window.removeEventListener('paste', onWindowPaste);
  }, [inlineComposerType, selectedTicket?.ticketId]);

  const handleRemoveComposerAttachment = (id: string) => {
    setComposerAttachments((prev) => prev.filter((a) => a.id !== id));
  };

  // One-click Share / Copy link for media attachments
  const handleShareAttachment = (att: { name: string; fileUrl?: string; s3Key?: string }) => {
    const shareText = att.s3Key || att.fileUrl || `https://teamone.internal/tickets/${selectedTicket?.ticketId}/attachments/${att.name}`;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(shareText);
      toast.success(`Share link for "${att.name}" copied to clipboard!`);
    } else {
      toast.success(`Storage path: ${shareText}`);
    }
  };


  const resolveComposerAgentAndTeam = (targetAssigneeName?: string, targetTeamStr?: string) => {
    const rawStaff = (targetAssigneeName || inlineComposerData.staff || selectedTicket?.assigneeName || currentUserName || '').trim();
    const matchedAgent = (supportAgentsList || []).find(
      (a: any) =>
        a.name?.toLowerCase() === rawStaff.toLowerCase() ||
        a.id === rawStaff ||
        a.userId === rawStaff ||
        a.email?.toLowerCase() === rawStaff.toLowerCase()
    );
    const resolvedAgentId = matchedAgent?.userId || matchedAgent?.id || rawStaff;
    const resolvedAgentName = matchedAgent?.name || rawStaff;

    const rawTeam = (targetTeamStr || inlineComposerData.team || selectedTicket?.teamName || '').trim();
    const matchedQueue = (storeQueues || []).find((q: any) =>
      (q.label || '').toLowerCase() === rawTeam.toLowerCase() ||
      (q.name || '').toLowerCase() === rawTeam.toLowerCase() ||
      (q.team_name || '').toLowerCase() === rawTeam.toLowerCase() ||
      (q.key || '').toLowerCase() === rawTeam.toLowerCase() ||
      (q.team_key || '').toLowerCase() === rawTeam.toLowerCase()
    );
    const resolvedTeamName = matchedQueue?.label || matchedQueue?.team_name || matchedQueue?.name || rawTeam;
    const resolvedTeamKey = matchedQueue?.key || matchedQueue?.team_key || matchedQueue?.queue_key || rawTeam.toLowerCase().replace(/\s+/g, '-');
    const resolvedTeamId = matchedQueue?.id || undefined;

    return {
      agentId: resolvedAgentId,
      agentName: resolvedAgentName,
      teamId: resolvedTeamId,
      teamName: resolvedTeamName,
      teamKey: resolvedTeamKey,
    };
  };

  // Handle immediate submission or open preview modal from inline composer
  const handleSaveInlineComposer = async () => {
    if (!selectedTicket) return;
    const formattedContent = (inlineComposerData.content || '').trim();

    const actionLabel = composerActionLabel || 'Note (+Email)';
    const isInternal = isStrictNoteOnly || (!isMailMode && (actionLabel === 'Internal Note' || actionLabel === 'Private Note'));
    const targetStatus = inlineComposerData.status || selectedTicket.status;
    const targetAssignee = inlineComposerData.staff || selectedTicket.assigneeName || currentUserName;
    // Check if this action is linked to a backend workflow action
    const backendAct = activeBackendAction || (availableActions || []).find((a: any) =>
      a.actionId === activeBackendAction?.id ||
      a.id === activeBackendAction?.id ||
      a.actionName?.toLowerCase() === actionLabel.toLowerCase() ||
      a.name?.toLowerCase() === actionLabel.toLowerCase() ||
      a.actionCode?.toLowerCase() === actionLabel.toLowerCase() ||
      a.code?.toLowerCase() === actionLabel.toLowerCase()
    );

    if (backendAct && !isMailMode) {
      if ((backendAct.requiresComment || backendAct.requiresReason) && !formattedContent) {
        toast.error(`Please provide a note or comment for "${actionLabel}"`);
        return;
      }

      try {
        const { agentId, agentName, teamId, teamName, teamKey } = resolveComposerAgentAndTeam(targetAssignee, inlineComposerData.team);
        const resolvedTargetTeamId = teamId || backendAct.targetTeamId || undefined;
        const resolvedTargetAgentId = agentId || backendAct.targetAgentId || undefined;

        const payload: any = {
          comment: formattedContent || undefined,
          reason: formattedContent || undefined,
          resolutionNote: (actionLabel.toLowerCase().includes('resolve') || actionLabel.toLowerCase().includes('close')) ? formattedContent : undefined,
          notifyRequester,
          notifyAssignee,
          notifyTeam,
          sendEmail: false,
          to: toEmails.length > 0 ? toEmails.join('; ') : undefined,
          cc: ccEmails.length > 0 ? ccEmails.join('; ') : undefined,
          targetTeamId: resolvedTargetTeamId,
          targetAgentId: resolvedTargetAgentId,
          assignedAgentId: resolvedTargetAgentId,
          assignee: resolvedTargetAgentId || agentName,
          assigneeId: resolvedTargetAgentId || agentName,
          staff: agentName,
          team: teamName,
          status: targetStatus,
          isInternal: true,
          formValues: {
            assignee: resolvedTargetAgentId || agentName,
            assignee_id: resolvedTargetAgentId || agentName,
            assigned_agent_id: resolvedTargetAgentId || agentName,
            staff: agentName,
            team: resolvedTargetTeamId || teamName,
            status: targetStatus,
            resolution_note: formattedContent || undefined,
            resolutionNote: formattedContent || undefined,
            supplier_note: formattedContent || undefined,
            workaround: formattedContent || undefined,
            comment: formattedContent || undefined,
            note: formattedContent || undefined,
          },
        };

        await executeTicketAction(selectedTicket.id, backendAct.actionId || backendAct.id, payload);
        await fetchAvailableActions(selectedTicket.id);
        const refreshed = await fetchTicket(selectedTicket.id);
        if (refreshed) {
          setSelectedTicket(refreshed);
        }

        if (agentName && agentName !== selectedTicket.assigneeName) {
          try {
            await assignTicket(selectedTicket.id, agentName, agentName);
          } catch (e) {
            console.warn('Fallback assignTicket notice:', e);
          }
        }
        if (teamName && (teamName !== selectedTicket.teamName || teamKey !== selectedTicket.teamKey)) {
          try {
            await updateTicket(selectedTicket.id, {
              teamName,
              teamKey,
            });
          } catch (e) {
            console.warn('Fallback updateTicket team notice:', e);
          }
        }

        toast.success(`Action "${actionLabel}" executed successfully`);
        setInlineComposerType(null);
        setActiveBackendAction(null);
        setComposerAttachments([]);
        return;
      } catch (err: any) {
        toast.error(err?.message || 'Failed to execute action');
        return;
      }
    }

    // FOR OUTBOUND EMAIL ACTIONS: Open the Email Preview Modal (Matching Image 4)
    if (isMailMode && !isStrictNoteOnly) {
      let recipientEmails = [...toEmails];
      if (recipientEmails.length === 0 && selectedTicket.requesterEmail) {
        recipientEmails = [selectedTicket.requesterEmail];
      }
      if (recipientEmails.length === 0) {
        toast.error('Please enter at least one recipient email in the To field');
        return;
      }

      let topicAction = 'Update';
      if (actionLabel === 'Send Acknowledgement') topicAction = 'Acknowledgement';
      else if (actionLabel === 'Close') topicAction = 'Ticket Resolved';
      else if (actionLabel === 'Email Supplier' || actionLabel === 'Log to Supplier') topicAction = 'Supplier Inquiry';
      else if (actionLabel === 'Mark as Hold') topicAction = 'Waiting for Approval';
      else if (actionLabel === 'Assign' || actionLabel === 'Re-assign') topicAction = 'Ticket Update';
      else if (actionLabel === 'Create Appointment') topicAction = 'Ticket Update';
      else if (actionLabel === 'Create Child Ticket') topicAction = 'Ticket Update';

      const cleanSubj = (selectedTicket.subject || '').replace(/\s*\[TB#\d+\]|\s*\[[A-Z0-9#_-]+\]/gi, '').replace(/^re:\s*/i, '').trim();
      const targetSubject = inlineComposerData.subject.trim() || `${cleanSubj} [${selectedTicket.ticketId}]`;

      setEmailPreviewData({
        isOpen: true,
        activeTab: 'email',
        actionLabel,
        topicAction,
        from: selectedTicket.teamEmail
          ? `${selectedTicket.teamName || activeSupportSender.displayName || 'Support Team'} <${selectedTicket.teamEmail}>`
          : (activeSupportSender.displayFrom || activeSupportSender.formatted || ''),
        to: recipientEmails.join(', '),
        cc: ccEmails.join(', '),
        bcc: bccEmails.join(', '),
        replyTo: replyDirectlyToMe ? (user?.email || selectedTicket.teamEmail || activeSupportSender.email) : undefined,
        subject: targetSubject,
        body: formattedContent,
        status: targetStatus,
        staff: targetAssignee,
        team: inlineComposerData.team || selectedTicket.teamName || 'Support Team',
        timeHours: inlineComposerData.timeHours || '00',
        timeMinutes: inlineComposerData.timeMinutes || '00',
        nextUpdate: inlineComposerData.nextUpdate,
        issue: inlineComposerData.issue,
        issueDetail: inlineComposerData.issueDetail,
        currentAction: actionLabel,
        assets: inlineComposerData.assets,
        attachments: composerAttachments,
      });
      return;
    }

    // NORMAL NOTE / ACTION DIRECT SAVE
    const mappedAttachments: TicketAttachment[] = composerAttachments.map((att) => ({
      id: att.id,
      name: att.name,
      size: att.size,
      sizeBytes: att.sizeBytes,
      type: att.isImage ? 'image' : att.isVideo ? 'video' : att.isDocument ? 'document' : 'other',
      mimeType: att.type,
      fileUrl: att.fileUrl || att.dataUrl,
      previewUrl: att.previewUrl,
      s3Key: att.s3Key || `s3://teamone-ticket-storage/${selectedTicket.ticketId}/attachments/${att.name}`,
      uploadedAt: new Date().toISOString(),
      uploadedByName: currentUserName,
    }));

    const nowIso = new Date().toISOString();
    const noteText = appointmentDateTime
      ? `[Appointment: ${formatDateTime(appointmentDateTime)}]\n${formattedContent}`.trim()
      : formattedContent;

    const newHistoryEntry: TicketHistoryItem = {
      id: Date.now(),
      ticketId: Number(selectedTicket.id) || 0,
      note: noteText,
      internal: isInternal,
      actionType: actionLabel,
      createdAt: nowIso,
      changedByName: `${currentUserName} (You)`,
      attachments: mappedAttachments.length > 0 ? mappedAttachments : undefined,
      to: toEmails.length > 0 ? toEmails.join('; ') : (!isInternal ? selectedTicket.requesterEmail : undefined),
      cc: ccEmails.length > 0 ? ccEmails.join('; ') : undefined,
      bcc: bccEmails.length > 0 ? bccEmails.join('; ') : undefined,
      timeTaken: (inlineComposerData.timeHours || inlineComposerData.timeMinutes) ? `${inlineComposerData.timeHours || '00'}:${inlineComposerData.timeMinutes || '00'}` : undefined,
      meta: {
        to: toEmails.length > 0 ? toEmails.join('; ') : (!isInternal ? selectedTicket.requesterEmail : undefined),
        cc: ccEmails.length > 0 ? ccEmails.join('; ') : undefined,
        bcc: bccEmails.length > 0 ? bccEmails.join('; ') : undefined,
        timeTaken: (inlineComposerData.timeHours || inlineComposerData.timeMinutes) ? `${inlineComposerData.timeHours || '00'}:${inlineComposerData.timeMinutes || '00'}` : undefined,
        notifyRequester,
        notifyAssignee,
        notifyTeam,
        sendEmail: Boolean(isMailMode),
      },
    };

    const targetTeam = (inlineComposerData.team || selectedTicket.teamName || '').trim();
    const matchedQueue = (storeQueues || []).find((q: any) =>
      (q.label || '').toLowerCase() === targetTeam.toLowerCase() ||
      (q.name || '').toLowerCase() === targetTeam.toLowerCase() ||
      (q.team_name || '').toLowerCase() === targetTeam.toLowerCase() ||
      (q.key || '').toLowerCase() === targetTeam.toLowerCase() ||
      (q.team_key || '').toLowerCase() === targetTeam.toLowerCase()
    );
    const resolvedTeamName = matchedQueue?.label || matchedQueue?.team_name || matchedQueue?.name || targetTeam;
    const resolvedTeamKey = matchedQueue?.key || matchedQueue?.team_key || matchedQueue?.queue_key || targetTeam.toLowerCase().replace(/\s+/g, '-');

    setSelectedTicket((prev) => {
      if (!prev) return null;
      return {
        ...prev,
        status: targetStatus as any,
        assigneeName: targetAssignee,
        ...(resolvedTeamName ? { teamName: resolvedTeamName, teamKey: resolvedTeamKey } : {}),
        history: [newHistoryEntry, ...(prev.history || [])],
        attachments: mappedAttachments.length > 0 ? [...mappedAttachments, ...(prev.attachments || [])] : prev.attachments,
        updatedAt: nowIso,
      };
    });

    try {
      if (actionLabel === 'Create Child Ticket') {
        await createTicket({
          subject: childTicketSubject || `Child: [${selectedTicket.ticketId}] ${selectedTicket.subject}`,
          description: formattedContent || 'Child ticket created',
          priority: selectedTicket.priority,
          category: selectedTicket.category || 'General',
          client: selectedTicket.client,
          requesterEmail: selectedTicket.requesterEmail,
          parentId: selectedTicket.id,
          type: selectedTicket.type || 'Incident',
        });
      }

      await addHistory(selectedTicket.id, noteText, isInternal, mappedAttachments, actionLabel, `${currentUserName} (You)`);

      const currentStatusNorm = String(selectedTicket.status || '').trim().toLowerCase().replace(/[\s_]+/g, '-');
      const targetStatusNorm = String(targetStatus || '').trim().toLowerCase().replace(/[\s_]+/g, '-');
      if (targetStatus && targetStatusNorm !== currentStatusNorm) {
        await transitionTicket(selectedTicket.id, targetStatus as any);
        await useUnifiedSyncStore.getState().syncTicketActionToModule({
          ticketId: selectedTicket.id,
          ticketStatus: targetStatus,
          resolutionNote: noteText,
          performedBy: currentUserName,
        });
      }
      if (targetAssignee && targetAssignee !== selectedTicket.assigneeName) {
        await assignTicket(selectedTicket.id, targetAssignee);
      }
      if (resolvedTeamName && (resolvedTeamName !== selectedTicket.teamName || resolvedTeamKey !== selectedTicket.teamKey)) {
        await updateTicket(selectedTicket.id, {
          teamName: resolvedTeamName,
          teamKey: resolvedTeamKey,
        });
      }

      await fetchTicket(selectedTicket.id);

      toast.success(`${actionLabel} saved successfully!`);

      setInlineComposerType(null);
      setComposerAttachments([]);
      setAppointmentDateTime('');
      setChildTicketSubject('');
      setInlineComposerData({
        to: '',
        cc: '',
        subject: '',
        content: '',
        status: targetStatus || selectedTicket.status || 'in-progress',
        team: resolvedTeamName || selectedTicket.teamName || 'Support Team',
        staff: targetAssignee || selectedTicket.assigneeName || currentUserName,
        timeHours: '00',
        timeMinutes: '00',
        nextUpdate: '',
        issue: 'Appearance',
        issueDetail: 'Appearance > Cleanliness',
        currentAction: '',
        faultsNextAction: 'Awaiting User Response',
        assets: [],
      });
    } catch (err: any) {
      toast.error(`Failed to save action: ${err?.message || 'Error'}`);
    }
  };

  // Fast direct execution without entering a note (when action doesn't mandate note/reason)
  const handleExecuteWithoutNote = async () => {
    if (!selectedTicket || !activeBackendAction) return;
    if (activeBackendAction.requiresComment || activeBackendAction.requiresReason) {
      toast.error(`A note or comment is required for "${composerActionLabel}"`);
      return;
    }
    const targetStatus = inlineComposerData.status || activeBackendAction?.statusAfterAction || activeBackendAction?.targetStepName || selectedTicket.status;
    const targetAssignee = inlineComposerData.staff || selectedTicket.assigneeName || currentUserName;
    const { agentId, agentName, teamId, teamName, teamKey } = resolveComposerAgentAndTeam(targetAssignee, inlineComposerData.team);
    const resolvedTargetTeamId = teamId || activeBackendAction.targetTeamId || undefined;
    const resolvedTargetAgentId = agentId || activeBackendAction.targetAgentId || undefined;

    try {
      const payload: any = {
        notifyRequester,
        notifyAssignee,
        notifyTeam,
        sendEmail: false,
        to: toEmails.length > 0 ? toEmails.join('; ') : undefined,
        cc: ccEmails.length > 0 ? ccEmails.join('; ') : undefined,
        targetTeamId: resolvedTargetTeamId,
        targetAgentId: resolvedTargetAgentId,
        assignedAgentId: resolvedTargetAgentId,
        assignee: resolvedTargetAgentId || agentName,
        assigneeId: resolvedTargetAgentId || agentName,
        staff: agentName,
        team: teamName,
        status: targetStatus,
        isInternal: true,
        formValues: {
          assignee: resolvedTargetAgentId || agentName,
          assignee_id: resolvedTargetAgentId || agentName,
          assigned_agent_id: resolvedTargetAgentId || agentName,
          staff: agentName,
          team: resolvedTargetTeamId || teamName,
          status: targetStatus,
        },
      };

      await executeTicketAction(selectedTicket.id, activeBackendAction.actionId || activeBackendAction.id, payload);
      await fetchAvailableActions(selectedTicket.id);
      const refreshed = await fetchTicket(selectedTicket.id);
      if (refreshed) {
        setSelectedTicket(refreshed);
      }
      if (agentName && agentName !== selectedTicket.assigneeName) {
        try {
          await assignTicket(selectedTicket.id, agentName, agentName);
        } catch (e) {
          console.warn('Fallback assignTicket notice:', e);
        }
      }
      if (teamName && (teamName !== selectedTicket.teamName || teamKey !== selectedTicket.teamKey)) {
        try {
          await updateTicket(selectedTicket.id, {
            teamName,
            teamKey,
          });
        } catch (e) {
          console.warn('Fallback updateTicket team notice:', e);
        }
      }
      const finalStatus = activeBackendAction.statusAfterAction || activeBackendAction.targetStepName || refreshed?.status;
      if (finalStatus) {
        await useUnifiedSyncStore.getState().syncTicketActionToModule({
          ticketId: selectedTicket.id,
          ticketStatus: finalStatus,
          resolutionNote: composerActionLabel,
          performedBy: currentUserName,
        });
      }

      toast.success(`Action "${composerActionLabel}" executed successfully`);
      setInlineComposerType(null);
      setActiveBackendAction(null);
      setComposerAttachments([]);
    } catch (err: any) {
      toast.error(err?.message || 'Failed to execute action');
    }
  };

  // Confirm and Send Real Email from Preview Modal (Matching Image 4)
  const handleConfirmSendEmail = async () => {
    if (!selectedTicket || !emailPreviewData) return;
    setIsSendingEmail(true);

    const mappedAttachments: TicketAttachment[] = emailPreviewData.attachments.map((att) => ({
      id: att.id,
      name: att.name,
      size: att.size,
      sizeBytes: att.sizeBytes,
      type: att.isImage ? 'image' : att.isVideo ? 'video' : att.isDocument ? 'document' : 'other',
      mimeType: att.type,
      fileUrl: att.fileUrl || att.dataUrl,
      previewUrl: att.previewUrl,
      s3Key: att.s3Key || `s3://teamone-ticket-storage/${selectedTicket.ticketId}/attachments/${att.name}`,
      uploadedAt: new Date().toISOString(),
      uploadedByName: currentUserName,
    }));

    const nowIso = new Date().toISOString();
    const newHistoryEntry: TicketHistoryItem = {
      id: Date.now(),
      ticketId: Number(selectedTicket.id) || 0,
      note: emailPreviewData.body || '',
      internal: false,
      actionType: emailPreviewData.actionLabel,
      createdAt: nowIso,
      changedByName: `${currentUserName} (You)`,
      attachments: mappedAttachments.length > 0 ? mappedAttachments : undefined,
    };

    const targetStatus = emailPreviewData.status || selectedTicket.status;
    const targetAssignee = emailPreviewData.staff || selectedTicket.assigneeName;
    const targetTeam = (emailPreviewData.team || selectedTicket.teamName || '').trim();
    const matchedQueue = (storeQueues || []).find((q: any) =>
      (q.label || '').toLowerCase() === targetTeam.toLowerCase() ||
      (q.name || '').toLowerCase() === targetTeam.toLowerCase() ||
      (q.team_name || '').toLowerCase() === targetTeam.toLowerCase() ||
      (q.key || '').toLowerCase() === targetTeam.toLowerCase() ||
      (q.team_key || '').toLowerCase() === targetTeam.toLowerCase()
    );
    const resolvedTeamName = matchedQueue?.label || matchedQueue?.team_name || matchedQueue?.name || targetTeam;
    const resolvedTeamKey = matchedQueue?.key || matchedQueue?.team_key || matchedQueue?.queue_key || targetTeam.toLowerCase().replace(/\s+/g, '-');

    // Immediately update local selectedTicket state so timeline and buttons update instantaneously
    setSelectedTicket((prev) => {
      if (!prev) return null;
      return {
        ...prev,
        status: targetStatus as any,
        assigneeName: targetAssignee,
        ...(resolvedTeamName ? { teamName: resolvedTeamName, teamKey: resolvedTeamKey } : {}),
        history: [newHistoryEntry, ...(prev.history || [])],
        attachments: mappedAttachments.length > 0 ? [...mappedAttachments, ...(prev.attachments || [])] : prev.attachments,
        updatedAt: nowIso,
      };
    });

    try {
      // 1. Generate outbound HTML email from the dynamic template
      const rawSubject = emailPreviewData.subject || selectedTicket.subject || 'Support Ticket';
      const cleanSubj = rawSubject
        .replace(/\s*\[(?:STD|TB|INC|REQ|CHG|[A-Z]+)#[a-z0-9_ -]+\]/gi, '')
        .replace(/^re:\s*/i, '')
        .trim() || 'Support Ticket';

      const generatedFullCardHtml = renderEmailCard(null, {
        ticketId: selectedTicket.ticketId || 'TB#01752',
        subject: cleanSubj,
        clientName: selectedTicket.requesterName || selectedTicket.client || 'Customer',
        status: targetStatus || selectedTicket.status || 'In-progress',
        currentAction: emailPreviewData.currentAction || selectedTicket.status || 'In-progress',
        nextAction: emailPreviewData.topicAction === 'Acknowledgement'
          ? 'Escalate to Supplier'
          : (emailPreviewData.topicAction || 'Review and Resolve'),
        priority: selectedTicket.priority || 'Medium',
        body: emailPreviewData.body || '',
        agentName: emailPreviewData.staff || currentUserName || 'Team One',
        teamName: emailPreviewData.team || selectedTicket.teamName || 'Support Team',
        fromEmail: activeSupportSender.isConfigured ? activeSupportSender.email : '',
        from: activeSupportSender.isConfigured ? activeSupportSender.displayFrom : '',
        senderName: activeSupportSender.isConfigured ? activeSupportSender.displayName : 'Support Team',
        ticketLink: typeof window !== 'undefined' ? `${window.location.origin}/support/tickets/${encodeURIComponent(selectedTicket.ticketId || '')}` : '',
      });

      // 2. Send outbound email response via API with full HTML card
      await sendTicketResponse(selectedTicket.id, {
        message: emailPreviewData.body || '',
        to: emailPreviewData.to,
        cc: emailPreviewData.cc,
        bcc: emailPreviewData.bcc,
        subject: emailPreviewData.subject,
        html: generatedFullCardHtml,
        sendEmail: true,
        actionType: emailPreviewData.topicAction || emailPreviewData.actionLabel,
        authorName: `${currentUserName} (You)`,
        attachments: mappedAttachments,
        timeTaken: (emailPreviewData.timeHours || emailPreviewData.timeMinutes) ? `${emailPreviewData.timeHours || '00'}:${emailPreviewData.timeMinutes || '00'}` : undefined,
      });

      // 2. Update status, assignee, and team if changed
      const currentEmailStatusNorm = String(selectedTicket.status || '').trim().toLowerCase().replace(/[\s_]+/g, '-');
      const targetEmailStatusNorm = String(emailPreviewData.status || '').trim().toLowerCase().replace(/[\s_]+/g, '-');
      if (emailPreviewData.status && targetEmailStatusNorm !== currentEmailStatusNorm) {
        await transitionTicket(selectedTicket.id, emailPreviewData.status as any);
      }
      if (emailPreviewData.staff && emailPreviewData.staff !== selectedTicket.assigneeName) {
        await assignTicket(selectedTicket.id, emailPreviewData.staff);
      }
      if (resolvedTeamName && (resolvedTeamName !== selectedTicket.teamName || resolvedTeamKey !== selectedTicket.teamKey)) {
        await updateTicket(selectedTicket.id, {
          teamName: resolvedTeamName,
          teamKey: resolvedTeamKey,
        });
      }

      // If linked to a backend workflow action, execute the state machine transition
      const backendAct = activeBackendAction || (availableActions || []).find((a: any) =>
        a.actionId === activeBackendAction?.id ||
        a.id === activeBackendAction?.id ||
        a.actionName?.toLowerCase() === (emailPreviewData.actionLabel || '').toLowerCase() ||
        a.name?.toLowerCase() === (emailPreviewData.actionLabel || '').toLowerCase() ||
        a.actionCode?.toLowerCase() === (emailPreviewData.actionLabel || '').toLowerCase() ||
        a.code?.toLowerCase() === (emailPreviewData.actionLabel || '').toLowerCase()
      );

      if (backendAct) {
        const targetAssignee = emailPreviewData.staff || selectedTicket.assigneeName || currentUserName;
        const { agentId, agentName, teamId, teamName } = resolveComposerAgentAndTeam(targetAssignee, emailPreviewData.team);
        const resolvedTargetTeamId = teamId || backendAct.targetTeamId || undefined;
        const resolvedTargetAgentId = agentId || backendAct.targetAgentId || undefined;

        try {
          await executeTicketAction(selectedTicket.id, backendAct.actionId || backendAct.id, {
            comment: emailPreviewData.body || undefined,
            reason: emailPreviewData.body || undefined,
            resolutionNote: (emailPreviewData.actionLabel?.toLowerCase().includes('resolve') || emailPreviewData.actionLabel?.toLowerCase().includes('close')) ? emailPreviewData.body : undefined,
            notifyRequester,
            notifyAssignee,
            notifyTeam,
            sendEmail: true,
            to: emailPreviewData.to,
            cc: emailPreviewData.cc,
            targetTeamId: resolvedTargetTeamId,
            targetAgentId: resolvedTargetAgentId,
            assignedAgentId: resolvedTargetAgentId,
            assignee: resolvedTargetAgentId || agentName,
            assigneeId: resolvedTargetAgentId || agentName,
            staff: agentName,
            team: teamName,
            isInternal: false,
            formValues: {
              assignee: resolvedTargetAgentId || agentName,
              assignee_id: resolvedTargetAgentId || agentName,
              assigned_agent_id: resolvedTargetAgentId || agentName,
              staff: agentName,
              team: resolvedTargetTeamId || teamName,
              resolution_note: emailPreviewData.body || undefined,
              resolutionNote: emailPreviewData.body || undefined,
              supplier_note: emailPreviewData.body || undefined,
              workaround: emailPreviewData.body || undefined,
              comment: emailPreviewData.body || undefined,
            },
          });
          await fetchAvailableActions(selectedTicket.id);
        } catch (actErr: any) {
          console.warn('Workflow action transition error in email preview:', actErr);
        }
      }

      await fetchTicket(selectedTicket.id);

      toast.success(`Email dispatched to ${emailPreviewData.to} for [${selectedTicket.ticketId}]`);

      setEmailPreviewData(null);
      setInlineComposerType(null);
      setActiveBackendAction(null);
      setComposerAttachments([]);
      setInlineComposerData({
        to: '',
        cc: '',
        subject: '',
        content: '',
        status: targetStatus || selectedTicket.status || 'in-progress',
        team: resolvedTeamName || selectedTicket.teamName || 'Support Team',
        staff: targetAssignee || selectedTicket.assigneeName || currentUserName,
        timeHours: '00',
        timeMinutes: '01',
        nextUpdate: '',
        issue: 'Appearance',
        issueDetail: 'Appearance > Cleanliness',
        currentAction: '',
        faultsNextAction: 'Awaiting Supplier Response',
        assets: [],
      });
    } catch (err: any) {
      toast.error(`Failed to send email: ${err?.response?.data?.error || err?.message || 'SMTP delivery error'}`);
    } finally {
      setIsSendingEmail(false);
    }
  };

  // Activity Log Tab state
  const [activityTab, setActivityTab] = useState<ActivityLogTab>('all');
  const [subLogTab, setSubLogTab] = useState<'progress' | 'additional'>('progress');
  const [showLogFilterMenu, setShowLogFilterMenu] = useState(false);
  const [feedCollapsed, setFeedCollapsed] = useState(false);
  const [logActionFilter, setLogActionFilter] = useState('all');
  const [isEditingSubject, setIsEditingSubject] = useState(false);
  const [subjectInput, setSubjectInput] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState<number>(20);
  const [showBulkActionsMenu, setShowBulkActionsMenu] = useState(false);
  const [bulkActionModal, setBulkActionModal] = useState<string | null>(null);
  const [bulkInputValue, setBulkInputValue] = useState('');
  const [reassignTeam, setReassignTeam] = useState('');
  const [reassignStaff, setReassignStaff] = useState('');
  const [showExportMenu, setShowExportMenu] = useState(false);

  // Export tickets handler supporting CSV, Excel (.xlsx), and JSON (all columns)
  const handleExportTickets = (format: 'csv' | 'xlsx' | 'json', scope: 'selected' | 'all') => {
    const listToExport =
      scope === 'selected'
        ? sortedTickets.filter((t) => selectedRowIds.has(t.id) || (t.ticketId && selectedRowIds.has(t.ticketId)) || ((t as any).ticket_no && selectedRowIds.has((t as any).ticket_no)))
        : sortedTickets;

    if (listToExport.length === 0) {
      toast.error('No tickets found to export');
      return;
    }

    const d = new Date();
    const pad = (n: number) => String(n).padStart(2, '0');
    const timestamp = `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`;

    if (format === 'json') {
      const jsonContent =
        'data:application/json;charset=utf-8,' +
        encodeURIComponent(JSON.stringify(listToExport, null, 2));
      const link = document.createElement('a');
      link.setAttribute('href', jsonContent);
      link.setAttribute('download', `Tickets_Export_${scope}_${timestamp}.json`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success(`Exported ${listToExport.length} tickets as JSON`);
      return;
    }

    const headers = [
      'Ticket ID',
      'Ticket Number',
      'Subject',
      'Description',
      'Status',
      'Priority',
      'Impact',
      'Urgency',
      'Type',
      'Category',
      'Subcategory',
      'Team',
      'Assignee',
      'Assignee Email',
      'Client / Requester',
      'Requester Email',
      'Requester Department',
      'Requester Phone',
      'Asset Tag',
      'Source',
      'Origin Module',
      'Resolution',
      'Date Created',
      'Date Updated',
      'Due Date',
      'First Responded At',
      'Resolved At',
      'Closed At',
      'SLA Breached',
      'SLA On Hold',
    ];

    const rows = listToExport.map((t) => [
      t.ticketId || (t as any).ticket_no || String(t.id),
      t.ticketNumber || (t as any).ticket_number || '',
      t.subject || (t as any).title || '',
      t.description || '',
      t.status || '',
      t.priority || '',
      t.impact || '',
      t.urgency || '',
      t.type || '',
      t.category || '',
      t.subcategory || '',
      t.teamName || t.teamKey || '',
      t.assigneeName || 'Unassigned',
      t.assigneeEmail || '',
      t.client || t.requesterName || '',
      t.requesterEmail || '',
      t.requesterDepartment || t.department || '',
      t.requesterPhone || '',
      t.assetTag || '',
      t.source || (t as any).channel || '',
      (t as any).origin_module || '',
      t.resolution || '',
      t.createdAt ? new Date(t.createdAt).toLocaleString() : '',
      t.updatedAt ? new Date(t.updatedAt).toLocaleString() : '',
      (t as any).dueDate || (t as any).due_date ? new Date((t as any).dueDate || (t as any).due_date).toLocaleString() : '',
      t.firstRespondedAt || (t as any).first_response_at ? new Date(t.firstRespondedAt || (t as any).first_response_at).toLocaleString() : '',
      t.resolvedAt || (t as any).resolved_at ? new Date(t.resolvedAt || (t as any).resolved_at).toLocaleString() : '',
      t.closedAt || (t as any).closed_at ? new Date(t.closedAt || (t as any).closed_at).toLocaleString() : '',
      (t as any).sla_breached ? 'Yes' : 'No',
      t.slaHold || (t as any).sla_hold ? 'Yes' : 'No',
    ]);

    if (format === 'csv') {
      const csvContent =
        'data:text/csv;charset=utf-8,' +
        encodeURIComponent(
          [headers.join(','), ...rows.map((r) => r.map((c) => `"${String(c).replace(/"/g, '""')}"`).join(','))].join('\n')
        );
      const link = document.createElement('a');
      link.setAttribute('href', csvContent);
      link.setAttribute('download', `Tickets_Export_${scope}_${timestamp}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success(`Exported ${listToExport.length} tickets as CSV`);
      return;
    }

    if (format === 'xlsx') {
      const tableHtml = `
        <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel">
        <head><meta charset="utf-8"/></head>
        <body>
          <h2>TeamOne Support Tickets Export (${scope.toUpperCase()})</h2>
          <p>Exported at: ${new Date().toLocaleString()} | Total: ${listToExport.length}</p>
          <table border="1">
            <tr style="background:#0284c7;color:#ffffff;font-weight:bold;">
              ${headers.map((h) => `<th>${h}</th>`).join('')}
            </tr>
            ${rows
          .map((r) => `<tr>${r.map((c) => `<td>${c}</td>`).join('')}</tr>`)
          .join('')}
          </table>
        </body></html>
      `;
      const blob = 'data:application/vnd.ms-excel;charset=utf-8,' + encodeURIComponent(tableHtml);
      const link = document.createElement('a');
      link.setAttribute('href', blob);
      link.setAttribute('download', `Tickets_Export_${scope}_${timestamp}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success(`Exported ${listToExport.length} tickets as Excel`);
      return;
    }
  };

  // Available support teams for bulk Re-assign
  const availableTeamsList = useMemo(() => {
    const map = new Map<string, { key: string; label: string }>();
    (storeQueues || []).forEach((q: any) => {
      const k = q.key || q.queue_key || q.team_key || q.label;
      const l = q.label || q.queue_label || q.team_name || q.name || k;
      if (k && !map.has(k)) {
        map.set(k, { key: k, label: l });
      }
    });
    (queuesSummary || []).forEach((q: any) => {
      const k = q.key;
      const l = q.label || k;
      if (k && !map.has(k)) {
        map.set(k, { key: k, label: l });
      }
    });
    (employees || []).forEach((emp: any) => {
      const d = (emp.department || '').trim();
      if (d && !map.has(d)) {
        map.set(d, { key: d, label: d });
      }
    });
    if (map.size === 0) {
      [
        { key: 'helpdesk', label: 'Support Team (Line 1)' },
        { key: 'it-support', label: 'IT Support' },
        { key: 'tier2', label: 'Tier 2 Support' },
        { key: 'infrastructure', label: 'Infrastructure & Cloud' },
        { key: 'network', label: 'Network & Security' },
      ].forEach((t) => map.set(t.key, t));
    }
    return Array.from(map.values());
  }, [storeQueues, queuesSummary, employees]);

  // Dynamically filter staff members by selected team in Re-assign modal
  const filteredEmployeesForReassign = useMemo(() => {
    if (!reassignTeam) return employees;
    const teamLower = reassignTeam.toLowerCase().trim();
    const matchedTeamObj = availableTeamsList.find((t) => t.key.toLowerCase() === teamLower || t.label.toLowerCase() === teamLower);
    const labelLower = matchedTeamObj ? matchedTeamObj.label.toLowerCase().trim() : teamLower;

    const matched = employees.filter((emp: any) => {
      const dept = (emp.department || '').toLowerCase().trim();
      if (!dept) return false;
      return (
        dept === teamLower ||
        dept === labelLower ||
        teamLower.includes(dept) ||
        dept.includes(teamLower) ||
        labelLower.includes(dept) ||
        dept.includes(labelLower)
      );
    });
    return matched.length > 0 ? matched : employees;
  }, [employees, reassignTeam, availableTeamsList]);

  // Right Panel Edit / Dropdown & Card Collapse Toggle States
  const [isChangingUser, setIsChangingUser] = useState(false);
  const [isChangingAsset, setIsChangingAsset] = useState(false);
  const [isAddingAsset, setIsAddingAsset] = useState(false);
  const [isChangingVendor, setIsChangingVendor] = useState(false);
  const [assetSearchQuery, setAssetSearchQuery] = useState('');
  const [assetToChangeId, setAssetToChangeId] = useState<string | number | null>(null);
  const [selectedAssetCardId, setSelectedAssetCardId] = useState<string | number | null>(null);
  const [editingField, setEditingField] = useState<string | null>(null);
  const [selectedSlaPolicy, setSelectedSlaPolicy] = useState('Standard ITSM Service SLA');
  const [isSlaPolicyOpen, setIsSlaPolicyOpen] = useState(false);
  const [isSlaPriorityOpen, setIsSlaPriorityOpen] = useState(false);
  const [selectedSlaPriorityLabel, setSelectedSlaPriorityLabel] = useState<string>('Medium');
  const [slaCollapsed, setSlaCollapsed] = useState(false);
  const [ticketInfoCollapsed, setTicketInfoCollapsed] = useState(false);
  const [assetCardCollapsed, setAssetCardCollapsed] = useState(false);
  const [vendorCardCollapsed, setVendorCardCollapsed] = useState(false);
  const [appCardCollapsed, setAppCardCollapsed] = useState(false);
  const [isChangingApp, setIsChangingApp] = useState(false);
  const [endUserCollapsed, setEndUserCollapsed] = useState(false);

  const { licenses, fetchLicenses } = useLicenseStore();

  // Detect if current ticket is a software ticket type (e.g. Bug, Feature Request, Enhancement, Dev Task, Deployment, or Software Team)
  const isSoftwareTicket = useMemo(() => {
    if (!selectedTicket) return false;
    const tType = String(selectedTicket.type || (selectedTicket as any).ticketTypeName || '').toLowerCase();
    const tCode = String((selectedTicket as any).ticketTypeCode || selectedTicket.tag || selectedTicket.tagPrefix || '').toLowerCase();
    const tTeamKey = String(selectedTicket.teamKey || (selectedTicket as any).team || currentTicketTypeConfig?.teamKey || '').toLowerCase();
    const tTeamName = String(selectedTicket.teamName || currentTicketTypeConfig?.teamName || '').toLowerCase();
    const cfgVal = String(currentTicketTypeConfig?.value || '').toLowerCase();
    const cfgCode = String(currentTicketTypeConfig?.code || '').toLowerCase();
    const cfgPrefix = String(currentTicketTypeConfig?.tagPrefix || '').toLowerCase();

    return (
      tTeamKey === 'software' ||
      tTeamName.includes('software') ||
      cfgVal.startsWith('sw-') ||
      cfgCode.startsWith('sw_') ||
      ['bug', 'feat', 'enh', 'dev', 'dep'].includes(cfgPrefix) ||
      ['bug', 'feat', 'enh', 'dev', 'dep'].includes(tCode) ||
      ['bug', 'feature', 'enhancement', 'dev', 'deployment', 'defect', 'release', 'software'].some((k) => tType.includes(k)) ||
      cfgVal === 'sw-bug' ||
      cfgVal === 'sw-feature' ||
      cfgVal === 'sw-enhancement' ||
      cfgVal === 'sw-dev' ||
      cfgVal === 'sw-deployment'
    );
  }, [selectedTicket, currentTicketTypeConfig]);

  // Detect if current ticket is an HR / People ticket type (e.g. HR Enquiry, Leave Request, Onboarding, Offboarding)
  const isHrTicket = useMemo(() => {
    if (!selectedTicket) return false;
    const tType = String(selectedTicket.type || (selectedTicket as any).ticketTypeName || '').toLowerCase();
    const tCode = String((selectedTicket as any).ticketTypeCode || selectedTicket.tag || selectedTicket.tagPrefix || '').toLowerCase();
    const tTeamKey = String(selectedTicket.teamKey || (selectedTicket as any).team || currentTicketTypeConfig?.teamKey || '').toLowerCase();
    const tTeamName = String(selectedTicket.teamName || currentTicketTypeConfig?.teamName || '').toLowerCase();
    const cfgVal = String(currentTicketTypeConfig?.value || '').toLowerCase();
    const cfgCode = String(currentTicketTypeConfig?.code || '').toLowerCase();
    const cfgPrefix = String(currentTicketTypeConfig?.tagPrefix || '').toLowerCase();

    return (
      tTeamKey === 'hr' ||
      tTeamName.includes('hr') ||
      cfgVal.startsWith('hr-') ||
      cfgCode.startsWith('hr_') ||
      cfgPrefix.startsWith('hr') ||
      cfgPrefix === 'leave' ||
      cfgPrefix === 'onb' ||
      cfgPrefix === 'offb' ||
      ['hr', 'leave', 'onboarding', 'offboarding', 'payroll', 'benefits', 'attendance'].some((k) => tType.includes(k) || tCode.includes(k)) ||
      selectedTicket.originModule === 'people' ||
      selectedTicket.originModule === 'hr'
    );
  }, [selectedTicket, currentTicketTypeConfig]);

  // Determine whether to display the Asset Card and Top Asset Badge
  const showAssetCard = useMemo(() => {
    if (isSelectedSysGen) return false;
    if (isSoftwareTicket) return false;
    if (currentTicketTypeConfig && (currentTicketTypeConfig as any).enableAsset !== undefined) {
      return Boolean((currentTicketTypeConfig as any).enableAsset);
    }
    if (isHrTicket) return false;
    return true;
  }, [isSelectedSysGen, isSoftwareTicket, isHrTicket, currentTicketTypeConfig]);

  // Determine whether to display the Vendor Card and Top Vendor Badge
  const showVendorCard = useMemo(() => {
    if (isSelectedSysGen) return false;
    if (isSoftwareTicket) return false;
    if (currentTicketTypeConfig && (currentTicketTypeConfig as any).enableVendor !== undefined) {
      return Boolean((currentTicketTypeConfig as any).enableVendor);
    }
    if (isHrTicket) return false;
    return true;
  }, [isSelectedSysGen, isSoftwareTicket, isHrTicket, currentTicketTypeConfig]);

  // Determine whether to display the SLA Card
  const showSlaCard = useMemo(() => {
    if (isSelectedSysGen) return false;
    if (currentTicketTypeConfig && (currentTicketTypeConfig as any).enableSla !== undefined) {
      return Boolean((currentTicketTypeConfig as any).enableSla);
    }
    return true;
  }, [isSelectedSysGen, currentTicketTypeConfig]);

  // Resolves the currently linked software / application details
  const currentApp = useMemo(() => {
    if (!selectedTicket) return null;
    const ref = String(
      selectedTicket.softwareApplication ||
      (selectedTicket as any).software_application ||
      selectedTicket.primaryAssetCode ||
      (selectedTicket as any).primary_asset_code ||
      ''
    ).trim();

    const isHardwareCode = /^((AST|HW|LAP|SRV|PC|MON|PRN|NET|MOB|DEV)[-_#]|\d+$)/i.test(ref);

    if (ref && !isHardwareCode) {
      const matchSys = SYSTEM_APPLICATIONS.find(
        (app) => app.code.toLowerCase() === ref.toLowerCase() ||
          app.name.toLowerCase() === ref.toLowerCase() ||
          app.service.toLowerCase() === ref.toLowerCase()
      );
      if (matchSys) return matchSys;

      const matchLic = (licenses || []).find(
        (lic) => lic.name.toLowerCase() === ref.toLowerCase() || String(lic.id) === ref
      );
      if (matchLic) {
        return {
          name: matchLic.name,
          code: (matchLic.publisher || 'LIC').toUpperCase().slice(0, 6),
          type: matchLic.licenseType || 'Software License',
          service: matchLic.publisher || 'Vendor Tool',
          environment: 'Production',
          version: 'Active License',
          component: `${matchLic.seatsUsed || 0} / ${matchLic.totalSeats || 'Unlimited'} seats assigned`,
        };
      }

      return {
        name: ref,
        code: 'SW_APP',
        type: 'Software Application',
        service: 'software/module',
        environment: 'Production',
        version: '1.0.0',
        component: 'Application Module',
      };
    }

    if (isSoftwareTicket) {
      return SYSTEM_APPLICATIONS[0]; // Default to TeamOne Web Frontend
    }
    return null;
  }, [selectedTicket, isSoftwareTicket, licenses]);

  // Fetch licenses when viewing software tickets
  useEffect(() => {
    if (isSoftwareTicket && (!licenses || licenses.length === 0)) {
      fetchLicenses().catch(() => { });
    }
  }, [isSoftwareTicket, licenses, fetchLicenses]);

  const handleSelectApp = async (app: { name: string; code: string; environment?: string }) => {
    if (!selectedTicket) return;
    try {
      await updateTicket(selectedTicket.id, {
        primaryAssetCode: app.code,
        softwareApplication: app.name,
        primaryAssetId: undefined,
      } as any);
      toast.success(`Linked application: ${app.name}`);
      setIsChangingApp(false);
    } catch (err) {
      toast.error('Failed to link application');
    }
  };

  const handleUnlinkApp = async () => {
    if (!selectedTicket) return;
    try {
      await updateTicket(selectedTicket.id, {
        primaryAssetCode: '',
        softwareApplication: '',
      } as any);
      toast.success('Unlinked application from ticket');
      setIsChangingApp(false);
    } catch (err) {
      toast.error('Failed to unlink application');
    }
  };

  const slaPolicyList = useMemo(() => {
    const defaultList = [
      'Standard ITSM Service SLA',
      'Mission Critical 24x7 SLA',
      'Technical Engineering SLA',
      'Software Development & Bug SLA',
      'Security & Compliance Incident SLA',
      'VIP & Executive Support SLA',
      'HR Operations & Leave SLA',
      'Management & Governance SLA',
      'Supplier & Vendor Management SLA',
    ];
    const currentPol = selectedTicket?.slaPolicy || selectedTicket?.sla_policy;
    if (currentPol && !defaultList.includes(currentPol)) {
      defaultList.unshift(currentPol);
    }
    return defaultList;
  }, [selectedTicket?.slaPolicy, selectedTicket?.sla_policy]);

  const slaPriorityList = [
    'Critical',
    'High',
    'Medium',
    'Low',
  ];

  useEffect(() => {
    if (selectedTicket) {
      if (selectedTicket.priority === 'urgent') setSelectedSlaPriorityLabel('Critical');
      else if (selectedTicket.priority === 'high') setSelectedSlaPriorityLabel('High');
      else if (selectedTicket.priority === 'low') setSelectedSlaPriorityLabel('Low');
      else setSelectedSlaPriorityLabel('Medium');

      if (selectedTicket.slaPolicy || selectedTicket.sla_policy) {
        setSelectedSlaPolicy(selectedTicket.slaPolicy || selectedTicket.sla_policy || 'Standard ITSM Service SLA');
      }
    }
  }, [selectedTicket?.id, selectedTicket?.priority, selectedTicket?.slaPolicy, selectedTicket?.sla_policy]);

  // Live timer tick for SLA countdown
  const [currentTimestamp, setCurrentTimestamp] = useState(Date.now());
  useEffect(() => {
    const timer = setInterval(() => setCurrentTimestamp(Date.now()), 10000);
    return () => clearInterval(timer);
  }, []);

  // Real-time SLA & Time Tracking Calculation
  const slaTracker = useMemo(() => {
    if (!selectedTicket) return null;

    const p = String(selectedTicket.priority || 'medium').toLowerCase();
    const resolutionHours = p === 'urgent' || p === 'critical' ? 2 : p === 'high' ? 4 : p === 'low' ? 24 : 12;
    const responseMinutes = p === 'urgent' || p === 'critical' ? 15 : p === 'high' ? 30 : p === 'low' ? 240 : 60;

    const startMs = selectedTicket.slaStart
      ? new Date(selectedTicket.slaStart).getTime()
      : selectedTicket.createdAt
        ? new Date(selectedTicket.createdAt).getTime()
        : currentTimestamp - 3600000;

    const targetResMs = resolutionHours * 3600 * 1000;
    const targetRespMs = responseMinutes * 60 * 1000;

    const breachMs = selectedTicket.slaBreach
      ? new Date(selectedTicket.slaBreach).getTime()
      : startMs + targetResMs;

    const now = currentTimestamp;
    const isResolved = ['resolved', 'closed', 'fulfilled'].includes(String(selectedTicket.status || '').toLowerCase());
    const resolvedMs = selectedTicket.resolvedAt ? new Date(selectedTicket.resolvedAt).getTime() : now;

    // Resolution Elapsed & Remaining
    const resElapsedMs = isResolved ? Math.max(0, resolvedMs - startMs) : Math.max(0, now - startMs);
    const resRemainingMs = breachMs - now;
    const isResBreached = !isResolved && now > breachMs;
    const resProgressPercent = Math.min(100, Math.max(4, Math.round((resElapsedMs / targetResMs) * 100)));

    // Response Elapsed & Remaining
    const isTriggeredByOtherApp = Boolean(
      selectedTicket.originModule ||
      (selectedTicket as any).origin_module ||
      selectedTicket.primaryAssetId ||
      (selectedTicket as any).primary_asset_id ||
      selectedTicket.primaryAssetCode ||
      (selectedTicket as any).primary_asset_code ||
      selectedTicket.assetId ||
      (selectedTicket.assetTag && selectedTicket.assetTag !== '-') ||
      ['assets', 'asset', 'people', 'purchase_order', 'money', 'work'].includes(String(selectedTicket.source || (selectedTicket as any).origin_module || '').toLowerCase())
    );

    const hasResponded = Boolean(
      isTriggeredByOtherApp ||
      selectedTicket.firstResponseMet ||
      (selectedTicket as any).first_response_met ||
      selectedTicket.firstRespondedAt ||
      (selectedTicket as any).first_responded_at ||
      (selectedTicket as any).firstResponseAt ||
      (selectedTicket as any).first_response_at ||
      selectedTicket.sla?.response?.completedAt ||
      (Array.isArray(selectedTicket.history) && selectedTicket.history.some((h) => !h.internal && h.changedByName !== selectedTicket.requesterName))
    );
    const respCompletedMs = selectedTicket.firstRespondedAt
      ? new Date(selectedTicket.firstRespondedAt).getTime()
      : selectedTicket.sla?.response?.completedAt
        ? new Date(selectedTicket.sla?.response?.completedAt).getTime()
        : startMs + targetRespMs * 0.5;

    const respElapsedMs = hasResponded ? Math.max(0, respCompletedMs - startMs) : Math.max(0, now - startMs);
    const isRespBreached = !hasResponded && (now - startMs > targetRespMs);
    const respProgressPercent = hasResponded ? 100 : Math.min(100, Math.max(4, Math.round((respElapsedMs / targetRespMs) * 100)));

    const formatDuration = (ms: number) => {
      const isNeg = ms < 0;
      const abs = Math.abs(ms);
      const totalMin = Math.floor(abs / 60000);
      const hrs = Math.floor(totalMin / 60);
      const mins = totalMin % 60;
      if (hrs > 0) return `${isNeg ? '-' : ''}${hrs}h ${mins}m`;
      return `${isNeg ? '-' : ''}${mins}m`;
    };

    const formatTimer = (ms: number) => {
      const totalSec = Math.floor(Math.max(0, ms) / 1000);
      const hrs = String(Math.floor(totalSec / 3600)).padStart(2, '0');
      const mins = String(Math.floor((totalSec % 3600) / 60)).padStart(2, '0');
      const secs = String(totalSec % 60).padStart(2, '0');
      return `${hrs}:${mins}:${secs}`;
    };

    return {
      resolutionHours,
      responseMinutes,
      isResolved,
      isResBreached,
      resProgressPercent,
      resRemainingLabel: isResolved ? 'Met' : isResBreached ? `Breached by ${formatDuration(Math.abs(resRemainingMs))}` : `${formatDuration(resRemainingMs)} left`,
      resElapsedLabel: formatDuration(resElapsedMs),
      resTargetLabel: `${resolutionHours}h 00m`,
      hasResponded,
      isRespBreached,
      respProgressPercent,
      respRemainingLabel: hasResponded ? 'Met' : isRespBreached ? 'Breached' : `${formatDuration(Math.max(0, (startMs + targetRespMs) - now))} left`,
      respElapsedLabel: formatDuration(respElapsedMs),
      respTargetLabel: responseMinutes >= 60 ? `${responseMinutes / 60}h 00m` : `${responseMinutes}m`,
      timeSpentTimer: formatTimer(resElapsedMs),
    };
  }, [selectedTicket, currentTimestamp]);

  // Multi-Asset Management for Selected Ticket
  const relatedAssets = useMemo(() => {
    if (!selectedTicket) return [];
    const list: any[] = [];
    const seenIds = new Set<string>();

    if (Array.isArray(selectedTicket.relatedAssets) && selectedTicket.relatedAssets.length > 0) {
      selectedTicket.relatedAssets.forEach((item: any) => {
        const astId = typeof item === 'object' ? (item.id || item.asset_code) : item;
        const found = assets.find((a) => String(a.id) === String(astId) || a.asset_code === String(astId)) || (typeof item === 'object' ? item : null);
        if (found) {
          const key = String(found.id || found.asset_code);
          if (!seenIds.has(key)) {
            seenIds.add(key);
            list.push(found);
          }
        }
      });
    }

    if (selectedTicket.assetId || selectedTicket.asset || selectedTicket.assetTag) {
      const primaryRef = selectedTicket.assetId || selectedTicket.asset?.id || selectedTicket.assetTag;
      const found = assets.find((a) => String(a.id) === String(primaryRef) || a.asset_code === String(primaryRef)) || selectedTicket.asset;
      if (found) {
        const key = String(found.id || found.asset_code);
        if (!seenIds.has(key)) {
          list.unshift(found);
          seenIds.add(key);
        }
      }
    }

    return list;
  }, [selectedTicket?.relatedAssets, selectedTicket?.assetId, selectedTicket?.asset, selectedTicket?.assetTag, assets]);

  const primaryRelatedAssetId = useMemo(() => {
    if (!selectedTicket || relatedAssets.length === 0) return null;
    if (selectedTicket.primaryAssetId) {
      const match = relatedAssets.find((a) => String(a.id) === String(selectedTicket.primaryAssetId) || a.asset_code === String(selectedTicket.primaryAssetId));
      if (match) return match.id || match.asset_code;
    }
    if (selectedTicket.assetId) {
      const match = relatedAssets.find((a) => String(a.id) === String(selectedTicket.assetId) || a.asset_code === String(selectedTicket.assetId));
      if (match) return match.id || match.asset_code;
    }
    return relatedAssets[0].id || relatedAssets[0].asset_code;
  }, [selectedTicket?.primaryAssetId, selectedTicket?.assetId, relatedAssets]);

  const handleAddRelatedAsset = (ast: any) => {
    if (!selectedTicket) return;
    const isAlreadyLinked = relatedAssets.some((a) => String(a.id) === String(ast.id) || a.asset_code === ast.asset_code);
    if (isAlreadyLinked) {
      toast.error(`Asset ${ast.asset_code} is already linked`);
      return;
    }

    const nextList = [...relatedAssets, ast];
    const nextPrimaryId = primaryRelatedAssetId || ast.id;
    const primaryObj = (String(ast.id) === String(nextPrimaryId) ? ast : relatedAssets.find((a) => String(a.id) === String(nextPrimaryId))) || ast;

    const updates = {
      relatedAssets: nextList,
      primaryAssetId: nextPrimaryId,
      assetId: primaryObj.id,
      assetTag: primaryObj.asset_code,
      asset: primaryObj,
      assetDetails: primaryObj,
    };

    updateTicket(selectedTicket.id, updates);
    setSelectedTicket({ ...selectedTicket, ...updates });
    addHistory(selectedTicket.id, `Linked asset [${ast.asset_code}] ${ast.name}`, true);
    toast.success(`Asset ${ast.asset_code} linked to ticket!`);
    setIsAddingAsset(false);
    setAssetSearchQuery('');
  };

  const handleChangeRelatedAsset = (oldAssetId: string | number | null, newAst: any) => {
    if (!selectedTicket) return;

    const isAlreadyLinkedElsewhere = relatedAssets.some(
      (a) => (String(a.id) !== String(oldAssetId) && a.asset_code !== String(oldAssetId)) &&
        (String(a.id) === String(newAst.id) || a.asset_code === newAst.asset_code)
    );
    if (isAlreadyLinkedElsewhere) {
      toast.error(`Asset ${newAst.asset_code} is already linked to this ticket`);
      return;
    }

    let nextList: any[];
    if (oldAssetId) {
      nextList = relatedAssets.map((a) => (String(a.id) === String(oldAssetId) || a.asset_code === String(oldAssetId) ? newAst : a));
    } else {
      nextList = [newAst];
    }

    const wasPrimary = !oldAssetId || String(primaryRelatedAssetId) === String(oldAssetId);
    const nextPrimaryId = wasPrimary ? (newAst.id || newAst.asset_code) : primaryRelatedAssetId;
    const primaryObj = nextList.find((a) => String(a.id) === String(nextPrimaryId) || a.asset_code === String(nextPrimaryId)) || newAst;

    const updates = {
      relatedAssets: nextList,
      primaryAssetId: nextPrimaryId,
      assetId: primaryObj.id,
      assetTag: primaryObj.asset_code,
      asset: primaryObj,
      assetDetails: primaryObj,
    };

    updateTicket(selectedTicket.id, updates);
    setSelectedTicket({ ...selectedTicket, ...updates });
    addHistory(selectedTicket.id, `Replaced asset [${oldAssetId}] with [${newAst.asset_code}] ${newAst.name}`, true);
    toast.success(`Asset updated to ${newAst.asset_code}`);
    setSelectedAssetCardId(newAst.id || newAst.asset_code);
    setIsChangingAsset(false);
    setAssetToChangeId(null);
    setAssetSearchQuery('');
  };

  const handleRemoveRelatedAsset = (assetIdToRemove: string | number) => {
    if (!selectedTicket) return;
    const nextList = relatedAssets.filter((a) => String(a.id) !== String(assetIdToRemove) && a.asset_code !== String(assetIdToRemove));
    const wasPrimary = String(primaryRelatedAssetId) === String(assetIdToRemove);

    let updates: any;
    if (nextList.length === 0) {
      updates = {
        relatedAssets: [],
        primaryAssetId: null,
        assetId: null,
        assetTag: null,
        asset: null,
        assetDetails: null,
      };
    } else if (wasPrimary) {
      const newPrimaryObj = nextList[0];
      updates = {
        relatedAssets: nextList,
        primaryAssetId: newPrimaryObj.id,
        assetId: newPrimaryObj.id,
        assetTag: newPrimaryObj.asset_code,
        asset: newPrimaryObj,
        assetDetails: newPrimaryObj,
      };
    } else {
      updates = {
        relatedAssets: nextList,
      };
    }

    updateTicket(selectedTicket.id, updates);
    setSelectedTicket({ ...selectedTicket, ...updates });
    addHistory(selectedTicket.id, `Unlinked asset from ticket`, true);
    toast.success('Asset removed');
  };

  const handleUnlinkVendor = async () => {
    if (!selectedTicket) return;
    try {
      const updates = {
        vendorId: undefined,
        supplierOrgId: undefined,
        vendorName: undefined,
        effectiveVendorName: undefined,
        vendorEmail: undefined,
        vendorPhone: undefined,
        vendorSlaTerms: undefined,
      };
      await updateTicket(selectedTicket.id, updates as any);
      setSelectedTicket({ ...selectedTicket, ...updates });
      addHistory(selectedTicket.id, 'Vendor unlinked from ticket', true);
      toast.success('Vendor unlinked from ticket');
    } catch (err: any) {
      toast.error(err?.message || 'Failed to unlink vendor');
    }
  };

  const handleSelectVendor = async (nextVendorId: number | null) => {
    if (!selectedTicket) return;
    if (!nextVendorId) {
      await handleUnlinkVendor();
      return;
    }
    const vObj = useAssetCatalogStore.getState().vendors.find((v) => v.id === nextVendorId);
    try {
      const updates = {
        vendorId: nextVendorId,
        supplierOrgId: nextVendorId,
        vendorName: vObj?.name,
        effectiveVendorName: vObj?.name,
        vendorEmail: vObj?.email || vObj?.contactEmail || undefined,
        vendorPhone: vObj?.phone || undefined,
        vendorSlaTerms: vObj?.slaTerms || undefined,
      };
      await updateTicket(selectedTicket.id, updates as any);
      setSelectedTicket({ ...selectedTicket, ...updates });
      addHistory(selectedTicket.id, `Linked vendor: ${vObj?.name || nextVendorId}`, true);
      toast.success(vObj ? `Linked vendor: ${vObj.name}` : 'Vendor updated');
    } catch (err: any) {
      toast.error(err?.message || 'Failed to update vendor');
    }
  };

  const handleRelinkAsset = (assetReference: string) => {
    if (!selectedTicket) return;

    const targetAsset = assets.find((a) =>
      String(a.id) === String(assetReference) ||
      a.asset_code === String(assetReference) ||
      a.name === String(assetReference)
    );

    if (!targetAsset) return;

    const alreadyLinked = relatedAssets.some((a) => String(a.id) === String(targetAsset.id) || a.asset_code === String(targetAsset.asset_code));
    if (alreadyLinked) {
      if (!selectedTicket.primaryAssetId && targetAsset) {
        const updates = {
          primaryAssetId: targetAsset.id,
          assetId: targetAsset.id,
          assetTag: targetAsset.asset_code,
          asset: targetAsset,
          assetDetails: targetAsset,
        };
        updateTicket(selectedTicket.id, updates);
        setSelectedTicket({ ...selectedTicket, ...updates });
      }
      return;
    }

    const nextList = [...relatedAssets, targetAsset];
    const nextPrimaryId = selectedTicket.primaryAssetId || targetAsset.id;
    const updates = {
      relatedAssets: nextList,
      primaryAssetId: nextPrimaryId,
      assetId: targetAsset.id,
      assetTag: targetAsset.asset_code,
      asset: targetAsset,
      assetDetails: targetAsset,
    };

    updateTicket(selectedTicket.id, updates);
    setSelectedTicket({ ...selectedTicket, ...updates });
    addHistory(selectedTicket.id, `Linked asset [${targetAsset.asset_code}] ${targetAsset.name}`, true);
    toast.success(`Asset ${targetAsset.asset_code} linked to ticket`);
  };

  const handleSetPrimaryAsset = (assetIdToSet: string | number) => {
    if (!selectedTicket) return;
    const targetAsset = relatedAssets.find((a) => String(a.id) === String(assetIdToSet) || a.asset_code === String(assetIdToSet));
    if (!targetAsset) return;

    const updates = {
      primaryAssetId: targetAsset.id,
      assetId: targetAsset.id,
      assetTag: targetAsset.asset_code,
      asset: targetAsset,
      assetDetails: targetAsset,
    };

    updateTicket(selectedTicket.id, updates);
    setSelectedTicket({ ...selectedTicket, ...updates });
    addHistory(selectedTicket.id, `Set [${targetAsset.asset_code}] ${targetAsset.name} as Primary Asset`, true);
    toast.success(`${targetAsset.asset_code} set as Primary Asset`);
  };

  // Dynamic Column Width Resizer State (All 17 ITSM Columns)
  const [columnWidths, setColumnWidths] = useState<Record<string, number>>({
    select: 52,
    status: 115,
    team: 135,
    ticketId: 100,
    subject: 320,
    type: 110,
    client: 110,
    sla: 135,
    priority: 85,
    assetTag: 100,
    lastAction: 135,
    dateCreated: 135,
    staff: 145,
    issue: 130,
    issueDetail: 130,
    resolution: 135,
    dateClosed: 135,
  });

  const startXRef = useRef<number>(0);
  const startWidthRef = useRef<number>(0);

  const handleMouseDownResize = (colKey: string, e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    startXRef.current = e.clientX;
    startWidthRef.current = columnWidths[colKey] || 100;

    const handleMouseMove = (moveEvent: MouseEvent) => {
      const delta = moveEvent.clientX - startXRef.current;
      const newWidth = Math.max(50, startWidthRef.current + delta);
      setColumnWidths((prev) => ({ ...prev, [colKey]: newWidth }));
    };

    const handleMouseUp = () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
  };

  // Table Column Sort & Filter States
  const [sortConfig, setSortConfig] = useState<{ column: string | null; direction: 'asc' | 'desc' | null }>({
    column: null,
    direction: null,
  });
  const [columnFilters, setColumnFilters] = useState<Record<string, string[]>>({});
  const [columnSearchFilters, setColumnSearchFilters] = useState<Record<string, string>>({});
  const [activeFilterDropdown, setActiveFilterDropdown] = useState<string | null>(null);
  const filterDropdownContainerRef = useRef<HTMLTableSectionElement | null>(null);

  // Close filter popover on clicking outside
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        filterDropdownContainerRef.current &&
        !filterDropdownContainerRef.current.contains(e.target as Node)
      ) {
        setActiveFilterDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSortColumn = (colKey: string, direction?: 'asc' | 'desc' | null) => {
    if (direction !== undefined) {
      setSortConfig({ column: direction ? colKey : null, direction: direction || null });
      return;
    }
    if (sortConfig.column !== colKey) {
      setSortConfig({ column: colKey, direction: 'asc' });
    } else if (sortConfig.direction === 'asc') {
      setSortConfig({ column: colKey, direction: 'desc' });
    } else {
      setSortConfig({ column: null, direction: null });
    }
  };

  const handleColumnFilterChange = (colKey: string, values: string[]) => {
    setColumnFilters((prev) => {
      const next = { ...prev };
      if (values.length === 0) {
        delete next[colKey];
      } else {
        next[colKey] = values;
      }
      return next;
    });
  };

  const handleColumnSearchChange = (colKey: string, val: string) => {
    setColumnSearchFilters((prev) => {
      const next = { ...prev };
      if (!val.trim()) {
        delete next[colKey];
      } else {
        next[colKey] = val;
      }
      return next;
    });
  };

  const handleResetAllColumnFilters = () => {
    setColumnFilters({});
    setColumnSearchFilters({});
    setSortConfig({ column: null, direction: null });
  };

  // Action Modals State
  const [activeActionModal, setActiveActionModal] = useState<string | null>(null);
  const [actionInput, setActionInput] = useState({ to: '', subject: '', body: '', note: '', teamKey: 'support' });

  // New ticket modal state (strictly wired with TeamOne Employees & Assets)
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isAddCiOpen, setIsAddCiOpen] = useState(false);
  const [isCreateEmojiOpen, setIsCreateEmojiOpen] = useState(false);
  const [isHeadingMenuOpen, setIsHeadingMenuOpen] = useState(false);
  const [allSubtypes, setAllSubtypes] = useState<any[]>([]);
  useEffect(() => {
    apiClient.get('/support/ticket-types/subtypes').then((res: any) => {
      const data = res.data?.data || res.data;
      if (Array.isArray(data)) setAllSubtypes(data);
    }).catch(() => { });
  }, []);

  const [newForm, setNewForm] = useState({
    subject: '',
    type: 'incident' as Ticket['type'],
    subtype: '',
    subtypeId: '',
    priority: 'medium' as Ticket['priority'],
    urgency: 'medium' as 'low' | 'medium' | 'high' | 'urgent',
    impact: 'medium' as 'low' | 'medium' | 'high' | 'urgent',
    teamKey: 'support',
    category: 'Laptops',
    client: currentUserName,
    assetTag: '',
    description: '',
    requesterId: '',
    requesterName: currentUserName,
    requesterEmail: user?.email || '',
    requesterDepartment: '',
    requesterDesignation: '',
    requesterPhone: '',
    assetId: '',
    aiTriage: false,
    source: 'Manual',
    ciList: [] as string[],
    projectReference: '',
    clientReference: '',
    dueDate: '',
    meetingDate: '',
    completionEvidence: '',
  });

  const availableSubtypes = useMemo(() => {
    if (!newForm.type) return [];
    const selType = availableTicketTypes.find(t => t.value === newForm.type || String(t.id) === String(newForm.type) || t.code?.toLowerCase() === String(newForm.type).toLowerCase());
    const typeId = selType?.id || newForm.type;
    return allSubtypes.filter(st =>
      String(st.ticket_type_id) === String(typeId) ||
      String(st.ticketTypeId) === String(typeId) ||
      (selType && st.ticket_type_name?.toLowerCase() === selType.label?.toLowerCase())
    );
  }, [allSubtypes, newForm.type, availableTicketTypes]);

  // Automatically initialize default end-user from active logged-in employee / user
  useEffect(() => {
    if (activeEmployee) {
      setNewForm((prev) => ({
        ...prev,
        requesterId: String(activeEmployee.id),
        requesterName: activeEmployee.name,
        client: activeEmployee.name,
        requesterEmail: activeEmployee.email || user?.email || '',
        requesterDepartment: activeEmployee.department || '',
        requesterDesignation: activeEmployee.designation || '',
        requesterPhone: activeEmployee.phone || '',
      }));
    } else if (!newForm.requesterId && (currentUserName && currentUserName !== 'User')) {
      setNewForm((prev) => ({
        ...prev,
        requesterId: user?.id ? String(user.id) : '',
        requesterName: currentUserName,
        client: currentUserName,
        requesterEmail: user?.email || '',
      }));
    }
  }, [activeEmployee, currentUserName, user]);

  // Ensure newForm.type is always valid for the active teamKey
  useEffect(() => {
    if (availableTicketTypes.length > 0) {
      const normTeam = normalizeTeamKey(newForm.teamKey);
      const teamTypes = availableTicketTypes.filter(
        (tt) => !normTeam || normTeam === 'all' || tt.teamKey === normTeam || normalizeTeamKey(tt.teamKey, tt.teamName) === normTeam
      );
      const isCurrentTypeValid = teamTypes.some(
        (t) => String(t.id) === String(newForm.type) || t.value === newForm.type || t.code?.toLowerCase() === String(newForm.type).toLowerCase() || t.label?.toLowerCase() === String(newForm.type).toLowerCase()
      );
      if (!isCurrentTypeValid && teamTypes.length > 0) {
        setNewForm((prev) => ({
          ...prev,
          type: (teamTypes[0].id || teamTypes[0].value) as any,
        }));
      }
    }
  }, [availableTicketTypes, newForm.teamKey]);

  const [timelineInput, setTimelineInput] = useState('');
  const [isInternalNote, setIsInternalNote] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);

  // URL Search Parameters Synchronization Hook & State Sync
  const [searchParams, setSearchParams] = useSearchParams();
  const isUrlRestoredRef = useRef(false);

  // Helper to sync UI state to URL Query Parameters matching user specification:
  // e.g. /support/tickets?mainview=team&viewid=20&selid=2&sellevel=1&selparentid=all%20teams
  const syncStateToUrl = (
    mode: SidebarViewMode,
    sub: SubFilter,
    ticket: Ticket | null
  ) => {
    const params = new URLSearchParams();

    // 1. mainview (e.g. team, staff, type, status, mylist)
    params.set('mainview', mode);

    // 2. viewid (numeric view mode mapping: team -> 20, staff -> 21, etc.)
    const viewIdMap: Record<string, string> = {
      team: '20',
      staff: '21',
      type: '22',
      status: '23',
      mylist: '24',
    };
    params.set('viewid', viewIdMap[mode] || '20');

    // 3. sellevel, selparentid, selid & ticketId
    if (ticket) {
      params.set('sellevel', '2');
      params.set('selparentid', sub.teamKey || sub.value || mode || 'all teams');
      params.set('selid', ticket.ticketId || String(ticket.id));
      params.set('ticketId', ticket.ticketId || String(ticket.id));
      if (ticket.assetTag) {
        params.set('assetTag', ticket.assetTag);
      }
    } else {
      params.set('sellevel', sub.type === 'all' ? '0' : '1');
      params.set('selparentid', 'all teams');

      if (sub.type === 'teamUnassigned' || sub.type === 'teamAgent') {
        params.set('selid', sub.teamKey || 'support');
      } else if (sub.type === 'staff' || sub.type === 'staffUnassigned') {
        params.set('selid', sub.value || 'unassigned');
      } else if (sub.type === 'status') {
        params.set('selid', sub.value || 'new');
      } else if (sub.type === 'ticketType') {
        params.set('selid', sub.value || 'incident');
      } else if (sub.type === 'myList') {
        params.set('selid', sub.value || 'allOpen');
      } else {
        params.set('selid', '2');
      }
    }

    setSearchParams(params, { replace: true });
  };

  useEffect(() => {
    fetchQueuesSummary();
    fetchQueues();
    fetchAgents();
    fetchMgmtAgents();
    fetchTickets();
    fetchEmployees();
    fetchAssets();
    fetchWorkflows();
    fetchTicketTypes();
    fetchExtendedWorkflows();
    fetchTicketActions();
    fetchCategories();
    fetchImpacts();
    fetchUrgencies();
    fetchEndUsers();

    // Silent background poll every 8s so inbound emails, portal tickets, teams & agents updates appear immediately
    const pollAll = () => {
      fetchTickets(undefined, true);
      fetchQueuesSummary();
      fetchQueues();
      fetchAgents();
      fetchMgmtAgents();
    };

    const interval = setInterval(pollAll, 8000);
    window.addEventListener('focus', pollAll);

    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', pollAll);
    };
  }, []);

  // Sync URL -> State on initial load once tickets are loaded
  useEffect(() => {
    if (!isUrlRestoredRef.current) {
      const createParam = searchParams.get('create');
      const assetIdParam = searchParams.get('assetId');
      const assetTagParam = searchParams.get('assetTag');
      const subjectParam = searchParams.get('subject');
      const typeParam = searchParams.get('type');
      const teamParam = searchParams.get('team');
      const categoryParam = searchParams.get('category');

      if (createParam === 'true') {
        const next = new URLSearchParams(searchParams);
        next.delete('create');
        setSearchParams(next, { replace: true });
        setIsCreateModalOpen(true);
        const linkedAst = assets.find((a) => a.id === assetIdParam || a.asset_code === assetTagParam);
        const resolvedTeam = teamParam ? normalizeTeamKey(teamParam) : 'support';
        const teamTypes = availableTicketTypes.filter(
          (tt) => tt.teamKey === resolvedTeam || normalizeTeamKey(tt.teamKey, tt.teamName) === resolvedTeam
        );
        const matchedType = typeParam
          ? teamTypes.find((t) => String(t.id) === typeParam || t.value === typeParam || t.code?.toLowerCase() === typeParam.toLowerCase())
          : (teamTypes.find((t) => t.code?.toLowerCase() === 'inc' || t.value?.includes('incident')) || teamTypes[0]);

        setNewForm((prev) => ({
          ...prev,
          assetId: linkedAst?.id || assetIdParam || '',
          assetTag: linkedAst?.asset_code || assetTagParam || '',
          subject: subjectParam ? decodeURIComponent(subjectParam) : prev.subject,
          teamKey: resolvedTeam,
          type: matchedType ? (matchedType.id || matchedType.value) : (teamTypes[0] ? (teamTypes[0].id || teamTypes[0].value) : prev.type),
          category: categoryParam ? decodeURIComponent(categoryParam) : (linkedAst?.category || prev.category || 'Hardware'),
        }));
      }
    }

    if (tickets.length > 0 && !isUrlRestoredRef.current) {
      isUrlRestoredRef.current = true;

      const mainviewParam = searchParams.get('mainview') as SidebarViewMode | null;
      if (mainviewParam && ['team', 'staff', 'type', 'status', 'mylist'].includes(mainviewParam)) {
        setSidebarViewMode(mainviewParam);
      }

      const ticketIdParam = searchParams.get('ticketId') || searchParams.get('selid');
      const selLevelParam = searchParams.get('sellevel');

      if (ticketIdParam && (selLevelParam === '2' || searchParams.get('ticketId'))) {
        const found = tickets.find(
          (t) => t.ticketId === ticketIdParam || String(t.id) === ticketIdParam
        );
        if (found) {
          setSelectedTicket(found);
        }
      } else if (selLevelParam === '1' && mainviewParam) {
        const selId = searchParams.get('selid');
        if (selId) {
          if (mainviewParam === 'type') {
            setSubFilter({ type: 'ticketType', value: selId });
          } else if (mainviewParam === 'status') {
            setSubFilter({ type: 'status', value: selId });
          } else if (mainviewParam === 'staff') {
            setSubFilter({ type: 'staff', value: selId });
          }
        }
      }
    }
  }, [tickets, assets, searchParams]);

  // Sync State -> URL whenever user changes mode, subFilter, or selectedTicket
  useEffect(() => {
    if (isUrlRestoredRef.current) {
      syncStateToUrl(sidebarViewMode, subFilter, selectedTicket);
    }
  }, [sidebarViewMode, subFilter, selectedTicket]);

  const handleRefresh = async () => {
    setIsRefreshing(true);
    try {
      await Promise.allSettled([
        fetchQueuesSummary(),
        fetchQueues(),
        fetchAgents(),
        fetchMgmtAgents(),
        fetchTickets(),
        fetchEmployees(),
        fetchAssets(),
      ]);
      if (selectedTicket?.id) {
        await fetchTicket(selectedTicket.id);
      }
      toast.success('Tickets refreshed');
    } catch {
      // ignore
    } finally {
      setIsRefreshing(false);
    }
  };

  const handleSaveSubject = async () => {
    if (!selectedTicket) {
      setIsEditingSubject(false);
      return;
    }
    const newSubject = subjectInput.trim();
    if (!newSubject) {
      toast.error('Subject cannot be empty');
      return;
    }
    setIsEditingSubject(false);

    // 1. Immediately update local selectedTicket so UI updates instantly
    setSelectedTicket((prev) => (prev ? { ...prev, subject: newSubject } : null));

    // 2. Update in store and localStorage
    await updateTicket(selectedTicket.id, { subject: newSubject });

    // 3. Re-sync from store to keep references unified
    const refreshed = useTicketStore
      .getState()
      .tickets.find(
        (tk) =>
          String(tk.id) === String(selectedTicket.id) ||
          String(tk.ticketId) === String(selectedTicket.ticketId)
      );
    if (refreshed) {
      setSelectedTicket({ ...refreshed, subject: newSubject });
    }

    toast.success('Subject updated');
  };

  // Auto-populate when selecting an Employee in Create Modal
  const handleSelectEmployee = (empId: string) => {
    const emp = employees.find((e) => e.id === empId);
    if (emp) {
      setNewForm((prev) => ({
        ...prev,
        client: emp.displayName || `${emp.firstName} ${emp.lastName}`.trim(),
        requesterId: emp.id,
        requesterName: emp.displayName || `${emp.firstName} ${emp.lastName}`.trim(),
        requesterEmail: emp.email,
        requesterDepartment: emp.department || '',
        requesterDesignation: emp.designation || '',
        requesterPhone: emp.phone || '',
      }));
    }
  };

  // Auto-populate when selecting an Asset in Create Modal
  const handleSelectAsset = (astId: string) => {
    const ast = assets.find((a) => a.id === astId || a.asset_code === astId);
    if (ast) {
      setNewForm((prev) => ({
        ...prev,
        assetTag: ast.asset_code,
        assetId: ast.id,
      }));
    }
  };

  // Match Employee object for selectedTicket
  const matchedEmployee = useMemo(() => {
    if (!selectedTicket) return null;
    return employees.find(
      (e) =>
        String(e.id) === String(selectedTicket.requesterId) ||
        String((e as any).userId || (e as any).user_id) === String(selectedTicket.requesterId) ||
        String(e.id) === String((selectedTicket as any).requesterEmployeeId) ||
        (selectedTicket.requesterEmail && e.email?.toLowerCase() === selectedTicket.requesterEmail?.toLowerCase()) ||
        (selectedTicket.requesterName && (e.displayName?.toLowerCase() === selectedTicket.requesterName?.toLowerCase() || `${e.firstName || ''} ${e.lastName || ''}`.trim().toLowerCase() === selectedTicket.requesterName?.toLowerCase())) ||
        (selectedTicket.client && (e.displayName?.toLowerCase() === selectedTicket.client?.toLowerCase() || `${e.firstName || ''} ${e.lastName || ''}`.trim().toLowerCase() === selectedTicket.client?.toLowerCase()))
    );
  }, [employees, selectedTicket]);

  const handleReassignEndUser = (empId: string) => {
    if (!selectedTicket || !empId) return;
    const emp = employees.find((e) => String(e.id) === String(empId) || String((e as any).userId || (e as any).user_id) === String(empId));
    if (emp) {
      const name = emp.displayName || `${emp.firstName || ''} ${emp.lastName || ''}`.trim();
      const updates = {
        requesterId: String(emp.id),
        requesterName: name,
        client: name,
        requesterEmail: emp.email || '',
        requesterDepartment: emp.department || '',
        department: emp.department || '',
        requesterDesignation: emp.designation || '',
        requesterPhone: emp.phone || '',
      };
      updateTicket(selectedTicket.id, updates);
      setSelectedTicket({
        ...selectedTicket,
        ...updates,
      });
      toast.success(`End user changed to ${name}`);
    }
    setIsChangingUser(false);
  };

  // Change SLA Priority directly in Right Panel
  const handleUpdatePrioritySla = (newPriority: Ticket['priority']) => {
    if (!selectedTicket) return;
    if (newPriority === selectedTicket.priority) return;
    const hours = newPriority === 'urgent' ? 2 : newPriority === 'high' ? 4 : newPriority === 'medium' ? 12 : 24;
    const breachIso = new Date(Date.now() + hours * 3600 * 1000).toISOString();

    updateTicket(selectedTicket.id, { priority: newPriority, slaBreach: breachIso });
    setSelectedTicket({ ...selectedTicket, priority: newPriority, slaBreach: breachIso });
  };

  const toggleTeamExpand = (teamKey: string, e: React.MouseEvent) => {
    e.stopPropagation();
    const next = new Set(expandedTeams);
    if (next.has(teamKey)) next.delete(teamKey);
    else next.add(teamKey);
    setExpandedTeams(next);
  };

  // Helper to check if a ticket matches the top toolbar status/preset dropdown filter
  const matchesDropdownFilter = useCallback(
    (t: Ticket) => {
      if (!selectedStatus || selectedStatus === 'all' || selectedStatus === 'all-tickets') return true;
      if (selectedStatus === 'actions-last-month') {
        const lastActionTime = new Date(t.updatedAt || t.createdAt).getTime();
        const thirtyDaysAgo = Date.now() - 30 * 24 * 60 * 60 * 1000;
        return !isNaN(lastActionTime) && lastActionTime >= thirtyDaysAgo;
      }
      if (selectedStatus === 'actions-last-week') {
        const lastActionTime = new Date(t.updatedAt || t.createdAt).getTime();
        const sevenDaysAgo = Date.now() - 7 * 24 * 60 * 60 * 1000;
        return !isNaN(lastActionTime) && lastActionTime >= sevenDaysAgo;
      }
      if (selectedStatus === 'actions-since-yesterday') {
        const lastActionTime = new Date(t.updatedAt || t.createdAt).getTime();
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        yesterday.setHours(0, 0, 0, 0);
        return !isNaN(lastActionTime) && lastActionTime >= yesterday.getTime();
      }
      if (selectedStatus === 'closed-tickets' || selectedStatus === 'closed') {
        return t.status === 'resolved' || t.status === 'closed';
      }
      if (selectedStatus === 'my-closed-tickets') {
        const isAssignedToMe =
          (t.assigneeName &&
            (t.assigneeName.toLowerCase().includes(currentUserName.toLowerCase()) ||
              currentUserName.toLowerCase().includes(t.assigneeName.toLowerCase()))) ||
          (user && (t.assigneeName === user.name || t.assigneeId === user.id));
        return Boolean(isAssignedToMe && (t.status === 'resolved' || t.status === 'closed'));
      }
      if (selectedStatus === 'my-open-tickets-incl-sla-hold') {
        const isAssignedToMe =
          (t.assigneeName &&
            (t.assigneeName.toLowerCase().includes(currentUserName.toLowerCase()) ||
              currentUserName.toLowerCase().includes(t.assigneeName.toLowerCase()))) ||
          (user && (t.assigneeName === user.name || t.assigneeId === user.id));
        return Boolean(isAssignedToMe && t.status !== 'resolved' && t.status !== 'closed');
      }
      if (selectedStatus === 'open-tickets') {
        return (
          t.status !== 'resolved' &&
          t.status !== 'closed' &&
          t.status !== 'on-hold' &&
          t.status !== 'pending'
        );
      }
      if (selectedStatus === 'open-tickets-incl-sla-hold') {
        return t.status !== 'resolved' && t.status !== 'closed';
      }
      if (selectedStatus === 'tickets-on-hold' || selectedStatus === 'on-hold') {
        return t.status === 'on-hold' || t.status === 'pending' || (t.status || '').toLowerCase().includes('hold');
      }
      return t.status === selectedStatus;
    },
    [selectedStatus, currentUserName, user]
  );

  // Tickets filtered ONLY by the top dropdown filter (selectedStatus)
  // Powers all sidebar counts (Team Queues & Staff, Type, Status, Staff, My Lists)
  // This ensures counts remain visible at all times across all options
  const dropdownFilteredTickets = useMemo(() => {
    return tickets.filter(matchesDropdownFilter);
  }, [tickets, matchesDropdownFilter]);

  // Unified roster of authorized support agents assigned by Support Admin in Agent Management
  const assignedAgentsRoster = useMemo(() => {
    const list: Array<{ id: string; userId?: string; name: string; email?: string; teams: string[] }> = [];
    const seen = new Set<string>();

    // 1. Primary source of truth: AgentManagementStore (where Support Admin configures team assignments)
    (mgmtAgents || []).forEach((ag) => {
      if ((ag.status || 'active').toLowerCase() !== 'active') return;
      const name = `${ag.firstName || ''} ${ag.lastName || ''}`.trim() || ag.email;
      const teamKeys: string[] = [];
      (ag.teams || []).forEach((m) => {
        const rawTeamKey = m.teamKey || (m as any).teamCode || '';
        const k = normalizeTeamKey(rawTeamKey, m.teamName);
        if (k && !teamKeys.includes(k)) teamKeys.push(k);
        const rawCode = String(rawTeamKey).toLowerCase();
        if (rawCode && !teamKeys.includes(rawCode)) teamKeys.push(rawCode);
        if (m.teamName) {
          const normName = String(m.teamName).toLowerCase();
          if (!teamKeys.includes(normName)) teamKeys.push(normName);
        }
        if (m.teamId) {
          const strId = String(m.teamId);
          if (!teamKeys.includes(strId)) teamKeys.push(strId);
        }
      });
      const idKey = String(ag.id || ag.userId || ag.email).toLowerCase();
      if (!seen.has(idKey)) {
        seen.add(idKey);
        list.push({
          id: String(ag.id),
          userId: ag.userId ? String(ag.userId) : undefined,
          name,
          email: ag.email,
          teams: teamKeys,
        });
      }
    });

    // 2. Secondary source / sync: SupportSettingsStore
    (storeAgents || []).forEach((sa) => {
      if ((sa.status || 'active').toLowerCase() !== 'active') return;
      const name = `${sa.first_name || ''} ${sa.last_name || ''}`.trim() || sa.name || sa.email;
      const idKey = String(sa.id || sa.email).toLowerCase();
      if (seen.has(idKey)) {
        const existing = list.find(
          (r) => r.id.toLowerCase() === idKey || (r.email && sa.email && r.email.toLowerCase() === sa.email.toLowerCase())
        );
        if (existing) {
          (sa.assigned_teams || []).forEach((t) => {
            const norm = normalizeTeamKey(t, t);
            if (norm && !existing.teams.includes(norm)) existing.teams.push(norm);
          });
        }
        return;
      }
      const teamKeys: string[] = [];
      (sa.assigned_teams || []).forEach((t) => {
        const norm = normalizeTeamKey(t, t);
        if (norm && !teamKeys.includes(norm)) teamKeys.push(norm);
      });
      (sa.assigned_queues || []).forEach((q) => {
        const norm = normalizeTeamKey(q, q);
        if (norm && !teamKeys.includes(norm)) teamKeys.push(norm);
      });
      seen.add(idKey);
      list.push({
        id: String(sa.id),
        name,
        email: sa.email,
        teams: teamKeys,
      });
    });

    return list;
  }, [mgmtAgents, storeAgents]);

  // Helper to test if an agent belongs to a team
  const isAgentInTeamRoster = useCallback(
    (agent: { teams: string[] }, teamKeyOrLabel: string): boolean => {
      if (!agent || !teamKeyOrLabel) return false;
      const normTarget = normalizeTeamKey(teamKeyOrLabel, teamKeyOrLabel);
      return agent.teams.some((t) => {
        const normT = normalizeTeamKey(t, t);
        return normT === normTarget || t === normTarget || t === teamKeyOrLabel.toLowerCase();
      });
    },
    []
  );

  // Helper to match a ticket's assignee to an agent on a specific team
  const findMatchedTeamAgent = useCallback(
    (t: Ticket, teamKeyOrLabel: string) => {
      if (!t || !t.assigneeName || t.assigneeName === 'Unassigned') return null;
      const normAssignee = t.assigneeName.trim().toLowerCase();
      const tAssigneeId = t.assigneeId != null ? String(t.assigneeId) : null;
      const tAssigneeEmail = (t as any).assigneeEmail ? String((t as any).assigneeEmail).toLowerCase() : null;

      const teamAgents = assignedAgentsRoster.filter((ag) => isAgentInTeamRoster(ag, teamKeyOrLabel));
      for (const ag of teamAgents) {
        const agName = ag.name.trim().toLowerCase();
        if (agName === normAssignee) return ag;
        if (agName.includes(normAssignee) || normAssignee.includes(agName)) return ag;
        if (tAssigneeId && (ag.id === tAssigneeId || (ag.userId && ag.userId === tAssigneeId))) return ag;
        if (tAssigneeEmail && ag.email && ag.email.toLowerCase() === tAssigneeEmail) return ag;
      }
      return null;
    },
    [assignedAgentsRoster, isAgentInTeamRoster]
  );

  // Compute breakdown of tickets per team for Unassigned and Staff members
  const teamBreakdown = useMemo(() => {
    const map: Record<string, { total: number; unassigned: number; agents: Record<string, number> }> = {};

    filteredQueuesSummary.forEach((q) => {
      const k = normalizeTeamKey(q.key, q.label);
      map[k] = { total: 0, unassigned: 0, agents: {} };
    });
    storeQueues.forEach((sq) => {
      const rawK = sq.key || sq.queue_key || sq.team_key || (sq as any).code || sq.name || '';
      const rawL = sq.label || sq.queue_label || sq.team_name || sq.name || sq.key || '';
      const k = normalizeTeamKey(rawK, rawL);
      if (k && !map[k]) {
        map[k] = { total: 0, unassigned: 0, agents: {} };
      }
    });

    // Populate official assigned agents for each team (only agents assigned in Agent Management)
    Object.keys(map).forEach((k) => {
      const teamAgents = assignedAgentsRoster.filter((ag) => isAgentInTeamRoster(ag, k));
      teamAgents.forEach((ag) => {
        map[k].agents[ag.name] = 0;
      });
    });

    dropdownFilteredTickets.forEach((t) => {
      const team = normalizeTeamKey(t.teamKey, t.teamName);
      if (!map[team]) {
        map[team] = { total: 0, unassigned: 0, agents: {} };
        const teamAgents = assignedAgentsRoster.filter((ag) => isAgentInTeamRoster(ag, team));
        teamAgents.forEach((ag) => {
          map[team].agents[ag.name] = 0;
        });
      }
      map[team].total += 1;

      const matched = findMatchedTeamAgent(t, team);
      if (matched) {
        map[team].agents[matched.name] = (map[team].agents[matched.name] || 0) + 1;
      } else {
        // Any ticket without an authorized team agent rolls into Unassigned
        map[team].unassigned += 1;
      }
    });

    return map;
  }, [dropdownFilteredTickets, filteredQueuesSummary, storeQueues, assignedAgentsRoster, isAgentInTeamRoster, findMatchedTeamAgent]);

  // Helper to match a ticket to a ticket type definition robustly
  const isTicketOfType = useCallback(
    (
      t: Ticket,
      tt: { id?: string; value: string; label: string; code?: string; tagPrefix?: string }
    ): boolean => {
      if (!t || !tt) return false;

      // 1. Direct ID match (most authoritative)
      if (t.ticketTypeId != null && tt.id != null && String(t.ticketTypeId) === String(tt.id)) {
        return true;
      }

      // 2. Exact or case-insensitive label / name match
      if (t.type && tt.label && t.type.trim().toLowerCase() === tt.label.trim().toLowerCase()) {
        return true;
      }

      // 3. Slug / value match (e.g. 'sd-incident', 'sd-access')
      if (t.type && tt.value) {
        const normTicket = t.type.trim().toLowerCase().replace(/\s+/g, '-').replace(/_/g, '-');
        const normVal = tt.value.trim().toLowerCase().replace(/\s+/g, '-').replace(/_/g, '-');
        if (normTicket === normVal) return true;
      }

      // 4. Code match (e.g. 'TT0001', 'TT0005', 'SD_INC')
      if (tt.code) {
        const c = tt.code.trim().toLowerCase();
        if (t.type && t.type.trim().toLowerCase() === c) return true;
        if ((t as any).ticketTypeCode && String((t as any).ticketTypeCode).trim().toLowerCase() === c) return true;
      }

      // 5. Prefix match (e.g. 'INC', 'LVE', 'BUG', 'PUR', 'ACC')
      if (tt.tagPrefix) {
        const p = tt.tagPrefix.trim().toUpperCase();
        const tPrefix = String(
          t.tagPrefix || t.tag || (t.ticketNumber || t.ticketId || '').split('#')[0] || ''
        ).trim().toUpperCase();
        if (p && tPrefix && p === tPrefix) return true;
      }

      return false;
    },
    []
  );

  // Compute breakdown by Type, Status, Staff, and My Lists
  const typeBuckets = useMemo(() => {
    // 1. Initialize items from availableTicketTypes preserving catalog order
    const items: Array<{
      key: string;
      id?: string;
      label: string;
      code?: string;
      tagPrefix?: string;
      teamName?: string;
      count: number;
    }> = [];

    const itemMap = new Map<string, typeof items[0]>();

    availableTicketTypes.forEach((tt) => {
      const key = tt.label || (tt.id != null ? String(tt.id) : tt.value);
      if (!itemMap.has(key)) {
        const item = {
          key,
          id: tt.id,
          label: tt.label || tt.value || 'Incident',
          code: tt.code,
          tagPrefix: tt.tagPrefix,
          teamName: tt.teamName,
          count: 0,
        };
        itemMap.set(key, item);
        items.push(item);
      }
    });

    // 2. Count matching tickets from dropdownFilteredTickets
    dropdownFilteredTickets.forEach((t) => {
      const matched = availableTicketTypes.find((tt) => isTicketOfType(t, tt));
      if (matched) {
        const key = matched.label || (matched.id != null ? String(matched.id) : matched.value);
        const bucket = itemMap.get(key);
        if (bucket) {
          bucket.count += 1;
        }
      } else {
        const rawLabel = t.type || 'Other';
        let bucket = itemMap.get(rawLabel);
        if (!bucket) {
          bucket = {
            key: rawLabel,
            label: rawLabel,
            count: 0,
          };
          itemMap.set(rawLabel, bucket);
          items.push(bucket);
        }
        bucket.count += 1;
      }
    });

    return items;
  }, [dropdownFilteredTickets, availableTicketTypes, isTicketOfType]);

  const statusBuckets = useMemo(() => {
    // Canonical workflow statuses in standard lifecycle order
    const coreOrder = [
      'New',
      'Draft',
      'Backlog',
      'In Progress',
      'Pending',
      'With User',
      'With Supplier',
      'On Hold',
      'Awaiting Approval',
      'With Management',
      'With HR',
      'Resolved',
      'Closed',
    ];

    const acc: Record<string, number> = {};
    coreOrder.forEach((st) => {
      acc[st] = 0;
    });

    dropdownFilteredTickets.forEach((t) => {
      const norm = normalizeStatusName(t.status);
      acc[norm] = (acc[norm] || 0) + 1;
    });

    return acc;
  }, [dropdownFilteredTickets]);

  const staffBuckets = useMemo(() => {
    const acc: Record<string, number> = { Unassigned: 0 };
    assignedAgentsRoster.forEach((ag) => {
      acc[ag.name] = 0;
    });

    dropdownFilteredTickets.forEach((t) => {
      if (!t.assigneeName || t.assigneeName === 'Unassigned') {
        acc.Unassigned = (acc.Unassigned || 0) + 1;
        return;
      }
      const matched = assignedAgentsRoster.find((ag) => {
        const agName = ag.name.toLowerCase();
        const tName = (t.assigneeName || '').toLowerCase();
        return agName === tName || agName.includes(tName) || tName.includes(agName);
      });
      if (matched) {
        acc[matched.name] = (acc[matched.name] || 0) + 1;
      } else {
        acc.Unassigned = (acc.Unassigned || 0) + 1;
      }
    });
    return acc;
  }, [dropdownFilteredTickets, assignedAgentsRoster]);

  // Real active support agents for assigning tickets (excludes non-agent employees)
  const supportAgentsList = useMemo(() => {
    const list: Array<{ id: string; userId?: string; name: string; email?: string; teams: string[] }> = [];
    const seenNames = new Set<string>();

    assignedAgentsRoster.forEach((a) => {
      if (!seenNames.has(a.name.toLowerCase())) {
        seenNames.add(a.name.toLowerCase());
        list.push({
          id: a.id,
          userId: a.userId,
          name: a.name,
          email: a.email,
          teams: a.teams,
        });
      }
    });

    // Fallback: If ticket has an assignee not in assignedAgentsRoster, keep them selectable so value is not lost
    if (selectedTicket?.assigneeName && selectedTicket.assigneeName !== 'Unassigned') {
      if (!seenNames.has(selectedTicket.assigneeName.toLowerCase())) {
        seenNames.add(selectedTicket.assigneeName.toLowerCase());
        list.push({
          id: String(selectedTicket.assigneeId || selectedTicket.assigneeName),
          name: selectedTicket.assigneeName,
          teams: [selectedTicket.teamKey || 'support'],
        });
      }
    }

    return list.sort((a, b) => a.name.localeCompare(b.name));
  }, [assignedAgentsRoster, selectedTicket?.assigneeName, selectedTicket?.assigneeId, selectedTicket?.teamKey]);

  const myListBuckets = useMemo(() => {
    const now = Date.now();
    return {
      allOpen: dropdownFilteredTickets.filter((t) => t.status !== 'resolved' && t.status !== 'closed').length,
      assignedToMe: dropdownFilteredTickets.filter((t) => t.assigneeName && t.assigneeName !== 'Unassigned').length,
      slaBreached: dropdownFilteredTickets.filter((t) => t.slaBreach && new Date(t.slaBreach).getTime() < now).length,
      closed: dropdownFilteredTickets.filter((t) => t.status === 'resolved' || t.status === 'closed').length,
    };
  }, [dropdownFilteredTickets]);

  // Compute distinct options and item counts for each column header filter popover
  const getColumnDistinctValues = useMemo(() => {
    const cache: Record<string, { value: string; count: number }[]> = {};

    const compute = (colKey: string) => {
      const counts: Record<string, number> = {};
      tickets.forEach((t) => {
        let val = '';
        switch (colKey) {
          case 'status':
            val = normalizeStatusName(t.status);
            break;
          case 'team':
            val = t.teamName || 'Support Team';
            break;
          case 'ticketId':
            val = t.ticketId || '';
            break;
          case 'type':
            val = t.type || 'incident';
            break;
          case 'client':
            val = t.client || t.requesterName || 'Giri';
            break;
          case 'assetTag':
            val = t.assetTag || '-';
            break;
          case 'priority':
            val = t.priority || 'low';
            break;
          case 'staff':
            val = t.assigneeName || 'Unassigned';
            break;
          case 'issue':
            val = t.category || t.teamName || 'Support Team';
            break;
          case 'issueDetail':
            val = t.subcategory || 'General Issue';
            break;
          case 'resolution':
            val = t.resolution || '-';
            break;
          default:
            val = '';
        }
        if (val) {
          counts[val] = (counts[val] || 0) + 1;
        }
      });
      return Object.entries(counts)
        .map(([value, count]) => ({ value, count }))
        .sort((a, b) => b.count - a.count);
    };

    ['status', 'team', 'type', 'client', 'assetTag', 'priority', 'staff', 'issue', 'issueDetail', 'resolution', 'ticketId'].forEach(
      (k) => {
        cache[k] = compute(k);
      }
    );

    return cache;
  }, [tickets]);

  // Filtered tickets based on active SubFilter, search query, status select, and column header filters
  const filteredTickets = useMemo(() => {
    return tickets.filter((t) => {
      // 1. Must match top toolbar status/preset dropdown filter
      if (!matchesDropdownFilter(t)) return false;

      // 2. Sidebar Queue SubFilter
      if (sidebarViewMode === 'team' || sidebarViewMode === 'all') {
        if (selectedTeamKey && selectedTeamKey !== 'all') {
          const sel = selectedTeamKey.toLowerCase();
          const tKey = (t.teamKey || '').toLowerCase();
          const tName = (t.teamName || '').toLowerCase();
          const isSupport = sel === 'support' && (tKey === 'support' || tKey === 'sd' || tName.includes('support') || (!tKey && !tName));
          const isHr = sel === 'hr' && (tKey.includes('hr') || tName.includes('hr'));
          const isAdministration = (sel === 'administration' || sel === 'technical' || sel === 'admin') && (tKey.includes('admin') || tName.includes('admin') || tKey.includes('technical') || tName.includes('technical'));
          const isSoftware = sel === 'software' && (tKey.includes('software') || tName.includes('software'));
          const isManagement = sel === 'management' && (tKey.includes('management') || tName.includes('management'));
          const isSupplier = sel === 'supplier' && (tKey.includes('supplier') || tName.includes('supplier'));
          const directMatch = tKey === sel || tName.toLowerCase() === sel;
          if (!isSupport && !isHr && !isAdministration && !isSoftware && !isManagement && !isSupplier && !directMatch) {
            return false;
          }
        }
        if (subFilter.type === 'teamUnassigned') {
          const isAssigned = Boolean(findMatchedTeamAgent(t, selectedTeamKey));
          if (isAssigned) return false;
        } else if (subFilter.type === 'teamAgent') {
          const matched = findMatchedTeamAgent(t, selectedTeamKey);
          if (!matched || matched.name !== subFilter.value) return false;
        }
      } else if (sidebarViewMode === 'staff') {
        if (subFilter.type === 'staffUnassigned') {
          const matched = assignedAgentsRoster.find((ag) => {
            const agName = ag.name.toLowerCase();
            const tName = (t.assigneeName || '').toLowerCase();
            return agName === tName || agName.includes(tName) || tName.includes(agName);
          });
          if (matched) return false;
        } else if (subFilter.type === 'staff') {
          const matched = assignedAgentsRoster.find((ag) => {
            const agName = ag.name.toLowerCase();
            const tName = (t.assigneeName || '').toLowerCase();
            return agName === tName || agName.includes(tName) || tName.includes(agName);
          });
          if (!matched || matched.name !== subFilter.value) return false;
        }
      } else if (sidebarViewMode === 'type') {
        if (subFilter.type === 'ticketType') {
          const activeTT = availableTicketTypes.find(
            (tt) =>
              tt.label === subFilter.value ||
              (tt.id != null && String(tt.id) === String(subFilter.value)) ||
              tt.value === subFilter.value ||
              tt.code === subFilter.value
          );
          if (activeTT) {
            if (!isTicketOfType(t, activeTT)) return false;
          } else {
            const normFilter = (subFilter.value || '').toLowerCase().trim();
            const normType = (t.type || '').toLowerCase().trim();
            if (normType !== normFilter) return false;
          }
        }
      } else if (sidebarViewMode === 'status') {
        if (subFilter.type === 'status') {
          if (normalizeStatusName(t.status) !== normalizeStatusName(subFilter.value)) return false;
        }
      } else if (sidebarViewMode === 'myLists' || (sidebarViewMode as any) === 'mylist') {
        if (subFilter.value === 'allOpen' && (t.status === 'resolved' || t.status === 'closed')) return false;
        if (subFilter.value === 'assignedToMe' && (!t.assigneeName || t.assigneeName === 'Unassigned')) return false;
        if (subFilter.value === 'slaBreached' && (!t.slaBreach || new Date(t.slaBreach).getTime() >= Date.now())) return false;
        if (subFilter.value === 'closed' && t.status !== 'resolved' && t.status !== 'closed') return false;
      }

      // 3. Global Search Query in Toolbar
      if (searchQuery.trim()) {
        const q = searchQuery.toLowerCase().trim();
        const matchId = (t.ticketId || '').toLowerCase().includes(q);
        const matchSubject = (t.subject || '').toLowerCase().includes(q);
        const matchClient = (t.client || t.requesterName || '').toLowerCase().includes(q);
        const matchTeam = (t.teamName || '').toLowerCase().includes(q);
        const matchStaff = (t.assigneeName || '').toLowerCase().includes(q);
        const matchAsset = (t.assetTag || '').toLowerCase().includes(q);
        const matchCategory = (t.category || '').toLowerCase().includes(q);
        if (!matchId && !matchSubject && !matchClient && !matchTeam && !matchStaff && !matchAsset && !matchCategory) {
          return false;
        }
      }

      // 4. Column Header Discrete Value Filters (Multi-select Checkboxes)
      for (const [col, selectedVals] of Object.entries(columnFilters)) {
        if (!selectedVals || selectedVals.length === 0) continue;
        let val = '';
        switch (col) {
          case 'status':
            val = t.status || 'new';
            break;
          case 'team':
            val = t.teamName || 'Support Team';
            break;
          case 'ticketId':
            val = t.ticketId || '';
            break;
          case 'type':
            val = t.type || 'incident';
            break;
          case 'client':
            val = t.client || t.requesterName || 'Giri';
            break;
          case 'assetTag':
            val = t.assetTag || '-';
            break;
          case 'priority':
            val = t.priority || 'low';
            break;
          case 'staff':
            val = t.assigneeName || 'Unassigned';
            break;
          case 'issue':
            val = t.category || t.teamName || 'Support Team';
            break;
          case 'issueDetail':
            val = t.subcategory || 'General Issue';
            break;
          case 'resolution':
            val = t.resolution || '-';
            break;
          default:
            val = '';
        }
        if (!selectedVals.includes(val)) return false;
      }

      // 5. Column Header Text Search Filters
      for (const [col, searchVal] of Object.entries(columnSearchFilters)) {
        if (!searchVal || !searchVal.trim()) continue;
        const q = searchVal.toLowerCase().trim();
        let targetVal = '';
        switch (col) {
          case 'subject':
            targetVal = t.subject || '';
            break;
          case 'ticketId':
            targetVal = t.ticketId || '';
            break;
          case 'client':
            targetVal = t.client || t.requesterName || '';
            break;
          case 'assetTag':
            targetVal = t.assetTag || '';
            break;
          case 'issue':
            targetVal = t.category || t.teamName || '';
            break;
          case 'issueDetail':
            targetVal = t.subcategory || '';
            break;
          case 'resolution':
            targetVal = t.resolution || '';
            break;
          case 'team':
            targetVal = t.teamName || '';
            break;
          case 'staff':
            targetVal = t.assigneeName || '';
            break;
          default:
            targetVal = '';
        }
        if (!targetVal.toLowerCase().includes(q)) return false;
      }

      return true;
    });
  }, [tickets, subFilter, searchQuery, selectedStatus, columnFilters, columnSearchFilters]);

  // Sorted Tickets based on active Header Sort Column & Direction
  const sortedTickets = useMemo(() => {
    if (!sortConfig.column || !sortConfig.direction) return filteredTickets;
    const dir = sortConfig.direction === 'asc' ? 1 : -1;
    const col = sortConfig.column;

    return [...filteredTickets].sort((a, b) => {
      if (col === 'status') {
        return (a.status || '').localeCompare(b.status || '') * dir;
      }
      if (col === 'team') {
        const aVal = a.teamName || 'Support Team';
        const bVal = b.teamName || 'Support Team';
        return aVal.localeCompare(bVal) * dir;
      }
      if (col === 'ticketId') {
        const aNum = parseInt(String(a.ticketId || '').replace(/\D/g, ''), 10) || 0;
        const bNum = parseInt(String(b.ticketId || '').replace(/\D/g, ''), 10) || 0;
        return (aNum - bNum) * dir;
      }
      if (col === 'subject') {
        return (a.subject || '').localeCompare(b.subject || '') * dir;
      }
      if (col === 'type') {
        return (a.type || '').localeCompare(b.type || '') * dir;
      }
      if (col === 'client') {
        const aVal = a.client || a.requesterName || '';
        const bVal = b.client || b.requesterName || '';
        return aVal.localeCompare(bVal) * dir;
      }
      if (col === 'sla') {
        const now = Date.now();
        const getSlaRemaining = (t: Ticket) => {
          if (t.status === 'resolved' || t.status === 'closed') return 999999999999;
          const breach = t.slaBreach
            ? new Date(t.slaBreach).getTime()
            : (t.createdAt ? new Date(t.createdAt).getTime() + 4 * 3600000 : now + 4 * 3600000);
          return breach - now;
        };
        return (getSlaRemaining(a) - getSlaRemaining(b)) * dir;
      }
      if (col === 'assetTag') {
        return (a.assetTag || '').localeCompare(b.assetTag || '') * dir;
      }
      if (col === 'priority') {
        const rank: Record<string, number> = { urgent: 4, high: 3, medium: 2, low: 1 };
        const aRank = rank[a.priority] || 0;
        const bRank = rank[b.priority] || 0;
        return (aRank - bRank) * dir;
      }
      if (col === 'lastAction') {
        const aTime = new Date(a.updatedAt || a.createdAt || 0).getTime();
        const bTime = new Date(b.updatedAt || b.createdAt || 0).getTime();
        return (aTime - bTime) * dir;
      }
      if (col === 'dateCreated') {
        const aTime = new Date(a.createdAt || 0).getTime();
        const bTime = new Date(b.createdAt || 0).getTime();
        return (aTime - bTime) * dir;
      }
      if (col === 'staff') {
        const aVal = a.assigneeName || 'Unassigned';
        const bVal = b.assigneeName || 'Unassigned';
        return aVal.localeCompare(bVal) * dir;
      }
      if (col === 'issue') {
        const aVal = a.category || a.teamName || '';
        const bVal = b.category || b.teamName || '';
        return aVal.localeCompare(bVal) * dir;
      }
      if (col === 'issueDetail') {
        return (a.subcategory || '').localeCompare(b.subcategory || '') * dir;
      }
      if (col === 'resolution') {
        return (a.resolution || '').localeCompare(b.resolution || '') * dir;
      }
      if (col === 'dateClosed') {
        const aTime = a.closedAt ? new Date(a.closedAt).getTime() : 0;
        const bTime = b.closedAt ? new Date(b.closedAt).getTime() : 0;
        return (aTime - bTime) * dir;
      }
      return 0;
    });
  }, [filteredTickets, sortConfig]);

  // Paginated Tickets & Page Calculations (Using sortedTickets)
  const totalItems = sortedTickets.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / rowsPerPage));
  const currentPage = Math.min(pagination.page || 1, totalPages);
  const startIndex = totalItems > 0 ? (currentPage - 1) * rowsPerPage : 0;
  const endIndex = Math.min(startIndex + rowsPerPage, totalItems);

  const paginatedTickets = useMemo(() => {
    return sortedTickets.slice(startIndex, endIndex);
  }, [sortedTickets, startIndex, endIndex]);

  // Handler for all 21 bulk actions on selected rows matching user's screenshot
  const handleExecuteBulkAction = (actionKey: string, payload?: string) => {
    if (selectedRowIds.size === 0) return;
    const ids = Array.from(selectedRowIds);

    ids.forEach((id) => {
      const ticketIdStr = String(id);
      switch (actionKey) {
        case 'read':
          updateTicket(ticketIdStr, { isRead: true, is_read: true });
          addHistory(ticketIdStr, 'Marked as read', true);
          break;
        case 'unread':
          updateTicket(ticketIdStr, { isRead: false, is_read: false });
          addHistory(ticketIdStr, 'Marked as unread', true);
          break;
        case 'flag':
          updateTicket(ticketIdStr, { isFlagged: true, is_flagged: true });
          addHistory(ticketIdStr, 'Flagged ticket', true);
          break;
        case 'unflag':
          updateTicket(ticketIdStr, { isFlagged: false, is_flagged: false });
          addHistory(ticketIdStr, 'Unflagged ticket', true);
          break;
        case 'raiseProblem':
          updateTicket(ticketIdStr, { type: 'problem' });
          addHistory(ticketIdStr, 'Raised ticket to Problem type', true);
          break;
        case 'link':
          addHistory(ticketIdStr, `Linked with target reference: ${payload || 'TB-LINKED'}`, true);
          break;
        case 'merge':
          addHistory(ticketIdStr, `Merged into target ticket: ${payload || 'TB-MASTER'}`, true);
          break;
        case 'clone':
          addHistory(ticketIdStr, 'Cloned ticket record created', true);
          break;
        case 'reassign': {
          let teamKey = '';
          let staffId = '';
          if (payload) {
            try {
              if (payload.startsWith('{')) {
                const parsed = JSON.parse(payload);
                teamKey = parsed.team || '';
                staffId = parsed.staff || '';
              } else {
                staffId = payload;
              }
            } catch {
              staffId = payload;
            }
          }
          if (!teamKey && reassignTeam) teamKey = reassignTeam;
          if (!staffId && reassignStaff) staffId = reassignStaff;

          const matchedTeam = availableTeamsList.find((tm) => tm.key === teamKey || tm.label === teamKey);
          let teamLabel = matchedTeam ? matchedTeam.label : teamKey;
          const emp = employees.find((e) => String(e.id) === String(staffId));
          const empName = emp ? (emp.displayName || `${emp.firstName} ${emp.lastName}`.trim()) : '';

          if (emp && !teamLabel && emp.department) {
            teamLabel = emp.department;
          }

          if (staffId && empName) {
            assignTicket(ticketIdStr, staffId, empName);
            updateTicket(ticketIdStr, {
              assigneeId: staffId,
              assigneeName: empName,
              ...(teamLabel ? { teamName: teamLabel, teamKey: teamKey || teamLabel } : {}),
            });
            addHistory(
              ticketIdStr,
              `Bulk re-assigned to ${teamLabel ? `Team "${teamLabel}" • ` : ''}Staff "${empName}"`,
              true
            );
            if (selectedTicket && (String(selectedTicket.id) === ticketIdStr || String(selectedTicket.ticketId) === ticketIdStr)) {
              setSelectedTicket((prev) =>
                prev
                  ? {
                    ...prev,
                    assigneeId: staffId,
                    assigneeName: empName,
                    ...(teamLabel ? { teamName: teamLabel, teamKey: teamKey || teamLabel } : {}),
                    updatedAt: new Date().toISOString(),
                  }
                  : null
              );
            }
          } else if (teamLabel) {
            updateTicket(ticketIdStr, {
              assigneeId: undefined,
              assigneeName: 'Unassigned',
              teamName: teamLabel,
              teamKey: teamKey || teamLabel,
            });
            addHistory(ticketIdStr, `Bulk re-assigned to Team queue "${teamLabel}"`, true);
            if (selectedTicket && (String(selectedTicket.id) === ticketIdStr || String(selectedTicket.ticketId) === ticketIdStr)) {
              setSelectedTicket((prev) =>
                prev
                  ? {
                    ...prev,
                    assigneeId: undefined,
                    assigneeName: 'Unassigned',
                    teamName: teamLabel,
                    teamKey: teamKey || teamLabel,
                    updatedAt: new Date().toISOString(),
                  }
                  : null
              );
            }
          }
          break;
        }
        case 'changeCategory':
          if (payload) {
            const matchedCat = (ticketCategories || []).find((c: any) => c.name === payload || String(c.id) === String(payload));
            const catName = matchedCat ? matchedCat.name : payload;
            const catId = matchedCat?.id ? String(matchedCat.id) : undefined;
            updateTicket(ticketIdStr, {
              category: catName,
              categoryId: catId,
              assetCategoryId: catId,
            });
            addHistory(ticketIdStr, `Category updated to: ${catName}`, true);
          }
          break;
        case 'addPrivateNote':
          if (payload) {
            addHistory(ticketIdStr, `[Private Note] ${payload}`, false);
          }
          break;
        case 'addPublicNote':
          if (payload) {
            addHistory(ticketIdStr, `[Public Reply] ${payload}`, true);
          }
          break;
        case 'changeStatus':
          if (payload) {
            transitionTicket(ticketIdStr, payload);
            addHistory(ticketIdStr, `Status updated to: ${payload}`, true);
          }
          break;
        case 'addTags':
          if (payload) {
            addHistory(ticketIdStr, `Added tags: ${payload}`, true);
          }
          break;
        case 'slaHold': {
          const holdStartIso = new Date().toISOString();
          updateTicket(ticketIdStr, {
            slaHold: true,
            sla_hold: true,
            slaHoldStartedAt: holdStartIso,
            sla_hold_started_at: holdStartIso,
          });
          transitionTicket(ticketIdStr, 'on-hold');
          addHistory(ticketIdStr, 'SLA clock placed on Hold', true);
          break;
        }
        case 'slaRelease': {
          const t = tickets.find((item) => String(item.id) === ticketIdStr);
          let newBreachIso = t?.slaBreach;
          let cumSecs = Number(t?.slaCumulativeHoldSecs || t?.sla_cumulative_hold_secs || 0);
          const prevHoldStarted = t?.slaHoldStartedAt || t?.sla_hold_started_at;
          if (prevHoldStarted) {
            const holdElapsedMs = Math.max(0, Date.now() - new Date(prevHoldStarted).getTime());
            cumSecs += Math.floor(holdElapsedMs / 1000);
            if (t?.slaBreach) {
              const currentBreachMs = new Date(t.slaBreach).getTime();
              newBreachIso = new Date(currentBreachMs + holdElapsedMs).toISOString();
            }
          }
          updateTicket(ticketIdStr, {
            slaHold: false,
            sla_hold: false,
            slaHoldStartedAt: undefined,
            sla_hold_started_at: undefined,
            slaCumulativeHoldSecs: cumSecs,
            sla_cumulative_hold_secs: cumSecs,
            slaBreach: newBreachIso,
          });
          transitionTicket(ticketIdStr, 'in-progress');
          addHistory(ticketIdStr, 'SLA clock Released & resumed', true);
          break;
        }
        case 'changePriority':
          if (payload) {
            let normPriority: 'urgent' | 'high' | 'medium' | 'low' = 'medium';
            const pLower = payload.toLowerCase();
            if (pLower.startsWith('p1') || pLower.includes('urgent') || pLower.includes('critical')) normPriority = 'urgent';
            else if (pLower.startsWith('p2') || pLower.includes('high')) normPriority = 'high';
            else if (pLower.startsWith('p3') || pLower.includes('medium')) normPriority = 'medium';
            else if (pLower.startsWith('p4') || pLower.includes('low')) normPriority = 'low';
            else normPriority = (['urgent', 'high', 'medium', 'low'].includes(payload) ? payload : 'medium') as any;

            updateTicket(ticketIdStr, { priority: normPriority });
            addHistory(ticketIdStr, `Priority updated to: ${payload}`, true);
          }
          break;
        case 'changeType':
          if (payload) {
            const matchedTT = availableTicketTypes.find(
              (tt) => tt.value === payload || tt.label.toLowerCase() === payload.toLowerCase() || tt.code?.toLowerCase() === payload.toLowerCase()
            );
            const targetTicket = tickets.find((t) => String(t.id) === String(ticketIdStr) || t.ticketId === ticketIdStr);
            const newTypeName = matchedTT ? matchedTT.label : payload;
            const newTag = matchedTT?.tagPrefix || 'INC';
            const newWorkflow = matchedTT?.defaultWorkflow || matchedTT?.workflow;
            const newTeamName = matchedTT?.teamName;
            const newTeamKey = matchedTT?.teamKey;

            let updatedTicketId = targetTicket?.ticketId;
            if (updatedTicketId) {
              const hashIdx = updatedTicketId.indexOf('#');
              if (hashIdx !== -1) {
                updatedTicketId = `${newTag}#${updatedTicketId.substring(hashIdx + 1)}`;
              } else {
                updatedTicketId = `${newTag}#${updatedTicketId}`;
              }
            }

            const bulkPatch: Partial<Ticket> = {
              type: newTypeName,
              ticketTypeId: matchedTT?.id,
              tag: newTag,
              tagCode: newTag,
              tagPrefix: newTag,
              tags: [newTag],
              ...(updatedTicketId ? { ticketId: updatedTicketId, ticketNumber: updatedTicketId } : {}),
              ...(newWorkflow ? { workflow: newWorkflow } : {}),
              ...(newTeamName ? { teamName: newTeamName, teamKey: newTeamKey } : {}),
            };

            updateTicket(ticketIdStr, bulkPatch);
            addHistory(ticketIdStr, `Ticket type updated to: ${newTypeName} (Tag: ${newTag})`, true);
          }
          break;
        case 'changeSiteUser':
          if (payload) {
            const matchedEndUser = (combinedEndUsers || []).find((eu: any) => String(eu.id) === String(payload) || String(eu.employeeId) === String(payload));
            const newName = matchedEndUser ? matchedEndUser.name : payload;
            const newEmail = matchedEndUser?.email || '';
            const newDept = matchedEndUser?.department || '';
            const newDesig = matchedEndUser?.designation || '';
            const newPhone = matchedEndUser?.phone || '';
            updateTicket(ticketIdStr, {
              requesterId: payload,
              requesterName: newName,
              requesterEmail: newEmail,
              requesterDepartment: newDept,
              requesterDesignation: newDesig,
              requesterPhone: newPhone,
              client: newName,
            });
            addHistory(ticketIdStr, `Re-assigned enduser to: ${newName}`, true);
          }
          break;
        case 'changeBudget':
          if (payload) {
            addHistory(ticketIdStr, `Budget allocation set to: ${payload}`, true);
          }
          break;
        case 'spam':
          transitionTicket(ticketIdStr, 'closed');
          addHistory(ticketIdStr, 'Marked as Spam and closed', true);
          break;
        default:
          break;
      }
    });

    const actionLabels: Record<string, string> = {
      read: 'Marked as read',
      unread: 'Marked as unread',
      flag: 'Flagged as urgent',
      unflag: 'Unflagged',
      raiseProblem: 'Raised to Problem ticket',
      link: 'Linked tickets',
      merge: 'Merged tickets',
      clone: 'Cloned tickets',
      reassign: 'Re-assigned tickets',
      changeCategory: 'Category updated',
      addPrivateNote: 'Private note added',
      addPublicNote: 'Public reply added',
      changeStatus: 'Status updated',
      addTags: 'Tags updated',
      slaHold: 'Placed SLA on hold',
      slaRelease: 'Released SLA hold',
      changePriority: 'Priority updated',
      changeType: 'Ticket type updated',
      changeSiteUser: 'Enduser re-assigned',
      spam: 'Marked as spam and closed',
    };

    toast.success(`${actionLabels[actionKey] || 'Action executed'} on ${ids.length} ticket(s)`);
    setShowBulkActionsMenu(false);
    setBulkActionModal(null);
    setBulkInputValue('');
    setSelectedRowIds(new Set());
  };

  // Activity Dropdown Filter Options (Emails & Notes is default)
  const [activityDropdownFilter, setActivityDropdownFilter] = useState<
    'emails_notes' | 'emails' | 'notes' | 'public' | 'staff' | 'time' | 'all'
  >('emails_notes');

  // Reset to default 'emails_notes' whenever a ticket is opened
  useEffect(() => {
    setActivityDropdownFilter('emails_notes');
  }, [selectedTicket?.id]);

  // Filtered Activity & Action Log entries (with automatic duplicate protection & initial email at the bottom)
  const filteredActivityHistory = useMemo(() => {
    if (!selectedTicket) return [];

    // Extract non-initial history items
    const rawHistory = (selectedTicket.history || []).filter(
      (h) => h.actionType !== 'First User Email' && !(h.note || '').toLowerCase().includes('created ticket')
    );

    // Build the initial user email (ticket body / description)
    let initialNote: TicketHistoryItem | null = null;
    if (selectedTicket.description && selectedTicket.description.trim()) {
      initialNote = {
        id: -1,
        ticketId: Number(selectedTicket.id) || 0,
        actionType: 'First User Email',
        note: selectedTicket.description,
        internal: false,
        createdAt: selectedTicket.createdAt || new Date(0).toISOString(),
        changedByName: selectedTicket.requesterEmail || selectedTicket.requesterName || selectedTicket.client || 'Requester',
        to: selectedTicket.teamEmail || undefined,
        attachments: (selectedTicket.attachments || []).filter(
          (a) => !isTicketBackupJson(a.name || a.filename)
        ),
      };
    }

    // Sort newer actions in reverse-chronological order (newest on top)
    const sortedActions = [...rawHistory].sort((a, b) => {
      const timeA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
      const timeB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
      return timeB - timeA;
    });

    // Place the First User Email (body of the mail) at the very LAST of the feed
    const historyList: TicketHistoryItem[] = initialNote ? [...sortedActions, initialNote] : sortedActions;

    const seen = new Set<string>();
    const uniqueHistory = historyList.filter((h) => {
      const key = `${h.id}|${h.actionType || ''}|${h.note || ''}|${h.createdAt || ''}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });

    // Activity classification engine
    const getClassification = (h: TicketHistoryItem) => {
      const actType = (h.actionType || h.action_type || '').toLowerCase().trim();
      const noteLower = (h.note || '').toLowerCase();
      const authorLower = (h.changedByName || h.author_name || '').toLowerCase();
      const requesterName = (selectedTicket.requesterName || '').toLowerCase();
      const requesterEmail = (selectedTicket.requesterEmail || '').toLowerCase();
      const clientName = (selectedTicket.client || '').toLowerCase();

      // Check if author is the customer/requester
      const isCustomer =
        (authorLower && (authorLower === requesterName || authorLower === requesterEmail || authorLower === clientName)) ||
        authorLower.includes('requester') ||
        actType === 'first user email';

      // Check if author is staff
      const isStaffAuthor =
        !isCustomer &&
        authorLower &&
        !authorLower.includes('system') &&
        !authorLower.includes('unity platform') &&
        !authorLower.includes('autoclose') &&
        !authorLower.includes('bot');

      // 1. Reassignment Activity (Right-panel assignment of staff / team)
      const isReassignment =
        actType === 'reassignment' ||
        actType === 'reassign' ||
        actType === 'assign' ||
        actType === 'assigned' ||
        actType === 'team_reassigned' ||
        noteLower.includes('staff reassigned') ||
        noteLower.includes('team reassigned') ||
        noteLower.includes('reassigned') ||
        noteLower.includes('re-assigned') ||
        noteLower.includes('assigned to team') ||
        noteLower.includes('assigned staff changed') ||
        noteLower.includes('assigned staff to') ||
        noteLower.includes('assigned to');

      // 2. Time Entry
      const isTime =
        actType === 'time' ||
        actType === 'time_entry' ||
        actType === 'time_log' ||
        actType === 'logged_time' ||
        noteLower.startsWith('[time entry]') ||
        noteLower.includes('time spent:') ||
        noteLower.includes('logged time') ||
        noteLower.includes('time entry added');

      // 3. Workflow Action Progress (Actions executed from the header toolbar, status transitions, etc.)
      const isActionProgress =
        actType === 'action_executed' ||
        actType === 'action executed' ||
        actType.includes('action') ||
        Boolean(h.fromStatus && h.toStatus) ||
        noteLower.includes('action "') ||
        noteLower.includes('executed action') ||
        noteLower.includes('workflow step') ||
        noteLower.includes('state changed from') ||
        Boolean((h as any).newValue && ((h as any).newValue.actionName || (h as any).newValue.actionCode));

      // 4. System / Right-Panel Property Changes (when NOT an explicit workflow action)
      const isSystemChange =
        !isActionProgress &&
        (
          isReassignment ||
          actType === 'status_change' ||
          actType === 'type_change' ||
          actType === 'workflow_change' ||
          actType === 'sla_change' ||
          actType === 'asset_change' ||
          actType === 'end_user_change' ||
          actType === 'priority_change' ||
          actType === 'category_change' ||
          actType === 'subcategory_change' ||
          actType === 'resolution_change' ||
          actType === 'site_change' ||
          actType === 'additional_staff_change' ||
          actType === 'property_change' ||
          actType === 'ticket_updated' ||
          actType === 'ticket_created' ||
          actType === 'ticket_deleted' ||
          actType === 'system_change' ||
          actType === 'autoclose' ||
          actType === 'ticket_closed' ||
          noteLower.includes('status updated') ||
          noteLower.includes('status changed') ||
          noteLower.includes('ticket type changed') ||
          noteLower.includes('workflow updated') ||
          noteLower.includes('workflow auto-updated') ||
          noteLower.includes('category updated') ||
          noteLower.includes('category changed') ||
          noteLower.includes('issue detail updated') ||
          noteLower.includes('issue detail changed') ||
          noteLower.includes('resolution updated') ||
          noteLower.includes('resolution set') ||
          noteLower.includes('site updated') ||
          noteLower.includes('site changed') ||
          noteLower.includes('sla policy changed') ||
          noteLower.includes('sla policy updated') ||
          noteLower.includes('sla priority updated') ||
          noteLower.includes('sla target updated') ||
          noteLower.includes('sla hold') ||
          noteLower.includes('end user changed') ||
          noteLower.includes('end user re-assigned') ||
          noteLower.includes('additional staff set') ||
          noteLower.includes('additional staff updated') ||
          noteLower.includes('linked asset') ||
          noteLower.includes('unlinked asset') ||
          noteLower.includes('replaced asset') ||
          noteLower.includes('set primary asset') ||
          noteLower.includes('asset assigned') ||
          noteLower.includes('priority updated') ||
          noteLower.includes('priority changed') ||
          noteLower.includes('ticket updated')
        );

      // 5. Note (Internal & Staff Notes)
      const isNote =
        !isSystemChange &&
        !isReassignment &&
        !isTime &&
        (
          actType === 'note' ||
          actType === 'note_added' ||
          actType === 'internal_note' ||
          actType === 'internal note' ||
          actType === 'private_note' ||
          actType === 'private note' ||
          actType === 'supplier_log' ||
          actType === 'supplier log' ||
          noteLower.startsWith('[internal note]') ||
          noteLower.startsWith('[private note]') ||
          noteLower.startsWith('[supplier log]') ||
          Boolean(
            h.internal &&
            !isSystemChange &&
            !isReassignment &&
            !actType.includes('email') &&
            !actType.includes('acknowledgement') &&
            !noteLower.includes('[email]')
          )
        );

      // 6. Email
      const isEmail =
        !isSystemChange &&
        !isReassignment &&
        !isTime &&
        (
          actType === 'first user email' ||
          actType === 'email' ||
          actType === 'acknowledgement' ||
          actType === 'send acknowledgement' ||
          actType === 'send_acknowledgement' ||
          actType === 'email_sent' ||
          actType === 'email_received' ||
          actType === 'response' ||
          actType === 'reply' ||
          actType === 'public_reply' ||
          actType === 'email end user' ||
          actType === 'email end user (faults)' ||
          actType === 'email supplier' ||
          actType === 'first response' ||
          actType === 'conversation' ||
          actType === 'note (+email)' ||
          actType === 'note + email' ||
          actType.includes('email') ||
          actType.includes('acknowledgement') ||
          noteLower.startsWith('[email]') ||
          noteLower.startsWith('[public reply]') ||
          noteLower.startsWith('[email end user]') ||
          noteLower.startsWith('[note (+email)]') ||
          noteLower.includes('email sent to') ||
          noteLower.includes('email received from') ||
          (!h.internal && !isNote && !isActionProgress)
        );

      // 7. Public (Customer / Public-facing only)
      const isPublic =
        !h.internal &&
        !isNote &&
        !isSystemChange &&
        !isTime &&
        !isReassignment &&
        (isEmail || isCustomer || actType === 'first user email' || noteLower.startsWith('[public reply]'));

      // 8. Staff (Staff communication/actions belonging to ticket conversation)
      const isStaff =
        !isSystemChange &&
        !isReassignment &&
        !isCustomer &&
        isStaffAuthor &&
        (isEmail || isNote || isActionProgress);

      return {
        isEmail,
        isNote,
        isActionProgress,
        isPublic,
        isStaff,
        isTime,
        isReassignment,
        isSystemChange,
      };
    };

    return uniqueHistory.filter((h) => {
      const {
        isEmail,
        isNote,
        isActionProgress,
        isPublic,
        isStaff,
        isTime,
        isReassignment,
        isSystemChange,
      } = getClassification(h);

      switch (activityDropdownFilter) {
        case 'emails_notes':
          // 1. Emails & Notes (DEFAULT VIEW):
          // Show email conversations, actual notes, AND workflow action progress!
          return (isEmail || isNote || isActionProgress) && !isTime;

        case 'emails':
          // 2. Email:
          // Show actual email messages only.
          return isEmail && !isNote && !isSystemChange && !isReassignment && !isTime;

        case 'notes':
          // 3. Notes:
          // Show internal and private notes only.
          return isNote && !isEmail && !isSystemChange && !isReassignment && !isTime;

        case 'public':
          // 4. Public:
          // Show only customer/public emails and replies.
          return isPublic && !isReassignment && !isSystemChange && !isTime && !h.internal;

        case 'staff':
          // 5. Staff:
          // Show staff-authored communications (notes/emails) only.
          return isStaff && !isSystemChange && !isReassignment && !isTime;

        case 'time':
          // 6. Time entries:
          return isTime && !isSystemChange && !isReassignment;

        case 'all':
        default:
          // 7. All actions:
          // Complete audit/activity timeline: everything including status changes and all right-panel actions!
          return true;
      }
    });
  }, [selectedTicket, activityDropdownFilter]);

  const handleSelectAllRows = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      setSelectedRowIds(new Set(sortedTickets.map((t) => t.id)));
    } else {
      setSelectedRowIds(new Set());
    }
  };

  const handleToggleRow = (id: string | number) => {
    const next = new Set(selectedRowIds);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    setSelectedRowIds(next);
  };

  const handleCloseCreateModal = () => {
    setIsCreateModalOpen(false);
    setIsAddCiOpen(false);
    setIsCreateEmojiOpen(false);
    setIsHeadingMenuOpen(false);
    if (searchParams.get('create')) {
      const next = new URLSearchParams(searchParams);
      next.delete('create');
      setSearchParams(next, { replace: true });
    }
  };

  const applyCreateModalFormat = (formatType: string) => {
    const textarea = document.getElementById('create-modal-details-textarea') as HTMLTextAreaElement | null;
    if (!textarea) return;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selectedText = text.substring(start, end);

    let replacement = '';
    switch (formatType) {
      case 'bold':
        replacement = `**${selectedText || 'bold text'}**`;
        break;
      case 'italic':
        replacement = `*${selectedText || 'italic text'}*`;
        break;
      case 'h1':
        replacement = `\n# ${selectedText || 'Heading 1'}\n`;
        break;
      case 'h2':
        replacement = `\n## ${selectedText || 'Heading 2'}\n`;
        break;
      case 'h3':
        replacement = `\n### ${selectedText || 'Heading 3'}\n`;
        break;
      case 'quote':
        replacement = `\n> ${selectedText || 'Quote text'}\n`;
        break;
      case 'bullet':
        replacement = `\n- ${selectedText || 'List item'}\n`;
        break;
      case 'ordered':
        replacement = `\n1. ${selectedText || 'List item'}\n`;
        break;
      case 'code':
        replacement = selectedText.includes('\n')
          ? `\n\`\`\`\n${selectedText || '// code here'}\n\`\`\`\n`
          : `\`${selectedText || 'code'}\``;
        break;
      case 'link':
        replacement = `[${selectedText || 'Link Title'}](https://example.com)`;
        break;
      case 'table':
        replacement = `\n| Column 1 | Column 2 |\n| --- | --- |\n| Item 1 | Item 2 |\n`;
        break;
      case 'strikethrough':
        replacement = `~~${selectedText || 'strikethrough'}~~`;
        break;
      default:
        replacement = selectedText;
    }

    const updated = text.substring(0, start) + replacement + text.substring(end);
    setNewForm((prev) => ({ ...prev, description: updated }));
    setTimeout(() => {
      textarea.focus();
      textarea.setSelectionRange(start + replacement.length, start + replacement.length);
    }, 10);
  };

  const handleInsertCreateEmoji = (emojiData: EmojiClickData) => {
    const emoji = emojiData.emoji;
    const textarea = document.getElementById('create-modal-details-textarea') as HTMLTextAreaElement | null;
    if (!textarea) {
      setNewForm((prev) => ({ ...prev, description: prev.description + emoji }));
      setIsCreateEmojiOpen(false);
      return;
    }
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const updated = text.substring(0, start) + emoji + text.substring(end);
    setNewForm((prev) => ({ ...prev, description: updated }));
    setIsCreateEmojiOpen(false);
    setTimeout(() => {
      textarea.focus();
      textarea.setSelectionRange(start + emoji.length, start + emoji.length);
    }, 10);
  };

  const handleCreateSubmit = async (e?: React.FormEvent) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (!newForm.subject.trim()) {
      toast.error('Please enter a ticket subject');
      return;
    }

    // Calculate priority from impact and urgency
    let calculatedPriority: Ticket['priority'] = 'medium';
    if (newForm.urgency === 'urgent' || newForm.impact === 'urgent') {
      calculatedPriority = 'urgent';
    } else if (newForm.urgency === 'high' || newForm.impact === 'high') {
      calculatedPriority = 'high';
    } else if (newForm.urgency === 'low' && newForm.impact === 'low') {
      calculatedPriority = 'low';
    }

    // Find linked employee and asset details
    const emp = combinedEndUsers.find((e) => String(e.id) === String(newForm.requesterId) || String(e.employeeId) === String(newForm.requesterId) || e.name === newForm.requesterName);
    const clientDisplayName = emp ? emp.name : (newForm.requesterName || newForm.client || currentUserName);
    const relatedAssetsList = newForm.ciList.map((tag) => {
      const found = assets.find((a) => a.asset_code === tag || a.name === tag || String(a.id) === tag);
      return found ? { id: found.id, name: found.name, assetTag: found.asset_code || found.name, asset_code: found.asset_code } : { name: tag, assetTag: tag };
    });
    const ast = assets.find((a) => String(a.id) === String(newForm.assetId) || a.asset_code === newForm.assetTag) || (relatedAssetsList[0] as any);
    const linkedCi = ast?.asset_code || ast?.name || newForm.assetTag || newForm.ciList[0] || '';

    try {
      const created = await createTicket({
        subject: newForm.subject.trim(),
        type: newForm.type,
        priority: calculatedPriority,
        urgency: newForm.urgency,
        impact: newForm.impact,
        teamKey: newForm.teamKey,
        teamName: queuesSummary.find((q) => q.key === newForm.teamKey)?.label || 'Support Team',
        category: newForm.category || 'Laptops',
        categoryId: (ticketCategories || []).find((c) => c.name === newForm.category)?.id ? String((ticketCategories || []).find((c) => c.name === newForm.category)?.id) : undefined,
        assetCategory: newForm.category || 'Laptops',
        assetCategoryId: (ticketCategories || []).find((c) => c.name === newForm.category)?.id ? String((ticketCategories || []).find((c) => c.name === newForm.category)?.id) : undefined,
        client: clientDisplayName,
        assetTag: ast ? (ast.asset_code || ast.name) : linkedCi,
        assetId: ast ? String(ast.id) : undefined,
        relatedAssets: relatedAssetsList.length > 0 ? relatedAssetsList : undefined,
        primaryAssetId: ast ? String(ast.id) : undefined,
        requesterId: emp ? String(emp.id) : undefined,
        requesterName: clientDisplayName,
        requesterEmail: emp?.email || user?.email || '',
        requesterDepartment: emp?.department || 'General',
        requesterDesignation: emp?.designation || 'Staff',
        requesterPhone: emp?.phone,
        description: newForm.description.trim(),
        subtypeId: newForm.subtypeId || undefined,
        subtype: newForm.subtype || undefined,
        projectReference: newForm.projectReference || undefined,
        clientReference: newForm.clientReference || undefined,
        dueDate: newForm.dueDate || undefined,
        meetingDate: newForm.meetingDate || undefined,
        completionEvidence: newForm.completionEvidence || undefined,
        assetDetails: ast,
        source: newForm.source || 'Manual',
      });

      setIsCreateModalOpen(false);
      handleCloseCreateModal();
      setSelectedTicket(created);
      toast.success(`Ticket [${created.ticketId || created.ticketNumber || 'created'}] created successfully!`);

      // Reset create modal form to default active user
      setNewForm({
        subject: '',
        type: (ticketTypes && ticketTypes.length > 0 ? (ticketTypes[0].code?.toLowerCase() || ticketTypes[0].name.toLowerCase()) : 'incident') as any,
        subtype: '',
        subtypeId: '',
        priority: 'medium',
        urgency: 'medium',
        impact: 'medium',
        teamKey: 'support',
        category: (ticketCategories && ticketCategories.length > 0 ? ticketCategories[0].name : 'Laptops'),
        client: activeEmployee ? activeEmployee.name : currentUserName,
        assetTag: '',
        description: '',
        requesterId: activeEmployee ? String(activeEmployee.id) : (user?.id ? String(user.id) : ''),
        requesterName: activeEmployee ? activeEmployee.name : currentUserName,
        requesterEmail: activeEmployee?.email || user?.email || '',
        requesterDepartment: activeEmployee?.department || '',
        requesterDesignation: activeEmployee?.designation || '',
        requesterPhone: activeEmployee?.phone || '',
        assetId: '',
        aiTriage: false,
        source: 'Manual',
        ciList: [],
        projectReference: '',
        clientReference: '',
        dueDate: '',
        meetingDate: '',
        completionEvidence: '',
      });
    } catch (err: any) {
      console.error('Failed to create ticket', err);
      toast.error(err?.message || 'Failed to create ticket');
    }
  };

  const handleAddNote = async () => {
    if (!selectedTicket || !timelineInput.trim()) return;
    try {
      const notePrefix = isInternalNote ? 'Internal staff note' : 'Public response sent';
      await addHistory(selectedTicket.id, `${notePrefix}: ${timelineInput.trim()}`, isInternalNote);
      setTimelineInput('');
      const updated = tickets.find((t) => t.id === selectedTicket.id);
      if (updated) setSelectedTicket(updated);
    } catch (err) {
      console.error('Failed to add note', err);
    }
  };

  const handleActionModalSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedTicket || !activeActionModal) return;
    try {
      // Priority: Execute real backend action transaction if matching available workflow action
      const actModalLower = activeActionModal.toLowerCase();
      const matchingBackendAct = (availableActions || []).find((a: any) =>
        a.actionId === activeActionModal ||
        a.id === activeActionModal ||
        a.actionName?.toLowerCase() === actModalLower ||
        a.name?.toLowerCase() === actModalLower ||
        a.actionCode?.toLowerCase() === actModalLower ||
        a.code?.toLowerCase() === actModalLower ||
        (actModalLower.includes('resolve') && (a.actionCode === 'RESOLVE' || a.code === 'RESOLVE')) ||
        (actModalLower.includes('reopen') && (a.actionCode === 'REOPEN' || a.code === 'REOPEN')) ||
        (actModalLower.includes('close') && (a.actionCode === 'CLOSE' || a.code === 'CLOSE')) ||
        (actModalLower.includes('escalate') && (a.actionCode?.includes('ESCALATE') || a.code?.includes('ESCALATE'))) ||
        (actModalLower.includes('hold') && (a.actionCode?.includes('HOLD') || a.code?.includes('HOLD')))
      );

      if (matchingBackendAct) {
        await executeTicketAction(selectedTicket.id, matchingBackendAct.actionId || matchingBackendAct.id, {
          comment: actionInput.note || actionInput.body,
          reason: actionInput.note,
          resolutionNote: actionInput.note,
          targetTeamId: actionInput.teamKey,
        });
        await fetchAvailableActions(selectedTicket.id);
        const refreshed = await fetchTicket(selectedTicket.id);
        if (refreshed) {
          setSelectedTicket(refreshed);
        }
        setActiveActionModal(null);
        setActionInput({ to: '', subject: '', body: '', note: '', teamKey: 'support' });
        return;
      }

      if (activeActionModal === 'emailUser') {
        await addHistory(selectedTicket.id, `Emailed User (${actionInput.to}): ${actionInput.body}`, false);
      } else if (activeActionModal === 'logSupplier') {
        await addHistory(selectedTicket.id, `Logged to Supplier: ${actionInput.note}`, true);
        await updateTicket(selectedTicket.id, { client: `Supplier (${actionInput.note.slice(0, 15)})` });
      } else if (activeActionModal === 'internalNote') {
        await addHistory(selectedTicket.id, `Internal note: ${actionInput.note}`, true);
      } else if (activeActionModal === 'privateNote') {
        await addHistory(selectedTicket.id, `Private note: ${actionInput.note}`, true);
      } else if (activeActionModal === 'noteEmail') {
        await addHistory(selectedTicket.id, `Note + Email sent: ${actionInput.note}`, false);
      } else if (activeActionModal === 'escalate') {
        const teamLabel = queuesSummary.find((q) => q.key === actionInput.teamKey)?.label || 'Support Team';
        await updateTicket(selectedTicket.id, { teamKey: actionInput.teamKey, teamName: teamLabel, priority: 'urgent' });
        await assignTicket(selectedTicket.id, 'unassigned', 'Unassigned');
        await addHistory(selectedTicket.id, `Escalated to team ${teamLabel}: ${actionInput.note}`, true);
      } else if (activeActionModal === 'approval') {
        const curStatusNorm = String(selectedTicket.status || '').trim().toLowerCase().replace(/[\s_]+/g, '-');
        if (curStatusNorm !== 'pending') {
          await transitionTicket(selectedTicket.id, 'pending');
        }
        await addHistory(selectedTicket.id, `Approval Requested: ${actionInput.note}`, true);
      } else if (activeActionModal === 'close') {
        const curStatusNorm = String(selectedTicket.status || '').trim().toLowerCase().replace(/[\s_]+/g, '-');
        if (curStatusNorm !== 'closed' && curStatusNorm !== 'resolved') {
          await transitionTicket(selectedTicket.id, 'closed');
        }
        await updateTicket(selectedTicket.id, { resolution: actionInput.note || 'Resolved by IT Support agent' });
        await addHistory(selectedTicket.id, `Ticket Closed & Resolved: ${actionInput.note || 'Issue resolved'}`, true);
      }

      setActiveActionModal(null);
      setActionInput({ to: '', subject: '', body: '', note: '', teamKey: 'support' });

      // Refresh current ticket view
      const updated = tickets.find((t) => t.id === selectedTicket.id);
      if (updated) setSelectedTicket(updated);
    } catch (err) {
      console.error('Action failed:', err);
    }
  };

  const handleDeleteCurrentTicket = async () => {
    if (!selectedTicket) return;
    if (window.confirm(`Are you sure you want to delete ticket ${selectedTicket.ticketId}?`)) {
      try {
        await deleteTicket(selectedTicket.id);
        setSelectedTicket(null);
      } catch (err) {
        console.error('Failed to delete ticket', err);
      }
    }
  };

  // Total calculated table width for horizontal scroll
  const totalTableWidth = useMemo(() => {
    return Object.values(columnWidths).reduce((acc, curr) => acc + curr, 0);
  }, [columnWidths]);

  // Helper title for view mode
  const viewModeTitles: Record<SidebarViewMode, string> = {
    team: 'Tickets by Team',
    staff: 'Tickets by Staff',
    type: 'Tickets by Ticket Type',
    status: 'Tickets by Status',
    myLists: 'My Lists',
    all: 'All Tickets View Picker',
  };

  return (
    <div className="flex h-full flex-1 w-full min-h-0 overflow-hidden bg-background text-foreground text-xs">
      {/* ═══════════════════════════════════════════════════════════════ */}
      {/* LEFT QUEUE SELECTION SIDEBAR (SOFT GREY ACTIVE SELECTION THEME) */}
      {/* ═══════════════════════════════════════════════════════════════ */}
      <aside className={cn(
        "shrink-0 h-full bg-card text-card-foreground flex flex-col justify-between border-r border-border transition-all duration-200",
        isQueueSidebarCollapsed ? "w-13 p-2 items-center" : "w-60 p-3.5 overflow-y-auto"
      )}>
        {isQueueSidebarCollapsed ? (
          <div className="flex flex-col items-center gap-3 w-full">
            <button
              type="button"
              onClick={() => setIsQueueSidebarCollapsed(false)}
              className="flex size-8 items-center justify-center rounded-lg hover:bg-muted text-muted-foreground hover:text-foreground transition-colors cursor-pointer"
              title="Expand Ticket Queues"
            >
              <Menu className="size-4.5" />
            </button>
            <div className="w-full border-b border-border my-0.5" />
            <div className="flex flex-col items-center gap-1.5 w-full">
              {filteredQueuesSummary.map((q) => {
                const isTeamSelected = selectedTeamKey === q.key && subFilter.type === 'all';
                return (
                  <button
                    key={q.key}
                    type="button"
                    onClick={() => {
                      closeTicketView();
                      setSelectedTeamKey(q.key);
                      setSubFilter({ type: 'all' });
                    }}
                    className={cn(
                      "flex size-8 items-center justify-center rounded-lg text-xs font-semibold transition-all relative group cursor-pointer",
                      isTeamSelected
                        ? "bg-primary text-primary-foreground shadow-xs"
                        : "text-muted-foreground hover:text-foreground hover:bg-muted"
                    )}
                    title={`${q.label} (${q.count} tickets)`}
                  >
                    <span>{q.label.slice(0, 1).toUpperCase()}</span>
                    {q.count > 0 && (
                      <span className="absolute -top-1 -right-1 size-4 flex items-center justify-center rounded-full bg-primary text-primary-foreground text-xs font-semibold">
                        {q.count > 99 ? '99+' : q.count}
                      </span>
                    )}
                  </button>
                );
              })}
            </div>
          </div>
        ) : (
          <div className="space-y-3.5">
            {/* QUEUE HEADER WITH VIEW PICKER DROPDOWN */}
            <div className="relative">
              <div className="flex items-center justify-between border-b border-border pb-2.5">
                <div className="flex items-center gap-2 min-w-0 flex-1">
                  <button
                    type="button"
                    onClick={() => setIsQueueSidebarCollapsed(true)}
                    className="flex size-7 items-center justify-center rounded-md hover:bg-muted text-muted-foreground hover:text-foreground transition-colors cursor-pointer shrink-0"
                    title="Collapse Ticket Queues"
                  >
                    <Menu className="size-4" />
                  </button>
                  <button
                    type="button"
                    onClick={() => setIsViewModePickerOpen(!isViewModePickerOpen)}
                    className="group flex flex-1 items-center justify-between text-left hover:opacity-90 transition-opacity min-w-0 cursor-pointer"
                  >
                    <div className="min-w-0">
                      <div className="flex items-center gap-1">
                        <span className="text-xs font-semibold uppercase tracking-wider text-foreground truncate">
                          {viewModeTitles[sidebarViewMode]}
                        </span>
                        <Edit3 className="size-3 text-muted-foreground group-hover:text-foreground transition-colors shrink-0" />
                      </div>
                      <p className="text-xs text-muted-foreground truncate">Click to change view mode</p>
                    </div>
                  </button>
                </div>
              </div>

              {/* VIEW MODE PICKER MENU */}
              {isViewModePickerOpen && (
                <div className="absolute left-0 top-11 z-50 w-52 rounded-lg border border-border bg-card p-1 shadow-xl text-foreground animate-in fade-in zoom-in-95">
                  <div className="px-2 py-1 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
                    Select Navigation View
                  </div>
                  {(
                    [
                      { key: 'team', label: 'Tickets by Team', icon: Users },
                      { key: 'staff', label: 'Tickets by Staff', icon: UserCheck },
                      { key: 'type', label: 'Tickets by Ticket Type', icon: TagIcon },
                      { key: 'status', label: 'Tickets by Status', icon: Activity },
                      { key: 'myLists', label: 'My Lists', icon: List },
                      { key: 'all', label: 'All Tickets Options', icon: Layers },
                    ] as const
                  ).map((mode) => {
                    const Icon = mode.icon;
                    const active = sidebarViewMode === mode.key;
                    return (
                      <button
                        key={mode.key}
                        onClick={() => {
                          closeTicketView();
                          setSidebarViewMode(mode.key);
                          setIsViewModePickerOpen(false);
                          setSubFilter({ type: 'all' });
                        }}
                        className={cn(
                          'flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-xs font-medium transition-colors',
                          active ? 'bg-primary text-primary-foreground font-semibold shadow-xs' : 'text-foreground hover:bg-accent'
                        )}
                      >
                        <Icon className={cn("size-3", active ? "text-primary-foreground" : "text-muted-foreground")} />
                        {mode.label}
                      </button>
                    );
                  })}
                </div>
              )}
            </div>

            {/* QUEUE LIST IMPLEMENTATION (SOFT GREY FOR ACTIVE SELECTIONS) */}
            <nav className="space-y-1 text-xs">
              {/* MODE 1: TICKETS BY TEAM (EXPANDABLE DROPDOWNS) */}
              {(sidebarViewMode === 'team' || sidebarViewMode === 'all') && (
                <div className="space-y-0.5">
                  <div className="px-1 text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-1">
                    Team Queues & Staff
                  </div>
                  {filteredQueuesSummary.map((q) => {
                    const isExpanded = expandedTeams.has(q.key);
                    const isTeamSelected = selectedTeamKey === q.key && subFilter.type === 'all';
                    const b = teamBreakdown[q.key] || { total: q.count, unassigned: q.count, agents: {} };

                    return (
                      <div key={q.key} className="space-y-0.5">
                        {/* TEAM PARENT HEADER */}
                        <button
                          onClick={() => {
                            closeTicketView();
                            setSelectedTeamKey(q.key);
                            setSubFilter({ type: 'all' });
                          }}
                          className={cn(
                            'group flex w-full items-center justify-between rounded-lg px-2.5 py-1.5 text-xs font-medium transition-all',
                            isTeamSelected
                              ? 'bg-primary text-primary-foreground font-semibold shadow-xs'
                              : 'text-foreground hover:bg-accent/60'
                          )}
                        >
                          <span className="flex items-center gap-1.5 truncate">
                            <span
                              onClick={(e) => toggleTeamExpand(q.key, e)}
                              className={cn(
                                "p-0.5 rounded transition-colors",
                                isTeamSelected ? "hover:bg-primary-foreground/20" : "hover:bg-accent/80"
                              )}
                            >
                              {isExpanded ? (
                                <ChevronDown className={cn("size-3", isTeamSelected ? "text-primary-foreground" : "text-muted-foreground")} />
                              ) : (
                                <ChevronRight className={cn("size-3", isTeamSelected ? "text-primary-foreground" : "text-muted-foreground")} />
                              )}
                            </span>
                            <span className="truncate">{q.label}</span>
                          </span>
                          <span className={cn(
                            "font-mono text-xs font-semibold min-w-[20px] text-right ml-auto",
                            isTeamSelected ? "text-primary-foreground" : "text-muted-foreground"
                          )}>
                            {b.total}
                          </span>
                        </button>

                        {/* EXPANDABLE ACCORDION SUB-QUEUE ITEMS (SOFT GREY SELECTION) */}
                        {isExpanded && (
                          <div className="pl-5 space-y-0.5 border-l border-border/60 ml-2.5 my-0.5">
                            {/* Unassigned Sub-item */}
                            <button
                              onClick={() => {
                                closeTicketView();
                                setSelectedTeamKey(q.key);
                                setSubFilter({ type: 'teamUnassigned', teamKey: q.key });
                              }}
                              className={cn(
                                'flex w-full items-center justify-between rounded-lg px-2.5 py-1.5 text-xs transition-colors',
                                subFilter.type === 'teamUnassigned' && subFilter.teamKey === q.key
                                  ? 'bg-primary text-primary-foreground font-semibold shadow-xs'
                                  : 'text-muted-foreground hover:bg-accent/50 hover:text-foreground'
                              )}
                            >
                              <span className="flex items-center gap-1.5 truncate">
                                <UserX className={cn(
                                  "size-3",
                                  subFilter.type === 'teamUnassigned' && subFilter.teamKey === q.key ? "text-primary-foreground" : "text-muted-foreground"
                                )} />
                                Unassigned
                              </span>
                              <span className={cn(
                                "font-mono text-xs font-semibold min-w-[20px] text-right ml-auto",
                                subFilter.type === 'teamUnassigned' && subFilter.teamKey === q.key ? "text-primary-foreground" : "text-muted-foreground"
                              )}>{b.unassigned}</span>
                            </button>

                            {/* Agent Sub-items (Show all assigned team agents) */}
                            {Object.entries(b.agents).map(([agentName, agentCount]) => (
                              <button
                                key={`${q.key}-${agentName}`}
                                onClick={() => {
                                  closeTicketView();
                                  setSelectedTeamKey(q.key);
                                  setSubFilter({ type: 'teamAgent', teamKey: q.key, value: agentName });
                                }}
                                className={cn(
                                  'flex w-full items-center justify-between rounded-lg px-2.5 py-1.5 text-xs transition-colors',
                                  subFilter.type === 'teamAgent' && subFilter.teamKey === q.key && subFilter.value === agentName
                                    ? 'bg-primary text-primary-foreground font-semibold shadow-xs'
                                    : 'text-muted-foreground hover:bg-accent/50 hover:text-foreground'
                                )}
                              >
                                <span className="flex items-center gap-1.5 truncate">
                                  <User className={cn(
                                    "size-3",
                                    subFilter.type === 'teamAgent' && subFilter.teamKey === q.key && subFilter.value === agentName ? "text-primary-foreground" : "text-muted-foreground"
                                  )} />
                                  {agentName}
                                </span>
                                <span className={cn(
                                  "font-mono text-xs font-semibold min-w-[20px] text-right ml-auto",
                                  subFilter.type === 'teamAgent' && subFilter.teamKey === q.key && subFilter.value === agentName ? "text-primary-foreground" : "text-muted-foreground"
                                )}>{agentCount}</span>
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}

              {/* MODE 2: TICKETS BY STAFF */}
              {sidebarViewMode === 'staff' && (
                <div className="space-y-0.5">
                  <div className="px-1 text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-1">
                    Filter by Staff Member
                  </div>
                  {Object.entries(staffBuckets).map(([staffName, count]) => {
                    const active = subFilter.type === 'staff' && subFilter.value === staffName;
                    return (
                      <button
                        key={staffName}
                        onClick={() => {
                          closeTicketView();
                          setSubFilter({ type: 'staff', value: staffName });
                        }}
                        className={cn(
                          'flex w-full items-center justify-between rounded-lg px-2.5 py-1.5 text-xs font-medium transition-colors',
                          active ? 'bg-primary text-primary-foreground font-semibold shadow-xs' : 'text-foreground hover:bg-accent'
                        )}
                      >
                        <span className="flex items-center gap-1.5 truncate">
                          <User className={cn("size-3", active ? "text-primary-foreground" : "text-muted-foreground")} />
                          {staffName}
                        </span>
                        <span className={cn(
                          "font-mono text-xs font-semibold min-w-[20px] text-right ml-auto",
                          active ? "text-primary-foreground" : "text-muted-foreground"
                        )}>
                          {count}
                        </span>
                      </button>
                    );
                  })}
                </div>
              )}

              {/* MODE 3: TICKETS BY TICKET TYPE */}
              {sidebarViewMode === 'type' && (
                <div className="space-y-0.5">
                  <div className="px-1 text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-1">
                    Filter by Ticket Type
                  </div>
                  {typeBuckets.map((item) => {
                    const active =
                      subFilter.type === 'ticketType' &&
                      (subFilter.value === item.key ||
                        subFilter.value === item.label ||
                        (item.id != null && String(subFilter.value) === String(item.id)) ||
                        (item.code && subFilter.value === item.code));
                    return (
                      <button
                        key={item.key}
                        onClick={() => {
                          closeTicketView();
                          setSubFilter(
                            active ? { type: 'all' } : { type: 'ticketType', value: item.key }
                          );
                        }}
                        title={item.code ? `${item.label} (${item.code})` : item.label}
                        className={cn(
                          'flex w-full items-center justify-between rounded-lg px-2.5 py-1.5 text-xs font-medium transition-colors',
                          active
                            ? 'bg-primary text-primary-foreground font-semibold shadow-xs'
                            : 'text-foreground hover:bg-accent'
                        )}
                      >
                        <span className="flex items-center gap-1.5 truncate">
                          <TagIcon className={cn("size-3 shrink-0", active ? "text-primary-foreground" : "text-muted-foreground")} />
                          <span className="truncate">{item.label}</span>
                        </span>
                        <span className={cn(
                          "font-mono text-xs font-semibold min-w-[20px] text-right ml-auto",
                          active ? "text-primary-foreground" : "text-muted-foreground"
                        )}>
                          {item.count}
                        </span>
                      </button>
                    );
                  })}
                </div>
              )}

              {/* MODE 4: TICKETS BY STATUS */}
              {sidebarViewMode === 'status' && (
                <div className="space-y-0.5">
                  <div className="px-1 text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-1">
                    Filter by Ticket Status
                  </div>
                  {Object.entries(statusBuckets).map(([statusKey, count]) => {
                    const active = subFilter.type === 'status' && normalizeStatusName(subFilter.value) === normalizeStatusName(statusKey);
                    return (
                      <button
                        key={statusKey}
                        onClick={() => {
                          closeTicketView();
                          setSubFilter({ type: 'status', value: statusKey });
                        }}
                        className={cn(
                          'flex w-full items-center justify-between rounded-lg px-2.5 py-1.5 text-xs font-medium transition-colors',
                          active ? 'bg-primary text-primary-foreground font-semibold shadow-xs' : 'text-foreground hover:bg-accent'
                        )}
                      >
                        <span className="flex items-center gap-1.5 truncate">
                          <Activity className={cn("size-3", active ? "text-primary-foreground" : "text-muted-foreground")} />
                          {statusKey}
                        </span>
                        <span className={cn(
                          "font-mono text-xs font-semibold min-w-[20px] text-right ml-auto",
                          active ? "text-primary-foreground" : "text-muted-foreground"
                        )}>
                          {count}
                        </span>
                      </button>
                    );
                  })}
                </div>
              )}

              {/* MODE 5: MY LISTS */}
              {sidebarViewMode === 'myLists' && (
                <div className="space-y-0.5">
                  <div className="px-1 text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-1">
                    Custom Saved Views
                  </div>
                  {[
                    { key: 'allOpen', label: 'All Open Tickets', count: myListBuckets.allOpen, icon: List },
                    { key: 'assignedToMe', label: 'My Assigned Tickets', count: myListBuckets.assignedToMe, icon: UserCheck },
                    { key: 'slaBreached', label: 'SLA Breached Tickets', count: myListBuckets.slaBreached, icon: AlertTriangle },
                    { key: 'closed', label: 'Resolved / Closed Tickets', count: myListBuckets.closed, icon: CheckSquare },
                  ].map((item) => {
                    const Icon = item.icon;
                    const active = subFilter.type === 'myList' && subFilter.value === item.key;
                    return (
                      <button
                        key={item.key}
                        onClick={() => {
                          closeTicketView();
                          setSubFilter({ type: 'myList', value: item.key });
                        }}
                        className={cn(
                          'flex w-full items-center justify-between rounded-lg px-2.5 py-1.5 text-xs font-medium transition-colors',
                          active ? 'bg-primary text-primary-foreground font-semibold shadow-xs' : 'text-foreground hover:bg-accent'
                        )}
                      >
                        <span className="flex items-center gap-1.5 truncate">
                          <Icon className={cn("size-3", active ? "text-primary-foreground" : "text-muted-foreground")} />
                          {item.label}
                        </span>
                        <span className={cn(
                          "font-mono text-xs font-semibold min-w-[20px] text-right ml-auto",
                          active ? "text-primary-foreground" : "text-muted-foreground"
                        )}>
                          {item.count}
                        </span>
                      </button>
                    );
                  })}
                </div>
              )}
            </nav>
          </div>
        )}
      </aside>

      {/* ═══════════════════════════════════════════════════════════════ */}
      {/* RIGHT MAIN AREA: LIST VIEW OR FULL ITSM TICKET VIEW            */}
      {/* ═══════════════════════════════════════════════════════════════ */}
      {selectedTicket ? (
        /* ------------------------------------------------------------- */
        /* FULL ITSM TICKET VIEW PAGE MODE                              */
        /* ------------------------------------------------------------- */
        <main className="flex flex-1 flex-col overflow-hidden bg-background">
          {ticketLoadError && <p role="alert" className="p-3 text-sm text-destructive">{ticketLoadError}</p>}
          {/* TOP ACTION BAR */}
          <div className="border-b border-border bg-background">
            <header className="flex items-start justify-between gap-2 px-5 py-2">
              {/* LEFT: ACTION BUTTONS CONTAINER (UP TO 2 LINES) */}
              <div className="flex items-start gap-1.5 flex-1 min-w-0">
                {/* CIRCULAR BACK BUTTON */}
                <button
                  type="button"
                  onClick={() => {
                    setSelectedTicket(null);
                    useTicketStore.getState().setCurrentTicket(null);
                  }}
                  className="flex size-7 shrink-0 items-center justify-center rounded-full border border-border bg-background hover:bg-muted text-foreground transition-colors shadow-2xs mt-0"
                  title="Back to List"
                >
                  <ArrowLeft className="size-3.5" />
                </button>

                {/* NO ACTIONS AVAILABLE FOR CURRENT STAGE */}
                {stageTransitionActions.length === 0 && (
                  <span className="text-xs text-muted-foreground/80 italic px-2 py-1 select-none">
                    No actions available for current stage
                  </span>
                )}

                {/* DYNAMIC ACTION BUTTONS (UP TO 2 LINES) */}
                <div
                  ref={actionsContainerRef}
                  className="flex items-center gap-1.5 flex-wrap flex-1 min-w-0"
                >
                  {visibleQuickActions.map((act) => {
                    const isActiveComposer = inlineComposerType && composerActionLabel === act.buttonName;

                    return (
                      <button
                        key={act.id}
                        type="button"
                        disabled={isLoading}
                        onClick={(e) => handleExecuteUnifiedAction(act, e)}
                        className={cn(
                          "inline-flex h-7 shrink-0 whitespace-nowrap items-center gap-1.5 rounded-full border px-3 text-xs font-medium transition-all cursor-pointer active:scale-95 disabled:opacity-50 disabled:pointer-events-none shadow-2xs",
                          isActiveComposer
                            ? "border-primary bg-primary/10 text-primary font-semibold ring-2 ring-primary/20"
                            : "border-border bg-card text-foreground hover:bg-accent hover:border-border/80"
                        )}
                        title={`Action: ${act.buttonName}${act.targetStepName ? ` (${selectedTicket.status} → ${act.targetStepName})` : ''}`}
                      >
                        {getActionIcon(act.actionCode || act.icon || act.buttonName, "size-3.5")}
                        <span>{act.buttonName}</span>
                      </button>
                    );
                  })}

                  {/* MORE ACTIONS DROPDOWN */}
                  {overflowActions.length > 0 && (
                    <div className="relative shrink-0">
                      <button
                        type="button"
                        onClick={() => setShowMoreActionsMenu(!showMoreActionsMenu)}
                        className={cn(
                          "inline-flex h-7 shrink-0 whitespace-nowrap items-center gap-1.5 rounded-full border px-3 text-xs font-semibold shadow-2xs cursor-pointer active:scale-95 transition-all",
                          showMoreActionsMenu
                            ? "border-primary bg-primary/10 text-primary font-semibold"
                            : "border-border bg-card hover:bg-accent text-foreground"
                        )}
                      >
                        <span>More Actions</span>
                        <ChevronDown className="size-3 text-muted-foreground" />
                      </button>

                      {showMoreActionsMenu && (
                        <>
                          <div
                            className="fixed inset-0 z-40"
                            onClick={() => setShowMoreActionsMenu(false)}
                          />
                          <div className="absolute left-0 sm:left-auto sm:right-0 top-8 z-50 min-w-48 max-w-xs rounded-xl border border-border bg-card p-1.5 shadow-2xl text-xs space-y-0.5 animate-in fade-in zoom-in-95 max-h-[380px] overflow-y-auto">
                            {overflowStageActions.length > 0 && (
                              <>
                                <div className="px-2 py-1 text-[10px] font-semibold text-muted-foreground uppercase tracking-wider">
                                  Stage Actions
                                </div>
                                {overflowStageActions.map((act) => (
                                  <button
                                    key={act.id}
                                    type="button"
                                    onClick={(e) => {
                                      setShowMoreActionsMenu(false);
                                      handleExecuteUnifiedAction(act, e);
                                    }}
                                    className="w-full flex items-center gap-2 px-2.5 py-1.5 rounded-lg text-left cursor-pointer transition-colors text-xs font-medium text-foreground hover:bg-muted/70"
                                  >
                                    {getActionIcon(act.actionCode || act.icon || act.buttonName, "size-3.5")}
                                    <span className="truncate">{act.buttonName}</span>
                                  </button>
                                ))}
                                <div className="my-1 border-t border-border/60" />
                              </>
                            )}

                            {globalUtilityActions.length > 0 && (
                              <>
                                {overflowStageActions.length > 0 && (
                                  <div className="px-2 py-1 text-[10px] font-semibold text-muted-foreground uppercase tracking-wider">
                                    General Actions
                                  </div>
                                )}
                                {globalUtilityActions.map((act) => (
                                  <button
                                    key={act.id}
                                    type="button"
                                    onClick={(e) => {
                                      setShowMoreActionsMenu(false);
                                      handleExecuteUnifiedAction(act, e);
                                    }}
                                    className="w-full flex items-center gap-2 px-2.5 py-1.5 rounded-lg text-left cursor-pointer transition-colors text-xs font-medium text-foreground hover:bg-muted/70"
                                  >
                                    {getActionIcon(act.actionCode || act.icon || act.buttonName, "size-3.5")}
                                    <span className="truncate">{act.buttonName}</span>
                                  </button>
                                ))}
                              </>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </div>

                {/* HIDDEN MEASUREMENT CONTAINER TO ACCURATELY DETECT 2-LINE OVERFLOW */}
                <div
                  ref={measureRef}
                  aria-hidden="true"
                  className="pointer-events-none fixed -top-[9999px] left-0 flex flex-wrap gap-1.5 invisible"
                  style={{ width: containerWidth > 0 ? `${containerWidth}px` : undefined }}
                >
                  {stageTransitionActions.map((act) => (
                    <div
                      key={`measure-${act.id}`}
                      data-measure-action="true"
                      className="inline-flex h-7 shrink-0 whitespace-nowrap items-center gap-1.5 rounded-full border px-3 text-xs font-semibold"
                    >
                      <span className="size-3.5 shrink-0" />
                      <span>{act.buttonName}</span>
                    </div>
                  ))}
                  <div
                    data-measure-more="true"
                    className="inline-flex h-7 shrink-0 whitespace-nowrap items-center gap-1.5 rounded-full border px-3 text-xs font-semibold"
                  >
                    <span>More Actions</span>
                    <span className="size-3 shrink-0" />
                  </div>
                </div>
              </div>

              {/* RIGHT: COMPACT UTILITIES (SYNC VAULT & FOLLOW) */}
              <div className="flex items-center gap-1.5 shrink-0 ml-auto pl-2">
                <button
                  type="button"
                  onClick={async () => {
                    try {
                      await useTicketStore.getState().syncTicketToVault(selectedTicket.id);
                    } catch {
                      // error toasted by store
                    }
                  }}
                  title="Sync to Cloud Vault (GDrive / S3)"
                  className="inline-flex h-7 items-center gap-1.5 px-2.5 rounded-full border border-border bg-background hover:bg-muted text-xs text-muted-foreground hover:text-foreground transition-colors shadow-2xs"
                >
                  <Cloud className="size-3 text-sky-500" />
                  <span className="hidden md:inline">Sync Vault</span>
                </button>

                <button
                  type="button"
                  onClick={(e) => {
                    toggleFollowTicket(selectedTicket.id, e);
                    const isNowFollowing = !followedTickets.has(selectedTicket.id);
                    const noteText = isNowFollowing
                      ? `Staff is now following updates for ticket [${selectedTicket.ticketId}].`
                      : `Staff unfollowed updates for ticket [${selectedTicket.ticketId}].`;
                    addHistory(selectedTicket.id, noteText, true, undefined, isNowFollowing ? 'Follow Ticket' : 'Unfollow Ticket', `${currentUserName} (You)`);
                    const updatedTicket = useTicketStore.getState().tickets.find(tk => String(tk.id) === String(selectedTicket.id) || tk.ticketId === selectedTicket.ticketId);
                    if (updatedTicket) {
                      setSelectedTicket(updatedTicket);
                    }
                  }}
                  title={followedTickets.has(selectedTicket.id) ? 'Following Ticket' : 'Follow Ticket'}
                  className={cn(
                    "inline-flex h-7 items-center gap-1.5 px-2.5 rounded-full border border-border bg-background hover:bg-muted text-xs transition-colors shadow-2xs",
                    followedTickets.has(selectedTicket.id) ? "text-blue-600 border-blue-200 bg-blue-50/60 dark:bg-blue-950/40" : "text-muted-foreground hover:text-foreground"
                  )}
                >
                  <Bell className="size-3" />
                  <span className="hidden md:inline">{followedTickets.has(selectedTicket.id) ? 'Following' : 'Follow'}</span>
                </button>
              </div>
            </header>
          </div>

          {/* FULL VIEW BODY: 2 COLUMNS (CHEVRON PIPELINE & METADATA PANELS) */}
          <div className="flex flex-1 overflow-hidden p-5 gap-5">
            {/* LEFT/CENTER COLUMN: CHEVRON STAGE PIPELINE & TABBED ACTIVITY LOG */}
            <div className="flex-1 flex flex-col overflow-y-auto space-y-4">
              {/* TICKET TITLE & SUBJECT BANNER (PREVIOUS DESIGN FORMAT) */}
              <div className="rounded-xl border border-border bg-card p-4 shadow-2xs">
                <div className="flex items-start gap-3">
                  <div className={cn(
                    "flex size-8 items-center justify-center rounded-full text-white shrink-0 shadow-xs transition-colors mt-0.5",
                    getTicketStatusIconColor(selectedTicket.status)
                  )} title={`Status: ${selectedTicket.status}`}>
                    <svg className="size-4 text-white shrink-0" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                      <rect x="9" y="2.5" width="6" height="11" rx="3" />
                      <circle cx="12" cy="19" r="3" />
                    </svg>
                  </div>

                  <div className="flex-1 min-w-0 flex flex-col justify-center gap-0.5">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="text-submenu font-semibold tracking-tight text-foreground font-sans select-text">
                        [{selectedTicket.ticketId}]
                      </span>
                      {selectedTicket.source === 'System Generated' && (
                        <span className="text-xs font-medium px-2 py-0.5 rounded bg-muted text-muted-foreground border border-border">
                          🤖 System Generated
                        </span>
                      )}
                      {selectedTicket.entryChannel && selectedTicket.entryChannel !== 'portal' && (
                        <span className="text-xs font-medium px-1.5 py-0.5 rounded bg-sky-50 text-sky-700 dark:bg-sky-950/40 dark:text-sky-300 border border-sky-200 capitalize">
                          Channel: {selectedTicket.entryChannel}
                        </span>
                      )}
                      {selectedTicket.isConfidential && (
                        <span className="text-xs font-semibold px-2 py-0.5 rounded bg-purple-50 text-purple-700 dark:bg-purple-950/40 dark:text-purple-300 border border-purple-200">
                          🔒 Confidential
                        </span>
                      )}
                      {ticketAsset && ticketAsset.assetCode && ticketAsset.assetCode !== '-' && !isSoftwareTicket && showAssetCard && (
                        <span
                          className={cn(
                            'inline-flex items-center gap-1.5 px-2 py-0.5 rounded text-xs font-medium border transition-colors',
                            ticketAsset.warrantyUntil
                              ? 'bg-info/10 text-info-strong border-info/20'
                              : 'bg-secondary text-muted-foreground border-border'
                          )}
                        >
                          <ShieldCheck className="size-3.5 text-info shrink-0" />
                          <span>
                            Asset: <strong className="font-semibold">{ticketAsset.assetCode}</strong>
                            {ticketAsset.name ? ` (${ticketAsset.name})` : ''}
                            {ticketAsset.warrantyUntil ? (
                              <>
                                {' · '}
                                <span className="font-mono text-[11px]">
                                  Warranty: {ticketAsset.warrantyUntil.includes('T') ? ticketAsset.warrantyUntil.slice(0, 10) : ticketAsset.warrantyUntil}
                                </span>
                              </>
                            ) : (
                              ' · No warranty date'
                            )}
                          </span>
                          <a
                            href="/assets/warranty"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="ml-1 text-[11px] underline text-primary hover:text-primary-focus font-semibold"
                            title="Open Warranty Tracker"
                          >
                            Warranty Tracker
                          </a>
                        </span>
                      )}
                      {!isSoftwareTicket && showVendorCard && ((ticketAsset && (ticketAsset.vendor || ticketAsset.supplierName)) || selectedTicket.vendorName || selectedTicket.effectiveVendorName) && (
                        <span className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded text-xs font-medium border bg-blue-50 text-blue-700 dark:bg-blue-950/40 dark:text-blue-300 border-blue-200">
                          <Truck className="size-3.5 text-blue-600 shrink-0" />
                          <span>
                            Vendor: <strong className="font-semibold">{selectedTicket.effectiveVendorName || selectedTicket.vendorName || ticketAsset?.vendor || ticketAsset?.supplierName}</strong>
                            {(selectedTicket.vendorEmail || ticketAsset?.vendorEmail) && (
                              <span className="font-mono text-[11px] ml-1">({selectedTicket.vendorEmail || ticketAsset?.vendorEmail})</span>
                            )}
                          </span>
                          <a
                            href={`/assets/vendors?search=${encodeURIComponent(selectedTicket.effectiveVendorName || selectedTicket.vendorName || ticketAsset?.vendor || '')}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="ml-1 text-[11px] underline text-primary hover:text-primary-focus font-semibold"
                            title="Open Vendor in Directory"
                          >
                            Vendors
                          </a>
                        </span>
                      )}
                      {isSoftwareTicket && (
                        <span className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded text-xs font-medium border bg-sky-50 text-sky-800 dark:bg-sky-950/40 dark:text-sky-300 border-sky-200">
                          <Code2 className="size-3.5 text-sky-600 shrink-0" />
                          <span>
                            Application: <strong className="font-semibold">{currentApp?.name || 'TeamOne Application'}</strong>
                            {currentApp?.environment ? ` (${currentApp.environment})` : ''}
                          </span>
                        </span>
                      )}
                    </div>

                    {isEditingSubject ? (
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          handleSaveSubject();
                        }}
                        className="flex items-center gap-2 mt-0.5"
                      >
                        <input
                          type="text"
                          value={subjectInput}
                          onChange={(e) => setSubjectInput(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === 'Escape') {
                              e.preventDefault();
                              setIsEditingSubject(false);
                            }
                          }}
                          autoFocus
                          className="flex-1 rounded-md border border-primary bg-background px-2.5 py-1 text-xs font-semibold text-foreground shadow-xs focus:outline-none focus:ring-1 focus:ring-primary"
                        />
                        <button
                          type="submit"
                          className="inline-flex items-center px-2.5 py-1 rounded bg-primary text-primary-foreground text-xs font-semibold hover:bg-primary/90 transition-opacity cursor-pointer"
                        >
                          Save
                        </button>
                        <button
                          type="button"
                          onClick={() => setIsEditingSubject(false)}
                          className="inline-flex items-center px-2.5 py-1 rounded border border-border text-xs text-muted-foreground hover:bg-muted transition-colors cursor-pointer"
                        >
                          Cancel
                        </button>
                      </form>
                    ) : (
                      <div
                        onClick={() => {
                          setIsEditingSubject(true);
                          setSubjectInput(selectedTicket.subject);
                        }}
                        className="group flex items-center gap-2 cursor-pointer text-xs font-semibold text-foreground hover:text-primary transition-colors"
                        title="Click to edit subject"
                      >
                        <span className="group-hover:underline truncate text-foreground font-semibold text-xs">
                          {selectedTicket.subject}
                        </span>
                        <Edit3 className="size-3 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity shrink-0" />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* PROGRESS / ACTIVITY LOG FEED (MATCHING SCREENSHOTS 2, 3, 4, 5) */}
              <div className="space-y-3">
                {/* PROGRESS HEADER ROW: LEFT PROGRESS TAB, RIGHT ACTION BUTTONS */}
                <div className="flex items-center justify-between border-b border-border pb-2">
                  <div className="flex items-center gap-4">
                    <button
                      type="button"
                      className="text-xs font-semibold text-blue-600 dark:text-blue-400 border-b-2 border-blue-600 pb-1.5 inline-block select-none"
                    >
                      Progress
                    </button>
                    <span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-muted border border-border text-muted-foreground">
                      {activityDropdownFilter === 'emails_notes' && 'Emails & Notes'}
                      {activityDropdownFilter === 'emails' && 'Email'}
                      {activityDropdownFilter === 'notes' && 'Notes'}
                      {activityDropdownFilter === 'public' && 'Public'}
                      {activityDropdownFilter === 'staff' && 'Staff'}
                      {activityDropdownFilter === 'time' && 'Time entries'}
                      {activityDropdownFilter === 'all' && 'All Actions'}
                    </span>
                  </div>

                  {/* RIGHT ACTION BUTTONS GROUP: SPEECH BUBBLE FILTER, EXPAND/COLLAPSE, SCROLL DOWN */}
                  <div className="flex items-center gap-2">
                    {/* 1. FILTER DROPDOWN BUTTON (MATCHING IMAGE 3) */}
                    <div className="relative">
                      <button
                        type="button"
                        onClick={() => setShowLogFilterMenu(!showLogFilterMenu)}
                        className={cn(
                          "flex size-7 items-center justify-center rounded-full border border-border bg-background hover:bg-muted transition-colors shadow-2xs cursor-pointer",
                          activityDropdownFilter !== 'emails_notes' && "border-blue-500 text-blue-600 dark:text-blue-400 bg-blue-50/50 dark:bg-blue-950/30"
                        )}
                        title={`Filter: ${activityDropdownFilter === 'emails_notes' ? 'Emails & Notes (Default)' :
                            activityDropdownFilter === 'emails' ? 'Email' :
                              activityDropdownFilter === 'notes' ? 'Notes' :
                                activityDropdownFilter === 'public' ? 'Public' :
                                  activityDropdownFilter === 'staff' ? 'Staff' :
                                    activityDropdownFilter === 'time' ? 'Time entries' : 'All Actions'
                          }`}
                      >
                        <MessageSquare className="size-3.5" />
                      </button>

                      {/* DROPDOWN MENU MATCHING SCREENSHOT 3 */}
                      {showLogFilterMenu && (
                        <div className="absolute right-0 top-9 z-50 w-56 rounded-xl border border-border bg-card p-1 shadow-2xl text-xs space-y-0.5 animate-in fade-in zoom-in-95">
                          {[
                            { key: 'emails_notes', label: 'Emails & Notes', icon: MessageSquare },
                            { key: 'emails', label: 'Email', icon: Mail },
                            { key: 'notes', label: 'Notes', icon: CornerUpLeft },
                            { key: 'public', label: 'Public', icon: Eye },
                            { key: 'staff', label: 'Staff', icon: User },
                            { key: 'time', label: 'Time entries', icon: Clock },
                            { key: 'all', label: 'All Actions', icon: Eye },
                          ].map((opt) => {
                            const IconC = opt.icon;
                            const isSelected = activityDropdownFilter === opt.key;
                            return (
                              <button
                                key={opt.key}
                                type="button"
                                onClick={() => {
                                  setActivityDropdownFilter(opt.key as any);
                                  setShowLogFilterMenu(false);
                                }}
                                className={cn(
                                  "w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-left text-xs transition-colors cursor-pointer",
                                  isSelected
                                    ? "bg-accent font-semibold text-foreground"
                                    : "text-muted-foreground hover:text-foreground hover:bg-muted/60"
                                )}
                              >
                                <IconC className="size-3.5 shrink-0" />
                                <span>{opt.label}</span>
                              </button>
                            );
                          })}
                        </div>
                      )}
                    </div>

                    {/* 2. EXPAND ALL / COLLAPSE ALL TOGGLE BUTTON */}
                    <button
                      type="button"
                      onClick={() => setFeedCollapsed(!feedCollapsed)}
                      className="flex size-7 items-center justify-center rounded-full border border-border bg-background hover:bg-muted transition-colors shadow-2xs cursor-pointer relative group"
                      title={feedCollapsed ? "Expand All" : "Collapse All"}
                    >
                      {feedCollapsed ? (
                        <PlusSquare className="size-3.5 text-foreground" />
                      ) : (
                        <MinusSquare className="size-3.5 text-foreground" />
                      )}
                      <span className="absolute right-0 top-8 hidden group-hover:block z-50 bg-black text-white text-xs font-semibold px-2 py-0.5 rounded shadow-md whitespace-nowrap">
                        {feedCollapsed ? "Expand All" : "Collapse All"}
                      </span>
                    </button>

                    {/* 3. SCROLL DOWN BUTTON */}
                    <button
                      type="button"
                      onClick={() => {
                        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                      }}
                      className="flex size-7 items-center justify-center rounded-full border border-border bg-background hover:bg-muted transition-colors shadow-2xs cursor-pointer"
                      title="Scroll to latest"
                    >
                      <ArrowDown className="size-3.5 text-muted-foreground hover:text-foreground" />
                    </button>
                  </div>
                </div>

                {/* INLINE COMPOSER CARD (MATCHING USER SCREENSHOTS) */}
                {inlineComposerType && (
                  <div
                    ref={composerContainerRef}
                    onPaste={handleComposerPaste}
                    onDragOver={(e) => {
                      e.preventDefault();
                      setIsDraggingOverComposer(true);
                    }}
                    onDragLeave={() => setIsDraggingOverComposer(false)}
                    onDrop={(e) => {
                      e.preventDefault();
                      setIsDraggingOverComposer(false);
                      handleComposerFilesSelected(e.dataTransfer.files);
                    }}
                    className={cn(
                      'rounded-2xl border border-border bg-card p-6 sm:p-7 shadow-sm space-y-5 animate-in fade-in slide-in-from-top-2 transition-all',
                      isDraggingOverComposer ? 'border-primary ring-2 ring-primary/20 bg-primary/5' : 'border-border'
                    )}
                  >
                    {/* Hidden Native File Inputs for Toolbar Buttons & Dropzone */}
                    <input
                      ref={composerFileInputRef}
                      type="file"
                      multiple
                      accept="image/*,image/webp,.webp,video/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.json,.zip"
                      className="hidden"
                      onChange={(e) => handleComposerFilesSelected(e.target.files)}
                    />
                    <input
                      ref={composerImageInputRef}
                      type="file"
                      accept="image/*,image/webp,.webp"
                      multiple
                      className="hidden"
                      onChange={(e) => handleComposerFilesSelected(e.target.files)}
                    />
                    <input
                      ref={composerVideoInputRef}
                      type="file"
                      accept="video/*"
                      multiple
                      className="hidden"
                      onChange={(e) => handleComposerFilesSelected(e.target.files)}
                    />

                    {/* 1. COMPOSER HEADER */}
                    <div className="flex items-center justify-between border-b border-border pb-3.5 flex-wrap gap-2.5">
                      {/* Left: Avatar + Name, Action Label & Target State Transition */}
                      <div className="flex items-center gap-3">
                        {renderCurrentUserAvatar("size-9", "text-sm")}
                        <div className="flex flex-col text-xs leading-tight">
                          <span className="font-semibold text-foreground text-sm tracking-tight">{currentUserName}</span>
                          <div className="flex items-center gap-1.5 mt-0.5 flex-wrap">
                            <span className="text-primary font-semibold text-xs inline-flex items-center gap-1">
                              {getActionIcon(activeBackendAction?.actionCode || composerActionLabel)}
                              {composerActionLabel || 'Note (+Email)'}
                            </span>
                            {activeBackendAction?.toStateName && (
                              <span className="inline-flex items-center gap-1 text-xs text-muted-foreground bg-muted px-2 py-0.5 rounded border border-border">
                                <span>{selectedTicket.status}</span>
                                <ArrowRight className="size-2.5 text-muted-foreground" />
                                <span className="text-foreground font-semibold text-primary">{activeBackendAction.toStateName}</span>
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Right: Header Control Icons */}
                      <div className="flex items-center gap-2 text-muted-foreground shrink-0 flex-wrap">
                        {!isStrictNoteOnly && isMailMode && (
                          <>
                            {/* Three Dot Options Menu Button */}
                            <div className="relative shrink-0">
                              <button
                                type="button"
                                onClick={() => setShowThreeDotMenu(!showThreeDotMenu)}
                                className={cn(
                                  "flex size-8 shrink-0 items-center justify-center rounded-full border transition-colors cursor-pointer shadow-2xs",
                                  showThreeDotMenu
                                    ? "border-primary bg-primary/10 text-primary font-semibold"
                                    : "border-border bg-card text-muted-foreground hover:text-foreground hover:bg-muted/70"
                                )}
                                title="Mail options (Cc, Bcc, From, Reply to me)"
                              >
                                <MoreHorizontal className="size-4 shrink-0" />
                              </button>

                              {showThreeDotMenu && (
                                <>
                                  <div
                                    className="fixed inset-0 z-40"
                                    onClick={() => setShowThreeDotMenu(false)}
                                  />
                                  <div className="absolute right-0 top-8.5 z-50 w-52 rounded-xl border border-border bg-card p-1 shadow-xl text-xs space-y-0.5 animate-in fade-in zoom-in-95">
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setShowFrom(!showFrom);
                                        setShowThreeDotMenu(false);
                                      }}
                                      className="w-full flex items-center justify-between px-3 py-2 rounded-lg text-left hover:bg-muted/60 text-foreground cursor-pointer"
                                    >
                                      <span>Show From</span>
                                      {showFrom && <Check className="size-3.5 text-blue-600 font-semibold" />}
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setShowCc(!showCc);
                                        setShowThreeDotMenu(false);
                                      }}
                                      className="w-full flex items-center justify-between px-3 py-2 rounded-lg text-left hover:bg-muted/60 text-foreground cursor-pointer"
                                    >
                                      <span>Show Cc</span>
                                      {showCc && <Check className="size-3.5 text-blue-600 font-semibold" />}
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setShowBcc(!showBcc);
                                        setShowThreeDotMenu(false);
                                      }}
                                      className="w-full flex items-center justify-between px-3 py-2 rounded-lg text-left hover:bg-muted/60 text-foreground cursor-pointer"
                                    >
                                      <span>Show Bcc</span>
                                      {showBcc && <Check className="size-3.5 text-blue-600 font-semibold" />}
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setReplyDirectlyToMe(!replyDirectlyToMe);
                                        setShowThreeDotMenu(false);
                                      }}
                                      className="w-full flex items-center justify-between px-3 py-2 rounded-lg text-left hover:bg-muted/60 text-foreground cursor-pointer"
                                    >
                                      <span>Reply directly to me</span>
                                      {replyDirectlyToMe && <Check className="size-3.5 text-blue-600 font-semibold" />}
                                    </button>
                                  </div>
                                </>
                              )}
                            </div>

                            {/* Priority / Urgent Button */}
                            <button
                              type="button"
                              onClick={() => setIsComposerUrgent(!isComposerUrgent)}
                              className={cn(
                                "flex size-8 shrink-0 items-center justify-center rounded-full border transition-colors cursor-pointer shadow-2xs",
                                isComposerUrgent
                                  ? "border-amber-500 bg-amber-50 text-amber-600 dark:bg-amber-950/50 dark:text-amber-400 font-semibold"
                                  : "border-border bg-card text-muted-foreground hover:text-foreground hover:bg-muted/70"
                              )}
                              title={isComposerUrgent ? "Urgent Priority Active" : "Mark as Urgent"}
                            >
                              <span className="font-semibold text-sm leading-none select-none">!</span>
                            </button>

                            {/* Active Mail Icon Button */}
                            <button
                              type="button"
                              onClick={() => setIsMailMode(false)}
                              className="flex size-8 shrink-0 items-center justify-center rounded-full border border-blue-500 bg-blue-50 text-blue-600 dark:bg-blue-950/50 dark:text-blue-400 dark:border-blue-800 hover:bg-blue-100 dark:hover:bg-blue-900/40 shadow-2xs transition-colors cursor-pointer"
                              title="Switch to Normal Note Editor (Deactivate Mail)"
                            >
                              <Mail className="size-4 shrink-0" />
                            </button>
                          </>
                        )}

                        {!isStrictNoteOnly && !isMailMode && (
                          /* Inactive Mail Icon Button */
                          <button
                            type="button"
                            onClick={() => setIsMailMode(true)}
                            className="flex size-8 shrink-0 items-center justify-center rounded-full border border-border bg-card text-muted-foreground hover:text-foreground hover:bg-muted/70 transition-colors cursor-pointer shadow-2xs"
                            title="Activate Mail Composer (Send Email)"
                          >
                            <Mail className="size-4 shrink-0" />
                          </button>
                        )}

                        {/* Paperclip Button */}
                        <button
                          type="button"
                          onClick={() => composerFileInputRef.current?.click()}
                          className="flex size-8 shrink-0 items-center justify-center rounded-full border border-border bg-card text-muted-foreground hover:text-foreground hover:bg-muted/70 transition-colors cursor-pointer shadow-2xs"
                          title="Attach File or Document"
                        >
                          <Paperclip className="size-4 shrink-0" />
                        </button>

                        {/* Close Composer Button */}
                        <button
                          type="button"
                          onClick={() => {
                            setInlineComposerType(null);
                            setComposerAttachments([]);
                            setAppointmentDateTime('');
                            setChildTicketSubject('');
                          }}
                          className="flex size-8 shrink-0 items-center justify-center rounded-full border border-border bg-card text-muted-foreground hover:text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-950/30 transition-colors cursor-pointer shadow-2xs"
                          title="Close composer"
                        >
                          <X className="size-4 shrink-0" />
                        </button>
                      </div>
                    </div>

                    {/* 2. EMAIL FIELDS (RENDERED WHEN MAIL MODE IS ACTIVE & NOT STRICT NOTE ONLY) */}
                    {!isStrictNoteOnly && isMailMode && (
                      <div className="space-y-3.5 text-xs border-b border-border pb-4 pt-1 animate-in fade-in">
                        {/* Show From Row */}
                        {showFrom && (
                          <div className="flex items-center gap-3.5">
                            <span className="w-14 font-semibold text-muted-foreground">From</span>
                            <div className="flex-1 rounded-lg border border-border bg-muted/30 px-3.5 py-2 text-xs text-foreground font-medium">
                              {replyDirectlyToMe
                                ? `${currentUserName} <${user?.email || selectedTicket?.teamEmail || activeSupportSender.email}>`
                                : (selectedTicket?.teamEmail
                                  ? `${selectedTicket?.teamName || activeSupportSender.name} <${selectedTicket?.teamEmail}>`
                                  : activeSupportSender.formatted)}
                            </div>
                          </div>
                        )}

                        {/* To Field with Clean Recipient Chips */}
                        <div className="flex items-start gap-3.5">
                          <span className="w-14 pt-2.5 font-semibold text-muted-foreground">To</span>
                          <div className="flex-1 min-h-[42px] flex flex-wrap items-center gap-2 rounded-xl border border-border bg-background px-3 py-1.5 focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/10 transition-all">
                            {toEmails.map((email, idx) => (
                              <span
                                key={idx}
                                className="inline-flex items-center gap-1.5 rounded-lg bg-secondary text-foreground border border-border px-2.5 py-1 text-xs font-sans shadow-2xs"
                              >
                                <span>{email}</span>
                                <button
                                  type="button"
                                  onClick={() => setToEmails(toEmails.filter((_, i) => i !== idx))}
                                  className="text-muted-foreground hover:text-rose-600 font-semibold ml-1 cursor-pointer transition-colors"
                                  title="Remove recipient"
                                >
                                  ×
                                </button>
                              </span>
                            ))}
                            <input
                              type="email"
                              value={toInput}
                              onChange={(e) => setToInput(e.target.value)}
                              onKeyDown={(e) => {
                                if ((e.key === 'Enter' || e.key === ',') && toInput.trim()) {
                                  e.preventDefault();
                                  const trimmed = toInput.trim().replace(/,$/, '');
                                  if (trimmed && !toEmails.includes(trimmed)) {
                                    setToEmails([...toEmails, trimmed]);
                                  }
                                  setToInput('');
                                }
                              }}
                              onBlur={() => {
                                const trimmed = toInput.trim().replace(/,$/, '');
                                if (trimmed && !toEmails.includes(trimmed)) {
                                  setToEmails([...toEmails, trimmed]);
                                }
                                setToInput('');
                              }}
                              placeholder={toEmails.length === 0 ? "recipient@example.com (press Enter to add)" : "add more..."}
                              className="min-w-[180px] flex-1 bg-transparent px-2 py-1 text-xs text-foreground placeholder:text-muted-foreground outline-none"
                            />
                            {toEmails.length > 0 && (
                              <button
                                type="button"
                                onClick={() => {
                                  setToEmails([]);
                                  setToInput('');
                                }}
                                className="p-1 hover:text-rose-600 cursor-pointer ml-auto text-muted-foreground"
                                title="Clear all recipients"
                              >
                                <X className="size-3.5" />
                              </button>
                            )}
                          </div>
                        </div>

                        {/* Cc Field with Chips */}
                        {showCc && (
                          <div className="flex items-start gap-3.5">
                            <span className="w-14 pt-2.5 font-semibold text-muted-foreground">Cc</span>
                            <div className="flex-1 min-h-[42px] flex flex-wrap items-center gap-2 rounded-xl border border-border bg-background px-3 py-1.5 focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/10 transition-all">
                              {ccEmails.map((email, idx) => (
                                <span
                                  key={idx}
                                  className="inline-flex items-center gap-1.5 rounded-lg bg-secondary text-foreground border border-border px-2.5 py-1 text-xs font-sans shadow-2xs"
                                >
                                  <span>{email}</span>
                                  <button
                                    type="button"
                                    onClick={() => setCcEmails(ccEmails.filter((_, i) => i !== idx))}
                                    className="text-muted-foreground hover:text-rose-600 font-semibold ml-1 cursor-pointer transition-colors"
                                    title="Remove Cc"
                                  >
                                    ×
                                  </button>
                                </span>
                              ))}
                              <input
                                type="email"
                                value={ccInput}
                                onChange={(e) => setCcInput(e.target.value)}
                                onKeyDown={(e) => {
                                  if ((e.key === 'Enter' || e.key === ',') && ccInput.trim()) {
                                    e.preventDefault();
                                    const trimmed = ccInput.trim().replace(/,$/, '');
                                    if (trimmed && !ccEmails.includes(trimmed)) {
                                      setCcEmails([...ccEmails, trimmed]);
                                    }
                                    setCcInput('');
                                  }
                                }}
                                onBlur={() => {
                                  const trimmed = ccInput.trim().replace(/,$/, '');
                                  if (trimmed && !ccEmails.includes(trimmed)) {
                                    setCcEmails([...ccEmails, trimmed]);
                                  }
                                  setCcInput('');
                                }}
                                placeholder={ccEmails.length === 0 ? "cc@example.com (press Enter)" : "add more..."}
                                className="min-w-[180px] flex-1 bg-transparent px-2 py-1 text-xs text-foreground placeholder:text-muted-foreground outline-none"
                              />
                              {ccEmails.length > 0 && (
                                <button
                                  type="button"
                                  onClick={() => {
                                    setCcEmails([]);
                                    setCcInput('');
                                  }}
                                  className="p-1 hover:text-rose-600 cursor-pointer ml-auto text-muted-foreground"
                                  title="Clear all Cc"
                                >
                                  <X className="size-3.5" />
                                </button>
                              )}
                            </div>
                          </div>
                        )}

                        {/* Bcc Field with Chips */}
                        {showBcc && (
                          <div className="flex items-start gap-3.5">
                            <span className="w-14 pt-2.5 font-semibold text-muted-foreground">Bcc</span>
                            <div className="flex-1 min-h-[42px] flex flex-wrap items-center gap-2 rounded-xl border border-border bg-background px-3 py-1.5 focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/10 transition-all">
                              {bccEmails.map((email, idx) => (
                                <span
                                  key={idx}
                                  className="inline-flex items-center gap-1.5 rounded-lg bg-secondary text-foreground border border-border px-2.5 py-1 text-xs font-sans shadow-2xs"
                                >
                                  <span>{email}</span>
                                  <button
                                    type="button"
                                    onClick={() => setBccEmails(bccEmails.filter((_, i) => i !== idx))}
                                    className="text-muted-foreground hover:text-rose-600 font-semibold ml-1 cursor-pointer transition-colors"
                                    title="Remove Bcc"
                                  >
                                    ×
                                  </button>
                                </span>
                              ))}
                              <input
                                type="email"
                                value={bccInput}
                                onChange={(e) => setBccInput(e.target.value)}
                                onKeyDown={(e) => {
                                  if ((e.key === 'Enter' || e.key === ',') && bccInput.trim()) {
                                    e.preventDefault();
                                    const trimmed = bccInput.trim().replace(/,$/, '');
                                    if (trimmed && !bccEmails.includes(trimmed)) {
                                      setBccEmails([...bccEmails, trimmed]);
                                    }
                                    setBccInput('');
                                  }
                                }}
                                onBlur={() => {
                                  const trimmed = bccInput.trim().replace(/,$/, '');
                                  if (trimmed && !bccEmails.includes(trimmed)) {
                                    setBccEmails([...bccEmails, trimmed]);
                                  }
                                  setBccInput('');
                                }}
                                placeholder={bccEmails.length === 0 ? "bcc@example.com (press Enter)" : "add more..."}
                                className="min-w-[180px] flex-1 bg-transparent px-2 py-1 text-xs text-foreground placeholder:text-muted-foreground outline-none"
                              />
                              {bccEmails.length > 0 && (
                                <button
                                  type="button"
                                  onClick={() => {
                                    setBccEmails([]);
                                    setBccInput('');
                                  }}
                                  className="p-1 hover:text-rose-600 cursor-pointer ml-auto text-muted-foreground"
                                  title="Clear all Bcc"
                                >
                                  <X className="size-3.5" />
                                </button>
                              )}
                            </div>
                          </div>
                        )}

                        {/* Reply Directly to Me notice */}
                        {replyDirectlyToMe && (
                          <div className="flex items-center gap-1.5 text-xs text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-950/40 px-3.5 py-2 rounded-lg border border-blue-200 dark:border-blue-900 font-medium">
                            <CornerUpLeft className="size-3.5 shrink-0" />
                            <span>Replies to this email will route directly to {user?.email || 'your email'}</span>
                          </div>
                        )}

                        {/* Subject Line */}
                        <div className="flex items-center gap-3.5 py-1 text-xs text-foreground">
                          <span className="w-14 font-semibold text-muted-foreground">Subject:</span>
                          <input
                            type="text"
                            value={inlineComposerData.subject}
                            onChange={(e) => setInlineComposerData({ ...inlineComposerData, subject: e.target.value })}
                            className="flex-1 bg-transparent font-medium text-foreground outline-none text-xs border-b border-border/80 focus:border-primary py-1.5 transition-colors"
                            placeholder={`${(selectedTicket.subject || '').replace(/\s*\[TB#\d+\]|\s*\[[A-Z0-9#_-]+\]/gi, '').replace(/^re:\s*/i, '').trim()} [${selectedTicket.ticketId}]`}
                          />
                        </div>
                      </div>
                    )}

                    {/* 3. ACTION SPECIFIC FIELDS (APPOINTMENT / CHILD TICKET) */}
                    {composerActionLabel === 'Create Appointment' && (
                      <div className="flex items-center gap-3 p-3 bg-blue-50/50 dark:bg-blue-950/30 border border-blue-200 dark:border-blue-900 rounded-xl text-xs">
                        <Calendar className="size-4 text-blue-600 shrink-0" />
                        <span className="font-semibold text-foreground">Appointment Date & Time:</span>
                        <input
                          type="datetime-local"
                          value={appointmentDateTime}
                          onChange={(e) => setAppointmentDateTime(e.target.value)}
                          className="rounded-lg border border-border bg-background px-3 py-1.5 text-xs outline-none focus:border-primary text-foreground"
                        />
                      </div>
                    )}
                    {composerActionLabel === 'Create Child Ticket' && (
                      <div className="flex items-center gap-3 p-3 bg-purple-50/50 dark:bg-purple-950/30 border border-purple-200 dark:border-purple-900 rounded-xl text-xs">
                        <Plus className="size-4 text-purple-600 shrink-0" />
                        <span className="font-semibold text-foreground">Child Ticket Subject:</span>
                        <input
                          type="text"
                          value={childTicketSubject}
                          onChange={(e) => setChildTicketSubject(e.target.value)}
                          placeholder={`Child: [${selectedTicket.ticketId}] ${selectedTicket.subject}`}
                          className="flex-1 rounded-lg border border-border bg-background px-3 py-1.5 text-xs outline-none focus:border-purple-500 text-foreground"
                        />
                      </div>
                    )}

                    {/* Supplier dropdown for Log to Supplier action */}
                    {(composerActionLabel === 'Log to Supplier' ||
                      (composerActionLabel?.toLowerCase().startsWith('log') &&
                        (composerActionLabel?.toLowerCase().includes('supplier') ||
                          composerActionLabel?.toLowerCase().includes('vendor'))) ||
                      activeBackendAction?.actionCode === 'LOG_TO_SUPPLIER') && (
                        <div className="flex flex-col gap-1.5 max-w-sm pt-0.5">
                          <label className="text-xs font-semibold text-muted-foreground">
                            Supplier
                          </label>
                          <div className="relative flex items-center">
                            <select
                              value={
                                (vendors.find(
                                  (v) =>
                                    (selectedTicket.vendorId && v.id === selectedTicket.vendorId) ||
                                    (selectedTicket.supplierOrgId && v.id === selectedTicket.supplierOrgId) ||
                                    (selectedTicket.effectiveVendorName &&
                                      v.name.toLowerCase() === selectedTicket.effectiveVendorName.toLowerCase()) ||
                                    (selectedTicket.vendorName &&
                                      v.name.toLowerCase() === selectedTicket.vendorName.toLowerCase())
                                )?.id) || selectedTicket.vendorId || selectedTicket.supplierOrgId || ''
                              }
                              onChange={async (e) => {
                                const val = e.target.value;
                                const nextVendorId = val && !isNaN(Number(val)) ? Number(val) : null;
                                if (nextVendorId) {
                                  await handleSelectVendor(nextVendorId);
                                  const vObj = vendors.find((v) => v.id === nextVendorId);
                                  const supplierMail = vObj?.email || vObj?.contactEmail;
                                  if (supplierMail && !toEmails.includes(supplierMail)) {
                                    setToEmails([supplierMail]);
                                  }
                                } else {
                                  await handleUnlinkVendor();
                                }
                              }}
                              className="w-full appearance-none rounded-lg border border-border bg-background px-3.5 py-2 text-xs text-foreground outline-none cursor-pointer pr-8 font-medium focus:border-primary focus:ring-1 focus:ring-primary transition-all shadow-2xs"
                            >
                              <option value="">Supplier and Contract</option>
                              {vendors.map((v) => (
                                <option key={v.id} value={v.id}>
                                  {v.name} {v.contactPerson ? `(${v.contactPerson})` : ''}
                                </option>
                              ))}
                              {selectedTicket.effectiveVendorName &&
                                !vendors.some(
                                  (v) =>
                                    v.name.toLowerCase() === selectedTicket.effectiveVendorName?.toLowerCase()
                                ) && (
                                  <option value={selectedTicket.vendorId || ''}>
                                    {selectedTicket.effectiveVendorName}
                                  </option>
                                )}
                            </select>
                            <ChevronDown className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 size-4 text-muted-foreground" />
                          </div>
                        </div>
                      )}

                    {/* 4. UNIFIED RICH TEXT EDITOR BOX */}
                    <div className={cn(
                      "rounded-xl border border-border bg-background overflow-hidden focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/10 transition-all shadow-xs flex flex-col",
                      isComposerFullscreen && "fixed inset-4 sm:inset-8 z-50 shadow-2xl bg-card border-border"
                    )}>
                      {/* Integrated Toolbar */}
                      <div className="flex items-center gap-1.5 border-b border-border bg-muted/25 px-3 py-2 text-muted-foreground flex-wrap text-xs">
                        {/* Fullscreen Button */}
                        <button
                          type="button"
                          onClick={() => setIsComposerFullscreen(!isComposerFullscreen)}
                          className={cn(
                            "p-1 hover:text-foreground hover:bg-background rounded transition-colors cursor-pointer",
                            isComposerFullscreen && "bg-background text-primary"
                          )}
                          title={isComposerFullscreen ? "Exit Fullscreen" : "Fullscreen"}
                        >
                          {isComposerFullscreen ? <Minimize2 className="size-3.5" /> : <Maximize2 className="size-3.5" />}
                        </button>

                        <span className="text-border mx-0.5">|</span>

                        {/* Headings & Text Styles Dropdown */}
                        <div className="relative">
                          <button
                            type="button"
                            onClick={() => setShowHeadingMenu(!showHeadingMenu)}
                            className={cn(
                              "px-1.5 py-0.5 font-semibold hover:text-foreground hover:bg-background rounded transition-colors cursor-pointer text-xs flex items-center gap-0.5",
                              showHeadingMenu && "bg-background text-primary"
                            )}
                            title="Text Styles & Headings"
                          >
                            <span>A▾</span>
                          </button>

                          {showHeadingMenu && (
                            <>
                              <div className="fixed inset-0 z-40" onClick={() => setShowHeadingMenu(false)} />
                              <div className="absolute left-0 top-full mt-1.5 z-50 w-44 rounded-xl border border-border bg-card p-1 shadow-xl text-xs space-y-0.5 animate-in fade-in zoom-in-95">
                                <button
                                  type="button"
                                  onClick={() => { applyTextFormat('h1'); setShowHeadingMenu(false); }}
                                  className="w-full flex items-center gap-2 px-2.5 py-1.5 rounded-lg text-left hover:bg-muted text-foreground cursor-pointer font-semibold text-sm"
                                >
                                  <span className="font-semibold text-sm">H1</span> Heading 1
                                </button>
                                <button
                                  type="button"
                                  onClick={() => { applyTextFormat('h2'); setShowHeadingMenu(false); }}
                                  className="w-full flex items-center gap-2 px-2.5 py-1.5 rounded-lg text-left hover:bg-muted text-foreground cursor-pointer font-semibold text-xs"
                                >
                                  <span className="font-semibold text-sm">H2</span> Heading 2
                                </button>
                                <button
                                  type="button"
                                  onClick={() => { applyTextFormat('h3'); setShowHeadingMenu(false); }}
                                  className="w-full flex items-center gap-2 px-2.5 py-1.5 rounded-lg text-left hover:bg-muted text-foreground cursor-pointer font-semibold text-xs"
                                >
                                  <span className="font-semibold text-xs">H3</span> Heading 3
                                </button>
                                <button
                                  type="button"
                                  onClick={() => { applyTextFormat('normal'); setShowHeadingMenu(false); }}
                                  className="w-full flex items-center gap-2 px-2.5 py-1.5 rounded-lg text-left hover:bg-muted text-foreground cursor-pointer text-xs"
                                >
                                  <span>P</span> Normal text
                                </button>
                              </div>
                            </>
                          )}
                        </div>

                        {/* Bold Button */}
                        <button
                          type="button"
                          onClick={() => applyTextFormat('bold')}
                          className="p-1 hover:text-foreground hover:bg-background rounded transition-colors cursor-pointer"
                          title="Bold (Ctrl+B)"
                        >
                          <Bold className="size-3.5" />
                        </button>

                        {/* Italic Button */}
                        <button
                          type="button"
                          onClick={() => applyTextFormat('italic')}
                          className="p-1 hover:text-foreground hover:bg-background rounded transition-colors cursor-pointer"
                          title="Italic (Ctrl+I)"
                        >
                          <Italic className="size-3.5" />
                        </button>

                        {/* Bullet List Button */}
                        <button
                          type="button"
                          onClick={() => applyTextFormat('bullet')}
                          className="p-1 hover:text-foreground hover:bg-background rounded transition-colors cursor-pointer"
                          title="Bullet list"
                        >
                          <List className="size-3.5" />
                        </button>

                        {/* Numbered List Button */}
                        <button
                          type="button"
                          onClick={() => applyTextFormat('number')}
                          className="p-1 hover:text-foreground hover:bg-background rounded transition-colors cursor-pointer"
                          title="Numbered list"
                        >
                          <ListOrdered className="size-3.5" />
                        </button>

                        {/* Quote Button */}
                        <button
                          type="button"
                          onClick={() => applyTextFormat('quote')}
                          className="p-1 hover:text-foreground hover:bg-background rounded transition-colors cursor-pointer"
                          title="Blockquote"
                        >
                          <Quote className="size-3.5" />
                        </button>

                        <span className="text-border mx-0.5">|</span>

                        {/* Insert Link Button */}
                        <button
                          type="button"
                          onClick={() => applyTextFormat('link')}
                          className="p-1 hover:text-foreground hover:bg-background rounded transition-colors cursor-pointer"
                          title="Insert Link"
                        >
                          <Link className="size-3.5" />
                        </button>

                        {/* Single Unified Attachment Button (Images, Videos, Documents, etc.) */}
                        <button
                          type="button"
                          onClick={() => composerFileInputRef.current?.click()}
                          className="p-1 hover:text-primary hover:bg-background rounded cursor-pointer transition-colors"
                          title="Attach files (images, videos, documents, etc.)"
                        >
                          <Paperclip className="size-3.5" />
                        </button>

                        {/* Open-Source Emoji Palette Button & Popover */}
                        <div className="relative">
                          <button
                            type="button"
                            onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                            className={cn(
                              "p-1 hover:text-foreground hover:bg-background rounded transition-colors cursor-pointer",
                              showEmojiPicker && "bg-background text-primary"
                            )}
                            title="Insert Emoji"
                          >
                            <Smile className="size-3.5" />
                          </button>

                          {showEmojiPicker && (
                            <>
                              <div
                                className="fixed inset-0 z-40"
                                onClick={() => setShowEmojiPicker(false)}
                              />
                              <div className="absolute left-0 bottom-full mb-2 z-50 shadow-2xl rounded-2xl border border-border overflow-hidden animate-in fade-in zoom-in-95">
                                <EmojiPicker
                                  onEmojiClick={handleEmojiSelect}
                                  theme={document.documentElement.classList.contains('dark') ? Theme.DARK : Theme.LIGHT}
                                  lazyLoadEmojis={true}
                                  searchPlaceHolder="Search emoji..."
                                  previewConfig={{ showPreview: false }}
                                  width={320}
                                  height={380}
                                />
                              </div>
                            </>
                          )}
                        </div>

                        {/* Code Block Button */}
                        <button
                          type="button"
                          onClick={() => applyTextFormat('code')}
                          className="p-1 hover:text-foreground hover:bg-background rounded transition-colors cursor-pointer"
                          title="Inline Code / Code block"
                        >
                          <LucideCode className="size-3.5" />
                        </button>

                        {/* Live Formatted Markdown Preview Toggle */}
                        <button
                          type="button"
                          onClick={() => setIsComposerPreviewMode(!isComposerPreviewMode)}
                          className={cn(
                            "p-1 hover:text-foreground hover:bg-background rounded transition-colors cursor-pointer ml-auto flex items-center gap-1 text-xs font-semibold px-2 border",
                            isComposerPreviewMode
                              ? "border-primary bg-primary/10 text-primary shadow-2xs"
                              : "border-border bg-card text-muted-foreground hover:bg-muted"
                          )}
                          title={isComposerPreviewMode ? "Switch to Editor Mode" : "Preview formatted text"}
                        >
                          {isComposerPreviewMode ? <EyeOff className="size-3" /> : <Eye className="size-3" />}
                          <span>{isComposerPreviewMode ? "Edit" : "Preview"}</span>
                        </button>
                      </div>

                      {/* Textarea or Live Formatted Preview */}
                      {isComposerPreviewMode ? (
                        <div className="w-full bg-background/50 p-4 sm:p-5 text-xs text-foreground leading-relaxed font-sans min-h-[220px] overflow-y-auto">
                          {inlineComposerData.content ? (
                            <div className="space-y-2 whitespace-pre-wrap">
                              {inlineComposerData.content.split('\n').map((line, idx) => {
                                if (line.startsWith('# ')) {
                                  return <h1 key={idx} className="font-display text-page-title text-foreground mt-2 mb-1">{line.slice(2)}</h1>;
                                }
                                if (line.startsWith('## ')) {
                                  return <h2 key={idx} className="font-display text-section-title text-foreground mt-2 mb-1">{line.slice(3)}</h2>;
                                }
                                if (line.startsWith('### ')) {
                                  return <h3 key={idx} className="text-xs font-semibold text-foreground mt-1.5 mb-0.5">{line.slice(4)}</h3>;
                                }
                                if (line.startsWith('> ')) {
                                  return <blockquote key={idx} className="border-l-3 border-primary pl-3 italic text-muted-foreground my-1 bg-muted/20 py-1 rounded-r">{line.slice(2)}</blockquote>;
                                }
                                if (line.startsWith('- ')) {
                                  return <li key={idx} className="list-disc ml-5 my-0.5">{line.slice(2)}</li>;
                                }
                                if (/^\d+\.\s/.test(line)) {
                                  return <li key={idx} className="list-decimal ml-5 my-0.5">{line.replace(/^\d+\.\s/, '')}</li>;
                                }
                                const formatted = line
                                  .replace(/\*\*(.+?)\*\*/g, '<strong class="font-semibold text-foreground">$1</strong>')
                                  .replace(/\*([^*]+)\*/g, '<em class="italic">$1</em>')
                                  .replace(/`([^`]+)`/g, '<code class="bg-muted px-1.5 py-0.5 rounded font-mono text-xs text-primary font-semibold">$1</code>')
                                  .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline font-semibold">$1</a>');
                                return <p key={idx} className="my-1" dangerouslySetInnerHTML={{ __html: formatted }} />;
                              })}
                            </div>
                          ) : (
                            <p className="text-muted-foreground italic">Nothing to preview yet. Start typing to see formatted preview.</p>
                          )}
                        </div>
                      ) : (
                        <textarea
                          ref={composerTextareaRef}
                          rows={10}
                          value={inlineComposerData.content}
                          onChange={(e) => setInlineComposerData({ ...inlineComposerData, content: e.target.value })}
                          onPaste={handleComposerPaste}
                          placeholder={
                            activeBackendAction
                              ? `Add notes, instructions, review remarks or message to notify stakeholders for "${composerActionLabel}"... (You can paste screenshots or drag & drop files)`
                              : isStrictNoteOnly
                                ? `Type your ${composerActionLabel.toLowerCase()} here... (You can paste screenshots or drag & drop files)`
                                : isMailMode
                                  ? "Type your update/message to send via email... (You can paste screenshots or drag & drop files)"
                                  : "Type your update/note here..."
                          }
                          className="w-full bg-transparent p-4 sm:p-5 text-xs text-foreground placeholder:text-muted-foreground outline-none resize-y leading-relaxed font-sans min-h-[220px]"
                        />
                      )}
                    </div>

                    {/* 5. STAGED ATTACHMENTS PREVIEW BAR */}
                    {composerAttachments.length > 0 && (
                      <div className="rounded-xl border border-border bg-muted/20 p-3.5 space-y-2.5">
                        <div className="flex items-center justify-between text-xs font-semibold">
                          <span className="text-foreground flex items-center gap-1.5">
                            <Paperclip className="size-3.5 text-primary" /> Staged Attachments ({composerAttachments.length})
                          </span>
                          <button
                            type="button"
                            onClick={() => setComposerAttachments([])}
                            className="text-xs text-rose-500 hover:underline cursor-pointer"
                          >
                            Clear All
                          </button>
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2.5">
                          {composerAttachments.map((att) => (
                            <div
                              key={att.id}
                              className="relative flex items-center gap-2.5 p-2 rounded-lg border border-border bg-background overflow-hidden shadow-2xs group"
                            >
                              {att.isImage ? (
                                <img src={att.dataUrl} alt={att.name} className="size-10 rounded object-cover border border-border shrink-0" />
                              ) : att.isVideo ? (
                                <div className="size-10 rounded bg-purple-500/10 text-purple-600 dark:text-purple-400 flex items-center justify-center shrink-0 border border-purple-500/20">
                                  <Film className="size-5" />
                                </div>
                              ) : (
                                <div className="size-10 rounded bg-blue-500/10 text-blue-600 dark:text-blue-400 flex items-center justify-center shrink-0 border border-blue-500/20">
                                  <FileIcon className="size-5" />
                                </div>
                              )}

                              <div className="overflow-hidden flex-1">
                                <p className="text-xs font-semibold text-foreground truncate">{att.name}</p>
                                <div className="flex items-center gap-1.5 text-xs font-mono text-muted-foreground">
                                  <span className="font-semibold">{att.size}</span>
                                  <span>•</span>
                                  <span className="capitalize">{att.category}</span>
                                </div>
                              </div>

                              <button
                                type="button"
                                onClick={() => handleRemoveComposerAttachment(att.id)}
                                className="p-1 rounded-full text-muted-foreground hover:text-rose-600 hover:bg-rose-500/10 transition-colors"
                                title="Remove attachment"
                              >
                                <X className="size-3.5" />
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* 6. BOTTOM FIELDS ROW: STATUS *, TEAM *, STAFF * */}
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-xs pt-1.5">
                      {/* Status */}
                      <div className="space-y-1.5">
                        <label className="text-xs font-semibold text-muted-foreground">Status *</label>
                        <div className="relative flex items-center">
                          <select
                            value={inlineComposerData.status}
                            onChange={(e) => setInlineComposerData({ ...inlineComposerData, status: e.target.value })}
                            className="w-full appearance-none rounded-lg border border-border bg-background px-3.5 py-2 text-xs text-foreground outline-none cursor-pointer pr-8 font-medium focus:border-primary focus:ring-1 focus:ring-primary transition-all"
                          >
                            <option value="in-progress">In Progress</option>
                            <option value="pending">Pending</option>
                            <option value="with-user">With User</option>
                            <option value="with-supplier">With Supplier</option>
                            <option value="on-hold">On Hold</option>
                            <option value="awaiting-approval">Awaiting Approval</option>
                            <option value="resolved">Resolved</option>
                            <option value="closed">Closed</option>
                          </select>
                          <ChevronDown className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 size-4 text-muted-foreground" />
                        </div>
                      </div>

                      {/* Team (Dynamic from Settings Store) */}
                      <div className="space-y-1.5">
                        <label className="text-xs font-semibold text-muted-foreground">Team *</label>
                        <div className="relative flex items-center">
                          <select
                            value={inlineComposerData.team}
                            onChange={(e) => setInlineComposerData({ ...inlineComposerData, team: e.target.value })}
                            className="w-full appearance-none rounded-lg border border-border bg-background px-3.5 py-2 text-xs text-foreground outline-none cursor-pointer pr-8 font-medium focus:border-primary focus:ring-1 focus:ring-primary transition-all"
                          >
                            {filteredStoreQueues && filteredStoreQueues.length > 0 ? (
                              filteredStoreQueues.map((q) => (
                                <option key={q.id || q.key} value={q.label || q.key}>
                                  {q.label || q.key}
                                </option>
                              ))
                            ) : (
                              <option value={selectedTicket.teamName || "Support Team"}>{selectedTicket.teamName || "Support Team"}</option>
                            )}
                          </select>
                          <ChevronDown className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 size-4 text-muted-foreground" />
                        </div>
                      </div>

                      {/* Staff */}
                      <div className="space-y-1.5">
                        <label className="text-xs font-semibold text-muted-foreground">Staff *</label>
                        <div className="relative flex items-center">
                          <select
                            value={inlineComposerData.staff}
                            onChange={(e) => setInlineComposerData({ ...inlineComposerData, staff: e.target.value })}
                            className="w-full appearance-none rounded-lg border border-border bg-background px-3.5 py-2 text-xs text-foreground outline-none cursor-pointer pr-8 font-medium focus:border-primary focus:ring-1 focus:ring-primary transition-all"
                          >
                            <option value={currentUserName}>{currentUserName} (You)</option>
                            {selectedTicket.assigneeName && selectedTicket.assigneeName !== currentUserName && (
                              <option value={selectedTicket.assigneeName}>{selectedTicket.assigneeName}</option>
                            )}
                            {supportAgentsList
                              .filter((a) => a.name !== currentUserName && a.name !== selectedTicket.assigneeName)
                              .map((a) => (
                                <option key={a.id} value={a.name}>
                                  {a.name}
                                </option>
                              ))}
                          </select>
                          <ChevronDown className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 size-4 text-muted-foreground" />
                        </div>
                      </div>
                    </div>

                    {/* 7. BOTTOM ACTION BUTTONS: PREVIEW AND SEND / SAVE, DISCARD (ALIGNED RIGHT) */}
                    <div className="flex items-center justify-between gap-3 pt-3">
                      <div>
                        {activeBackendAction && (
                          <button
                            type="button"
                            onClick={handleExecuteWithoutNote}
                            disabled={Boolean(activeBackendAction.requiresComment || activeBackendAction.requiresReason)}
                            title={
                              activeBackendAction.requiresComment || activeBackendAction.requiresReason
                                ? `A comment is required for "${composerActionLabel}"`
                                : `Execute "${composerActionLabel}" immediately without adding a note`
                            }
                            className={cn(
                              "rounded-lg border px-4 py-2 text-xs font-semibold transition-colors cursor-pointer",
                              activeBackendAction.requiresComment || activeBackendAction.requiresReason
                                ? "border-border bg-muted/40 text-muted-foreground/50 cursor-not-allowed"
                                : "border-border bg-card text-foreground hover:bg-muted"
                            )}
                          >
                            Execute without note
                          </button>
                        )}
                      </div>

                      <div className="flex items-center gap-3">
                        <button
                          type="button"
                          onClick={() => {
                            setInlineComposerType(null);
                            setActiveBackendAction(null);
                            setComposerAttachments([]);
                          }}
                          className="rounded-lg border border-border bg-card px-5 py-2 text-xs font-semibold text-muted-foreground hover:text-foreground hover:bg-muted transition-colors cursor-pointer"
                        >
                          Discard
                        </button>

                        <button
                          type="button"
                          onClick={handleSaveInlineComposer}
                          className="rounded-lg bg-primary text-primary-foreground font-semibold px-6 py-2 text-xs shadow-sm hover:bg-primary/90 active:scale-95 transition-all cursor-pointer"
                        >
                          {activeBackendAction
                            ? `Execute ${composerActionLabel}`
                            : isMailMode && !isStrictNoteOnly
                              ? 'Preview and Send'
                              : 'Save'} {composerAttachments.length > 0 ? `(${composerAttachments.length})` : ''}
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {/* PROGRESS / ACTIVITY LOG FEED ENTRIES WITH IMAGE, VIDEO & DOC RENDERING */}
                <div className="space-y-3">
                  {filteredActivityHistory.length === 0 ? (
                    <div className="rounded-xl border border-border bg-card p-5 text-center text-xs text-muted-foreground">
                      No matching log entries found for this filter.
                    </div>
                  ) : (
                    filteredActivityHistory.map((h: TicketHistoryItem, idx: number) => {
                      const rawNote = (h.note || '')
                        .replace(/\[EMAIL\]/gi, '')
                        .replace(/^\s*\[(EMAIL|Email End User|Internal Note|Supplier Log|Note \+ Email|Public Reply|Private Note|Note \(\+Email\))\]\s*/i, '')
                        .trim();
                      const displayNote = stripSubjectFromBody(rawNote, selectedTicket?.subject);
                      const noteLower = (h.note || '').toLowerCase();
                      const rawAuthor = h.changedByName || selectedTicket?.requesterEmail || selectedTicket?.requesterName || selectedTicket?.client || 'Unity Platform';
                      const authorDisplayName = getUserDisplayName(
                        rawAuthor,
                        selectedTicket?.requesterName,
                        selectedTicket?.client,
                        employees
                      );
                      const initials = authorDisplayName
                        .split(' ')
                        .map((n: string) => n[0])
                        .join('')
                        .slice(0, 2)
                        .toUpperCase() || 'U';

                      let tagLabel = h.actionType || (h as any).buttonLabel || (h as any).button_label || 'Internal Note';
                      const actTypeClean = (tagLabel || '').toLowerCase();

                      // If tagLabel is empty or generic 'Action Executed' / 'action_executed' / 'ACTION_EXECUTED' / 'Internal Note', resolve the actual action done:
                      if (
                        !tagLabel ||
                        actTypeClean.includes('action executed') ||
                        actTypeClean === 'action_executed' ||
                        (actTypeClean === 'internal note' && (noteLower.startsWith('executed ') || (h as any).buttonLabel || (h as any).button_label))
                      ) {
                        const hAny = h as any;
                        if (h.buttonLabel || hAny.button_label) {
                          tagLabel = h.buttonLabel || hAny.button_label;
                        } else if (noteLower.startsWith('executed ')) {
                          tagLabel = (h.note || '').replace(/^Executed\s+/i, '').trim();
                        } else if (noteLower.match(/action\s*["'`]([^"'`]+)["'`]\s*executed/i)) {
                          const m = (h.note || '').match(/action\s*["'`]([^"'`]+)["'`]\s*executed/i);
                          if (m && m[1]) tagLabel = m[1].trim();
                        } else if (noteLower.includes('auto-generated ticket') || noteLower.includes('ticket created') || hAny.fromStageId === null || hAny.from_stage_id === null) {
                          tagLabel = 'Ticket Created';
                        } else if (h.toStatus || hAny.toStageName) {
                          tagLabel = `Status: ${h.toStatus || hAny.toStageName}`;
                        }
                      }

                      const actTypeFinal = (tagLabel || '').toLowerCase();
                      if (actTypeFinal === 'rule_applied' || actTypeFinal === 'rule applied' || actTypeFinal === 'rule') tagLabel = 'Rule Applied';
                      else if (actTypeFinal === 'type_change') tagLabel = 'Type Change';
                      else if (actTypeFinal === 'workflow_change') tagLabel = 'Workflow Change';
                      else if (actTypeFinal === 'sla_change') tagLabel = 'SLA Change';
                      else if (actTypeFinal === 'reassignment' || actTypeFinal === 'reassign' || actTypeFinal === 'assign') tagLabel = 'Reassignment';
                      else if (actTypeFinal === 'asset_change') tagLabel = 'Asset Change';
                      else if (actTypeFinal === 'end_user_change') tagLabel = 'End User Change';
                      else if (actTypeFinal === 'status_change') tagLabel = 'Status Change';
                      else if (actTypeFinal === 'priority_change') tagLabel = 'Priority Change';
                      else if (actTypeFinal === 'category_change') tagLabel = 'Category Change';
                      else if (actTypeFinal === 'subcategory_change') tagLabel = 'Issue Detail Change';
                      else if (actTypeFinal === 'resolution_change') tagLabel = 'Resolution Change';
                      else if (actTypeFinal === 'site_change') tagLabel = 'Site Change';
                      else if (actTypeFinal === 'additional_staff_change') tagLabel = 'Staff Change';
                      else if (actTypeFinal === 'time_entry' || actTypeFinal === 'time') tagLabel = 'Time Entry';
                      else if (actTypeFinal === 'property_change' || actTypeFinal === 'ticket_updated') tagLabel = 'Property Change';
                      else if (actTypeFinal === 'first user email') tagLabel = 'Customer Request';
                      else if (!h.actionType || actTypeFinal === 'internal note' || actTypeFinal.includes('action executed')) {
                        if (noteLower.includes('rule applied') || noteLower.includes('matched rule')) tagLabel = 'Rule Applied';
                        else if (noteLower.startsWith('executed ')) tagLabel = (h.note || '').replace(/^Executed\s+/i, '').trim();
                        else if (noteLower.includes('reassigned') || noteLower.includes('assigned to')) tagLabel = 'Reassignment';
                        else if (noteLower.includes('type changed')) tagLabel = 'Type Change';
                        else if (noteLower.includes('workflow updated')) tagLabel = 'Workflow Change';
                        else if (noteLower.includes('sla')) tagLabel = 'SLA Change';
                        else if (noteLower.includes('priority')) tagLabel = 'Priority Change';
                        else if (noteLower.includes('category')) tagLabel = 'Category Change';
                        else if (noteLower.includes('issue detail')) tagLabel = 'Issue Detail Change';
                        else if (noteLower.includes('resolution')) tagLabel = 'Resolution Change';
                        else if (noteLower.includes('site')) tagLabel = 'Site Change';
                        else if (noteLower.includes('asset')) tagLabel = 'Asset Change';
                        else if (noteLower.includes('end user')) tagLabel = 'End User Change';
                        else if (noteLower.includes('auto-generated ticket') || noteLower.includes('ticket created')) tagLabel = 'Ticket Created';
                        else if (noteLower.includes('status updated') || noteLower.includes('status changed')) tagLabel = 'Status Change';
                        else if (noteLower.includes('accept')) tagLabel = 'Accept Ticket';
                        else if (noteLower.includes('first response')) tagLabel = 'First Response';
                        else if (noteLower.includes('pending')) tagLabel = 'Pending Info';
                        else if (noteLower.includes('on hold') || noteLower.includes('on-hold')) tagLabel = 'Mark On Hold';
                        else if (noteLower.includes('close') || noteLower.includes('autoclose')) tagLabel = 'Close Fault';
                        else if (noteLower.includes('supplier')) tagLabel = 'Supplier Log';
                        else if (noteLower.includes('note + email') || noteLower.includes('note (+email)')) tagLabel = 'Note (+Email)';
                        else if (noteLower.includes('email end user') || noteLower.includes('faults')) tagLabel = 'Email End User (Faults)';
                        else if (noteLower.includes('direct email') || noteLower.includes('no history')) tagLabel = 'Email (no history)';
                        else if (noteLower.includes('follow')) tagLabel = 'Follow Ticket';
                        else if (!h.internal || noteLower.includes('email') || noteLower.includes('conversation')) tagLabel = 'Conversation';
                      }

                      // Avatar styling (Google SSO profile, custom avatar, or default generated avatar)
                      const isCurrentUser = authorDisplayName.includes('(You)') || authorDisplayName.toLowerCase().includes(currentUserName.toLowerCase());
                      const isUnityOrSystem = authorDisplayName.toLowerCase().includes('unity') || authorDisplayName.toLowerCase().includes('system');
                      const authorEmployee = employees.find(
                        (e) =>
                          (h.changedById && String(e.id) === String(h.changedById)) ||
                          (h.agentEmail && e.email && e.email.toLowerCase() === h.agentEmail.toLowerCase()) ||
                          (h.author_email && e.email && e.email.toLowerCase() === h.author_email.toLowerCase()) ||
                          (e.displayName && authorDisplayName.toLowerCase().includes(e.displayName.toLowerCase())) ||
                          (e.firstName && authorDisplayName.toLowerCase().includes(e.firstName.toLowerCase())) ||
                          (e.email && authorDisplayName.toLowerCase().includes(e.email.toLowerCase()))
                      );
                      const authorAvatarUrl =
                        (h.meta as any)?.authorAvatar ||
                        (h.meta as any)?.avatar ||
                        (isCurrentUser ? (user?.avatar || authorEmployee?.avatar) : (authorEmployee?.avatar || undefined));
                      const authorEmail =
                        h.agentEmail ||
                        h.author_email ||
                        authorEmployee?.email ||
                        (isCurrentUser ? user?.email : undefined);

                      const isEmailOrConversation =
                        tagLabel.includes('Email') ||
                        tagLabel === 'Conversation' ||
                        tagLabel === 'First Response' ||
                        tagLabel === 'Customer Request' ||
                        tagLabel === 'Acknowledgement' ||
                        tagLabel.includes('Response');

                      const rawTo =
                        h.to ||
                        h.meta?.to ||
                        h.meta?.recipient ||
                        (isEmailOrConversation && !h.internal
                          ? tagLabel === 'Customer Request'
                            ? selectedTicket?.teamEmail
                            : (selectedTicket?.requesterEmail || (selectedTicket?.client && selectedTicket.client.includes('@') ? selectedTicket.client : undefined))
                          : undefined);

                      const rawCc =
                        h.cc ||
                        h.meta?.cc ||
                        (isEmailOrConversation && !h.internal && selectedTicket?.additionalAgents?.length
                          ? selectedTicket.additionalAgents.filter((a: any) => typeof a === 'string' && a.includes('@')).join('; ')
                          : undefined);

                      const timeTakenVal = h.timeTaken || h.meta?.timeTaken || h.meta?.time_taken;

                      const formatEmails = (val?: string) => {
                        if (!val || typeof val !== 'string') return '';
                        return val
                          .split(/[,;]+/)
                          .map((s) => s.trim())
                          .filter(Boolean)
                          .join('; ');
                      };

                      const toFormatted = formatEmails(rawTo);
                      const ccFormatted = formatEmails(rawCc);

                      const validAttachments = (h.attachments || []).filter(
                        (a) => !isTicketBackupJson(a.name || a.filename)
                      );
                      const imageAtts = validAttachments.filter(a => a.type === 'image' || a.mimeType?.startsWith('image/'));
                      const videoAtts = validAttachments.filter(a => a.type === 'video' || a.mimeType?.startsWith('video/'));
                      const docAtts = validAttachments.filter(a => a.type === 'document' || (!imageAtts.includes(a) && !videoAtts.includes(a)));

                      return (
                        <div key={h.id} className="rounded-xl border border-border bg-card p-4 shadow-2xs space-y-3">
                          {/* HEADER ROW */}
                          <div className="flex items-start justify-between">
                            <div className="flex items-center gap-2.5">
                              {isUnityOrSystem ? (
                                <div className="flex size-8 shrink-0 items-center justify-center rounded-full bg-slate-800 text-white dark:bg-slate-700 shadow-2xs select-none">
                                  <Settings className="size-4 text-white" />
                                </div>
                              ) : (
                                <UserAvatar
                                  name={authorDisplayName.replace(/\s*\(You\)\s*/i, '')}
                                  email={authorEmail}
                                  avatarUrl={authorAvatarUrl}
                                  size="md"
                                />
                              )}
                              <div>
                                {tagLabel === 'Rule Applied' ? (
                                  <div>
                                    <div className="font-semibold text-xs text-foreground">
                                      {authorDisplayName}
                                    </div>
                                    <div className="flex items-center gap-1 text-xs font-semibold text-primary mt-0.5">
                                      <span>Rule Applied</span>
                                      <EyeOff className="size-3 text-muted-foreground ml-0.5" />
                                    </div>
                                  </div>
                                ) : (
                                  <div className="flex items-center gap-1.5 flex-wrap">
                                    <span className="font-semibold text-xs text-foreground">
                                      {authorDisplayName}
                                    </span>
                                    <span className="text-xs font-semibold text-muted-foreground">
                                      |
                                    </span>
                                    <span className={cn(
                                      "inline-flex items-center px-1.5 py-0.5 rounded text-xs font-semibold border",
                                      tagLabel.includes('Type') || tagLabel.includes('Workflow') || tagLabel.includes('Property') || tagLabel.includes('Rule')
                                        ? "bg-slate-100 text-slate-700 border-slate-300 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700"
                                        : tagLabel.includes('Category') || tagLabel.includes('Issue Detail')
                                          ? "bg-violet-50 text-violet-700 border-violet-200 dark:bg-violet-950/60 dark:text-violet-300 dark:border-violet-800"
                                          : tagLabel.includes('End User')
                                            ? "bg-teal-50 text-teal-700 border-teal-200 dark:bg-teal-950/60 dark:text-teal-300 dark:border-teal-800"
                                            : tagLabel.includes('Site')
                                              ? "bg-cyan-50 text-cyan-700 border-cyan-200 dark:bg-cyan-950/60 dark:text-cyan-300 dark:border-cyan-800"
                                              : tagLabel.includes('Reassign')
                                                ? "bg-sky-50 text-sky-700 border-sky-200 dark:bg-sky-950/60 dark:text-sky-300 dark:border-sky-800"
                                                : tagLabel.includes('Asset')
                                                  ? "bg-indigo-50 text-indigo-700 border-indigo-200 dark:bg-indigo-950/60 dark:text-indigo-300 dark:border-indigo-800"
                                                  : tagLabel.includes('SLA')
                                                    ? "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/60 dark:text-amber-300 dark:border-amber-800"
                                                    : tagLabel.includes('Priority')
                                                      ? "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/60 dark:text-amber-300 dark:border-amber-800"
                                                      : tagLabel.includes('Status')
                                                        ? "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/60 dark:text-emerald-300 dark:border-emerald-800"
                                                        : tagLabel.includes('Accept') || tagLabel.includes('Resolution') || tagLabel.includes('Created')
                                                          ? "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/60 dark:text-emerald-300 dark:border-emerald-800"
                                                          : tagLabel.includes('Pending') || tagLabel.includes('Hold')
                                                            ? "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/60 dark:text-amber-300 dark:border-amber-800"
                                                            : tagLabel.includes('Close')
                                                              ? "bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-950/60 dark:text-rose-300 dark:border-rose-800"
                                                              : tagLabel.includes('Supplier')
                                                                ? "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/60 dark:text-amber-300 dark:border-amber-800"
                                                                : tagLabel.includes('Internal') || tagLabel.includes('Note')
                                                                  ? "bg-purple-50 text-purple-700 border-purple-200 dark:bg-purple-950/60 dark:text-purple-300 dark:border-purple-800"
                                                                  : tagLabel.includes('Email') || tagLabel.includes('Response') || tagLabel.includes('Conversation') || tagLabel.includes('Request')
                                                                    ? "bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950/60 dark:text-blue-300 dark:border-blue-800"
                                                                    : tagLabel.includes('Work')
                                                                      ? "bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950/60 dark:text-blue-300 dark:border-blue-800"
                                                                      : "bg-primary/10 text-primary border-primary/20"
                                    )}>
                                      {tagLabel}
                                    </span>
                                    {h.internal && <span title="Internal only note"><EyeOff className="size-3 text-muted-foreground" /></span>}
                                    {validAttachments.length > 0 && (
                                      <span className="inline-flex items-center gap-1 text-xs font-mono px-1.5 py-0.5 rounded bg-primary/10 text-primary font-semibold">
                                        <Paperclip className="size-2.5" /> {validAttachments.length} attachment(s)
                                      </span>
                                    )}
                                    {/* Notified Stakeholders Pill */}
                                    {(() => {
                                      const meta = h.meta || (h as any).metadata || {};
                                      const notifiedList: string[] = [];
                                      if (meta.notifyRequester) notifiedList.push('Requester');
                                      if (meta.notifyAssignee) notifiedList.push('Assignee');
                                      if (meta.notifyTeam) notifiedList.push('Team');
                                      if (meta.sendEmail) notifiedList.push('Email');
                                      if (notifiedList.length === 0) return null;
                                      return (
                                        <span className="inline-flex items-center gap-1 text-xs font-mono px-1.5 py-0.5 rounded bg-blue-500/10 text-blue-600 dark:text-blue-400 border border-blue-500/20 font-medium" title={`Notifications recorded for: ${notifiedList.join(', ')}`}>
                                          <Bell className="size-2.5" /> Notified: {notifiedList.join(', ')}
                                        </span>
                                      );
                                    })()}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="flex items-center gap-2">
                              <span className="text-xs font-mono text-muted-foreground">
                                {formatDateTime(h.createdAt)}
                              </span>
                            </div>
                          </div>

                          {/* BODY: TEXT CONTENT */}
                          {feedCollapsed ? (
                            displayNote ? (
                              <p className="text-xs text-muted-foreground pl-10.5 truncate">
                                {displayNote}
                              </p>
                            ) : null
                          ) : (
                            <div className="text-xs text-foreground pl-10.5 leading-relaxed whitespace-pre-wrap space-y-3">
                              {/* TO, CC & TIME TAKEN (SAMPLE REFERENCE DESIGN) */}
                              {(timeTakenVal || toFormatted || ccFormatted) && (
                                <div className="space-y-0.5 text-xs text-muted-foreground pb-0.5 select-text font-normal">
                                  {timeTakenVal && (
                                    <div className="text-muted-foreground">
                                      <span>Time Taken: </span>
                                      <span className="text-foreground font-mono font-medium">{timeTakenVal}</span>
                                    </div>
                                  )}
                                  {toFormatted && (
                                    <div className="flex items-baseline gap-1.5 flex-wrap">
                                      <span className="text-muted-foreground font-normal shrink-0">To:</span>
                                      <span className="text-foreground font-normal break-all">{toFormatted}</span>
                                    </div>
                                  )}
                                  {ccFormatted && (
                                    <div className="flex items-baseline gap-1.5 flex-wrap">
                                      <span className="text-muted-foreground font-normal shrink-0">Cc:</span>
                                      <span className="text-foreground font-normal break-all">{ccFormatted}</span>
                                    </div>
                                  )}
                                </div>
                              )}

                              {displayNote ? <p>{displayNote}</p> : null}

                              {/* Workflow Action State Transition Flow Indicator */}
                              {h.fromStatus && h.toStatus && (
                                <div className="flex items-center gap-1.5 text-xs font-medium pt-0.5">
                                  <span className="px-2 py-0.5 rounded bg-muted text-muted-foreground border border-border">
                                    {h.fromStatus}
                                  </span>
                                  <ArrowRight className="size-3 text-muted-foreground shrink-0" />
                                  <span className="px-2 py-0.5 rounded bg-primary/10 text-primary font-semibold border border-primary/20">
                                    {h.toStatus}
                                  </span>
                                </div>
                              )}

                              {/* MEDIA & DOCUMENT ATTACHMENTS RENDERING */}
                              {validAttachments.length > 0 && (
                                <div className="space-y-3 pt-2 border-t border-border/60">
                                  {/* 1. IMAGES GALLERY */}
                                  {imageAtts.length > 0 && (
                                    <div className="space-y-1.5">
                                      <span className="text-xs font-semibold text-muted-foreground flex items-center gap-1">
                                        <LucideImage className="size-3 text-emerald-500" /> Attached Images ({imageAtts.length})
                                      </span>
                                      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
                                        {imageAtts.map((img) => (
                                          <div
                                            key={img.id}
                                            className="group relative aspect-video rounded-lg overflow-hidden border border-border bg-muted cursor-pointer shadow-2xs"
                                            onClick={() => setMediaLightbox({ isOpen: true, url: img.fileUrl, name: img.name })}
                                          >
                                            <img src={img.fileUrl} alt={img.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform" />
                                            <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 flex items-center justify-center gap-2 transition-opacity">
                                              <Eye className="size-4 text-white" />
                                            </div>
                                            <span className="absolute bottom-1 left-1 bg-black/75 text-white px-1.5 py-0.5 text-xs font-mono rounded max-w-[80%] truncate">
                                              {img.name} ({img.size})
                                            </span>
                                            <div className="absolute top-1 right-1 opacity-0 group-hover:opacity-100 flex items-center gap-1 transition-opacity">
                                              <button
                                                type="button"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleShareAttachment(img);
                                                }}
                                                className="size-6 rounded-full bg-black/80 text-white flex items-center justify-center hover:bg-blue-600"
                                                title="Copy Share Link"
                                              >
                                                <Share2 className="size-3" />
                                              </button>
                                              <button
                                                type="button"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  downloadMediaFile(img.fileUrl, img.name);
                                                }}
                                                className="size-6 rounded-full bg-black/80 text-white flex items-center justify-center hover:bg-emerald-600"
                                                title="Download Image"
                                              >
                                                <Download className="size-3" />
                                              </button>
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  )}

                                  {/* 2. VIDEOS ATTACHMENTS */}
                                  {videoAtts.length > 0 && (
                                    <div className="space-y-1.5">
                                      <span className="text-xs font-semibold text-muted-foreground flex items-center gap-1">
                                        <Film className="size-3 text-purple-500" /> Attached Videos ({videoAtts.length})
                                      </span>
                                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                                        {videoAtts.map((vid) => (
                                          <div
                                            key={vid.id}
                                            className="p-3 rounded-lg border border-border bg-background flex items-center justify-between gap-3 shadow-2xs hover:border-purple-500/40 transition-colors"
                                          >
                                            <div
                                              className="flex items-center gap-3 overflow-hidden cursor-pointer"
                                              onClick={() => setVideoModal({ isOpen: true, url: vid.fileUrl, name: vid.name })}
                                            >
                                              <div className="size-9 rounded-lg bg-purple-500/10 text-purple-600 dark:text-purple-400 flex items-center justify-center shrink-0">
                                                <PlayCircle className="size-5" />
                                              </div>
                                              <div className="overflow-hidden">
                                                <p className="text-xs font-semibold text-foreground truncate">{vid.name}</p>
                                                <p className="text-xs font-mono text-muted-foreground">{vid.size} • Video Recording</p>
                                              </div>
                                            </div>

                                            <div className="flex items-center gap-1.5 shrink-0">
                                              <button
                                                type="button"
                                                onClick={() => setVideoModal({ isOpen: true, url: vid.fileUrl, name: vid.name })}
                                                className="px-2.5 py-1 text-xs font-semibold rounded bg-accent text-foreground hover:bg-muted"
                                              >
                                                Play Video
                                              </button>
                                              <button
                                                type="button"
                                                onClick={() => handleShareAttachment(vid)}
                                                className="p-1 rounded text-muted-foreground hover:text-blue-600"
                                                title="Copy Share Link"
                                              >
                                                <Share2 className="size-3.5" />
                                              </button>
                                              <button
                                                type="button"
                                                onClick={() => downloadMediaFile(vid.fileUrl, vid.name)}
                                                className="p-1 rounded text-muted-foreground hover:text-emerald-600"
                                                title="Download Video"
                                              >
                                                <Download className="size-3.5" />
                                              </button>
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  )}

                                  {/* 3. DOCUMENTS ATTACHMENTS */}
                                  {docAtts.length > 0 && (
                                    <div className="space-y-1.5">
                                      <span className="text-xs font-semibold text-muted-foreground flex items-center gap-1">
                                        <FileText className="size-3 text-blue-500" /> Attached Documents &amp; Files ({docAtts.length})
                                      </span>
                                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                                        {docAtts.map((doc) => (
                                          <div
                                            key={doc.id}
                                            className="p-3 rounded-lg border border-border bg-background flex items-center justify-between gap-3 shadow-2xs hover:border-blue-500/40 transition-colors"
                                          >
                                            <div
                                              className="flex items-center gap-3 overflow-hidden cursor-pointer"
                                              onClick={() => setDocModal({
                                                isOpen: true,
                                                url: doc.fileUrl,
                                                name: doc.name,
                                                isPdf: doc.name.endsWith('.pdf') || doc.mimeType === 'application/pdf',
                                              })}
                                            >
                                              <div className="size-9 rounded-lg bg-blue-500/10 text-blue-600 dark:text-blue-400 flex items-center justify-center shrink-0">
                                                <FileIcon className="size-5" />
                                              </div>
                                              <div className="overflow-hidden">
                                                <p className="text-xs font-semibold text-foreground truncate">{doc.name}</p>
                                                <p className="text-xs font-mono text-muted-foreground">{doc.size} • Stored S3 Record</p>
                                              </div>
                                            </div>

                                            <div className="flex items-center gap-1.5 shrink-0">
                                              <button
                                                type="button"
                                                onClick={() => setDocModal({
                                                  isOpen: true,
                                                  url: doc.fileUrl,
                                                  name: doc.name,
                                                  isPdf: doc.name.endsWith('.pdf') || doc.mimeType === 'application/pdf',
                                                })}
                                                className="px-2.5 py-1 text-xs font-semibold rounded bg-accent text-foreground hover:bg-muted"
                                              >
                                                View
                                              </button>
                                              <button
                                                type="button"
                                                onClick={() => handleShareAttachment(doc)}
                                                className="p-1 rounded text-muted-foreground hover:text-blue-600"
                                                title="Copy Share Link"
                                              >
                                                <Share2 className="size-3.5" />
                                              </button>
                                              <button
                                                type="button"
                                                onClick={() => downloadMediaFile(doc.fileUrl, doc.name)}
                                                className="p-1 rounded text-muted-foreground hover:text-emerald-600"
                                                title="Download Document"
                                              >
                                                <Download className="size-3.5" />
                                              </button>
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            </div>

            {/* RIGHT SIDEBAR: METADATA CARDS (BOX & CHEVRON ICON APPEAR ON HOVER ALONE) */}
            <div className="w-80 shrink-0 overflow-y-auto space-y-3.5 custom-scrollbar pr-0.5">
              {/* SYSTEM GENERATED LEAVE REQUEST CARD */}
              {isSelectedSysGen && (
                <div className="rounded-xl border border-border bg-card p-4 shadow-2xs space-y-3 font-sans">
                  <div className="flex items-center justify-between border-b border-border pb-1.5">
                    <div className="flex items-center gap-1.5">
                      <Calendar className="size-3.5 text-primary" />
                      <h4 className="text-xs font-semibold text-foreground">Leave Request Details</h4>
                    </div>
                    <span className="text-[10px] font-semibold px-2 py-0.5 rounded bg-blue-50 text-blue-700 dark:bg-blue-950/40 dark:text-blue-300 border border-blue-200">
                      HR Queue
                    </span>
                  </div>

                  <div className="space-y-2 text-xs">
                    <div className="flex items-center justify-between">
                      <span className="text-muted-foreground font-medium">Leave Type:</span>
                      <span className="font-semibold text-foreground">
                        {selectedTicket.leaveRequest?.leaveTypeName || selectedTicket.leaveType || 'Annual Leave'}
                      </span>
                    </div>

                    <div className="flex items-center justify-between">
                      <span className="text-muted-foreground font-medium">Duration:</span>
                      <span className="font-semibold text-foreground">
                        {selectedTicket.leaveRequest?.totalDays || selectedTicket.totalDays || 1} day(s)
                      </span>
                    </div>

                    <div className="flex items-center justify-between">
                      <span className="text-muted-foreground font-medium">Dates:</span>
                      <span className="font-semibold text-foreground">
                        {selectedTicket.leaveRequest?.startDate ? `${new Date(selectedTicket.leaveRequest.startDate).toLocaleDateString()} – ${new Date(selectedTicket.leaveRequest.endDate).toLocaleDateString()}` : '—'}
                      </span>
                    </div>

                    <div className="flex items-center justify-between">
                      <span className="text-muted-foreground font-medium">Requester:</span>
                      <span className="font-semibold text-foreground truncate max-w-[140px]" title={selectedTicket.requesterName || selectedTicket.client || 'Employee'}>
                        {selectedTicket.requesterName || selectedTicket.client || 'Employee'}
                      </span>
                    </div>

                    {(selectedTicket.leaveRequest?.reason || selectedTicket.description) && (
                      <div className="pt-1.5 border-t border-border/60">
                        <span className="text-muted-foreground font-medium block mb-0.5">Reason:</span>
                        <p className="text-foreground bg-muted/40 p-2 rounded border border-border text-xs italic">
                          {selectedTicket.leaveRequest?.reason || selectedTicket.description}
                        </p>
                      </div>
                    )}

                    <div className="pt-2 border-t border-border/60">
                      <button
                        type="button"
                        onClick={() => navigate('/people/leave')}
                        className="w-full flex items-center justify-center gap-1.5 py-1.5 px-3 rounded-md bg-primary/10 hover:bg-primary/20 text-primary font-semibold text-xs border border-primary/20 transition-colors cursor-pointer"
                      >
                        <ExternalLink className="size-3.5" />
                        <span>View in Leave Management</span>
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* CARD 1: SERVICE LEVEL AGREEMENT (MATCHING USER SPEC) */}
              {!isSelectedSysGen && showSlaCard && (
                <div className="rounded-xl border border-border bg-card p-4 shadow-2xs space-y-2.5">
                  <div className="flex items-center justify-between border-b border-border pb-1.5">
                    <h4 className="text-xs font-semibold text-foreground">Service Level Agreement</h4>
                    <button
                      type="button"
                      onClick={() => setSlaCollapsed(!slaCollapsed)}
                      className="text-xs font-semibold text-muted-foreground hover:text-foreground px-1 cursor-pointer"
                      aria-label="Toggle Service Level Agreement card"
                    >
                      {slaCollapsed ? '+' : '−'}
                    </button>
                  </div>

                  {!slaCollapsed && (
                    <div className="space-y-2 pt-0.5">
                      {/* YELLOW SLA BLOCK (MATCHING SCREENSHOTS 1, 2, 3, 4) */}
                      <div className="relative rounded-lg bg-[#FFD200] p-1.5 text-black shadow-xs space-y-0.5">
                        {/* 1. SLA POLICY ROW */}
                        <div className="relative">
                          {isSlaPolicyOpen ? (
                            <div className="relative flex items-center justify-between border-2 border-[#1E88E5] rounded-md bg-[#FFD200] px-2 py-0.5 shadow-xs">
                              <span className="font-mono text-black font-semibold mr-1 select-none">|</span>
                              <span className="flex-1 text-center font-semibold text-xs text-black truncate">
                                {selectedSlaPolicy || 'Standard ITSM Service SLA'}
                              </span>
                              <span className="text-black/30 text-xs mr-1.5 select-none">|</span>
                              <button
                                type="button"
                                onClick={() => setIsSlaPolicyOpen(false)}
                                className="cursor-pointer"
                              >
                                <ChevronDown className="size-3.5 text-black shrink-0" />
                              </button>

                              {/* Dropdown popup (Matching Image 2) */}
                              <div className="fixed inset-0 z-40" onClick={() => setIsSlaPolicyOpen(false)} />
                              <div className="absolute left-0 right-0 top-full mt-1 z-50 rounded-md border border-border bg-white shadow-xl max-h-56 overflow-y-auto custom-scrollbar p-0.5 text-xs select-none animate-in fade-in zoom-in-95">
                                {slaPolicyList.map((policy) => {
                                  const isSelected = (selectedSlaPolicy || 'Default SLA') === policy;
                                  return (
                                    <button
                                      key={policy}
                                      type="button"
                                      onClick={() => {
                                        setSelectedSlaPolicy(policy);
                                        setIsSlaPolicyOpen(false);
                                        updateTicket(selectedTicket.id, { slaPolicy: policy });
                                        setSelectedTicket({ ...selectedTicket, slaPolicy: policy });
                                        toast.success(`SLA Policy set to ${policy}`);
                                      }}
                                      className={cn(
                                        "w-full py-1.5 px-3 text-center text-xs transition-colors cursor-pointer rounded-sm truncate block",
                                        isSelected
                                          ? "bg-[#1877F2] text-white font-medium"
                                          : "text-black hover:bg-slate-100 font-normal"
                                      )}
                                    >
                                      {policy}
                                    </button>
                                  );
                                })}
                              </div>
                            </div>
                          ) : (
                            <button
                              type="button"
                              onClick={() => {
                                setIsSlaPolicyOpen(true);
                                setIsSlaPriorityOpen(false);
                              }}
                              className="w-full py-1 text-center font-medium text-xs text-black cursor-pointer hover:bg-black/5 rounded transition-colors truncate block"
                              title="Click to select SLA Policy"
                            >
                              {selectedSlaPolicy || 'Standard ITSM Service SLA'}
                            </button>
                          )}
                        </div>

                        {/* 2. SLA PRIORITY ROW */}
                        <div className="relative">
                          {isSlaPriorityOpen ? (
                            <div className="relative flex items-center justify-between border-2 border-[#1E88E5] rounded-md bg-[#FFD200] px-2 py-0.5 shadow-xs">
                              <span className="flex-1 text-center font-semibold text-xs text-black truncate pl-4">
                                {selectedSlaPriorityLabel || 'Medium'}
                              </span>
                              <span className="text-black/30 text-xs mr-1.5 select-none">|</span>
                              <button
                                type="button"
                                onClick={() => setIsSlaPriorityOpen(false)}
                                className="cursor-pointer"
                              >
                                <ChevronDown className="size-3.5 text-black shrink-0" />
                              </button>

                              {/* Dropdown popup (Matching Image 3) */}
                              <div className="fixed inset-0 z-40" onClick={() => setIsSlaPriorityOpen(false)} />
                              <div className="absolute left-0 right-0 top-full mt-1 z-50 rounded-md border border-border bg-white shadow-xl p-0.5 text-xs select-none animate-in fade-in zoom-in-95">
                                {slaPriorityList.map((p) => {
                                  const isSelected = (selectedSlaPriorityLabel || 'Medium') === p;
                                  return (
                                    <button
                                      key={p}
                                      type="button"
                                      onClick={() => {
                                        const pMap: Record<string, Ticket['priority']> = {
                                          Critical: 'urgent',
                                          High: 'high',
                                          Medium: 'medium',
                                          'Medium-Low': 'low',
                                          Low: 'low',
                                        };
                                        handleUpdatePrioritySla(pMap[p] || 'medium');
                                        setSelectedSlaPriorityLabel(p);
                                        setIsSlaPriorityOpen(false);
                                      }}
                                      className={cn(
                                        "w-full py-1.5 px-3 text-center text-xs transition-colors cursor-pointer rounded-sm block",
                                        isSelected
                                          ? "bg-[#1877F2] text-white font-medium"
                                          : "text-black hover:bg-slate-100 font-normal"
                                      )}
                                    >
                                      {p}
                                    </button>
                                  );
                                })}
                              </div>
                            </div>
                          ) : (
                            <button
                              type="button"
                              onClick={() => {
                                setIsSlaPriorityOpen(true);
                                setIsSlaPolicyOpen(false);
                              }}
                              className="w-full py-1 text-center font-medium text-xs text-black cursor-pointer hover:bg-black/5 rounded transition-colors truncate block"
                              title="Click to select Priority"
                            >
                              {selectedSlaPriorityLabel || 'Medium'}
                            </button>
                          )}
                        </div>
                      </div>

                      {/* SLA TIME TRACKER & PROGRESS BARS */}
                      {slaTracker && (
                        <div className="pt-2.5 border-t border-border space-y-3 font-sans">
                          {/* Tracker Header */}
                          <div className="flex items-center justify-between">
                            <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground flex items-center gap-1.5">
                              <Clock className="size-3.5 text-primary" /> Time Tracker &amp; SLA
                            </span>
                            <span className={cn(
                              "px-2 py-0.5 rounded text-xs font-semibold border",
                              slaTracker.isResolved
                                ? "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-800"
                                : slaTracker.isResBreached
                                  ? "bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-950/40 dark:text-rose-300 dark:border-rose-800 animate-pulse"
                                  : slaTracker.resProgressPercent > 75
                                    ? "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-800"
                                    : "bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950/40 dark:text-blue-300 dark:border-blue-800"
                            )}>
                              {slaTracker.isResolved ? "SLA Met" : slaTracker.isResBreached ? "Breached" : slaTracker.resProgressPercent > 75 ? "At Risk" : "In SLA"}
                            </span>
                          </div>

                          {/* 1. Resolution Target Progress Bar */}
                          <div className="space-y-1.5 bg-muted/30 p-2.5 rounded-lg border border-border/60">
                            <div className="flex items-center justify-between text-xs">
                              <span className="font-semibold text-foreground text-xs">Resolution SLA</span>
                              <span className={cn(
                                "font-semibold font-mono text-xs",
                                slaTracker.isResolved
                                  ? "text-emerald-600 dark:text-emerald-400"
                                  : slaTracker.isResBreached
                                    ? "text-rose-600 dark:text-rose-400"
                                    : slaTracker.resProgressPercent > 75
                                      ? "text-amber-600 dark:text-amber-400"
                                      : "text-foreground"
                              )}>
                                {slaTracker.resRemainingLabel}
                              </span>
                            </div>

                            {/* Progress Bar Container */}
                            <div className="w-full bg-slate-200 dark:bg-slate-700 rounded-full h-2 overflow-hidden shadow-inner">
                              <div
                                className={cn(
                                  "h-full rounded-full transition-all duration-500",
                                  slaTracker.isResolved
                                    ? "bg-emerald-500"
                                    : slaTracker.isResBreached
                                      ? "bg-rose-500"
                                      : slaTracker.resProgressPercent > 75
                                        ? "bg-amber-500"
                                        : "bg-primary"
                                )}
                                style={{ width: `${slaTracker.resProgressPercent}%` }}
                              />
                            </div>

                            <div className="flex items-center justify-between text-xs text-muted-foreground pt-0.5">
                              <span>Elapsed: {slaTracker.resElapsedLabel}</span>
                              <span>Target: {slaTracker.resTargetLabel}</span>
                            </div>
                          </div>

                          {/* 2. First Response Target Progress Bar */}
                          <div className="space-y-1.5 bg-muted/30 p-2.5 rounded-lg border border-border/60">
                            <div className="flex items-center justify-between text-xs">
                              <span className="font-semibold text-foreground text-xs">First Response Target</span>
                              <span className={cn(
                                "font-semibold font-mono text-xs",
                                slaTracker.hasResponded
                                  ? "text-emerald-600 dark:text-emerald-400"
                                  : slaTracker.isRespBreached
                                    ? "text-rose-600 dark:text-rose-400"
                                    : "text-foreground"
                              )}>
                                {slaTracker.respRemainingLabel}
                              </span>
                            </div>

                            {/* Progress Bar Container */}
                            <div className="w-full bg-slate-200 dark:bg-slate-700 rounded-full h-2 overflow-hidden shadow-inner">
                              <div
                                className={cn(
                                  "h-full rounded-full transition-all duration-500",
                                  slaTracker.hasResponded
                                    ? "bg-emerald-500"
                                    : slaTracker.isRespBreached
                                      ? "bg-rose-500"
                                      : slaTracker.respProgressPercent > 75
                                        ? "bg-amber-500"
                                        : "bg-primary"
                                )}
                                style={{ width: `${slaTracker.respProgressPercent}%` }}
                              />
                            </div>

                            <div className="flex items-center justify-between text-xs text-muted-foreground pt-0.5">
                              <span>{slaTracker.hasResponded ? "Responded" : `Elapsed: ${slaTracker.respElapsedLabel}`}</span>
                              <span>Target: {slaTracker.respTargetLabel}</span>
                            </div>
                          </div>

                          {/* 3. Time Spent on Ticket */}
                          <div className="flex items-center justify-between px-1 text-xs pt-0.5">
                            <span className="text-muted-foreground font-medium text-xs flex items-center gap-1">
                              <Clock className="size-3 text-muted-foreground" /> Time Spent:
                            </span>
                            <div className="flex items-center gap-1.5">
                              <span className="font-mono font-semibold text-foreground text-xs">{slaTracker.timeSpentTimer}</span>
                              <span className="inline-flex size-2 rounded-full bg-emerald-500 animate-pulse" title="Active Tracker" />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

              {/* CARD 2: TICKET INFORMATION */}
              <div className="rounded-xl border border-border bg-card p-4 shadow-2xs space-y-3">
                <div className="flex items-center justify-between border-b border-border pb-1.5">
                  <h4 className="text-xs font-semibold text-foreground">Ticket information</h4>
                  <button
                    type="button"
                    onClick={() => setTicketInfoCollapsed(!ticketInfoCollapsed)}
                    className="text-xs font-semibold text-muted-foreground hover:text-foreground px-1"
                    aria-label="Toggle Ticket information card"
                  >
                    {ticketInfoCollapsed ? '+' : '−'}
                  </button>
                </div>

                {!ticketInfoCollapsed && (
                  <div className="space-y-3 text-xs">
                    {/* READ-ONLY FIELD: ORIGIN DOMAIN REQUEST */}
                    {Boolean(selectedTicket.originModule || selectedTicket.originRecordType || selectedTicket.originRecordNumber) && (
                      <div>
                        <div className="flex items-center justify-between mb-1">
                          <span className="text-xs font-semibold text-muted-foreground block">Origin Domain Request</span>
                          {selectedTicket.originModule && (
                            <button
                              type="button"
                              onClick={() => {
                                const mod = selectedTicket.originModule?.toLowerCase();
                                if (mod === 'people') {
                                  if (selectedTicket.originRecordType === 'leave_request') navigate('/people/leave');
                                  else if (selectedTicket.originRecordType === 'attendance_regularization') navigate('/people/attendance');
                                  else if (selectedTicket.originRecordType === 'shift_swap') navigate('/people/shifts');
                                  else if (selectedTicket.originRecordType === 'holiday_request') navigate('/people/holidays');
                                  else navigate('/people/employees');
                                } else if (mod === 'assets') {
                                  if (selectedTicket.originRecordType === 'asset_requisition') navigate('/assets/requisitions');
                                  else if (selectedTicket.originRecordType === 'asset_fault') navigate('/assets/service');
                                  else navigate('/assets/registry');
                                } else if (mod === 'money') {
                                  navigate('/money/payroll');
                                } else if (mod === 'work') {
                                  navigate('/work/projects');
                                } else {
                                  navigate('/support/tickets');
                                }
                              }}
                              className="inline-flex items-center gap-1 text-[11px] font-semibold text-primary hover:underline hover:text-primary/80 transition-colors cursor-pointer"
                            >
                              <span>Open in {selectedTicket.originModule?.toUpperCase()} Hub</span>
                              <ExternalLink className="size-3" />
                            </button>
                          )}
                        </div>
                        <div className="rounded-md border border-border bg-muted/20 px-2.5 py-1.5 font-medium text-foreground text-xs shadow-2xs flex items-center justify-between gap-2">
                          <div className="flex items-center gap-1.5 truncate">
                            <span className="font-semibold text-primary uppercase text-[11px] px-1.5 py-0.5 rounded bg-primary/10 border border-primary/20 shrink-0">
                              {selectedTicket.originModule?.toUpperCase() || 'SUPPORT'}
                            </span>
                            <span className="truncate">
                              {(selectedTicket.originRecordType || selectedTicket.type || 'Request').replace(/_/g, ' ')}
                              {(selectedTicket.originRecordNumber || selectedTicket.originRecordId) && (
                                <span className="text-muted-foreground font-mono ml-1">
                                  [{selectedTicket.originRecordNumber || selectedTicket.originRecordId}]
                                </span>
                              )}
                            </span>
                          </div>
                          <span className="text-[10px] font-medium text-muted-foreground uppercase font-mono tracking-wider shrink-0">
                            1:1 Synced
                          </span>
                        </div>
                      </div>
                    )}

                    {/* READ-ONLY FIELD: ENTRY CHANNEL */}
                    {Boolean(selectedTicket.entryChannel || (selectedTicket.source && selectedTicket.source !== 'Manual')) && (
                      <div>
                        <span className="text-xs font-semibold text-muted-foreground block mb-1">Entry Channel</span>
                        <div className="rounded-md border border-border bg-muted/20 px-2.5 py-1.5 font-medium text-foreground text-xs shadow-2xs truncate">
                          {selectedTicket.source === 'System Generated' ? '🤖 System Generated' : (selectedTicket.entryChannel || selectedTicket.source)}
                        </div>
                      </div>
                    )}

                    {/* READ-ONLY FIELD: DATE CREATED (NON-EDITABLE) */}
                    <div>
                      <span className="text-xs font-semibold text-muted-foreground block mb-1">Date Created</span>
                      <div className="rounded-md border border-border bg-muted/20 px-2.5 py-1.5 font-medium text-foreground font-mono text-xs shadow-2xs">
                        {formatDateTime(selectedTicket.createdAt)}
                      </div>
                    </div>

                    {/* READ-ONLY FIELD: CREATED BY (NON-EDITABLE) */}
                    <div>
                      <span className="text-xs font-semibold text-muted-foreground block mb-1">Created by</span>
                      <div className="rounded-md border border-border bg-muted/20 px-2.5 py-1.5 font-medium text-foreground text-xs shadow-2xs truncate">
                        {selectedTicket.createdBy || selectedTicket.requesterName || selectedTicket.client || 'Giri'}
                      </div>
                    </div>

                    {/* EDITABLE FIELD: TICKET TYPE */}
                    <div>
                      <span className="text-xs font-semibold text-muted-foreground block mb-1">Ticket Type</span>
                      <div className="relative flex items-center rounded-md border border-border bg-card hover:bg-muted/10 focus-within:border-primary focus-within:ring-1 focus-within:ring-primary/20 transition-all px-2.5 py-1.5 shadow-2xs group">
                        <select
                          value={currentTicketTypeConfig?.value || availableTicketTypes[0]?.value || 'sd-service-request'}
                          onChange={(e) => handleTicketTypeSelect(e.target.value)}
                          className="w-full appearance-none bg-transparent text-xs font-semibold text-foreground outline-none cursor-pointer pr-6 font-sans"
                        >
                          {ticketTypesByTeam.length > 0 ? (
                            ticketTypesByTeam.map((grp) => (
                              <optgroup key={grp.teamName} label={grp.teamName} className="font-semibold text-muted-foreground">
                                {grp.types.map((tt) => (
                                  <option key={tt.value} value={tt.value} className="text-foreground">
                                    {tt.label}
                                  </option>
                                ))}
                              </optgroup>
                            ))
                          ) : (
                            availableTicketTypes.map((tt) => (
                              <option key={tt.value} value={tt.value} className="text-foreground">
                                {tt.label}
                              </option>
                            ))
                          )}
                        </select>
                        <ChevronDown className="pointer-events-none absolute right-2.5 size-3.5 text-muted-foreground/70 group-hover:text-foreground transition-colors" />
                      </div>
                    </div>

                    {/* EDITABLE FIELD: WORKFLOW */}
                    <div>
                      <span className="text-xs font-semibold text-muted-foreground block mb-1">Workflow</span>
                      <div className="relative flex items-center rounded-md border border-border bg-card hover:bg-muted/10 focus-within:border-primary focus-within:ring-1 focus-within:ring-primary/20 transition-all px-2.5 py-1.5 shadow-2xs group">
                        <select
                          value={selectedTicket.workflow || ''}
                          onChange={(e) => handleWorkflowSelect(e.target.value)}
                          className="w-full appearance-none bg-transparent text-xs font-semibold text-foreground outline-none cursor-pointer pr-6 font-sans"
                        >
                          {allSelectableWorkflows.map((wf) => (
                            <option key={wf} value={wf} className="text-foreground">
                              {wf}
                            </option>
                          ))}
                        </select>
                        <ChevronDown className="pointer-events-none absolute right-2.5 size-3.5 text-muted-foreground/70 group-hover:text-foreground transition-colors" />
                      </div>
                    </div>

                    {/* READ-ONLY STATUS CHIP (DRIVEN EXCLUSIVELY BY ACTION BUTTONS) */}
                    <div>
                      <div className="flex items-center justify-between mb-1">
                        <span className="text-xs font-semibold text-muted-foreground">Status</span>
                        <span className="text-[10px] text-muted-foreground/70">Read-only (driven by actions)</span>
                      </div>
                      <div className={cn(
                        "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md border text-xs font-semibold w-full shadow-2xs",
                        ((selectedTicket as any).stageCategory || (selectedTicket as any).category) === 'start' && "bg-sky-50 text-sky-700 border-sky-200 dark:bg-sky-950/40 dark:text-sky-300 dark:border-sky-800",
                        ((selectedTicket as any).stageCategory || (selectedTicket as any).category) === 'active' && "bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950/40 dark:text-blue-300 dark:border-blue-800",
                        ((selectedTicket as any).stageCategory || (selectedTicket as any).category) === 'waiting' && "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-800",
                        ((selectedTicket as any).stageCategory || (selectedTicket as any).category) === 'done' && "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-800",
                        ((selectedTicket as any).stageCategory || (selectedTicket as any).category) === 'closed' && "bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700",
                        ((selectedTicket as any).stageCategory || (selectedTicket as any).category) === 'rejected' && "bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-950/40 dark:text-rose-300 dark:border-rose-800",
                        !['start', 'active', 'waiting', 'done', 'closed', 'rejected'].includes(String((selectedTicket as any).stageCategory || (selectedTicket as any).category)) && "bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950/40 dark:text-blue-300"
                      )}>
                        <span className="size-2 rounded-full bg-current opacity-80" />
                        <span className="truncate">{selectedTicket.status || 'New'}</span>
                      </div>
                    </div>

                    {/* METADATA: ASSIGNED APPROVER */}
                    {Boolean((selectedTicket as any).approverName || (selectedTicket as any).approver_id) && (
                      <div>
                        <span className="text-xs font-semibold text-muted-foreground block mb-1">Assigned Approver</span>
                        <div className="rounded-md border border-border bg-card px-2.5 py-1.5 text-xs text-foreground font-medium flex items-center gap-1.5">
                          <UserCheck className="size-3.5 text-blue-500" />
                          <span>{(selectedTicket as any).approverName || (selectedTicket as any).approver_id}</span>
                        </div>
                      </div>
                    )}

                    {/* METADATA: PLANNED SCHEDULE */}
                    {Boolean((selectedTicket as any).planned_start_at || (selectedTicket as any).planned_end_at) && (
                      <div>
                        <span className="text-xs font-semibold text-muted-foreground block mb-1">Planned Schedule</span>
                        <div className="rounded-md border border-border bg-card px-2.5 py-1.5 text-xs text-foreground space-y-0.5">
                          {(selectedTicket as any).planned_start_at && (
                            <div className="text-[11px] text-muted-foreground">
                              Start: <span className="text-foreground font-medium">{new Date((selectedTicket as any).planned_start_at).toLocaleString()}</span>
                            </div>
                          )}
                          {(selectedTicket as any).planned_end_at && (
                            <div className="text-[11px] text-muted-foreground">
                              End: <span className="text-foreground font-medium">{new Date((selectedTicket as any).planned_end_at).toLocaleString()}</span>
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {/* METADATA: RESOLUTION NOTE */}
                    {Boolean((selectedTicket as any).resolution_note) && (
                      <div>
                        <span className="text-xs font-semibold text-muted-foreground block mb-1">Resolution / Supplier Note</span>
                        <div className="rounded-md border border-border bg-card px-2.5 py-1.5 text-xs text-foreground bg-muted/20 whitespace-pre-wrap">
                          {(selectedTicket as any).resolution_note}
                        </div>
                      </div>
                    )}

                    {/* METADATA: KNOWN ERROR WORKAROUND */}
                    {Boolean((selectedTicket as any).known_error_workaround) && (
                      <div>
                        <span className="text-xs font-semibold text-muted-foreground block mb-1">Known Error Workaround</span>
                        <div className="rounded-md border border-amber-200 bg-amber-50/50 dark:bg-amber-950/20 px-2.5 py-1.5 text-xs text-foreground whitespace-pre-wrap">
                          {(selectedTicket as any).known_error_workaround}
                        </div>
                      </div>
                    )}

                    {/* DIRECT 1-CLICK SELECT FIELD: TEAM (DYNAMIC FROM SETTINGS STORE) */}
                    <div>
                      <span className="text-xs font-semibold text-muted-foreground block mb-1">Team</span>
                      <div className="relative flex items-center rounded-md border border-border bg-card hover:bg-muted/10 focus-within:border-primary focus-within:ring-1 focus-within:ring-primary/20 transition-all px-2.5 py-1.5 shadow-2xs group">
                        <select
                          value={selectedTicket.teamKey || (storeQueues.find(q => q.label === selectedTicket.teamName)?.key) || storeQueues[0]?.key || 'support'}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val === selectedTicket.teamKey || val === selectedTicket.teamName) return;
                            const match = storeQueues.find((q) => q.key === val || q.id === val);
                            const label = match?.label || val;
                            updateTicket(selectedTicket.id, { teamKey: val, teamName: label });
                            setSelectedTicket({ ...selectedTicket, teamKey: val, teamName: label });
                          }}
                          className="w-full appearance-none bg-transparent text-xs font-semibold text-foreground outline-none cursor-pointer pr-6 font-sans"
                        >
                          {filteredStoreQueues && filteredStoreQueues.length > 0 ? (
                            filteredStoreQueues.map((q) => (
                              <option key={q.id || q.key} value={q.key || q.id}>
                                {q.label || q.key}
                              </option>
                            ))
                          ) : (
                            <option value="support">Support Team</option>
                          )}
                        </select>
                        <ChevronDown className="pointer-events-none absolute right-2.5 size-3.5 text-muted-foreground/70 group-hover:text-foreground transition-colors" />
                      </div>
                    </div>

                    {/* DIRECT 1-CLICK SELECT FIELD: ASSIGNED STAFF */}
                    <div>
                      <span className="text-xs font-semibold text-muted-foreground block mb-1">Assigned Staff</span>
                      <div className="relative flex items-center rounded-md border border-border bg-card hover:bg-muted/10 focus-within:border-primary focus-within:ring-1 focus-within:ring-primary/20 transition-all px-2.5 py-1.5 shadow-2xs group">
                        <select
                          value={selectedTicket.assigneeName || 'Unassigned'}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val === selectedTicket.assigneeName) return;
                            assignTicket(selectedTicket.id, val, val);
                            setSelectedTicket({ ...selectedTicket, assigneeName: val, assigneeId: val });
                          }}
                          className="w-full appearance-none bg-transparent text-xs font-semibold text-foreground outline-none cursor-pointer pr-6 font-sans"
                        >
                          <option value="Unassigned">Unassigned</option>
                          {supportAgentsList.map((ag) => (
                            <option key={ag.id} value={ag.name}>
                              {ag.name}
                            </option>
                          ))}
                        </select>
                        <ChevronDown className="pointer-events-none absolute right-2.5 size-3.5 text-muted-foreground/70 group-hover:text-foreground transition-colors" />
                      </div>
                    </div>

                    {/* DIRECT 1-CLICK SELECT FIELD: ADDITIONAL STAFF */}
                    <div>
                      <span className="text-xs font-semibold text-muted-foreground block mb-1">Additional Staff</span>
                      <div className="relative flex items-center rounded-md border border-border bg-card hover:bg-muted/10 focus-within:border-primary focus-within:ring-1 focus-within:ring-primary/20 transition-all px-2.5 py-1.5 shadow-2xs group">
                        <select
                          value={selectedTicket.additionalAgents?.[0] || 'Not set'}
                          onChange={(e) => {
                            const val = e.target.value;
                            updateTicket(selectedTicket.id, { additionalAgents: [val] });
                            setSelectedTicket({ ...selectedTicket, additionalAgents: [val] });
                          }}
                          className="w-full appearance-none bg-transparent text-xs font-semibold text-foreground outline-none cursor-pointer pr-6 font-sans"
                        >
                          <option value="Not set">Not set</option>
                          {supportAgentsList.map((ag) => (
                            <option key={ag.id} value={ag.name}>
                              {ag.name}
                            </option>
                          ))}
                        </select>
                        <ChevronDown className="pointer-events-none absolute right-2.5 size-3.5 text-muted-foreground/70 group-hover:text-foreground transition-colors" />
                      </div>
                    </div>

                    {/* DIRECT 1-CLICK SELECT FIELD: ISSUE */}
                    <div>
                      <span className="text-xs font-semibold text-muted-foreground block mb-1">Issue</span>
                      <div className="relative flex items-center rounded-md border border-border bg-card hover:bg-muted/10 focus-within:border-primary focus-within:ring-1 focus-within:ring-primary/20 transition-all px-2.5 py-1.5 shadow-2xs group">
                        <select
                          value={selectedTicket.category || 'General'}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val === selectedTicket.category) return;
                            updateTicket(selectedTicket.id, { category: val });
                            setSelectedTicket({ ...selectedTicket, category: val });
                          }}
                          className="w-full appearance-none bg-transparent text-xs font-semibold text-foreground outline-none cursor-pointer pr-6 font-sans"
                        >
                          <option value="General">General</option>
                          <option value="Hardware">Hardware</option>
                          <option value="Software">Software</option>
                          <option value="Network">Network</option>
                          <option value="Access">Access / Security</option>
                          <option value="Billing">Billing</option>
                        </select>
                        <ChevronDown className="pointer-events-none absolute right-2.5 size-3.5 text-muted-foreground/70 group-hover:text-foreground transition-colors" />
                      </div>
                    </div>

                    {/* DIRECT 1-CLICK SELECT FIELD: ISSUE - DETAIL */}
                    <div>
                      <span className="text-xs font-semibold text-muted-foreground block mb-1">Issue - Detail</span>
                      <div className="relative flex items-center rounded-md border border-border bg-card hover:bg-muted/10 focus-within:border-primary focus-within:ring-1 focus-within:ring-primary/20 transition-all px-2.5 py-1.5 shadow-2xs group">
                        <select
                          value={selectedTicket.subcategory || 'General Issue'}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val === selectedTicket.subcategory) return;
                            updateTicket(selectedTicket.id, { subcategory: val });
                            setSelectedTicket({ ...selectedTicket, subcategory: val });
                          }}
                          className="w-full appearance-none bg-transparent text-xs font-semibold text-foreground outline-none cursor-pointer pr-6 font-sans"
                        >
                          <option value="General Issue">General Issue</option>
                          <option value="Hardware Fault">Hardware Fault</option>
                          <option value="Network Connection">Network Connection</option>
                          <option value="Software Application">Software Application</option>
                          <option value="Access & Permissions">Access & Permissions</option>
                        </select>
                        <ChevronDown className="pointer-events-none absolute right-2.5 size-3.5 text-muted-foreground/70 group-hover:text-foreground transition-colors" />
                      </div>
                    </div>

                    {/* DROPDOWN FIELD: RESOLUTION */}
                    <div>
                      <span className="text-xs font-semibold text-muted-foreground block mb-1">Resolution</span>
                      <div className="relative flex items-center rounded-md border border-border bg-card hover:bg-muted/10 focus-within:border-primary focus-within:ring-1 focus-within:ring-primary/20 transition-all px-2.5 py-1.5 shadow-2xs group">
                        <select
                          value={selectedTicket.resolution || ''}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val === selectedTicket.resolution) return;
                            updateTicket(selectedTicket.id, { resolution: val });
                            setSelectedTicket({ ...selectedTicket, resolution: val });
                          }}
                          className="w-full appearance-none bg-transparent text-xs font-semibold text-foreground outline-none cursor-pointer pr-6 font-sans"
                        >
                          <option value="">Select resolution...</option>
                          <option value="Fixed - Software Update">Fixed — Software Update</option>
                          <option value="Fixed - Hardware Replacement">Fixed — Hardware Replacement</option>
                          <option value="Fixed - Configuration Change">Fixed — Configuration Change</option>
                          <option value="Fixed - Restart / Reboot">Fixed — Restart / Reboot</option>
                          <option value="Fixed - Driver / Firmware Update">Fixed — Driver / Firmware Update</option>
                          <option value="Fixed - User Training Provided">Fixed — User Training Provided</option>
                          <option value="Fixed - Access / Permission Granted">Fixed — Access / Permission Granted</option>
                          <option value="Fixed - Third-party Vendor">Fixed — Third-party Vendor</option>
                          <option value="Workaround Applied">Workaround Applied</option>
                          <option value="No Issue Found">No Issue Found</option>
                          <option value="Duplicate - Closed">Duplicate — Closed</option>
                          <option value="Escalated - Pending Vendor">Escalated — Pending Vendor</option>
                          <option value="Not Reproducible">Not Reproducible</option>
                          <option value="Withdrawn by User">Withdrawn by User</option>
                          <option value="Auto-Resolved">Auto-Resolved</option>
                        </select>
                        <ChevronDown className="pointer-events-none absolute right-2.5 size-3.5 text-muted-foreground/70 group-hover:text-foreground transition-colors" />
                      </div>
                    </div>

                    {/* UNCHANGEABLE SOURCE BADGE */}
                    <div>
                      <span className="text-xs font-semibold text-muted-foreground block mb-1">Source (Unchangeable)</span>
                      <div className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-md bg-muted/20 border border-border text-xs font-semibold text-foreground select-none shadow-2xs">
                        {selectedTicket.source === 'Chatbot' || selectedTicket.source === 'Chat' || selectedTicket.source === 'chat' || selectedTicket.source?.toLowerCase().includes('bot') ? (
                          <><span>🤖</span> <span>Chatbot</span></>
                        ) : selectedTicket.source === 'Support Portal' || selectedTicket.source === 'Web Portal' || selectedTicket.source === 'portal' || selectedTicket.source?.toLowerCase().includes('portal') ? (
                          <><span>🌐</span> <span>Support Portal</span></>
                        ) : selectedTicket.source === 'Email' || selectedTicket.source === 'email' || selectedTicket.source?.toLowerCase().includes('mail') ? (
                          <><span>📧</span> <span>Email</span></>
                        ) : (
                          <><span>💻</span> <span>Manual (TeamOne Platform)</span></>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* CARD: APPLICATION / SOFTWARE (SHOWN FOR SOFTWARE TICKET TYPES) */}
              {!isSelectedSysGen && isSoftwareTicket && (
                <div className="rounded-xl border border-border bg-card p-4 shadow-2xs space-y-3 font-sans">
                  <div className="flex items-center justify-between border-b border-border pb-1.5">
                    <h4 className="text-xs font-semibold text-foreground flex items-center gap-1.5">
                      <Code2 className="size-3.5 text-primary" />
                      <span>Application / Software</span>
                    </h4>
                    <div className="flex items-center gap-2">
                      <button
                        type="button"
                        onClick={() => setAppCardCollapsed(!appCardCollapsed)}
                        className="text-xs font-semibold text-muted-foreground hover:text-foreground px-1 cursor-pointer"
                        aria-label="Toggle Application / Software card"
                      >
                        {appCardCollapsed ? '+' : '−'}
                      </button>
                    </div>
                  </div>

                  {!appCardCollapsed && (
                    <div className="space-y-3">
                      {currentApp ? (
                        <div className="space-y-2.5">
                          <div className="space-y-2.5 rounded-lg border border-border/80 bg-background/50 p-2.5">
                            <div className="flex items-start justify-between gap-2">
                              <div className="min-w-0 flex-1">
                                {/* Badges in order: App Code -> Environment -> Version */}
                                <div className="flex items-center gap-1.5 flex-wrap">
                                  <span className="font-semibold text-xs text-primary bg-primary/10 px-2 py-0.5 rounded border border-primary/20 select-none">
                                    {currentApp.code}
                                  </span>
                                  <span className="text-xs font-semibold px-1.5 py-0.5 rounded-full border bg-sky-50 text-sky-700 border-sky-200 dark:bg-sky-950/50 dark:text-sky-300 dark:border-sky-800 select-none">
                                    {currentApp.environment || 'Production'}
                                  </span>
                                  {currentApp.version && (
                                    <span className="text-[11px] font-mono text-muted-foreground px-1.5 py-0.5 rounded bg-muted/50 border border-border/60">
                                      v{currentApp.version}
                                    </span>
                                  )}
                                </div>

                                <h5 className="font-semibold text-xs text-foreground mt-1.5 truncate" title={currentApp.name}>
                                  {currentApp.name}
                                </h5>
                              </div>
                            </div>

                            {/* App Specs Grid */}
                            <div className="grid grid-cols-2 gap-2 text-xs pt-1 border-t border-border/60">
                              <div>
                                <span className="text-muted-foreground text-[11px] block">Type</span>
                                <span className="font-medium text-foreground truncate block">{currentApp.type || 'Web Application'}</span>
                              </div>
                              <div>
                                <span className="text-muted-foreground text-[11px] block">Service / Path</span>
                                <span className="font-mono text-[11px] text-foreground truncate block" title={currentApp.service}>
                                  {currentApp.service || '-'}
                                </span>
                              </div>
                              <div className="col-span-2">
                                <span className="text-muted-foreground text-[11px] block">Component</span>
                                <span className="font-medium text-foreground truncate block">{currentApp.component || 'Core Engine'}</span>
                              </div>
                            </div>

                            {/* Change / Unlink Actions */}
                            <div className="flex items-center gap-2 pt-1.5 border-t border-border/60">
                              <button
                                type="button"
                                onClick={() => setIsChangingApp(!isChangingApp)}
                                className="text-[11px] font-medium text-primary hover:text-primary-focus underline cursor-pointer"
                              >
                                {isChangingApp ? 'Cancel' : 'Change Application'}
                              </button>
                              <span className="text-muted-foreground text-[11px]">·</span>
                              <button
                                type="button"
                                onClick={handleUnlinkApp}
                                className="text-[11px] font-medium text-destructive hover:text-destructive/80 underline cursor-pointer"
                              >
                                Unlink
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="rounded-lg border border-dashed border-border/90 bg-muted/20 p-3 text-center space-y-2">
                          <p className="text-xs text-muted-foreground">No application linked to this ticket</p>
                          <button
                            type="button"
                            onClick={() => setIsChangingApp(true)}
                            className="inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-md bg-primary text-primary-foreground hover:bg-primary/90 transition-colors cursor-pointer"
                          >
                            <Plus className="size-3" />
                            <span>Link Application</span>
                          </button>
                        </div>
                      )}

                      {/* Change / Link Application Dropdown Selector */}
                      {isChangingApp && (
                        <div className="space-y-2 rounded-lg border border-primary/30 bg-primary/5 p-2.5 animate-in fade-in">
                          <div className="flex items-center justify-between">
                            <label className="text-[11px] font-semibold text-foreground">Select Application or Service</label>
                            <button
                              type="button"
                              onClick={() => setIsChangingApp(false)}
                              className="text-[11px] text-muted-foreground hover:text-foreground cursor-pointer"
                            >
                              Close
                            </button>
                          </div>

                          <select
                            onChange={(e) => {
                              const val = e.target.value;
                              if (!val) return;
                              const foundSys = SYSTEM_APPLICATIONS.find(app => app.code === val || app.name === val);
                              if (foundSys) {
                                handleSelectApp(foundSys);
                                return;
                              }
                              const foundLic = (licenses || []).find(lic => String(lic.id) === val || lic.name === val);
                              if (foundLic) {
                                handleSelectApp({
                                  name: foundLic.name,
                                  code: (foundLic.publisher || 'LIC').toUpperCase().slice(0, 6),
                                  environment: 'Production',
                                });
                                return;
                              }
                            }}
                            className="w-full h-8 text-xs rounded-md border border-input bg-background px-2 text-foreground focus:ring-1 focus:ring-primary cursor-pointer"
                            defaultValue=""
                          >
                            <option value="">— Select Application / Service —</option>
                            <optgroup label="System Microservices & Modules">
                              {SYSTEM_APPLICATIONS.map((app) => (
                                <option key={app.code} value={app.code}>
                                  {app.name} ({app.code}) — {app.type}
                                </option>
                              ))}
                            </optgroup>
                            {licenses && licenses.length > 0 && (
                              <optgroup label="Software Licenses & Tools">
                                {licenses.map((lic) => (
                                  <option key={lic.id} value={lic.id}>
                                    {lic.name} ({lic.publisher || 'Software'})
                                  </option>
                                ))}
                              </optgroup>
                            )}
                          </select>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

              {/* CARD 3: RELATED ASSETS */}
              {!isSelectedSysGen && !isSoftwareTicket && showAssetCard && (
                <div className="rounded-xl border border-border bg-card p-4 shadow-2xs space-y-3 font-sans">
                  <div className="flex items-center justify-between border-b border-border pb-1.5">
                    <h4 className="text-xs font-semibold text-foreground">
                      Related Assets {relatedAssets.length > 0 && `(${relatedAssets.length})`}
                    </h4>
                    <button
                      type="button"
                      onClick={() => setAssetCardCollapsed(!assetCardCollapsed)}
                      className="text-xs font-semibold text-muted-foreground hover:text-foreground px-1"
                      aria-label="Toggle Related Assets card"
                    >
                      {assetCardCollapsed ? '+' : '−'}
                    </button>
                  </div>

                  {!assetCardCollapsed && (
                    <div className="space-y-3">
                      {/* 1. LIST OF RELATED ASSETS */}
                      {relatedAssets.length > 0 ? (
                        <div className="space-y-2.5">
                          {relatedAssets.length > 1 && (
                            <div className="text-xs text-muted-foreground px-0.5">
                              Click an asset to select it for replacement:
                            </div>
                          )}

                          {relatedAssets.map((asset) => {
                            const isPrimary = String(asset.id) === String(primaryRelatedAssetId) || asset.asset_code === String(primaryRelatedAssetId);
                            const isSelectedCard = relatedAssets.length === 1
                              ? true
                              : String(selectedAssetCardId || primaryRelatedAssetId) === String(asset.id || asset.asset_code);

                            return (
                              <div
                                key={asset.id || asset.asset_code}
                                onClick={() => setSelectedAssetCardId(asset.id || asset.asset_code)}
                                className={cn(
                                  "space-y-2.5 rounded-lg border p-2.5 transition-all cursor-pointer",
                                  isSelectedCard
                                    ? "border-primary/60 bg-primary/5 ring-1.5 ring-primary/25 shadow-2xs"
                                    : "border-border/70 bg-background/50 hover:border-border hover:bg-muted/30"
                                )}
                              >
                                <div className="flex items-start justify-between gap-2">
                                  <div className="min-w-0 flex-1">
                                    {/* Badges in order: 1. Asset Code -> 2. Active Status -> 3. Primary / Set as Primary */}
                                    <div className="flex items-center gap-1.5 flex-wrap">
                                      <span className="font-semibold text-xs text-primary bg-primary/10 px-2 py-0.5 rounded border border-primary/20 select-none">
                                        {asset.asset_code}
                                      </span>

                                      {/* 2. ACTIVE STATUS (NEXT TO ASSET ID, BEFORE PRIMARY) */}
                                      <span className={cn(
                                        'text-xs font-semibold px-1.5 py-0.5 rounded-full border select-none',
                                        asset.status === 'Assigned' || asset.status === 'Active' || asset.status === 'active' || asset.status === 'in_stock'
                                          ? 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/50 dark:text-emerald-300 dark:border-emerald-800'
                                          : asset.status === 'In Maintenance'
                                            ? 'bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/50 dark:text-amber-300 dark:border-amber-800'
                                            : 'bg-muted text-muted-foreground border-border'
                                      )}>
                                        {asset.status || 'active'}
                                      </span>

                                      {/* 3. PRIMARY TEXT WITH ICON / SET AS PRIMARY ACTION WITH ICON */}
                                      {isPrimary ? (
                                        <span className="inline-flex items-center gap-1 text-xs font-semibold text-blue-600 dark:text-blue-400 select-none px-0.5">
                                          <Star className="size-3 fill-blue-600 dark:fill-blue-400 text-blue-600 dark:text-blue-400" />
                                          <span>Primary</span>
                                        </span>
                                      ) : (
                                        <button
                                          type="button"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleSetPrimaryAsset(asset.id || asset.asset_code);
                                          }}
                                          className="inline-flex items-center gap-1 text-xs font-semibold text-muted-foreground hover:text-blue-600 dark:hover:text-blue-400 hover:underline cursor-pointer transition-colors px-0.5"
                                          title="Make this the primary asset for this ticket"
                                        >
                                          <Star className="size-3 text-muted-foreground" />
                                          <span>Set as Primary</span>
                                        </button>
                                      )}
                                    </div>

                                    <h5 className="font-semibold text-xs text-foreground mt-1.5 truncate" title={asset.name}>
                                      {asset.name}
                                    </h5>
                                  </div>

                                  <div className="flex items-center gap-1 shrink-0" onClick={(e) => e.stopPropagation()}>
                                    {/* View in Assets Hub — icon only */}
                                    <button
                                      type="button"
                                      onClick={() => navigate(`/assets/registry/${asset.asset_code || asset.id}`)}
                                      title="View in Assets Hub"
                                      className="p-1 rounded text-muted-foreground hover:text-primary hover:bg-primary/10 transition-colors cursor-pointer"
                                    >
                                      <ExternalLink className="size-3.5" />
                                    </button>
                                    {/* Unlink / delete */}
                                    <button
                                      type="button"
                                      onClick={() => handleRemoveRelatedAsset(asset.id || asset.asset_code)}
                                      title="Unlink asset from ticket"
                                      className="p-1 rounded text-muted-foreground hover:text-destructive hover:bg-destructive/10 transition-colors cursor-pointer"
                                    >
                                      <Trash2 className="size-3.5" />
                                    </button>
                                  </div>
                                </div>

                                <div className="grid grid-cols-2 gap-2 text-xs bg-muted/40 p-2.5 rounded-lg border border-border/50">
                                  <div>
                                    <span className="text-xs text-muted-foreground block font-medium">Category</span>
                                    <span className="font-semibold text-foreground truncate block">{asset.category || asset.type || 'Hardware'}</span>
                                  </div>
                                  <div>
                                    <span className="text-xs text-muted-foreground block font-medium">Serial No</span>
                                    <span className="font-semibold text-foreground truncate block">{asset.serial_number || '—'}</span>
                                  </div>
                                  {asset.manufacturer && (
                                    <div>
                                      <span className="text-xs text-muted-foreground block font-medium">Brand</span>
                                      <span className="font-semibold text-foreground truncate block">{asset.manufacturer}</span>
                                    </div>
                                  )}
                                  {asset.location && (
                                    <div>
                                      <span className="text-xs text-muted-foreground block font-medium">Location</span>
                                      <span className="font-semibold text-foreground truncate block">{asset.location}</span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            );
                          })}

                          {/* ACTION BUTTONS: EQUAL WIDTH */}
                          {(!isAddingAsset && !isChangingAsset) && (
                            <div className="grid grid-cols-2 gap-2 pt-1">
                              <button
                                type="button"
                                onClick={() => {
                                  setIsAddingAsset(true);
                                  setIsChangingAsset(false);
                                  setAssetToChangeId(null);
                                  setAssetSearchQuery('');
                                }}
                                className="h-8 w-full flex items-center justify-center gap-1.5 px-2.5 rounded-md border border-border bg-card hover:bg-muted text-foreground text-xs font-semibold shadow-2xs transition-colors cursor-pointer active:scale-98"
                              >
                                <span>+ Add More Asset</span>
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  const targetId = selectedAssetCardId || primaryRelatedAssetId || relatedAssets[0]?.id;
                                  setIsChangingAsset(true);
                                  setIsAddingAsset(false);
                                  setAssetToChangeId(targetId);
                                  setAssetSearchQuery('');
                                }}
                                className="h-8 w-full flex items-center justify-center gap-1.5 px-2.5 rounded-md border border-border bg-card hover:bg-muted text-foreground text-xs font-semibold shadow-2xs transition-colors cursor-pointer active:scale-98"
                              >
                                <span>Change Asset</span>
                              </button>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="space-y-2">
                          <div className="flex items-center gap-2 text-muted-foreground text-xs py-1">
                            <Box className="size-4 opacity-50" />
                            <span>No asset linked to this ticket</span>
                          </div>
                          {!isAddingAsset && (
                            <button
                              type="button"
                              onClick={() => {
                                setIsAddingAsset(true);
                                setIsChangingAsset(false);
                                setAssetSearchQuery('');
                              }}
                              className="w-full flex items-center justify-center gap-1.5 h-8 px-2.5 bg-card hover:bg-muted border border-border text-foreground rounded-md text-xs font-semibold transition-colors shadow-2xs cursor-pointer"
                            >
                              <span>+ Link Asset from Registry</span>
                            </button>
                          )}
                        </div>
                      )}

                      {/* 2. SEARCHABLE FILTERABLE ASSET SELECTION POPOVER / DROPDOWN */}
                      {(isAddingAsset || isChangingAsset) && (
                        <div className="rounded-lg border border-border bg-card p-3 shadow-xs space-y-2.5 animate-in fade-in duration-150">
                          <div className="flex items-center justify-between">
                            <span className="text-xs font-semibold text-foreground">
                              {isChangingAsset
                                ? `Change Asset (${relatedAssets.find(a => String(a.id) === String(assetToChangeId) || a.asset_code === String(assetToChangeId))?.asset_code || 'Selected'})`
                                : '+ Add Asset to Ticket'}
                            </span>
                            <button
                              type="button"
                              onClick={() => {
                                setIsAddingAsset(false);
                                setIsChangingAsset(false);
                                setAssetToChangeId(null);
                                setAssetSearchQuery('');
                              }}
                              className="text-xs font-semibold text-muted-foreground hover:text-foreground cursor-pointer"
                            >
                              Cancel
                            </button>
                          </div>

                          {/* Search Text Filter Box */}
                          <div className="relative flex items-center rounded-md border border-input bg-background px-2.5 py-1.5 focus-within:ring-1 focus-within:ring-primary focus-within:border-primary">
                            <Search className="size-3.5 text-muted-foreground mr-1.5 shrink-0" />
                            <input
                              type="text"
                              value={assetSearchQuery}
                              onChange={(e) => setAssetSearchQuery(e.target.value)}
                              placeholder="Type to filter assets (e.g. AST-10038, Lenovo, Laptop)..."
                              className="w-full bg-transparent text-xs text-foreground placeholder:text-muted-foreground outline-none font-sans"
                              autoFocus
                            />
                            {assetSearchQuery && (
                              <button
                                type="button"
                                onClick={() => setAssetSearchQuery('')}
                                className="text-muted-foreground hover:text-foreground p-0.5 cursor-pointer"
                              >
                                <X className="size-3" />
                              </button>
                            )}
                          </div>

                          {/* Scrollable List of Filtered Assets */}
                          <div className="max-h-56 overflow-y-auto space-y-1 divide-y divide-border/40 custom-scrollbar border border-border/50 rounded-md p-1 bg-background/50">
                            {(() => {
                              const query = assetSearchQuery.toLowerCase().trim();
                              const filtered = assets.filter((ast) => {
                                if (!query) return true;
                                return (
                                  (ast.asset_code && ast.asset_code.toLowerCase().includes(query)) ||
                                  (ast.name && ast.name.toLowerCase().includes(query)) ||
                                  (ast.category && ast.category.toLowerCase().includes(query)) ||
                                  (ast.type && ast.type.toLowerCase().includes(query)) ||
                                  (ast.serial_number && ast.serial_number.toLowerCase().includes(query)) ||
                                  (ast.manufacturer && ast.manufacturer.toLowerCase().includes(query)) ||
                                  (ast.location && ast.location.toLowerCase().includes(query)) ||
                                  (ast.status && ast.status.toLowerCase().includes(query))
                                );
                              });

                              if (filtered.length === 0) {
                                return (
                                  <div className="py-4 text-center text-xs text-muted-foreground">
                                    No assets matching "{assetSearchQuery}"
                                  </div>
                                );
                              }

                              return filtered.map((ast) => {
                                const isAlreadyLinked = relatedAssets.some(
                                  (ra) => String(ra.id) === String(ast.id) || ra.asset_code === ast.asset_code
                                );

                                return (
                                  <button
                                    key={ast.id}
                                    type="button"
                                    disabled={isAddingAsset && isAlreadyLinked}
                                    onClick={() => {
                                      if (isChangingAsset) {
                                        handleChangeRelatedAsset(assetToChangeId || selectedAssetCardId || primaryRelatedAssetId, ast);
                                      } else {
                                        handleAddRelatedAsset(ast);
                                      }
                                    }}
                                    className={cn(
                                      "w-full text-left p-2 rounded-md transition-colors flex items-start justify-between gap-2 text-xs",
                                      isAlreadyLinked && isAddingAsset
                                        ? "opacity-50 cursor-not-allowed bg-muted/30"
                                        : "hover:bg-accent/80 cursor-pointer"
                                    )}
                                  >
                                    <div className="min-w-0 flex-1">
                                      <div className="flex items-center gap-1.5 flex-wrap">
                                        <span className="font-semibold text-xs text-primary bg-primary/10 px-2 py-0.5 rounded border border-primary/20">
                                          {ast.asset_code}
                                        </span>
                                        <span className="text-xs text-muted-foreground font-semibold">
                                          {ast.category || ast.type || 'Hardware'}
                                        </span>
                                        <span className={cn(
                                          'text-xs font-semibold px-1.5 py-0.2 rounded-full border',
                                          ast.status === 'Assigned' || ast.status === 'Active' || ast.status === 'in_stock'
                                            ? 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/50 dark:text-emerald-300 dark:border-emerald-800'
                                            : ast.status === 'In Maintenance'
                                              ? 'bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/50 dark:text-amber-300 dark:border-amber-800'
                                              : 'bg-muted text-muted-foreground border-border'
                                        )}>
                                          {ast.status || 'Active'}
                                        </span>
                                        {isAlreadyLinked && (
                                          <span className="text-xs font-semibold text-blue-600 dark:text-blue-400 bg-blue-500/10 px-1.5 py-0.2 rounded">
                                            Linked
                                          </span>
                                        )}
                                      </div>
                                      <p className="font-semibold text-xs text-foreground truncate mt-1">{ast.name}</p>
                                      <div className="flex items-center gap-2 text-xs text-muted-foreground font-normal mt-0.5">
                                        <span>SN: {ast.serial_number || '—'}</span>
                                        {ast.manufacturer && <span>• {ast.manufacturer}</span>}
                                      </div>
                                    </div>
                                  </button>
                                );
                              });
                            })()}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

              {/* VENDOR & SUPPLIER CARD */}
              {!isSelectedSysGen && !isSoftwareTicket && showVendorCard && (
                <div className="rounded-xl border border-border bg-card p-4 shadow-2xs space-y-3 font-sans">
                  <div className="flex items-center justify-between border-b border-border pb-1.5">
                    <h4 className="text-xs font-semibold text-foreground flex items-center gap-1.5">
                      <Truck className="size-3.5 text-primary" />
                      <span>Vendor &amp; Supplier</span>
                    </h4>
                    <div className="flex items-center gap-2">
                      <button
                        type="button"
                        onClick={() => setVendorCardCollapsed(!vendorCardCollapsed)}
                        className="text-xs font-semibold text-muted-foreground hover:text-foreground px-1 cursor-pointer"
                        aria-label="Toggle Vendor &amp; Supplier card"
                      >
                        {vendorCardCollapsed ? '+' : '−'}
                      </button>
                    </div>
                  </div>

                  {!vendorCardCollapsed && (
                    <div className="space-y-3">
                      {/* Active Vendor details if linked */}
                      {(selectedTicket.effectiveVendorName || selectedTicket.vendorName || ticketAsset?.vendor || ticketAsset?.supplierName) ? (
                        <div className="space-y-2.5">
                          <div className="space-y-2.5 rounded-lg border border-border/80 bg-background/50 p-2.5">
                            <div className="flex items-start justify-between gap-2">
                              <div className="min-w-0 flex-1">
                                {/* Badges in order: Vendor Tag/Code -> Active Status */}
                                <div className="flex items-center gap-1.5 flex-wrap">
                                  <span className="font-semibold text-xs text-primary bg-primary/10 px-2 py-0.5 rounded border border-primary/20 select-none">
                                    {selectedTicket.vendorCode || 'VENDOR'}
                                  </span>
                                  <span className="text-xs font-semibold px-1.5 py-0.5 rounded-full border bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/50 dark:text-emerald-300 dark:border-emerald-800 select-none">
                                    Active Supplier
                                  </span>
                                </div>

                                <h5 className="font-semibold text-xs text-foreground mt-1.5 truncate" title={selectedTicket.effectiveVendorName || selectedTicket.vendorName || ticketAsset?.vendor || ticketAsset?.supplierName}>
                                  {selectedTicket.effectiveVendorName || selectedTicket.vendorName || ticketAsset?.vendor || ticketAsset?.supplierName}
                                </h5>
                              </div>

                              <div className="flex items-center gap-1 shrink-0" onClick={(e) => e.stopPropagation()}>
                                <a
                                  href={`/assets/vendors?search=${encodeURIComponent(selectedTicket.effectiveVendorName || selectedTicket.vendorName || ticketAsset?.vendor || '')}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="p-1 rounded text-muted-foreground hover:text-primary hover:bg-primary/10 transition-colors cursor-pointer"
                                  title="View in Vendors Hub"
                                >
                                  <ExternalLink className="size-3.5" />
                                </a>
                                {/* Unlink vendor button */}
                                <button
                                  type="button"
                                  onClick={handleUnlinkVendor}
                                  title="Unlink vendor from ticket"
                                  className="p-1 rounded text-muted-foreground hover:text-destructive hover:bg-destructive/10 transition-colors cursor-pointer"
                                >
                                  <Trash2 className="size-3.5" />
                                </button>
                              </div>
                            </div>

                            <div className="grid grid-cols-2 gap-2 text-xs bg-muted/40 p-2.5 rounded-lg border border-border/50">
                              <div>
                                <span className="text-xs text-muted-foreground block font-medium">Contact Email</span>
                                <span className="font-semibold text-foreground truncate block" title={selectedTicket.vendorEmail || ticketAsset?.vendorEmail}>
                                  {selectedTicket.vendorEmail || ticketAsset?.vendorEmail || '—'}
                                </span>
                              </div>
                              <div>
                                <span className="text-xs text-muted-foreground block font-medium">Contact Phone</span>
                                <span className="font-semibold text-foreground truncate block">
                                  {selectedTicket.vendorPhone || ticketAsset?.vendorPhone || '—'}
                                </span>
                              </div>
                              {(selectedTicket.vendorSlaTerms || ticketAsset?.vendorSlaTerms) && (
                                <div className="col-span-2 pt-1 border-t border-border/50">
                                  <span className="text-xs text-muted-foreground block font-medium">SLA Terms</span>
                                  <span className="font-semibold text-foreground text-xs line-clamp-2">
                                    {selectedTicket.vendorSlaTerms || ticketAsset?.vendorSlaTerms}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>

                          {/* ACTION BUTTONS: CHANGE VENDOR / UNLINK VENDOR (MATCHING RELATED ASSET UI STYLE) */}
                          {!isChangingVendor ? (
                            <div className="grid grid-cols-2 gap-2 pt-1">
                              <button
                                type="button"
                                onClick={() => setIsChangingVendor(true)}
                                className="h-8 w-full flex items-center justify-center gap-1.5 px-2.5 rounded-md border border-border bg-card hover:bg-muted text-foreground text-xs font-semibold shadow-2xs transition-colors cursor-pointer active:scale-98"
                              >
                                <span>Change Vendor</span>
                              </button>
                              <button
                                type="button"
                                onClick={handleUnlinkVendor}
                                className="h-8 w-full flex items-center justify-center gap-1.5 px-2.5 rounded-md border border-border bg-card hover:bg-muted text-destructive text-xs font-semibold shadow-2xs transition-colors cursor-pointer active:scale-98"
                              >
                                <Trash2 className="size-3" />
                                <span>Unlink Vendor</span>
                              </button>
                            </div>
                          ) : (
                            <div className="space-y-1.5 pt-1 animate-in fade-in">
                              <div className="flex items-center justify-between text-xs">
                                <span className="font-medium text-muted-foreground">Select New Vendor:</span>
                                <button
                                  type="button"
                                  onClick={() => setIsChangingVendor(false)}
                                  className="text-xs text-muted-foreground hover:text-foreground cursor-pointer"
                                >
                                  Cancel
                                </button>
                              </div>
                              <select
                                value={selectedTicket.vendorId || selectedTicket.supplierOrgId || ''}
                                onChange={async (e) => {
                                  const nextVendorId = e.target.value ? Number(e.target.value) : null;
                                  await handleSelectVendor(nextVendorId);
                                  setIsChangingVendor(false);
                                }}
                                className="w-full h-8 text-xs rounded-md border border-input bg-background px-2 text-foreground focus:ring-1 focus:ring-primary cursor-pointer"
                              >
                                <option value="">— Select Vendor —</option>
                                {useAssetCatalogStore.getState().vendors.map((v) => (
                                  <option key={v.id} value={v.id}>
                                    {v.name} {v.contactPerson ? `(${v.contactPerson})` : ''}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="space-y-2.5">
                          <div className="flex items-center gap-2 text-muted-foreground text-xs py-1">
                            <Truck className="size-4 opacity-50" />
                            <span>No vendor linked to this ticket</span>
                          </div>
                          {!isChangingVendor ? (
                            <button
                              type="button"
                              onClick={() => setIsChangingVendor(true)}
                              className="h-8 w-full flex items-center justify-center gap-1.5 px-2.5 rounded-md border border-border bg-card hover:bg-muted text-foreground text-xs font-semibold shadow-2xs transition-colors cursor-pointer active:scale-98"
                            >
                              <span>+ Assign Vendor</span>
                            </button>
                          ) : (
                            <div className="space-y-1.5 pt-1 animate-in fade-in">
                              <div className="flex items-center justify-between text-xs">
                                <span className="font-medium text-muted-foreground">Select Vendor:</span>
                                <button
                                  type="button"
                                  onClick={() => setIsChangingVendor(false)}
                                  className="text-xs text-muted-foreground hover:text-foreground cursor-pointer"
                                >
                                  Cancel
                                </button>
                              </div>
                              <select
                                value=""
                                onChange={async (e) => {
                                  const nextVendorId = e.target.value ? Number(e.target.value) : null;
                                  if (nextVendorId) {
                                    await handleSelectVendor(nextVendorId);
                                    setIsChangingVendor(false);
                                  }
                                }}
                                className="w-full h-8 text-xs rounded-md border border-input bg-background px-2 text-foreground focus:ring-1 focus:ring-primary cursor-pointer"
                              >
                                <option value="">— Select Vendor —</option>
                                {useAssetCatalogStore.getState().vendors.map((v) => (
                                  <option key={v.id} value={v.id}>
                                    {v.name} {v.contactPerson ? `(${v.contactPerson})` : ''}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
              {/* CARD 4: END-USER DETAILS */}
              {!isSelectedSysGen && (
                <div className="rounded-xl border border-border bg-card p-4 shadow-2xs space-y-3">
                  <div className="flex items-center justify-between border-b border-border pb-1.5">
                    <h4 className="text-xs font-semibold text-foreground">End-User details</h4>
                    <button
                      type="button"
                      onClick={() => setEndUserCollapsed(!endUserCollapsed)}
                      className="text-xs font-semibold text-muted-foreground hover:text-foreground px-1"
                      aria-label="Toggle End-User details card"
                    >
                      {endUserCollapsed ? '+' : '−'}
                    </button>
                  </div>

                  {!endUserCollapsed && (
                    <div className="space-y-3">
                      <div className="flex items-center gap-3">
                        <div className="flex size-9 shrink-0 items-center justify-center rounded-full bg-emerald-600 text-white font-semibold text-xs shadow-2xs">
                          {(matchedEmployee?.displayName || selectedTicket.requesterName || selectedTicket.client || 'G').slice(0, 2).toUpperCase()}
                        </div>
                        <div className="min-w-0 flex-1">
                          <h5 className="font-semibold text-xs text-foreground truncate">
                            {matchedEmployee?.displayName || selectedTicket.requesterName || selectedTicket.client || '-'}
                          </h5>
                          <p className="text-xs text-muted-foreground truncate">
                            {matchedEmployee?.email || selectedTicket.requesterEmail || '-'}
                          </p>
                        </div>
                      </div>

                      <div className="space-y-2.5 text-xs">
                        {/* USER NAME */}
                        <div>
                          <span className="text-xs font-semibold text-muted-foreground block mb-1">User Name</span>
                          <div className="relative flex items-center rounded-md border border-border bg-card hover:bg-muted/10 focus-within:border-primary focus-within:ring-1 focus-within:ring-primary/20 transition-all px-2.5 py-1.5 shadow-2xs group">
                            <select
                              value={
                                combinedEndUsers.find((u) =>
                                  (selectedTicket.requesterId && (String(u.id) === String(selectedTicket.requesterId) || String(u.employeeId) === String(selectedTicket.requesterId) || String(u.userId) === String(selectedTicket.requesterId))) ||
                                  (selectedTicket.requesterEmail && u.email?.toLowerCase() === selectedTicket.requesterEmail?.toLowerCase()) ||
                                  (selectedTicket.requesterName && u.name?.toLowerCase() === selectedTicket.requesterName?.toLowerCase())
                                )?.id || selectedTicket.requesterId || ''
                              }
                              onChange={(e) => {
                                const val = e.target.value;
                                const targetUser = combinedEndUsers.find(
                                  (u) => String(u.id) === val || String(u.employeeId) === val || u.name === val || u.email === val
                                );
                                if (targetUser) {
                                  const updates = {
                                    requesterId: targetUser.id,
                                    requesterName: targetUser.name,
                                    requesterEmail: targetUser.email,
                                    client: targetUser.name,
                                    requesterPhone: targetUser.phone || '',
                                    department: targetUser.department || selectedTicket.requesterDepartment || selectedTicket.department,
                                    requesterDepartment: targetUser.department || selectedTicket.requesterDepartment || selectedTicket.department,
                                  };
                                  updateTicket(selectedTicket.id, updates);
                                  setSelectedTicket({ ...selectedTicket, ...updates });
                                  toast.success(`End user changed to ${targetUser.name}`);
                                }
                              }}
                              className="w-full appearance-none bg-transparent text-xs font-semibold text-blue-600 dark:text-blue-400 outline-none cursor-pointer pr-6 truncate font-sans"
                            >
                              {combinedEndUsers.length > 0 ? (
                                combinedEndUsers.map((u) => (
                                  <option key={u.id || u.email} value={u.id}>
                                    {u.name} {u.department ? `(${u.department})` : ''}
                                  </option>
                                ))
                              ) : (
                                <option value={selectedTicket.requesterName || ''}>
                                  {selectedTicket.requesterName || selectedTicket.client || '-'}
                                </option>
                              )}
                            </select>
                            <ChevronDown className="pointer-events-none absolute right-2.5 size-3.5 text-blue-500 group-hover:text-blue-600 transition-colors" />
                          </div>
                        </div>

                        {/* EMAIL ADDRESS */}
                        <div>
                          <span className="text-xs font-semibold text-muted-foreground block mb-1">Email Address</span>
                          <div className="rounded-md border border-border bg-muted/20 px-2.5 py-1.5 font-medium text-blue-600 dark:text-blue-400 text-xs shadow-2xs truncate select-text">
                            {matchedEmployee?.email || selectedTicket.requesterEmail || '-'}
                          </div>
                        </div>

                        {/* PHONE NUMBER */}
                        <div>
                          <span className="text-xs font-semibold text-muted-foreground block mb-1">Phone Number</span>
                          <div className="rounded-md border border-border bg-muted/20 px-2.5 py-1.5 font-medium text-foreground text-xs shadow-2xs truncate select-text">
                            {matchedEmployee?.phone || selectedTicket.requesterPhone || 'Not set'}
                          </div>
                        </div>

                        {/* DEPARTMENT */}
                        <div>
                          <span className="text-xs font-semibold text-muted-foreground block mb-1">Department</span>
                          <div className="rounded-md border border-border bg-muted/20 px-2.5 py-1.5 font-medium text-foreground text-xs shadow-2xs truncate">
                            {matchedEmployee?.department || selectedTicket.requesterDepartment || selectedTicket.department || 'General'}
                          </div>
                        </div>

                        {/* SITE */}
                        <div>
                          <span className="text-xs font-semibold text-muted-foreground block mb-1">Site</span>
                          <div className="relative flex items-center rounded-md border border-border bg-card hover:bg-muted/10 focus-within:border-primary focus-within:ring-1 focus-within:ring-primary/20 transition-all px-2.5 py-1.5 shadow-2xs group">
                            <select
                              value={selectedTicket.site || matchedEmployee?.location || 'Head Office'}
                              onChange={(e) => {
                                const val = e.target.value;
                                updateTicket(selectedTicket.id, { site: val });
                                setSelectedTicket({ ...selectedTicket, site: val });
                                toast.success(`Site changed to ${val}`);
                              }}
                              className="w-full appearance-none bg-transparent text-xs font-semibold text-foreground outline-none cursor-pointer pr-6 font-sans"
                            >
                              <option value="Head Office">Head Office</option>
                              <option value="Branch Office">Branch Office</option>
                              <option value="Remote / Home Office">Remote / Home Office</option>
                              <option value="Data Center">Data Center</option>
                            </select>
                            <ChevronDown className="pointer-events-none absolute right-2.5 size-3.5 text-muted-foreground/70 group-hover:text-foreground transition-colors" />
                          </div>
                        </div>

                        {/* REPORTING MANAGER */}
                        <div>
                          <span className="text-xs font-semibold text-muted-foreground block mb-1">Reporting Manager</span>
                          <div className="rounded-md border border-border bg-muted/20 px-2.5 py-1.5 font-medium text-foreground text-xs shadow-2xs truncate">
                            {matchedEmployee?.managerName || 'Not set'}
                          </div>
                        </div>

                        {/* CHANGE END USER */}
                        <div>
                          <span className="text-xs font-semibold text-blue-600 dark:text-blue-400 block mb-0.5">Change End User</span>
                          <div className="relative flex items-center rounded-md border border-transparent hover:border-input hover:bg-muted/40 transition-colors px-2 py-1 -ml-2 group">
                            <select
                              value={
                                employees.find(e =>
                                  String(e.id) === String(selectedTicket.requesterId) ||
                                  String((e as any).userId || (e as any).user_id) === String(selectedTicket.requesterId) ||
                                  (selectedTicket.requesterEmail && e.email?.toLowerCase() === selectedTicket.requesterEmail?.toLowerCase())
                                )?.id || selectedTicket.requesterId || ''
                              }
                              onChange={(e) => handleReassignEndUser(e.target.value)}
                              className="w-full appearance-none bg-transparent text-xs font-semibold text-foreground outline-none cursor-pointer pr-6"
                            >
                              <option value="">-- Choose Employee --</option>
                              {employees.map((emp) => (
                                <option key={emp.id} value={emp.id}>
                                  {emp.displayName || `${emp.firstName} ${emp.lastName}`.trim()} ({emp.department || emp.email})
                                </option>
                              ))}
                            </select>
                            <ChevronDown className="pointer-events-none absolute right-2 size-3.5 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </main>
      ) : (
        /* ------------------------------------------------------------- */
        /* MAIN TICKETS LIST VIEW MODE WITH TABLE & TILE ROW SWITCHER   */
        /* ------------------------------------------------------------- */
        <main className="flex flex-1 flex-col overflow-hidden bg-background">
          {ticketLoadError && <p role="alert" className="p-3 text-sm text-destructive">{ticketLoadError}</p>}
          {/* TOP TOOLBAR WITH TABLE & TILE VIEW SWITCHER */}
          <header className="flex flex-wrap items-center justify-between gap-2.5 border-b border-border bg-background px-5 py-2.5 shrink-0">
            {/* Left filters: Status filter dropdown */}
            <div className="flex items-center gap-2">
              <select
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
                className="h-8 rounded-md border border-input bg-background px-2.5 py-1 text-xs font-semibold text-foreground shadow-sm outline-none focus:ring-1 focus:ring-ring cursor-pointer"
              >
                <option value="all">All Tickets</option>
                <option value="actions-last-month">All Tickets With Actions in Last Month</option>
                <option value="actions-last-week">All Tickets With Actions in Last Week</option>
                <option value="actions-since-yesterday">All Tickets With Actions Since Yesterday</option>
                <option value="closed-tickets">Closed Tickets</option>
                <option value="my-closed-tickets">My closed tickets</option>
                <option value="my-open-tickets-incl-sla-hold">My open tickets (incl SLA hold)</option>
                <option value="open-tickets">Open Tickets</option>
                <option value="open-tickets-incl-sla-hold">Open Tickets (Including SLA Hold)</option>
                <option value="tickets-on-hold">Tickets On Hold</option>
              </select>

              {/* Search Input */}
              <div className="relative w-60 sm:w-72">
                <Search className="absolute left-2.5 top-1/2 size-3.5 -translate-y-1/2 text-muted-foreground" />
                <input
                  type="text"
                  placeholder="Search ticket ID, subject, client..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && fetchTickets()}
                  className="h-8 w-full rounded-md border border-input bg-background pl-8 pr-2.5 text-xs text-foreground shadow-sm placeholder:text-muted-foreground outline-none focus:ring-1 focus:ring-ring"
                />
              </div>

              {/* Active Column Filters / Sort Reset Button */}
              {(Object.keys(columnFilters).length > 0 ||
                Object.keys(columnSearchFilters).length > 0 ||
                sortConfig.column !== null) && (
                  <button
                    type="button"
                    onClick={handleResetAllColumnFilters}
                    className="inline-flex h-8 items-center gap-1.5 rounded-md border border-blue-200 dark:border-blue-800 bg-blue-50 dark:bg-blue-950/60 px-2.5 text-xs font-semibold text-blue-700 dark:text-blue-300 hover:bg-blue-100 dark:hover:bg-blue-900 transition-colors shadow-2xs"
                    title="Reset all active column filters and sorting"
                  >
                    <RotateCcw className="size-3" />
                    <span>
                      Reset filters (
                      {Object.keys(columnFilters).length +
                        Object.keys(columnSearchFilters).length +
                        (sortConfig.column ? 1 : 0)}
                      )
                    </span>
                  </button>
                )}
            </div>

            {/* Right actions toolbar in exact required order: [Refresh] [Actions on selected rows] [Export ▾] [Grid/List view switch] [+ New Ticket] */}
            <div className="flex items-center gap-2">
              <span className="text-xs font-medium text-muted-foreground mr-1">
                {totalItems > 0
                  ? `${startIndex + 1}-${endIndex} of ${totalItems.toLocaleString()}`
                  : '0 of 0'}
              </span>

              {/* 1. REFRESH BUTTON */}
              <button
                type="button"
                onClick={handleRefresh}
                className="inline-flex h-8 size-8 items-center justify-center rounded-md border border-border bg-card hover:bg-accent text-foreground transition-colors cursor-pointer"
                title="Refresh tickets"
              >
                <RefreshCw className={cn('size-3.5', isRefreshing && 'animate-spin')} />
              </button>

              {/* 2. ACTIONS ON SELECTED ROWS DROPDOWN */}
              <div className="relative">
                <button
                  type="button"
                  disabled={selectedRowIds.size === 0}
                  onClick={() => setShowBulkActionsMenu(!showBulkActionsMenu)}
                  className={cn(
                    "inline-flex h-8 items-center gap-1.5 rounded-md border bg-card px-2.5 text-xs font-semibold transition-colors shadow-2xs",
                    selectedRowIds.size === 0
                      ? "opacity-50 cursor-not-allowed text-muted-foreground border-border"
                      : "text-foreground hover:bg-accent cursor-pointer border-border"
                  )}
                  title={
                    selectedRowIds.size === 0
                      ? "Select one or more tickets to perform bulk actions"
                      : `Actions on selected rows (${selectedRowIds.size})`
                  }
                >
                  <span>Actions on selected rows ({selectedRowIds.size})</span>
                  <ChevronDown className="size-3.5 text-muted-foreground" />
                </button>

                {/* POPUP MENU FOR BULK ACTIONS */}
                {showBulkActionsMenu && selectedRowIds.size > 0 && (
                  <>
                    <div
                      className="fixed inset-0 z-40"
                      onClick={() => setShowBulkActionsMenu(false)}
                    />
                    <div className="absolute left-0 top-9 z-50 w-56 max-h-80 overflow-y-auto custom-scrollbar rounded-xl border border-border bg-card p-1 shadow-2xl text-xs space-y-0.5 animate-in fade-in zoom-in-95">
                      {[
                        { key: 'read', label: 'Mark as read', icon: Mail },
                        { key: 'unread', label: 'Mark as unread', icon: Mail },
                        { key: 'flag', label: 'Flag', icon: Flag },
                        { key: 'unflag', label: 'Unflag', icon: Minus },
                        { key: 'link', label: 'Link Ticket(s)', icon: Link, modal: 'link' },
                        { key: 'merge', label: 'Merge Ticket(s)', icon: Share2, modal: 'merge' },
                        { key: 'clone', label: 'Clone Ticket(s)', icon: Copy },
                        { key: 'reassign', label: 'Re-assign', icon: UserCheck, modal: 'reassign' },
                        { key: 'changeCategory', label: 'Change Category', icon: Edit3, modal: 'category' },
                        { key: 'changeStatus', label: 'Change Status', icon: Edit3, modal: 'status' },
                        { key: 'slaHold', label: 'SLA Hold', icon: Clock },
                        { key: 'slaRelease', label: 'SLA Release', icon: Clock },
                        { key: 'changePriority', label: 'Change Priority', icon: ArrowUp, modal: 'priority' },
                        { key: 'changeType', label: 'Change Ticket Type', icon: Edit3, modal: 'type' },
                        { key: 'changeSiteUser', label: 'Change Enduser', icon: User, modal: 'siteUser' },
                        { key: 'spam', label: 'Treat as Spam', icon: Ban },
                      ].map((item) => {
                        const IconComp = item.icon;
                        return (
                          <button
                            key={item.key}
                            type="button"
                            onClick={() => {
                              if (item.modal) {
                                setBulkActionModal(item.modal);
                                if (item.modal === 'reassign') {
                                  setReassignTeam('');
                                  setReassignStaff('');
                                }
                                setShowBulkActionsMenu(false);
                              } else {
                                handleExecuteBulkAction(item.key);
                              }
                            }}
                            className="w-full flex items-center gap-2.5 px-2.5 py-1.5 rounded-md text-left text-xs font-medium text-foreground hover:bg-muted transition-colors cursor-pointer"
                          >
                            <IconComp className="size-3.5 text-muted-foreground shrink-0" />
                            <span>{item.label}</span>
                          </button>
                        );
                      })}
                    </div>
                  </>
                )}
              </div>

              {/* 3. EXPORT DROPDOWN (CSV, EXCEL, PDF WITH SELECTED VS ALL FILTERED) */}
              <div className="relative">
                <button
                  type="button"
                  onClick={() => setShowExportMenu(!showExportMenu)}
                  className="inline-flex h-8 items-center gap-1.5 rounded-md border border-border bg-card px-2.5 text-xs font-semibold text-foreground hover:bg-accent transition-colors shadow-2xs cursor-pointer"
                  title="Export tickets"
                >
                  <Download className="size-3.5 text-muted-foreground" />
                  <span>Export</span>
                  <ChevronDown className="size-3 text-muted-foreground" />
                </button>

                {showExportMenu && (
                  <>
                    <div
                      className="fixed inset-0 z-40"
                      onClick={() => setShowExportMenu(false)}
                    />
                    <div className="absolute right-0 top-9 z-50 w-64 rounded-xl border border-border bg-card p-2 shadow-2xl text-xs space-y-2 animate-in fade-in zoom-in-95">
                      {selectedRowIds.size > 0 && (
                        <div className="space-y-1">
                          <div className="px-2 py-0.5 rounded bg-primary/10 text-primary font-semibold text-[11px] flex items-center justify-between">
                            <span>Export Selected</span>
                            <span className="font-mono">({selectedRowIds.size})</span>
                          </div>
                          <div className="grid grid-cols-3 gap-1">
                            <button
                              type="button"
                              onClick={() => {
                                handleExportTickets('csv', 'selected');
                                setShowExportMenu(false);
                              }}
                              className="flex items-center justify-center gap-1 py-1.5 px-2 rounded hover:bg-muted font-medium text-foreground transition-colors border border-border text-[11px] cursor-pointer"
                              title="Export selected tickets as CSV"
                            >
                              <FileText className="size-3 text-blue-500" />
                              <span>CSV</span>
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                handleExportTickets('xlsx', 'selected');
                                setShowExportMenu(false);
                              }}
                              className="flex items-center justify-center gap-1 py-1.5 px-2 rounded hover:bg-muted font-medium text-foreground transition-colors border border-border text-[11px] cursor-pointer"
                              title="Export selected tickets as Excel (.xlsx)"
                            >
                              <FileSpreadsheet className="size-3 text-emerald-600" />
                              <span>Excel</span>
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                handleExportTickets('json', 'selected');
                                setShowExportMenu(false);
                              }}
                              className="flex items-center justify-center gap-1 py-1.5 px-2 rounded hover:bg-muted font-medium text-foreground transition-colors border border-border text-[11px] cursor-pointer"
                              title="Export selected tickets as JSON"
                            >
                              <LucideCode className="size-3 text-amber-500" />
                              <span>JSON</span>
                            </button>
                          </div>
                        </div>
                      )}

                      <div className="space-y-1">
                        <div className="px-2 py-0.5 rounded bg-muted/60 text-muted-foreground font-semibold text-[11px] flex items-center justify-between">
                          <span>Export All Filtered</span>
                          <span className="font-mono">({totalItems})</span>
                        </div>
                        <div className="grid grid-cols-3 gap-1">
                          <button
                            type="button"
                            onClick={() => {
                              handleExportTickets('csv', 'all');
                              setShowExportMenu(false);
                            }}
                            className="flex items-center justify-center gap-1 py-1.5 px-2 rounded hover:bg-muted font-medium text-foreground transition-colors border border-border text-[11px] cursor-pointer"
                            title="Export all filtered tickets as CSV"
                          >
                            <FileText className="size-3 text-blue-500" />
                            <span>CSV</span>
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              handleExportTickets('xlsx', 'all');
                              setShowExportMenu(false);
                            }}
                            className="flex items-center justify-center gap-1 py-1.5 px-2 rounded hover:bg-muted font-medium text-foreground transition-colors border border-border text-[11px] cursor-pointer"
                            title="Export all filtered tickets as Excel (.xlsx)"
                          >
                            <FileSpreadsheet className="size-3 text-emerald-600" />
                            <span>Excel</span>
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              handleExportTickets('json', 'all');
                              setShowExportMenu(false);
                            }}
                            className="flex items-center justify-center gap-1 py-1.5 px-2 rounded hover:bg-muted font-medium text-foreground transition-colors border border-border text-[11px] cursor-pointer"
                            title="Export all filtered tickets as JSON"
                          >
                            <LucideCode className="size-3 text-amber-500" />
                            <span>JSON</span>
                          </button>
                        </div>
                      </div>

                      {selectedRowIds.size === 0 && (
                        <p className="px-2 pt-1 text-[10px] text-muted-foreground italic border-t border-border/50">
                          Select row checkboxes to enable exporting only selected tickets.
                        </p>
                      )}
                    </div>
                  </>
                )}
              </div>

              {/* 4. VIEW SWITCHER: TABLE & TILE ICON BUTTONS */}
              <div className="flex items-center rounded-md border border-border bg-card p-0.5 shadow-2xs">
                <button
                  onClick={() => setDisplayMode('table')}
                  className={cn(
                    'p-1.5 rounded transition-colors',
                    displayMode === 'table'
                      ? 'bg-primary text-primary-foreground font-semibold shadow-xs'
                      : 'text-muted-foreground hover:text-foreground hover:bg-accent'
                  )}
                  title="Table View"
                >
                  <Table className="size-3.5" />
                </button>
                <button
                  onClick={() => setDisplayMode('tile')}
                  className={cn(
                    'p-1.5 rounded transition-colors',
                    displayMode === 'tile'
                      ? 'bg-primary text-primary-foreground font-semibold shadow-xs'
                      : 'text-muted-foreground hover:text-foreground hover:bg-accent'
                  )}
                  title="Tile List View"
                >
                  <LayoutGrid className="size-3.5" />
                </button>
              </div>

              {/* 5. NEW TICKET BUTTON */}
              <button
                onClick={() => setIsCreateModalOpen(true)}
                className="inline-flex h-8 items-center gap-1.5 rounded-lg bg-primary px-3.5 text-xs font-semibold text-primary-foreground shadow-xs transition-colors hover:bg-primary/90 cursor-pointer"
              >
                <Plus className="size-3.5" />
                New Ticket
              </button>
            </div>
          </header>

          {/* VIEW DISPLAY: TABLE OR TILE ROW CARDS */}
          {displayMode === 'table' ? (
            /* DATA TABLE VIEW (HORIZONTAL & VERTICAL SCROLLABLE WITH ALTERNATING WHITE/GREY ROWS MATCHING SAMPLE IMAGE) */
            <div className="flex-1 overflow-x-auto overflow-y-auto custom-scrollbar p-4">
              <div
                style={{ minWidth: `${totalTableWidth}px` }}
                className="rounded-xl border border-border bg-card shadow-sm overflow-hidden"
              >
                <table className="w-full text-left text-xs table-fixed border-collapse">
                  <thead
                    ref={filterDropdownContainerRef}
                    className="border-b border-border bg-slate-100/90 dark:bg-slate-800/80 text-xs font-semibold uppercase tracking-wider text-muted-foreground select-none"
                  >
                    <tr>
                      {/* Checkbox */}
                      <th
                        style={{ width: `${columnWidths.select}px` }}
                        className="relative px-2 py-2.5 text-center group overflow-hidden"
                      >
                        <input
                          type="checkbox"
                          checked={sortedTickets.length > 0 && selectedRowIds.size === sortedTickets.length}
                          onChange={handleSelectAllRows}
                          className="size-3.5 rounded border-border"
                        />
                        <div
                          onMouseDown={(e) => handleMouseDownResize('select', e)}
                          className="absolute right-0 top-0 bottom-0 w-1.5 cursor-col-resize opacity-0 group-hover:opacity-100 hover:bg-black/40 bg-border transition-opacity"
                        />
                      </th>

                      {/* Status */}
                      <TableColumnHeader
                        colKey="status"
                        label="Status"
                        width={columnWidths.status}
                        sortConfig={sortConfig}
                        onSort={handleSortColumn}
                        selectedValues={columnFilters.status}
                        onFilterChange={handleColumnFilterChange}
                        distinctValues={getColumnDistinctValues.status}
                        isOpen={activeFilterDropdown === 'status'}
                        onToggleDropdown={(k) =>
                          setActiveFilterDropdown(activeFilterDropdown === k ? null : k)
                        }
                        onCloseDropdown={() => setActiveFilterDropdown(null)}
                        onResize={handleMouseDownResize}
                      />

                      {/* Team */}
                      <TableColumnHeader
                        colKey="team"
                        label="Team"
                        width={columnWidths.team}
                        sortConfig={sortConfig}
                        onSort={handleSortColumn}
                        selectedValues={columnFilters.team}
                        onFilterChange={handleColumnFilterChange}
                        searchValue={columnSearchFilters.team}
                        onSearchChange={handleColumnSearchChange}
                        distinctValues={getColumnDistinctValues.team}
                        isOpen={activeFilterDropdown === 'team'}
                        onToggleDropdown={(k) =>
                          setActiveFilterDropdown(activeFilterDropdown === k ? null : k)
                        }
                        onCloseDropdown={() => setActiveFilterDropdown(null)}
                        onResize={handleMouseDownResize}
                      />

                      {/* Ticket ID */}
                      <TableColumnHeader
                        colKey="ticketId"
                        label="Ticket ID"
                        width={columnWidths.ticketId}
                        sortConfig={sortConfig}
                        onSort={handleSortColumn}
                        selectedValues={columnFilters.ticketId}
                        onFilterChange={handleColumnFilterChange}
                        searchValue={columnSearchFilters.ticketId}
                        onSearchChange={handleColumnSearchChange}
                        distinctValues={getColumnDistinctValues.ticketId}
                        isOpen={activeFilterDropdown === 'ticketId'}
                        onToggleDropdown={(k) =>
                          setActiveFilterDropdown(activeFilterDropdown === k ? null : k)
                        }
                        onCloseDropdown={() => setActiveFilterDropdown(null)}
                        onResize={handleMouseDownResize}
                      />

                      {/* Subject */}
                      <TableColumnHeader
                        colKey="subject"
                        label="Subject"
                        width={columnWidths.subject}
                        sortConfig={sortConfig}
                        onSort={handleSortColumn}
                        searchValue={columnSearchFilters.subject}
                        onSearchChange={handleColumnSearchChange}
                        isTextSearchOnly={true}
                        isOpen={activeFilterDropdown === 'subject'}
                        onToggleDropdown={(k) =>
                          setActiveFilterDropdown(activeFilterDropdown === k ? null : k)
                        }
                        onCloseDropdown={() => setActiveFilterDropdown(null)}
                        onResize={handleMouseDownResize}
                      />

                      {/* Ticket Type */}
                      <TableColumnHeader
                        colKey="type"
                        label="Ticket Type"
                        width={columnWidths.type}
                        sortConfig={sortConfig}
                        onSort={handleSortColumn}
                        selectedValues={columnFilters.type}
                        onFilterChange={handleColumnFilterChange}
                        distinctValues={getColumnDistinctValues.type}
                        isOpen={activeFilterDropdown === 'type'}
                        onToggleDropdown={(k) =>
                          setActiveFilterDropdown(activeFilterDropdown === k ? null : k)
                        }
                        onCloseDropdown={() => setActiveFilterDropdown(null)}
                        onResize={handleMouseDownResize}
                      />

                      {/* Client */}
                      <TableColumnHeader
                        colKey="client"
                        label="Client"
                        width={columnWidths.client}
                        sortConfig={sortConfig}
                        onSort={handleSortColumn}
                        selectedValues={columnFilters.client}
                        onFilterChange={handleColumnFilterChange}
                        searchValue={columnSearchFilters.client}
                        onSearchChange={handleColumnSearchChange}
                        distinctValues={getColumnDistinctValues.client}
                        isOpen={activeFilterDropdown === 'client'}
                        onToggleDropdown={(k) =>
                          setActiveFilterDropdown(activeFilterDropdown === k ? null : k)
                        }
                        onCloseDropdown={() => setActiveFilterDropdown(null)}
                        onResize={handleMouseDownResize}
                      />

                      {/* SLA Time Left */}
                      <TableColumnHeader
                        colKey="sla"
                        label="SLA Time Left"
                        width={columnWidths.sla}
                        sortConfig={sortConfig}
                        onSort={handleSortColumn}
                        isNumericOrDate={true}
                        isOpen={activeFilterDropdown === 'sla'}
                        onToggleDropdown={(k) =>
                          setActiveFilterDropdown(activeFilterDropdown === k ? null : k)
                        }
                        onCloseDropdown={() => setActiveFilterDropdown(null)}
                        onResize={handleMouseDownResize}
                      />

                      {/* Priority */}
                      <TableColumnHeader
                        colKey="priority"
                        label="Priority"
                        width={columnWidths.priority}
                        sortConfig={sortConfig}
                        onSort={handleSortColumn}
                        selectedValues={columnFilters.priority}
                        onFilterChange={handleColumnFilterChange}
                        distinctValues={getColumnDistinctValues.priority}
                        isOpen={activeFilterDropdown === 'priority'}
                        onToggleDropdown={(k) =>
                          setActiveFilterDropdown(activeFilterDropdown === k ? null : k)
                        }
                        onCloseDropdown={() => setActiveFilterDropdown(null)}
                        onResize={handleMouseDownResize}
                      />

                      {/* Asset Tag */}
                      <TableColumnHeader
                        colKey="assetTag"
                        label="Asset Tag"
                        width={columnWidths.assetTag}
                        sortConfig={sortConfig}
                        onSort={handleSortColumn}
                        selectedValues={columnFilters.assetTag}
                        onFilterChange={handleColumnFilterChange}
                        searchValue={columnSearchFilters.assetTag}
                        onSearchChange={handleColumnSearchChange}
                        distinctValues={getColumnDistinctValues.assetTag}
                        isOpen={activeFilterDropdown === 'assetTag'}
                        onToggleDropdown={(k) =>
                          setActiveFilterDropdown(activeFilterDropdown === k ? null : k)
                        }
                        onCloseDropdown={() => setActiveFilterDropdown(null)}
                        onResize={handleMouseDownResize}
                      />

                      {/* Last Action */}
                      <TableColumnHeader
                        colKey="lastAction"
                        label="Last Action"
                        width={columnWidths.lastAction}
                        sortConfig={sortConfig}
                        onSort={handleSortColumn}
                        isNumericOrDate={true}
                        isOpen={activeFilterDropdown === 'lastAction'}
                        onToggleDropdown={(k) =>
                          setActiveFilterDropdown(activeFilterDropdown === k ? null : k)
                        }
                        onCloseDropdown={() => setActiveFilterDropdown(null)}
                        onResize={handleMouseDownResize}
                      />

                      {/* Date Created */}
                      <TableColumnHeader
                        colKey="dateCreated"
                        label="Date Created"
                        width={columnWidths.dateCreated}
                        sortConfig={sortConfig}
                        onSort={handleSortColumn}
                        isNumericOrDate={true}
                        isOpen={activeFilterDropdown === 'dateCreated'}
                        onToggleDropdown={(k) =>
                          setActiveFilterDropdown(activeFilterDropdown === k ? null : k)
                        }
                        onCloseDropdown={() => setActiveFilterDropdown(null)}
                        onResize={handleMouseDownResize}
                      />

                      {/* Staff */}
                      <TableColumnHeader
                        colKey="staff"
                        label="Staff"
                        width={columnWidths.staff}
                        sortConfig={sortConfig}
                        onSort={handleSortColumn}
                        selectedValues={columnFilters.staff}
                        onFilterChange={handleColumnFilterChange}
                        searchValue={columnSearchFilters.staff}
                        onSearchChange={handleColumnSearchChange}
                        distinctValues={getColumnDistinctValues.staff}
                        isOpen={activeFilterDropdown === 'staff'}
                        onToggleDropdown={(k) =>
                          setActiveFilterDropdown(activeFilterDropdown === k ? null : k)
                        }
                        onCloseDropdown={() => setActiveFilterDropdown(null)}
                        onResize={handleMouseDownResize}
                      />

                      {/* Issue */}
                      <TableColumnHeader
                        colKey="issue"
                        label="Issue"
                        width={columnWidths.issue}
                        sortConfig={sortConfig}
                        onSort={handleSortColumn}
                        selectedValues={columnFilters.issue}
                        onFilterChange={handleColumnFilterChange}
                        searchValue={columnSearchFilters.issue}
                        onSearchChange={handleColumnSearchChange}
                        distinctValues={getColumnDistinctValues.issue}
                        isOpen={activeFilterDropdown === 'issue'}
                        onToggleDropdown={(k) =>
                          setActiveFilterDropdown(activeFilterDropdown === k ? null : k)
                        }
                        onCloseDropdown={() => setActiveFilterDropdown(null)}
                        onResize={handleMouseDownResize}
                      />

                      {/* Issue - Detail */}
                      <TableColumnHeader
                        colKey="issueDetail"
                        label="Issue - Detail"
                        width={columnWidths.issueDetail}
                        sortConfig={sortConfig}
                        onSort={handleSortColumn}
                        selectedValues={columnFilters.issueDetail}
                        onFilterChange={handleColumnFilterChange}
                        searchValue={columnSearchFilters.issueDetail}
                        onSearchChange={handleColumnSearchChange}
                        distinctValues={getColumnDistinctValues.issueDetail}
                        isOpen={activeFilterDropdown === 'issueDetail'}
                        onToggleDropdown={(k) =>
                          setActiveFilterDropdown(activeFilterDropdown === k ? null : k)
                        }
                        onCloseDropdown={() => setActiveFilterDropdown(null)}
                        onResize={handleMouseDownResize}
                        alignRight={true}
                      />

                      {/* Resolution */}
                      <TableColumnHeader
                        colKey="resolution"
                        label="Resolution"
                        width={columnWidths.resolution}
                        sortConfig={sortConfig}
                        onSort={handleSortColumn}
                        selectedValues={columnFilters.resolution}
                        onFilterChange={handleColumnFilterChange}
                        searchValue={columnSearchFilters.resolution}
                        onSearchChange={handleColumnSearchChange}
                        distinctValues={getColumnDistinctValues.resolution}
                        isOpen={activeFilterDropdown === 'resolution'}
                        onToggleDropdown={(k) =>
                          setActiveFilterDropdown(activeFilterDropdown === k ? null : k)
                        }
                        onCloseDropdown={() => setActiveFilterDropdown(null)}
                        onResize={handleMouseDownResize}
                        alignRight={true}
                      />

                      {/* Date Closed */}
                      <TableColumnHeader
                        colKey="dateClosed"
                        label="Date Closed"
                        width={columnWidths.dateClosed}
                        sortConfig={sortConfig}
                        onSort={handleSortColumn}
                        isNumericOrDate={true}
                        isOpen={activeFilterDropdown === 'dateClosed'}
                        onToggleDropdown={(k) =>
                          setActiveFilterDropdown(activeFilterDropdown === k ? null : k)
                        }
                        onCloseDropdown={() => setActiveFilterDropdown(null)}
                        onResize={handleMouseDownResize}
                        alignRight={true}
                      />
                    </tr>
                  </thead>

                  <tbody className="divide-y divide-slate-200/80 dark:divide-slate-800/80 text-xs">
                    {isLoading && tickets.length === 0 ? (
                      <tr>
                        <td colSpan={17} className="py-12 text-center text-muted-foreground">
                          <RefreshCw className="mx-auto size-5 animate-spin mb-2" />
                          Loading support tickets...
                        </td>
                      </tr>
                    ) : paginatedTickets.length === 0 ? (
                      <tr>
                        <td colSpan={17} className="py-12 text-center text-muted-foreground">
                          <FileText className="mx-auto size-7 text-muted-foreground/50 mb-2" />
                          No tickets match the selected view criteria.
                        </td>
                      </tr>
                    ) : (
                      paginatedTickets.map((t: Ticket, idx: number) => {
                        const isSelected = selectedRowIds.has(t.id);
                        const isEven = idx % 2 === 0;
                        const staffName = t.assigneeName || 'Unassigned';
                        const isStaffAssigned = staffName !== 'Unassigned' && !staffName.toLowerCase().includes('unassigned');
                        const staffEmployee = employees.find(
                          (e) =>
                            (e.displayName && e.displayName.toLowerCase() === staffName.toLowerCase()) ||
                            (e.firstName && `${e.firstName} ${e.lastName || ''}`.trim().toLowerCase() === staffName.toLowerCase()) ||
                            (e.email && e.email.toLowerCase() === staffName.toLowerCase())
                        );
                        const staffAvatarUrl = staffEmployee?.avatar || (user && user.name?.toLowerCase() === staffName.toLowerCase() ? user.avatar : undefined);

                        return (
                          <tr
                            key={t.id}
                            onClick={() => setSelectedTicket(t)}
                            className={cn(
                              'group cursor-pointer transition-colors border-b border-slate-200/70 dark:border-slate-800/60',
                              isEven ? 'bg-white dark:bg-card hover:bg-slate-50 dark:hover:bg-slate-800/70' : 'bg-[#f4f5f7] dark:bg-slate-800/40 hover:bg-slate-100 dark:hover:bg-slate-800/90',
                              isSelected ? '!bg-blue-50/90 dark:!bg-blue-950/40 font-medium' : ''
                            )}
                          >
                            <td
                              style={{ width: `${columnWidths.select}px` }}
                              className="px-1 py-2.5 text-center overflow-hidden relative"
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* Left edge line for unread tickets: show line at left end of the row */}
                              {(t.isRead === false || t.is_read === false) && (
                                <span className="absolute left-0 top-1.5 bottom-1.5 w-1 bg-slate-800 dark:bg-slate-200 rounded-r" />
                              )}
                              <div className="flex items-center justify-center gap-1.5 pl-1.5">
                                <input
                                  type="checkbox"
                                  checked={isSelected}
                                  onChange={() => handleToggleRow(t.id)}
                                  className="size-3.5 rounded border-border cursor-pointer shrink-0"
                                />
                                {/* Flag symbol next to checkbox if flagged, or attachment icon */}
                                {(t.isFlagged || t.is_flagged) ? (
                                  <span title="Flagged" className="inline-flex shrink-0">
                                    <Flag className="size-3.5 fill-red-600 text-red-600 shrink-0" />
                                  </span>
                                ) : (t.attachments && t.attachments.some((a) => !isTicketBackupJson(a?.name || a?.filename))) ? (
                                  <span title="Attachments" className="inline-flex shrink-0">
                                    <Paperclip className="size-3.5 text-slate-400 dark:text-slate-500 shrink-0" />
                                  </span>
                                ) : (
                                  <span className="size-3.5 shrink-0" />
                                )}
                              </div>
                            </td>
                            <td className="px-3 py-2.5 overflow-hidden">
                              <StatusBadge status={t.status} />
                            </td>
                            <td className="px-3 py-2.5 font-medium text-foreground truncate overflow-hidden">
                              {t.teamName || 'Support Team'}
                            </td>
                            <td className="px-3 py-2.5 font-sans text-xs font-semibold text-foreground hover:underline truncate overflow-hidden">
                              {t.ticketId}
                            </td>
                            {/* SUBJECT */}
                            <td className="px-3 py-2.5 truncate font-medium text-foreground overflow-hidden">
                              <div className="flex items-center gap-1.5 truncate">
                                {t.source === 'System Generated' && (
                                  <span className="shrink-0 text-[10px] font-medium px-1.5 py-0.5 rounded bg-muted text-muted-foreground border border-border" title="System Generated Workflow">
                                    Sys
                                  </span>
                                )}
                                {t.isConfidential && (
                                  <span className="shrink-0 text-[10px] font-semibold px-1.5 py-0.5 rounded bg-purple-50 text-purple-700 dark:bg-purple-950/40 dark:text-purple-300 border border-purple-200" title="Confidential Request">
                                    🔒 Conf
                                  </span>
                                )}
                                <span className="truncate hover:underline text-foreground font-semibold">
                                  {t.subject}
                                </span>
                              </div>
                            </td>
                            <td className="px-3 py-2.5 capitalize text-muted-foreground truncate overflow-hidden">
                              {t.type?.replace('-', ' ')}
                            </td>
                            <td className="px-3 py-2.5 font-medium text-foreground truncate overflow-hidden">
                              {t.client || t.requesterName || 'Giri'}
                            </td>
                            <td className="px-3 py-2.5 overflow-hidden">
                              <SlaTimeLeftBadge
                                createdAt={t.createdAt}
                                slaBreach={t.slaBreach}
                                resolutionDueAt={t.resolutionDueAt}
                                status={t.status}
                                slaHold={t.slaHold || t.sla_hold}
                                slaHoldStartedAt={t.slaHoldStartedAt || t.sla_hold_started_at}
                                isSystemGenerated={t.isSystemGenerated || t.ticketTypeCode === 'SYS_GEN' || t.sourceReferenceType === 'LEAVE_REQUEST' || t.type === 'System Generated'}
                                isTriggeredByOtherApp={Boolean(
                                  t.originModule ||
                                  (t as any).origin_module ||
                                  t.primaryAssetId ||
                                  (t as any).primary_asset_id ||
                                  t.primaryAssetCode ||
                                  (t as any).primary_asset_code ||
                                  t.assetId ||
                                  (t.assetTag && t.assetTag !== '-') ||
                                  ['assets', 'asset', 'people', 'purchase_order', 'money', 'work'].includes(String(t.source || (t as any).origin_module || '').toLowerCase())
                                )}
                                firstResponseMet={Boolean(t.firstResponseMet || t.firstRespondedAt)}
                                firstRespondedAt={t.firstRespondedAt}
                              />
                            </td>
                            <td className="px-3 py-2.5 overflow-hidden">
                              <PriorityBadge priority={t.priority} />
                            </td>
                            <td className="px-3 py-2.5 font-sans text-xs font-semibold text-foreground truncate overflow-hidden">
                              {(t.isSystemGenerated || t.ticketTypeCode === 'SYS_GEN' || t.sourceReferenceType === 'LEAVE_REQUEST' || t.type === 'System Generated') ? '—' : (t.assetTag || '—')}
                            </td>
                            <td className="px-3 py-2.5 text-xs text-muted-foreground truncate overflow-hidden font-sans">
                              {formatDateTime(t.updatedAt || t.createdAt)}
                            </td>
                            {/* Date Created */}
                            <td className="px-3 py-2.5 text-xs text-muted-foreground truncate overflow-hidden font-sans">
                              {formatDateTime(t.createdAt)}
                            </td>
                            {/* Staff (Avatar + Name) */}
                            <td className="px-3 py-2.5 overflow-hidden">
                              <div className="flex items-center gap-1.5 truncate">
                                {isStaffAssigned ? (
                                  <UserAvatar
                                    name={staffName}
                                    email={staffEmployee?.email}
                                    avatarUrl={staffAvatarUrl}
                                    size="xs"
                                  />
                                ) : (
                                  <div className="flex size-5 shrink-0 items-center justify-center rounded-full text-xs font-semibold text-white bg-slate-500/60">
                                    U
                                  </div>
                                )}
                                <span className="truncate text-foreground font-medium">{staffName}</span>
                              </div>
                            </td>
                            {/* Issue */}
                            <td className="px-3 py-2.5 text-muted-foreground truncate overflow-hidden">
                              {t.category || t.teamName || 'Support Team'}
                            </td>
                            {/* Issue - Detail */}
                            <td className="px-3 py-2.5 text-muted-foreground truncate overflow-hidden">
                              {t.subcategory || 'General Issue'}
                            </td>
                            {/* Resolution */}
                            <td className="px-3 py-2.5 text-muted-foreground truncate overflow-hidden">
                              {t.resolution || '-'}
                            </td>
                            {/* Date Closed */}
                            <td className="px-3 py-2.5 text-xs text-muted-foreground truncate overflow-hidden font-sans">
                              {t.closedAt ? formatDateTime(t.closedAt) : '-'}
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            /* STACKED TILE ROW CARDS VIEW (WITH ALTERNATING WHITE/GREY BACKGROUNDS) */
            <div className="flex-1 overflow-y-auto p-4 custom-scrollbar space-y-2.5">
              {isLoading && tickets.length === 0 ? (
                <div className="py-12 text-center text-muted-foreground">
                  <RefreshCw className="mx-auto size-5 animate-spin mb-2" />
                  Loading support tickets...
                </div>
              ) : paginatedTickets.length === 0 ? (
                <div className="py-12 text-center text-muted-foreground">
                  <FileText className="mx-auto size-7 text-muted-foreground/50 mb-2" />
                  No tickets match the selected view criteria.
                </div>
              ) : (
                paginatedTickets.map((t: Ticket, idx: number) => {
                  const isBreached = t.slaBreach && new Date(t.slaBreach).getTime() < Date.now();
                  const isEven = idx % 2 === 0;

                  // Status-based accent color on the left line
                  const normStatus = (t.status || '').toLowerCase().replace(/[\s_-]+/g, '');
                  const statusBorderColor =
                    normStatus === 'closed' ? 'bg-slate-400 dark:bg-slate-500' :
                      normStatus === 'resolved' ? 'bg-emerald-500' :
                        normStatus === 'inprogress' || normStatus === 'open' || normStatus === 'investigating' ? 'bg-sky-500' :
                          normStatus === 'onhold' || normStatus === 'pending' || normStatus === 'waiting' ? 'bg-amber-500' :
                            normStatus === 'cancelled' || normStatus === 'rejected' ? 'bg-rose-500' :
                              'bg-blue-600';

                  const clientName = t.client && t.client !== '-' ? t.client : (t.requesterName || 'Internal Requester');
                  const staffName = t.assigneeName && t.assigneeName !== 'Unassigned' ? t.assigneeName : (t.teamName || 'Unassigned');
                  const isStaffAssigned = staffName !== 'Unassigned' && !staffName.toLowerCase().includes('unassigned') && !staffName.toLowerCase().includes('team');
                  const staffEmployee = employees.find(
                    (e) =>
                      (e.displayName && e.displayName.toLowerCase() === staffName.toLowerCase()) ||
                      (e.firstName && `${e.firstName} ${e.lastName || ''}`.trim().toLowerCase() === staffName.toLowerCase()) ||
                      (e.email && e.email.toLowerCase() === staffName.toLowerCase())
                  );
                  const staffAvatarUrl = staffEmployee?.avatar || (user && user.name?.toLowerCase() === staffName.toLowerCase() ? user.avatar : undefined);
                  const createdStr = formatDateTime(t.createdAt);
                  const closedStr = t.closedAt ? formatDateTime(t.closedAt) : (t.status === 'closed' || t.status === 'resolved' ? 'Resolved' : 'Active / In Progress');
                  const lastActionStr = formatDateTime(t.updatedAt || t.createdAt);

                  return (
                    <div
                      key={t.id}
                      onClick={() => setSelectedTicket(t)}
                      className={cn(
                        "group cursor-pointer rounded-xl border border-border p-4 shadow-2xs hover:shadow-md hover:border-primary/50 transition-all flex flex-col gap-3 relative overflow-hidden",
                        isEven ? "bg-card" : "bg-muted/20"
                      )}
                    >
                      {/* Left vertical status-colored accent bar */}
                      <div className={cn('absolute left-0 top-0 bottom-0 w-1.5 rounded-l-xl transition-colors', statusBorderColor)} />
                      {(t.isRead === false || t.is_read === false) && (
                        <div className="absolute left-0 top-1 bottom-1 w-1 bg-slate-800 dark:bg-slate-200 rounded-r z-10" />
                      )}

                      {/* Header Line: Status, Category, ID, Title, Type, Priority, SLA */}
                      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2.5 pl-1.5">
                        <div className="flex items-center gap-2.5 flex-wrap min-w-0">
                          {/* Info Icon & Status */}
                          <div className="flex items-center gap-1.5">
                            <Info className="size-4 text-muted-foreground shrink-0" />
                            <StatusBadge status={t.status} />
                          </div>

                          {/* Category Badge */}
                          {t.category && (
                            <span className="inline-flex rounded bg-muted text-muted-foreground px-2 py-0.5 text-xs font-semibold border border-border">
                              {t.category}
                            </span>
                          )}

                          {/* Ticket ID */}
                          <span className="font-mono text-xs font-semibold text-foreground bg-background px-2 py-0.5 rounded border border-border shadow-2xs inline-flex items-center gap-1">
                            {(t.isFlagged || t.is_flagged) && (
                              <span title="Flagged" className="inline-flex shrink-0">
                                <Flag className="size-3 fill-red-600 text-red-600 shrink-0" />
                              </span>
                            )}
                            <span>{t.ticketId || `TB#${t.id}`}</span>
                          </span>

                          {/* Origin Module & System Generated Badges */}
                          {t.source === 'System Generated' && (
                            <span className="inline-flex rounded bg-muted text-muted-foreground px-1.5 py-0.5 text-xs font-medium border border-border">
                              🤖 System
                            </span>
                          )}
                          {t.isConfidential && (
                            <span className="inline-flex rounded bg-purple-50 text-purple-700 dark:bg-purple-950/40 dark:text-purple-300 px-1.5 py-0.5 text-xs font-semibold border border-purple-200">
                              🔒 Conf
                            </span>
                          )}

                          {/* Subject / Title */}
                          <h4 className="text-submenu font-semibold text-foreground group-hover:text-primary transition-colors truncate max-w-md">
                            {t.subject}
                          </h4>
                        </div>

                        {/* Right Header Badges: Type, Priority, SLA Timer */}
                        <div className="flex items-center gap-2 shrink-0 self-end sm:self-center">
                          {/* Ticket Type */}
                          <span
                            className={cn(
                              'inline-flex items-center rounded px-2 py-0.5 text-xs font-semibold uppercase tracking-wider border',
                              t.type === 'incident' || t.type === 'inc'
                                ? 'bg-rose-50 text-rose-700 dark:bg-rose-950/40 dark:text-rose-300 border-rose-200 dark:border-rose-800/40'
                                : t.type === 'change' || t.type === 'change-requests' || t.type === 'chg' || t.type === 'chan'
                                  ? 'bg-purple-50 text-purple-700 dark:bg-purple-950/40 dark:text-purple-300 border-purple-200 dark:border-purple-800/40'
                                  : t.type?.includes('serv') || t.type === 'req'
                                    ? 'bg-blue-50 text-blue-700 dark:bg-blue-950/40 dark:text-blue-300 border-blue-200 dark:border-blue-800/40'
                                    : t.type?.includes('bug') || t.type?.includes('prob') || t.type === 'prb'
                                      ? 'bg-amber-50 text-amber-700 dark:bg-amber-950/40 dark:text-amber-300 border-amber-200 dark:border-amber-800/40'
                                      : t.type?.includes('acc')
                                        ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-300 border-emerald-200 dark:border-emerald-800/40'
                                        : t.type?.includes('feat')
                                          ? 'bg-indigo-50 text-indigo-700 dark:bg-indigo-950/40 dark:text-indigo-300 border-indigo-200 dark:border-indigo-800/40'
                                          : 'bg-slate-100 text-slate-800 dark:bg-slate-800 dark:text-slate-200 border-slate-300'
                            )}
                          >
                            {availableTicketTypes.find(at => at.value === t.type)?.label || t.type?.replace('-', ' ') || 'Incident'}
                          </span>

                          {/* SLA Timer */}
                          <SlaTimeLeftBadge
                            createdAt={t.createdAt}
                            slaBreach={t.slaBreach}
                            resolutionDueAt={t.resolutionDueAt}
                            status={t.status}
                            slaHold={t.slaHold || t.sla_hold}
                            slaHoldStartedAt={t.slaHoldStartedAt || t.sla_hold_started_at}
                            isSystemGenerated={t.isSystemGenerated || t.ticketTypeCode === 'SYS_GEN' || t.sourceReferenceType === 'LEAVE_REQUEST' || t.type === 'System Generated'}
                            isTriggeredByOtherApp={Boolean(
                              t.originModule ||
                              (t as any).origin_module ||
                              t.primaryAssetId ||
                              (t as any).primary_asset_id ||
                              t.primaryAssetCode ||
                              (t as any).primary_asset_code ||
                              t.assetId ||
                              (t.assetTag && t.assetTag !== '-') ||
                              ['assets', 'asset', 'people', 'purchase_order', 'money', 'work'].includes(String(t.source || (t as any).origin_module || '').toLowerCase())
                            )}
                            firstResponseMet={Boolean(t.firstResponseMet || t.firstRespondedAt)}
                            firstRespondedAt={t.firstRespondedAt}
                          />

                          {/* Priority */}
                          <span
                            className={cn(
                              'inline-flex items-center rounded px-1.5 py-0.5 text-xs font-semibold uppercase',
                              t.priority === 'urgent' ? 'bg-red-500/10 text-red-600 dark:text-red-400' :
                                t.priority === 'high' ? 'bg-orange-500/10 text-orange-600 dark:text-orange-400' :
                                  t.priority === 'medium' ? 'bg-amber-500/10 text-amber-600 dark:text-amber-400' :
                                    'bg-slate-500/10 text-slate-600 dark:text-slate-400'
                            )}
                          >
                            {t.priority || 'Normal'}
                          </span>
                        </div>
                      </div>

                      {/* Card Body: Description Text Snippet */}
                      <div className="pl-1.5">
                        <p className="text-xs text-muted-foreground line-clamp-2 leading-relaxed">
                          {t.description || `${t.teamName || 'Support Team'} • ${t.category || 'General Support Inquiry'}`}
                        </p>
                      </div>

                      {/* Structured Metadata Row: Client, Staff, Created, Closed, Last Action */}
                      <div className="pl-1.5 pt-2.5 border-t border-border/60 flex flex-wrap items-center justify-between gap-y-2 gap-x-4 text-xs">
                        {/* Client & Staff Group */}
                        <div className="flex items-center gap-3.5 flex-wrap">
                          {/* Client */}
                          <div className="flex items-center gap-1.5 text-foreground" title={`Client / Requester: ${clientName}`}>
                            <Building className="size-3.5 text-muted-foreground shrink-0" />
                            <span className="text-muted-foreground font-medium">Client:</span>
                            <span className="font-semibold">{clientName}</span>
                          </div>

                          {/* Staff / Assignee */}
                          <div className="flex items-center gap-1.5 text-foreground" title={`Assigned Staff: ${staffName}`}>
                            {isStaffAssigned ? (
                              <UserAvatar
                                name={staffName}
                                email={staffEmployee?.email}
                                avatarUrl={staffAvatarUrl}
                                size="xs"
                              />
                            ) : (
                              <UserCheck className="size-3.5 text-muted-foreground shrink-0" />
                            )}
                            <span className="text-muted-foreground font-medium">Staff:</span>
                            <span className="font-semibold">{staffName}</span>
                          </div>

                          {/* Impacted Asset if linked */}
                          {t.assetTag && t.assetTag !== '-' && (
                            <div className="flex items-center gap-1 text-slate-700 dark:text-slate-300 bg-muted px-2 py-0.5 rounded border border-border" title={`Asset: ${t.assetTag}`}>
                              <Box className="size-3 text-rose-500 shrink-0" />
                              <span className="font-mono font-semibold text-xs">{t.assetTag}</span>
                            </div>
                          )}
                        </div>

                        {/* Timestamps Group: Created Date, Closed Date, Last Action Date */}
                        <div className="flex items-center gap-3.5 flex-wrap text-muted-foreground">
                          {/* Created Date */}
                          <div className="flex items-center gap-1" title={`Created at ${t.createdAt}`}>
                            <Calendar className="size-3 text-muted-foreground shrink-0" />
                            <span>Created:</span>
                            <span className="font-semibold text-foreground">{createdStr}</span>
                          </div>

                          {/* Closed Date */}
                          <div className="flex items-center gap-1" title={`Closed at ${t.closedAt || 'Active'}`}>
                            <CheckCircle2 className={cn("size-3 shrink-0", t.closedAt || t.status === 'closed' || t.status === 'resolved' ? "text-emerald-500" : "text-muted-foreground/40")} />
                            <span>Closed:</span>
                            <span className={cn("font-semibold", t.closedAt || t.status === 'closed' || t.status === 'resolved' ? "text-foreground" : "text-muted-foreground italic")}>
                              {closedStr}
                            </span>
                          </div>

                          {/* Last Action Date */}
                          <div className="flex items-center gap-1" title={`Last updated at ${t.updatedAt || t.createdAt}`}>
                            <Clock className="size-3 text-muted-foreground shrink-0" />
                            <span>Last Action:</span>
                            <span className="font-semibold text-foreground">{lastActionStr}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          )}

          {/* BOTTOM TOOLBAR WITH ACTIONS & EXACT PAGINATION BAR (MATCHING SAMPLE USER SCREENSHOT) */}
          <div className="flex flex-wrap items-center justify-between gap-3 border-t border-border bg-card p-2.5 px-4 text-xs shrink-0 select-none">
            {/* Left: Rows per page selector strictly */}
            <div className="flex items-center gap-1.5 text-muted-foreground text-xs">
              <span>Rows per page:</span>
              <select
                value={rowsPerPage}
                onChange={(e) => {
                  setRowsPerPage(Number(e.target.value));
                  setPage(1);
                }}
                className="h-7 rounded border border-input bg-background px-2 text-xs font-semibold text-foreground outline-none cursor-pointer"
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={200}>200</option>
              </select>
            </div>

            {/* Right: Exact Pagination Controls matching sample image: |◄  ◄  [ 1 ] to X of Y  ►  ►| */}
            <div className="flex items-center gap-1.5 text-xs font-semibold">
              <button
                disabled={currentPage <= 1}
                onClick={() => setPage(1)}
                className="px-1.5 py-0.5 rounded hover:bg-muted disabled:opacity-30 transition-colors font-mono text-xs cursor-pointer"
                title="First Page"
              >
                |◄
              </button>
              <button
                disabled={currentPage <= 1}
                onClick={() => setPage(currentPage - 1)}
                className="px-1.5 py-0.5 rounded hover:bg-muted disabled:opacity-30 transition-colors font-mono text-xs cursor-pointer"
                title="Previous Page"
              >
                ◄
              </button>

              <span className="flex items-center gap-1 mx-1 text-muted-foreground font-medium text-xs">
                <input
                  type="number"
                  min={1}
                  max={totalPages}
                  value={currentPage}
                  onChange={(e) => {
                    const p = parseInt(e.target.value, 10);
                    if (!isNaN(p) && p >= 1 && p <= totalPages) {
                      setPage(p);
                    }
                  }}
                  className="w-10 h-6 text-center border border-input rounded bg-background font-semibold text-foreground text-xs outline-none"
                />
                <span>to {endIndex > 0 ? endIndex - startIndex : 0} of {totalItems.toLocaleString()}</span>
              </span>

              <button
                disabled={currentPage >= totalPages}
                onClick={() => setPage(currentPage + 1)}
                className="px-1.5 py-0.5 rounded hover:bg-muted disabled:opacity-30 transition-colors font-mono text-xs cursor-pointer"
                title="Next Page"
              >
                ►
              </button>
              <button
                disabled={currentPage >= totalPages}
                onClick={() => setPage(totalPages)}
                className="px-1.5 py-0.5 rounded hover:bg-muted disabled:opacity-30 transition-colors font-mono text-xs cursor-pointer"
                title="Last Page"
              >
                ►|
              </button>
            </div>
          </div>
        </main>
      )}

      {/* BULK ACTION INPUT DIALOG MODAL (RIGHT SLIDE-OVER DRAWER) */}
      {bulkActionModal && (
        <div className="fixed inset-0 top-14 z-50 flex justify-end bg-black/40 backdrop-blur-2xs animate-in fade-in">
          <div className="w-full max-w-lg bg-card border-l border-border h-full flex flex-col p-6 shadow-2xl space-y-6 animate-in slide-in-from-right duration-200 overflow-y-auto">
            {/* Header: Title and X close button */}
            <div className="flex items-center justify-between">
              <h3 className="text-xl font-normal text-slate-900 dark:text-slate-100">
                {bulkActionModal === 'status' ? 'Change Status' :
                  bulkActionModal === 'priority' ? 'Change Priority' :
                    bulkActionModal === 'type' ? 'Change Ticket Type' :
                      bulkActionModal === 'category' ? 'Change Category' :
                        bulkActionModal === 'reassign' ? 'Re-assign' :
                          bulkActionModal === 'siteUser' ? 'Change Enduser' :
                            bulkActionModal === 'link' ? 'Link Ticket(s)' :
                              bulkActionModal === 'merge' ? 'Merge Ticket(s)' : 'Bulk Action'}
              </h3>
              <button
                type="button"
                onClick={() => {
                  setBulkActionModal(null);
                  setBulkInputValue('');
                  setReassignTeam('');
                  setReassignStaff('');
                }}
                className="rounded-full p-1 text-slate-400 hover:text-slate-600 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors cursor-pointer"
              >
                <X className="size-5 stroke-[1.75]" />
              </button>
            </div>

            {/* Field Label and Styled Input with vertical divider and chevron matching screenshot */}
            <div className="space-y-4">
              {bulkActionModal !== 'reassign' && (
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-slate-700 dark:text-slate-300">
                    {bulkActionModal === 'status' ? 'Status' :
                      bulkActionModal === 'priority' ? 'Priority' :
                        bulkActionModal === 'type' ? 'Ticket Type' :
                          bulkActionModal === 'category' ? 'Category' :
                            bulkActionModal === 'siteUser' ? 'End User' : 'Target Ticket ID'} <span className="text-rose-500 font-semibold">*</span>
                  </label>

                  {bulkActionModal === 'status' && (
                    <div className="relative flex items-center rounded-lg border border-slate-300 dark:border-slate-700 bg-white dark:bg-card shadow-2xs">
                      <select
                        value={bulkInputValue || 'in-progress'}
                        onChange={(e) => setBulkInputValue(e.target.value)}
                        className="w-full h-11 appearance-none bg-transparent px-3 text-sm text-slate-800 dark:text-slate-100 outline-none cursor-pointer pr-12 font-normal"
                      >
                        <option value="in-progress">In Progress</option>
                        <option value="new">New</option>
                        <option value="pending">Pending</option>
                        <option value="with-user">With User</option>
                        <option value="with-supplier">With Supplier</option>
                        <option value="on-hold">On Hold</option>
                        <option value="awaiting-approval">Awaiting Approval</option>
                        <option value="with-management">With Management</option>
                        <option value="with-hr">With HR</option>
                        <option value="resolved">Resolved</option>
                        <option value="closed">Closed</option>
                      </select>
                      <div className="pointer-events-none absolute right-0 top-0 bottom-0 flex items-center pr-3 pl-3 border-l border-slate-300 dark:border-slate-700">
                        <ChevronDown className="size-4 text-slate-400 stroke-[1.75]" />
                      </div>
                    </div>
                  )}

                  {bulkActionModal === 'priority' && (
                    <div className="relative flex items-center rounded-lg border border-slate-300 dark:border-slate-700 bg-white dark:bg-card shadow-2xs">
                      <select
                        value={bulkInputValue || 'P4 - Functionality fault (playback not affected)'}
                        onChange={(e) => setBulkInputValue(e.target.value)}
                        className="w-full h-11 appearance-none bg-transparent px-3 text-sm text-slate-800 dark:text-slate-100 outline-none cursor-pointer pr-12 font-normal"
                      >
                        <option value="P4 - Functionality fault (playback not affected)">P4 - Functionality fault (playback not affected)</option>
                        <option value="P3 - Medium impact / Degraded service">P3 - Medium impact / Degraded service</option>
                        <option value="P2 - High impact fault">P2 - High impact fault</option>
                        <option value="P1 - Critical / Business outage">P1 - Critical / Business outage</option>
                        <option value="urgent">Critical</option>
                        <option value="high">High</option>
                        <option value="medium">Medium</option>
                        <option value="low">Low</option>
                      </select>
                      <div className="pointer-events-none absolute right-0 top-0 bottom-0 flex items-center pr-3 pl-3 border-l border-slate-300 dark:border-slate-700">
                        <ChevronDown className="size-4 text-slate-400 stroke-[1.75]" />
                      </div>
                    </div>
                  )}

                  {bulkActionModal === 'type' && (
                    <div className="relative flex items-center rounded-lg border border-slate-300 dark:border-slate-700 bg-white dark:bg-card shadow-2xs">
                      <select
                        value={bulkInputValue || (availableTicketTypes[0]?.value || 'incident')}
                        onChange={(e) => setBulkInputValue(e.target.value)}
                        className="w-full h-11 appearance-none bg-transparent px-3 text-sm text-slate-800 dark:text-slate-100 outline-none cursor-pointer pr-12 font-normal"
                      >
                        {availableTicketTypes.map((tt) => (
                          <option key={tt.value} value={tt.value}>
                            {tt.label} {tt.code ? `(${tt.code})` : ''}
                          </option>
                        ))}
                      </select>
                      <div className="pointer-events-none absolute right-0 top-0 bottom-0 flex items-center pr-3 pl-3 border-l border-slate-300 dark:border-slate-700">
                        <ChevronDown className="size-4 text-slate-400 stroke-[1.75]" />
                      </div>
                    </div>
                  )}

                  {bulkActionModal === 'category' && (
                    <div className="relative flex items-center rounded-lg border border-slate-300 dark:border-slate-700 bg-white dark:bg-card shadow-2xs">
                      <select
                        value={bulkInputValue || (ticketCategories && ticketCategories.length > 0 ? ticketCategories[0].name : 'Laptops')}
                        onChange={(e) => setBulkInputValue(e.target.value)}
                        className="w-full h-11 appearance-none bg-transparent px-3 text-sm text-slate-800 dark:text-slate-100 outline-none cursor-pointer pr-12 font-normal"
                      >
                        {ticketCategories && ticketCategories.length > 0 ? (
                          ticketCategories.map((cat: any) => (
                            <option key={cat.id || cat.name} value={cat.name}>
                              {cat.name}
                            </option>
                          ))
                        ) : (
                          <>
                            <option value="Laptops">Laptops</option>
                            <option value="Desktops & Workstations">Desktops & Workstations</option>
                            <option value="Monitors & Displays">Monitors & Displays</option>
                            <option value="Servers & Compute">Servers & Compute</option>
                            <option value="Networking & Security">Networking & Security</option>
                            <option value="Mobile Devices & Tablets">Mobile Devices & Tablets</option>
                            <option value="Audio & Video Peripherals">Audio & Video Peripherals</option>
                            <option value="Storage & NAS">Storage & NAS</option>
                            <option value="Cloud Infrastructure">Cloud Infrastructure</option>
                            <option value="Printers & Facilities">Printers & Facilities</option>
                          </>
                        )}
                      </select>
                      <div className="pointer-events-none absolute right-0 top-0 bottom-0 flex items-center pr-3 pl-3 border-l border-slate-300 dark:border-slate-700">
                        <ChevronDown className="size-4 text-slate-400 stroke-[1.75]" />
                      </div>
                    </div>
                  )}

                  {bulkActionModal === 'siteUser' && (
                    <div className="relative flex items-center rounded-lg border border-slate-300 dark:border-slate-700 bg-white dark:bg-card shadow-2xs">
                      <select
                        value={bulkInputValue || (combinedEndUsers && combinedEndUsers.length > 0 ? String(combinedEndUsers[0].id || combinedEndUsers[0].employeeId) : (employees[0]?.id || ''))}
                        onChange={(e) => setBulkInputValue(e.target.value)}
                        className="w-full h-11 appearance-none bg-transparent px-3 text-sm text-slate-800 dark:text-slate-100 outline-none cursor-pointer pr-12 font-normal"
                      >
                        <option value="">-- Select End User --</option>
                        {(combinedEndUsers && combinedEndUsers.length > 0 ? combinedEndUsers : employees).map((eu: any) => (
                          <option key={eu.id || eu.employeeId} value={eu.id || eu.employeeId}>
                            {eu.name || eu.displayName || `${eu.firstName || ''} ${eu.lastName || ''}`.trim()} {eu.email ? `(${eu.email})` : ''}
                          </option>
                        ))}
                      </select>
                      <div className="pointer-events-none absolute right-0 top-0 bottom-0 flex items-center pr-3 pl-3 border-l border-slate-300 dark:border-slate-700">
                        <ChevronDown className="size-4 text-slate-400 stroke-[1.75]" />
                      </div>
                    </div>
                  )}

                  {(bulkActionModal === 'link' || bulkActionModal === 'merge') && (
                    <div className="relative flex items-center rounded-lg border border-slate-300 dark:border-slate-700 bg-white dark:bg-card shadow-2xs">
                      <input
                        type="text"
                        value={bulkInputValue}
                        onChange={(e) => setBulkInputValue(e.target.value)}
                        placeholder="e.g. INC-00042 or TB#10"
                        className="w-full h-11 bg-transparent px-3 text-sm text-slate-800 dark:text-slate-100 outline-none font-normal"
                      />
                    </div>
                  )}
                </div>
              )}

              {/* RE-ASSIGN MODAL: TEAM DROPDOWN, THEN STAFF DROPDOWN DYNAMICALLY FILTERED */}
              {bulkActionModal === 'reassign' && (
                <div className="space-y-4">
                  {/* 1. Team Dropdown */}
                  <div className="space-y-1.5">
                    <label className="block text-sm font-medium text-slate-700 dark:text-slate-300">
                      Team <span className="text-rose-500 font-semibold">*</span>
                    </label>
                    <div className="relative flex items-center rounded-lg border border-slate-300 dark:border-slate-700 bg-white dark:bg-card shadow-2xs">
                      <select
                        value={reassignTeam}
                        onChange={(e) => {
                          const newTeam = e.target.value;
                          setReassignTeam(newTeam);
                          setReassignStaff('');
                        }}
                        className="w-full h-11 appearance-none bg-transparent px-3 text-sm text-slate-800 dark:text-slate-100 outline-none cursor-pointer pr-12 font-normal"
                      >
                        <option value="">-- Select Team --</option>
                        {availableTeamsList.map((tm) => (
                          <option key={tm.key} value={tm.key}>
                            {tm.label}
                          </option>
                        ))}
                      </select>
                      <div className="pointer-events-none absolute right-0 top-0 bottom-0 flex items-center pr-3 pl-3 border-l border-slate-300 dark:border-slate-700">
                        <ChevronDown className="size-4 text-slate-400 stroke-[1.75]" />
                      </div>
                    </div>
                  </div>

                  {/* 2. Staff Dropdown */}
                  <div className="space-y-1.5">
                    <div className="flex items-center justify-between">
                      <label className="block text-sm font-medium text-slate-700 dark:text-slate-300">
                        Staff
                      </label>
                      <span className="text-xs text-slate-400 dark:text-slate-500">
                        {reassignTeam ? '(Optional - leave blank for Team Queue)' : '(Select Team first or choose Staff directly)'}
                      </span>
                    </div>
                    <div className="relative flex items-center rounded-lg border border-slate-300 dark:border-slate-700 bg-white dark:bg-card shadow-2xs">
                      <select
                        value={reassignStaff}
                        onChange={(e) => {
                          const staffId = e.target.value;
                          setReassignStaff(staffId);
                          if (staffId && !reassignTeam) {
                            const emp = employees.find((em) => String(em.id) === String(staffId));
                            if (emp && emp.department) {
                              const deptLower = emp.department.toLowerCase();
                              const matchedTm = availableTeamsList.find(
                                (t) => t.key.toLowerCase() === deptLower || t.label.toLowerCase() === deptLower
                              );
                              if (matchedTm) {
                                setReassignTeam(matchedTm.key);
                              }
                            }
                          }
                        }}
                        className="w-full h-11 appearance-none bg-transparent px-3 text-sm text-slate-800 dark:text-slate-100 outline-none cursor-pointer pr-12 font-normal"
                      >
                        <option value="">
                          {reassignTeam ? '-- Select Staff Member (or leave blank for Team Queue) --' : '-- Select Staff Member --'}
                        </option>
                        {filteredEmployeesForReassign.map((emp) => (
                          <option key={emp.id} value={emp.id}>
                            {emp.displayName || `${emp.firstName} ${emp.lastName}`.trim()} {emp.department ? `(${emp.department})` : ''}
                          </option>
                        ))}
                      </select>
                      <div className="pointer-events-none absolute right-0 top-0 bottom-0 flex items-center pr-3 pl-3 border-l border-slate-300 dark:border-slate-700">
                        <ChevronDown className="size-4 text-slate-400 stroke-[1.75]" />
                      </div>
                    </div>
                    {reassignTeam && filteredEmployeesForReassign.length === 0 && (
                      <p className="text-xs text-amber-600 dark:text-amber-400">
                        No individual staff members found for this team. Ticket will be routed to the team queue.
                      </p>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* Action Buttons: Centered Save and Cancel Pill Buttons matching screenshot */}
            <div className="flex items-center justify-center gap-3.5 pt-4 pb-1">
              <button
                type="button"
                onClick={() => {
                  if (bulkActionModal === 'reassign') {
                    if (!reassignTeam && !reassignStaff) {
                      toast.error('Please select a Team or a Staff member to re-assign');
                      return;
                    }
                    const payload = JSON.stringify({ team: reassignTeam, staff: reassignStaff });
                    handleExecuteBulkAction('reassign', payload);
                    setBulkActionModal(null);
                    setBulkInputValue('');
                    setReassignTeam('');
                    setReassignStaff('');
                    return;
                  }

                  let val = bulkInputValue;
                  if (!val) {
                    if (bulkActionModal === 'status') val = 'in-progress';
                    else if (bulkActionModal === 'priority') val = 'P4 - Functionality fault (playback not affected)';
                    else if (bulkActionModal === 'type') val = availableTicketTypes[0]?.value || 'incident';
                    else if (bulkActionModal === 'category') val = (ticketCategories && ticketCategories.length > 0 ? ticketCategories[0].name : 'Laptops');
                    else if (bulkActionModal === 'siteUser') val = combinedEndUsers[0]?.id || combinedEndUsers[0]?.employeeId || employees[0]?.id || '';
                  }
                  const action =
                    bulkActionModal === 'status' ? 'changeStatus' :
                      bulkActionModal === 'priority' ? 'changePriority' :
                        bulkActionModal === 'category' ? 'changeCategory' :
                          bulkActionModal === 'link' ? 'link' :
                            bulkActionModal === 'merge' ? 'merge' :
                              bulkActionModal === 'type' ? 'changeType' :
                                bulkActionModal === 'siteUser' ? 'changeSiteUser' : 'read';

                  handleExecuteBulkAction(action, val);
                  setBulkActionModal(null);
                  setBulkInputValue('');
                  setReassignTeam('');
                  setReassignStaff('');
                }}
                className="min-w-[104px] rounded-full bg-primary hover:bg-primary/90 text-primary-foreground px-7 py-2 text-sm font-medium shadow-xs transition-colors cursor-pointer"
              >
                Save
              </button>
              <button
                type="button"
                onClick={() => {
                  setBulkActionModal(null);
                  setBulkInputValue('');
                  setReassignTeam('');
                  setReassignStaff('');
                }}
                className="min-w-[104px] rounded-full border border-slate-300 dark:border-slate-700 bg-white dark:bg-card text-slate-800 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 px-7 py-2 text-sm font-medium shadow-xs transition-colors cursor-pointer"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ═══════════════════════════════════════════════════════════════ */}
      {/* EMAIL PREVIEW MODAL (MATCHING IMAGE 4: media_1789875257743.png) */}
      {/* ═══════════════════════════════════════════════════════════════ */}
      {emailPreviewData?.isOpen && selectedTicket && (
        <div className="fixed inset-0 top-14 z-50 flex justify-end bg-black/40 backdrop-blur-2xs animate-in fade-in">
          <div className="w-full max-w-4xl xl:max-w-5xl bg-card border-l border-border h-full flex flex-col shadow-2xl animate-in slide-in-from-right duration-200 overflow-hidden">
            {/* 1. TOP HEADER & BADGE */}
            <div className="bg-background/95 border-b border-border px-6 pt-5 pb-0">
              <div className="flex items-center justify-between pb-3">
                <div className="flex items-center gap-2.5">
                  {renderCurrentUserAvatar("size-8", "text-xs")}
                  <h2 className="font-display text-section-title text-foreground">
                    {emailPreviewData.actionLabel}
                  </h2>
                </div>
                <button
                  type="button"
                  onClick={() => setEmailPreviewData(null)}
                  className="rounded-full p-1 text-muted-foreground hover:text-foreground hover:bg-muted transition-colors cursor-pointer"
                  title="Close preview"
                >
                  <X className="size-4" />
                </button>
              </div>

              {/* TABS: Email | Action details */}
              <div className="flex items-center gap-6 text-xs font-semibold">
                <button
                  type="button"
                  onClick={() => setEmailPreviewData({ ...emailPreviewData, activeTab: 'email' })}
                  className={cn(
                    "pb-2.5 transition-colors cursor-pointer relative",
                    emailPreviewData.activeTab === 'email'
                      ? "text-blue-600 dark:text-blue-400 font-semibold after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:bg-blue-600 dark:after:bg-blue-400"
                      : "text-muted-foreground hover:text-foreground"
                  )}
                >
                  Email
                </button>
                <button
                  type="button"
                  onClick={() => setEmailPreviewData({ ...emailPreviewData, activeTab: 'details' })}
                  className={cn(
                    "pb-2.5 transition-colors cursor-pointer relative",
                    emailPreviewData.activeTab === 'details'
                      ? "text-blue-600 dark:text-blue-400 font-semibold after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:bg-blue-600 dark:after:bg-blue-400"
                      : "text-muted-foreground hover:text-foreground"
                  )}
                >
                  Action details
                </button>
              </div>
            </div>

            {/* 2. TAB BODY CONTENT */}
            <div className="flex-1 overflow-y-auto p-6 text-xs space-y-4 bg-background/50">
              {emailPreviewData.activeTab === 'email' && (
                <div className="space-y-4 rounded-xl border border-border bg-card p-6 shadow-xs">
                  {/* Meta Table */}
                  <div className="space-y-2 border-b border-border pb-4 text-xs font-sans">
                    <div className="grid grid-cols-[100px_1fr] items-center gap-2">
                      <span className="font-medium text-muted-foreground">From:</span>
                      <div className="flex items-center gap-2 flex-wrap">
                        {emailPreviewData.from ? (
                          <>
                            <span className="font-semibold text-foreground">{emailPreviewData.from}</span>
                            {activeSupportSender.isConfigured && (
                              <span className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border border-emerald-500/20">
                                {activeSupportSender.badgeLabel}
                              </span>
                            )}
                          </>
                        ) : activeSupportSender.isConfigured ? (
                          <>
                            <span className="font-semibold text-foreground">{activeSupportSender.displayFrom}</span>
                            <span className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border border-emerald-500/20">
                              {activeSupportSender.badgeLabel}
                            </span>
                          </>
                        ) : (
                          <div className="flex items-center gap-2">
                            <span className="font-medium text-muted-foreground italic">(blank)</span>
                            <span className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-amber-500/10 text-amber-600 dark:text-amber-400 border border-amber-500/20">
                              Mail not configured
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="grid grid-cols-[100px_1fr] items-center gap-2">
                      <span className="font-medium text-muted-foreground">To:</span>
                      <span className="font-medium text-foreground">{emailPreviewData.to || selectedTicket.requesterEmail || 'Not set'}</span>
                    </div>
                    <div className="grid grid-cols-[100px_1fr] items-center gap-2">
                      <span className="font-medium text-muted-foreground">Cc:</span>
                      <span className="text-muted-foreground">{emailPreviewData.cc || 'Not set'}</span>
                    </div>
                    <div className="grid grid-cols-[100px_1fr] items-center gap-2">
                      <span className="font-medium text-muted-foreground">Bcc:</span>
                      <span className="text-muted-foreground">{emailPreviewData.bcc || 'Not set'}</span>
                    </div>
                    <div className="grid grid-cols-[100px_1fr] items-center gap-2">
                      <span className="font-medium text-muted-foreground">Subject:</span>
                      <span className="font-semibold text-foreground">{emailPreviewData.subject}</span>
                    </div>
                  </div>

                  {/* DYNAMIC EMAIL TEMPLATE PREVIEW (SYNCED WITH TEMPLATES BUILDER) */}
                  <div className="w-full max-w-3xl lg:max-w-4xl mx-auto rounded-xl border border-border bg-white shadow-sm overflow-hidden my-3">
                    <iframe
                      title="Outbound Email Preview"
                      sandbox="allow-same-origin"
                      srcDoc={renderedEmailPreviewHtml}
                      className="w-full border-0 bg-white"
                      style={{ minHeight: '520px', height: '100%', width: '100%' }}
                    />
                  </div>

                  {/* Attachments Preview if staged */}
                  {emailPreviewData.attachments && emailPreviewData.attachments.length > 0 && (
                    <div className="border-t border-border pt-3 space-y-1.5">
                      <span className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">
                        Attachments ({emailPreviewData.attachments.length}):
                      </span>
                      <div className="flex flex-wrap gap-2">
                        {emailPreviewData.attachments.map((att) => (
                          <span
                            key={att.id}
                            className="inline-flex items-center gap-1.5 rounded-lg border border-border bg-muted/40 px-2.5 py-1 text-xs font-medium text-foreground"
                          >
                            <Paperclip className="size-3 text-muted-foreground" />
                            <span>{att.name}</span>
                            <span className="text-xs text-muted-foreground">({att.size})</span>
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* ACTION DETAILS TAB */}
              {emailPreviewData.activeTab === 'details' && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 rounded-xl border border-border bg-card p-5 shadow-xs">
                  <div className="space-y-1">
                    <span className="text-xs font-semibold text-muted-foreground uppercase">Target Status</span>
                    <p className="text-xs font-semibold text-foreground capitalize">{emailPreviewData.status.replace('-', ' ')}</p>
                  </div>
                  <div className="space-y-1">
                    <span className="text-xs font-semibold text-muted-foreground uppercase">Target Team</span>
                    <p className="text-xs font-semibold text-foreground">{emailPreviewData.team || selectedTicket.teamName || '-'}</p>
                  </div>
                  <div className="space-y-1">
                    <span className="text-xs font-semibold text-muted-foreground uppercase">Target Staff</span>
                    <p className="text-xs font-semibold text-foreground">{emailPreviewData.staff || selectedTicket.assigneeName || '-'}</p>
                  </div>
                  <div className="space-y-1">
                    <span className="text-xs font-semibold text-muted-foreground uppercase">Next Update</span>
                    <p className="text-xs font-semibold text-foreground">{emailPreviewData.nextUpdate ? formatDateTime(emailPreviewData.nextUpdate) : 'Not scheduled'}</p>
                  </div>
                  <div className="space-y-1">
                    <span className="text-xs font-semibold text-muted-foreground uppercase">Issue Category</span>
                    <p className="text-xs font-semibold text-foreground">{emailPreviewData.issue || '-'}</p>
                  </div>
                  <div className="space-y-1">
                    <span className="text-xs font-semibold text-muted-foreground uppercase">Issue Detail</span>
                    <p className="text-xs font-semibold text-foreground">{emailPreviewData.issueDetail || '-'}</p>
                  </div>
                  <div className="space-y-1 md:col-span-2">
                    <span className="text-xs font-semibold text-muted-foreground uppercase">Current Action</span>
                    <p className="text-xs font-semibold text-foreground">{emailPreviewData.currentAction || '-'}</p>
                  </div>
                  <div className="space-y-1 md:col-span-2">
                    <span className="text-xs font-semibold text-muted-foreground uppercase">Linked Assets</span>
                    <div className="flex flex-wrap gap-1.5 pt-1">
                      {emailPreviewData.assets.length === 0 ? (
                        <span className="text-xs text-muted-foreground italic">None linked</span>
                      ) : (
                        emailPreviewData.assets.map((ast, i) => (
                          <span key={i} className="inline-flex items-center gap-1 rounded bg-rose-50 dark:bg-rose-950/40 border border-rose-200 dark:border-rose-800/50 px-2 py-0.5 text-xs font-semibold text-rose-700 dark:text-rose-300">
                            <Box className="size-3 text-rose-600" />
                            {ast}
                          </span>
                        ))
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* 3. FOOTER ACTIONS: SEND & CLOSE */}
            <div className="flex items-center justify-end gap-3 border-t border-border bg-background px-6 py-3.5">
              <button
                type="button"
                onClick={handleConfirmSendEmail}
                disabled={isSendingEmail}
                className="rounded-lg bg-primary text-primary-foreground font-semibold px-6 py-2 text-xs shadow-xs hover:bg-primary/90 active:scale-95 transition-all disabled:opacity-50 cursor-pointer flex items-center gap-2"
              >
                {isSendingEmail ? (
                  <>
                    <RefreshCw className="size-3.5 animate-spin" />
                    <span>Sending...</span>
                  </>
                ) : (
                  <span>Send</span>
                )}
              </button>
              <button
                type="button"
                onClick={() => setEmailPreviewData(null)}
                disabled={isSendingEmail}
                className="rounded-lg border border-border bg-background px-5 py-2 text-xs font-semibold text-foreground hover:bg-muted active:scale-95 transition-all cursor-pointer"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ACTION MODALS (RIGHT SLIDE-OVER DRAWER) */}
      {activeActionModal && selectedTicket && (
        <div className="fixed inset-0 top-14 z-50 flex justify-end bg-black/40 backdrop-blur-2xs animate-in fade-in">
          <div className="w-full max-w-lg bg-card border-l border-border h-full flex flex-col p-5 shadow-2xl space-y-3.5 animate-in slide-in-from-right duration-200 overflow-y-auto">
            <div className="flex items-center justify-between border-b border-border pb-2.5">
              <h3 className="font-display text-card-title text-foreground capitalize">
                {activeActionModal.replace(/([A-Z])/g, ' $1')} - [{selectedTicket.ticketId}]
              </h3>
              <button onClick={() => setActiveActionModal(null)} className="rounded-lg p-1 hover:bg-accent text-muted-foreground">
                <X className="size-4" />
              </button>
            </div>

            <form onSubmit={handleActionModalSubmit} className="space-y-3 text-xs">
              {activeActionModal === 'emailUser' && (
                <>
                  <div>
                    <label className="font-semibold text-foreground">To Email</label>
                    <input
                      type="email"
                      required
                      value={actionInput.to || selectedTicket.requesterEmail || ''}
                      onChange={(e) => setActionInput({ ...actionInput, to: e.target.value })}
                      className="mt-1 h-8 w-full rounded-md border border-input bg-background px-2.5 text-xs text-foreground outline-none focus:ring-1 focus:ring-ring"
                    />
                  </div>
                  <div>
                    <label className="font-semibold text-foreground">Message Body</label>
                    <textarea
                      rows={10}
                      required
                      placeholder="Write response email to user..."
                      value={actionInput.body}
                      onChange={(e) => setActionInput({ ...actionInput, body: e.target.value })}
                      className="mt-1 w-full rounded-md border border-input bg-background p-2.5 text-xs text-foreground outline-none focus:ring-1 focus:ring-ring min-h-[220px]"
                    />
                  </div>
                </>
              )}

              {activeActionModal === 'escalate' && (
                <>
                  <div>
                    <label className="font-semibold text-foreground">Escalate to Team</label>
                    <select
                      value={actionInput.teamKey}
                      onChange={(e) => setActionInput({ ...actionInput, teamKey: e.target.value })}
                      className="mt-1 h-8 w-full rounded-md border border-input bg-background px-2 text-xs text-foreground outline-none focus:ring-1 focus:ring-ring"
                    >
                      {filteredStoreQueues && filteredStoreQueues.length > 0 ? (
                        filteredStoreQueues.map((q) => (
                          <option key={q.id || q.key} value={q.key || q.id}>
                            {q.label || q.key}
                          </option>
                        ))
                      ) : (
                        <option value="support">Support Team</option>
                      )}
                    </select>
                  </div>
                  <div>
                    <label className="font-semibold text-foreground">Escalation Reason / Note</label>
                    <textarea
                      rows={3}
                      required
                      placeholder="Reason for escalation..."
                      value={actionInput.note}
                      onChange={(e) => setActionInput({ ...actionInput, note: e.target.value })}
                      className="mt-1 w-full rounded-md border border-input bg-background p-2.5 text-xs text-foreground outline-none focus:ring-1 focus:ring-ring"
                    />
                  </div>
                </>
              )}

              {activeActionModal !== 'emailUser' && activeActionModal !== 'escalate' && (
                <div>
                  <label className="font-semibold text-foreground">
                    {activeActionModal === 'logSupplier' && 'Supplier Communication / Log'}
                    {activeActionModal === 'internalNote' && 'Internal Team Note'}
                    {activeActionModal === 'privateNote' && 'Private Investigation Note'}
                    {activeActionModal === 'noteEmail' && 'Update Note (Dispatched to User)'}
                    {activeActionModal === 'approval' && 'Approval Request Details'}
                    {activeActionModal === 'close' && 'Final Resolution Note & Summary'}
                    {activeActionModal.toLowerCase().includes('resolve') && 'Resolution Summary / Note'}
                    {activeActionModal.toLowerCase().includes('reopen') && 'Reason for Reopening Ticket'}
                    {activeActionModal.toLowerCase().includes('hold') && 'Reason for Putting on Hold'}
                    {!['logSupplier', 'internalNote', 'privateNote', 'noteEmail', 'approval', 'close'].includes(activeActionModal) &&
                      !activeActionModal.toLowerCase().includes('resolve') &&
                      !activeActionModal.toLowerCase().includes('reopen') &&
                      !activeActionModal.toLowerCase().includes('hold') &&
                      `${activeActionModal} Note & Comments`}
                  </label>
                  <textarea
                    rows={4}
                    required
                    placeholder="Enter details..."
                    value={actionInput.note}
                    onChange={(e) => setActionInput({ ...actionInput, note: e.target.value })}
                    className="mt-1 w-full rounded-md border border-input bg-background p-2.5 text-xs text-foreground outline-none focus:ring-1 focus:ring-ring"
                  />
                </div>
              )}
            </form>

            <div className="flex items-center justify-end gap-2 border-t border-border bg-muted/40 px-4 py-3">
              <button
                type="button"
                onClick={() => setActiveActionModal(null)}
                className="rounded-md border border-border px-3 py-1.5 text-xs font-semibold text-muted-foreground hover:bg-muted"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleActionModalSubmit}
                className="rounded-md bg-primary px-4 py-1.5 text-xs font-semibold text-primary-foreground hover:bg-primary/90"
              >
                Confirm Action
              </button>
            </div>
          </div>
        </div>
      )}

      {/* CREATE TICKET MODAL (RIGHT SLIDE-OVER DRAWER) */}
      {isCreateModalOpen && (
        <div className="fixed inset-0 top-14 z-50 flex justify-end bg-black/40 backdrop-blur-2xs animate-in fade-in overflow-hidden">
          <div className="w-full max-w-3xl xl:max-w-4xl bg-card border-l border-border h-full flex flex-col p-6 shadow-2xl space-y-4 animate-in slide-in-from-right duration-200 overflow-hidden text-xs">
            {/* Header */}
            <div className="flex items-center justify-between pb-3 border-b border-slate-200 dark:border-slate-800">
              <div className="flex items-center gap-2">
                <TicketIcon className="size-4 text-primary" />
                <h3 className="text-sm font-semibold text-slate-900 dark:text-white">New Ticket</h3>
              </div>
              <button
                type="button"
                onClick={handleCloseCreateModal}
                className="text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 p-1 rounded-md hover:bg-slate-100 dark:hover:bg-slate-800 cursor-pointer transition-colors"
              >
                <X className="size-4" />
              </button>
            </div>

            {/* Scrollable Form Body */}
            <form onSubmit={handleCreateSubmit} className="flex-1 overflow-y-auto pr-1 mt-4 space-y-4 custom-scrollbar">
              {/* 1. TOP ROW: End-User (Left) | Ticket Type (Center) | Team (Right) */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {/* End-User (Left - All employees from Employee module / support.end_users, defaulting to active user) */}
                <div className="space-y-1">
                  <label className="font-semibold text-slate-800 dark:text-slate-200 block text-xs">
                    End-User <span className="text-rose-500">*</span>
                  </label>
                  <div className="relative">
                    <select
                      value={newForm.requesterId || (combinedEndUsers.find(e => e.name === newForm.client || e.name === newForm.requesterName)?.id) || ''}
                      onChange={(e) => {
                        const empId = e.target.value;
                        const emp = combinedEndUsers.find((x) => String(x.id) === String(empId) || String(x.employeeId) === String(empId));
                        if (emp) {
                          setNewForm((prev) => ({
                            ...prev,
                            requesterId: String(emp.id),
                            requesterName: emp.name,
                            client: emp.name,
                            requesterEmail: emp.email || '',
                            requesterDepartment: emp.department || '',
                            requesterDesignation: emp.designation || '',
                            requesterPhone: emp.phone || '',
                          }));
                        }
                      }}
                      className="h-10 w-full appearance-none rounded-md border border-slate-200 bg-white px-3 pr-8 text-xs font-semibold text-slate-900 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary dark:border-slate-700 dark:bg-slate-800 dark:text-white cursor-pointer shadow-2xs"
                    >
                      {combinedEndUsers && combinedEndUsers.length > 0 ? (
                        combinedEndUsers.map((emp) => (
                          <option key={emp.id} value={emp.id}>
                            {emp.name} {emp.email ? `(${emp.email})` : ''}
                          </option>
                        ))
                      ) : (
                        <option value="">{currentUserName}{user?.email ? ` (${user.email})` : ''}</option>
                      )}
                    </select>
                    <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 size-4 text-slate-400 pointer-events-none" />
                  </div>
                </div>

                {/* Team / Department * (Center) */}
                <div className="space-y-1">
                  <label className="font-semibold text-slate-800 dark:text-slate-200 block text-xs">
                    Team <span className="text-rose-500">*</span>
                  </label>
                  <div className="relative">
                    <select
                      value={newForm.teamKey}
                      onChange={(e) => {
                        const newTKey = e.target.value;
                        const normNewKey = normalizeTeamKey(newTKey);
                        const typesForTeam = availableTicketTypes.filter(
                          (tt) => tt.teamKey === newTKey || normalizeTeamKey(tt.teamKey, tt.teamName) === normNewKey
                        );
                        setNewForm((prev) => ({
                          ...prev,
                          teamKey: newTKey,
                          type: typesForTeam[0] ? (typesForTeam[0].id || typesForTeam[0].value) : prev.type,
                          subtype: '',
                          subtypeId: '',
                        }));
                      }}
                      className="h-10 w-full appearance-none rounded-md border border-slate-200 bg-white px-3 pr-8 text-xs font-semibold text-slate-900 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary dark:border-slate-700 dark:bg-slate-800 dark:text-white cursor-pointer shadow-2xs"
                    >
                      {filteredStoreQueues && filteredStoreQueues.length > 0 ? (
                        filteredStoreQueues.map((q) => (
                          <option key={q.id || q.key} value={q.key || q.id}>
                            {q.label || q.key}
                          </option>
                        ))
                      ) : (
                        <option value="support">Support Team</option>
                      )}
                    </select>
                    <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 size-4 text-slate-400 pointer-events-none" />
                  </div>
                </div>

                {/* Ticket Type * (Right - Cascading from selected Team) */}
                <div className="space-y-1">
                  <label className="font-semibold text-slate-800 dark:text-slate-200 block text-xs">
                    Ticket Type <span className="text-rose-500">*</span>
                  </label>
                  <div className="relative">
                    <select
                      value={(() => {
                        const normTeam = normalizeTeamKey(newForm.teamKey);
                        const typesForTeam = availableTicketTypes.filter(
                          (tt) =>
                            !newForm.teamKey ||
                            newForm.teamKey === 'all' ||
                            tt.teamKey === newForm.teamKey ||
                            normalizeTeamKey(tt.teamKey, tt.teamName) === normTeam
                        );
                        const matched = typesForTeam.find(
                          (t) =>
                            String(t.id) === String(newForm.type) ||
                            t.value === newForm.type ||
                            t.code?.toLowerCase() === String(newForm.type).toLowerCase() ||
                            t.label?.toLowerCase() === String(newForm.type).toLowerCase()
                        );
                        if (matched) return matched.id || matched.value;
                        if (typesForTeam.length > 0) return typesForTeam[0].id || typesForTeam[0].value;
                        return String(newForm.type || '');
                      })()}
                      onChange={(e) => {
                        const selVal = e.target.value;
                        const selType = availableTicketTypes.find(
                          (t) => String(t.id) === selVal || t.value === selVal || t.code?.toLowerCase() === selVal.toLowerCase()
                        );
                        setNewForm((prev) => ({
                          ...prev,
                          type: (selType?.id || selVal) as any,
                          teamKey: selType?.teamKey ? normalizeTeamKey(selType.teamKey, selType.teamName) : prev.teamKey || 'support',
                          subtype: '',
                          subtypeId: '',
                        }));
                      }}
                      className="h-10 w-full appearance-none rounded-md border border-primary/70 bg-white dark:bg-slate-800 px-3.5 pr-8 text-xs font-semibold text-slate-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary/20 cursor-pointer shadow-2xs"
                    >
                      {availableTicketTypes
                        .filter(
                          (tt) =>
                            !newForm.teamKey ||
                            newForm.teamKey === 'all' ||
                            tt.teamKey === newForm.teamKey ||
                            normalizeTeamKey(tt.teamKey, tt.teamName) === normalizeTeamKey(newForm.teamKey)
                        )
                        .map((tt) => (
                          <option key={tt.id || tt.value} value={tt.id || tt.value}>
                            {tt.label} {tt.code ? `(${tt.code})` : ''}
                          </option>
                        ))}
                    </select>
                    <ChevronDown className="absolute right-3.5 top-1/2 -translate-y-1/2 size-4 text-slate-400 pointer-events-none" />
                  </div>
                </div>
              </div>

              {/* Cascading Subtype dropdown */}
              {availableSubtypes && availableSubtypes.length > 0 && (
                <div className="space-y-1">
                  <label className="font-semibold text-slate-800 dark:text-slate-200 block text-xs">
                    Subtype
                  </label>
                  <div className="relative">
                    <select
                      value={newForm.subtypeId || newForm.subtype}
                      onChange={(e) => {
                        const val = e.target.value;
                        const foundSt = availableSubtypes.find((s) => String(s.id) === val || s.name === val);
                        setNewForm((prev) => ({
                          ...prev,
                          subtypeId: foundSt ? String(foundSt.id) : val,
                          subtype: foundSt ? foundSt.name : val,
                        }));
                      }}
                      className="h-10 w-full appearance-none rounded-md border border-slate-200 bg-white px-3.5 pr-8 text-xs font-semibold text-slate-900 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary dark:border-slate-700 dark:bg-slate-800 dark:text-white cursor-pointer shadow-2xs"
                    >
                      <option value="">Select Subtype (Optional)...</option>
                      {availableSubtypes.map((st) => (
                        <option key={st.id} value={st.id}>
                          {st.name} {st.response_sla_hours ? `(${st.response_sla_hours}h SLA)` : ''}
                        </option>
                      ))}
                    </select>
                    <ChevronDown className="absolute right-3.5 top-1/2 -translate-y-1/2 size-4 text-slate-400 pointer-events-none" />
                  </div>
                </div>
              )}

              {/* Management Team Project & Milestone Controls */}
              {(normalizeTeamKey(newForm.teamKey) === 'management' || newForm.teamKey === 'mgt') && (
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 p-3 rounded-lg border border-border bg-secondary/30">
                  <div className="space-y-1">
                    <label className="font-semibold text-foreground block text-xs">
                      Project Reference
                    </label>
                    <input
                      type="text"
                      placeholder="e.g. PRJ-2026-CORE-01"
                      value={newForm.projectReference || ''}
                      onChange={(e) => setNewForm({ ...newForm, projectReference: e.target.value })}
                      className="w-full h-8 rounded-md border border-border bg-card px-2.5 text-xs text-foreground focus:outline-none focus:ring-1 focus:ring-primary"
                    />
                  </div>
                  <div className="space-y-1">
                    <label className="font-semibold text-foreground block text-xs">
                      Committed / Target Due Date
                    </label>
                    <input
                      type="date"
                      value={newForm.dueDate || ''}
                      onChange={(e) => setNewForm({ ...newForm, dueDate: e.target.value })}
                      className="w-full h-8 rounded-md border border-border bg-card px-2.5 text-xs text-foreground focus:outline-none focus:ring-1 focus:ring-primary"
                    />
                  </div>
                  <div className="space-y-1">
                    <label className="font-semibold text-foreground block text-xs">
                      Meeting Date / Sign-off Ref
                    </label>
                    <input
                      type="date"
                      value={newForm.meetingDate || ''}
                      onChange={(e) => setNewForm({ ...newForm, meetingDate: e.target.value })}
                      className="w-full h-8 rounded-md border border-border bg-card px-2.5 text-xs text-foreground focus:outline-none focus:ring-1 focus:ring-primary"
                    />
                  </div>
                </div>
              )}

              {/* Subject * */}
              <div className="space-y-1">
                <label className="font-semibold text-slate-800 dark:text-slate-200 block text-xs">
                  Subject <span className="text-rose-500">*</span>
                </label>
                <input
                  type="text"
                  required
                  placeholder="Enter ticket subject..."
                  value={newForm.subject}
                  onChange={(e) => setNewForm({ ...newForm, subject: e.target.value })}
                  className="w-full h-9 rounded-md border border-slate-200 bg-white px-3 text-xs text-slate-900 placeholder:text-slate-400 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary dark:border-slate-700 dark:bg-slate-800 dark:text-white shadow-2xs"
                />
              </div>

              {/* Description Rich Text Editor (Details label removed per user instruction) */}
              <div className="space-y-1">
                <div className="rounded-md border border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-800 overflow-hidden focus-within:border-primary focus-within:ring-1 focus-within:ring-primary shadow-2xs">
                  {/* Toolbar */}
                  <div className="flex items-center gap-1 p-2 border-b border-slate-200 dark:border-slate-700 bg-slate-50/70 dark:bg-slate-800/50 flex-wrap text-slate-600 dark:text-slate-400">
                    <button
                      type="button"
                      onClick={() => applyCreateModalFormat('fullscreen')}
                      className="p-1 rounded hover:bg-slate-200/70 dark:hover:bg-slate-700 cursor-pointer"
                      title="Fullscreen"
                    >
                      <Maximize2 className="size-3.5" />
                    </button>

                    {/* Heading Dropdown */}
                    <div className="relative">
                      <button
                        type="button"
                        onClick={() => setIsHeadingMenuOpen(!isHeadingMenuOpen)}
                        className="flex items-center gap-0.5 px-1.5 py-1 rounded hover:bg-slate-200/70 dark:hover:bg-slate-700 font-semibold text-xs cursor-pointer"
                        title="Heading & Text Style"
                      >
                        A <ChevronDown className="size-2.5" />
                      </button>
                      {isHeadingMenuOpen && (
                        <div className="absolute left-0 top-full mt-1 w-32 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-md shadow-lg py-1 z-30">
                          <button type="button" onClick={() => { applyCreateModalFormat('h1'); setIsHeadingMenuOpen(false); }} className="w-full text-left px-3 py-1 text-xs hover:bg-slate-100 dark:hover:bg-slate-700 font-semibold">Heading 1</button>
                          <button type="button" onClick={() => { applyCreateModalFormat('h2'); setIsHeadingMenuOpen(false); }} className="w-full text-left px-3 py-1 text-xs hover:bg-slate-100 dark:hover:bg-slate-700 font-semibold">Heading 2</button>
                          <button type="button" onClick={() => { applyCreateModalFormat('h3'); setIsHeadingMenuOpen(false); }} className="w-full text-left px-3 py-1 text-xs hover:bg-slate-100 dark:hover:bg-slate-700 font-medium">Heading 3</button>
                        </div>
                      )}
                    </div>

                    <button
                      type="button"
                      onClick={() => applyCreateModalFormat('bold')}
                      className="p-1 rounded hover:bg-slate-200/70 dark:hover:bg-slate-700 font-semibold text-xs cursor-pointer"
                      title="Bold (**text**)"
                    >
                      <Bold className="size-3.5" />
                    </button>
                    <button
                      type="button"
                      onClick={() => applyCreateModalFormat('italic')}
                      className="p-1 rounded hover:bg-slate-200/70 dark:hover:bg-slate-700 cursor-pointer"
                      title="Italic (*text*)"
                    >
                      <Italic className="size-3.5" />
                    </button>
                    <button
                      type="button"
                      onClick={() => applyCreateModalFormat('bullet')}
                      className="p-1 rounded hover:bg-slate-200/70 dark:hover:bg-slate-700 cursor-pointer"
                      title="Bullet list"
                    >
                      <List className="size-3.5" />
                    </button>
                    <button
                      type="button"
                      onClick={() => applyCreateModalFormat('ordered')}
                      className="p-1 rounded hover:bg-slate-200/70 dark:hover:bg-slate-700 cursor-pointer"
                      title="Numbered list"
                    >
                      <ListOrdered className="size-3.5" />
                    </button>
                    <button
                      type="button"
                      onClick={() => applyCreateModalFormat('quote')}
                      className="p-1 rounded hover:bg-slate-200/70 dark:hover:bg-slate-700 cursor-pointer"
                      title="Quote"
                    >
                      <Quote className="size-3.5" />
                    </button>
                    <button
                      type="button"
                      onClick={() => applyCreateModalFormat('link')}
                      className="p-1 rounded hover:bg-slate-200/70 dark:hover:bg-slate-700 cursor-pointer"
                      title="Insert Link"
                    >
                      <Link className="size-3.5" />
                    </button>
                    <button
                      type="button"
                      onClick={() => applyCreateModalFormat('image')}
                      className="p-1 rounded hover:bg-slate-200/70 dark:hover:bg-slate-700 cursor-pointer"
                      title="Insert Image"
                    >
                      <LucideImage className="size-3.5" />
                    </button>
                    <button
                      type="button"
                      onClick={() => applyCreateModalFormat('table')}
                      className="p-1 rounded hover:bg-slate-200/70 dark:hover:bg-slate-700 cursor-pointer"
                      title="Insert Table"
                    >
                      <Table className="size-3.5" />
                    </button>

                    {/* Emoji Button */}
                    <div className="relative">
                      <button
                        type="button"
                        onClick={() => setIsCreateEmojiOpen(!isCreateEmojiOpen)}
                        className="p-1 rounded hover:bg-slate-200/70 dark:hover:bg-slate-700 cursor-pointer"
                        title="Emoji Palette"
                      >
                        <Smile className="size-3.5" />
                      </button>
                      {isCreateEmojiOpen && (
                        <div className="absolute left-0 top-full mt-1 z-40 shadow-2xl rounded-xl overflow-hidden border border-slate-200">
                          <EmojiPicker onEmojiClick={handleInsertCreateEmoji} theme={Theme.AUTO} width={300} height={350} />
                        </div>
                      )}
                    </div>

                    <span className="w-px h-4 bg-slate-200 dark:bg-slate-700 mx-1" />

                    <button
                      type="button"
                      onClick={() => applyCreateModalFormat('strikethrough')}
                      className="p-1 rounded hover:bg-slate-200/70 dark:hover:bg-slate-700 cursor-pointer"
                      title="Strikethrough"
                    >
                      <Minus className="size-3.5" />
                    </button>
                    <button
                      type="button"
                      onClick={() => applyCreateModalFormat('code')}
                      className="p-1 rounded hover:bg-slate-200/70 dark:hover:bg-slate-700 cursor-pointer"
                      title="Code Block"
                    >
                      <LucideCode className="size-3.5" />
                    </button>
                  </div>

                  {/* Textarea */}
                  <textarea
                    id="create-modal-details-textarea"
                    rows={8}
                    placeholder="Please provide a detailed description and include screenshots where possible."
                    value={newForm.description}
                    onChange={(e) => setNewForm({ ...newForm, description: e.target.value })}
                    className="w-full p-3.5 bg-transparent text-xs text-slate-900 dark:text-white placeholder:text-slate-400 focus:outline-none resize-y leading-relaxed font-sans min-h-[170px]"
                  />
                </div>
              </div>

              {/* Impact, Urgency, Category IN THE SAME LINE (Wired dynamically from database tables) */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-1">
                {/* Impact * (Wired from support.ticket_impacts table) */}
                <div className="space-y-1">
                  <label className="font-semibold text-slate-800 dark:text-slate-200 block text-xs">
                    Impact <span className="text-rose-500">*</span>
                  </label>
                  <div className="relative">
                    <select
                      value={newForm.impact}
                      onChange={(e) => setNewForm({ ...newForm, impact: e.target.value as any })}
                      className="h-10 w-full appearance-none rounded-md border border-slate-200 bg-white px-3 pr-8 text-xs text-slate-900 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary dark:border-slate-700 dark:bg-slate-800 dark:text-white cursor-pointer shadow-2xs"
                    >
                      {ticketImpacts && ticketImpacts.length > 0 ? (
                        ticketImpacts.map((imp) => (
                          <option key={imp.id || imp.code} value={imp.code || imp.name.toLowerCase()}>
                            {imp.name}
                          </option>
                        ))
                      ) : (
                        <>
                          <option value="low">Low</option>
                          <option value="medium">Medium</option>
                          <option value="high">High</option>
                          <option value="urgent">Urgent</option>
                        </>
                      )}
                    </select>
                    <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 size-4 text-slate-400 pointer-events-none" />
                  </div>
                </div>

                {/* Urgency * (Wired from support.ticket_urgencies table) */}
                <div className="space-y-1">
                  <label className="font-semibold text-slate-800 dark:text-slate-200 block text-xs">
                    Urgency <span className="text-rose-500">*</span>
                  </label>
                  <div className="relative">
                    <select
                      value={newForm.urgency}
                      onChange={(e) => setNewForm({ ...newForm, urgency: e.target.value as any })}
                      className="h-10 w-full appearance-none rounded-md border border-slate-200 bg-white px-3 pr-8 text-xs text-slate-900 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary dark:border-slate-700 dark:bg-slate-800 dark:text-white cursor-pointer shadow-2xs"
                    >
                      {ticketUrgencies && ticketUrgencies.length > 0 ? (
                        ticketUrgencies.map((urg) => (
                          <option key={urg.id || urg.code} value={urg.code || urg.name.toLowerCase()}>
                            {urg.name}
                          </option>
                        ))
                      ) : (
                        <>
                          <option value="low">Low</option>
                          <option value="medium">Medium</option>
                          <option value="high">High</option>
                          <option value="urgent">Urgent</option>
                        </>
                      )}
                    </select>
                    <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 size-4 text-slate-400 pointer-events-none" />
                  </div>
                </div>

                {/* Category * (Wired from asset module: assets.asset_categories table) */}
                <div className="space-y-1">
                  <label className="font-semibold text-slate-800 dark:text-slate-200 block text-xs">
                    Category <span className="text-rose-500">*</span>
                  </label>
                  <div className="relative">
                    <select
                      value={newForm.category}
                      onChange={(e) => setNewForm({ ...newForm, category: e.target.value })}
                      className="h-10 w-full appearance-none rounded-md border border-slate-200 bg-white px-3 pr-16 text-xs text-slate-900 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary dark:border-slate-700 dark:bg-slate-800 dark:text-white cursor-pointer shadow-2xs"
                    >
                      {ticketCategories && ticketCategories.length > 0 ? (
                        ticketCategories.map((cat) => (
                          <option key={cat.id || cat.name} value={cat.name}>
                            {cat.name}
                          </option>
                        ))
                      ) : (
                        <>
                          <option value="Laptops">Laptops</option>
                          <option value="Desktops & Workstations">Desktops & Workstations</option>
                          <option value="Monitors & Displays">Monitors & Displays</option>
                          <option value="Servers & Compute">Servers & Compute</option>
                          <option value="Networking & Security">Networking & Security</option>
                          <option value="Mobile Devices & Tablets">Mobile Devices & Tablets</option>
                          <option value="Audio & Video Peripherals">Audio & Video Peripherals</option>
                          <option value="Storage & NAS">Storage & NAS</option>
                          <option value="Cloud Infrastructure">Cloud Infrastructure</option>
                          <option value="Printers & Facilities">Printers & Facilities</option>
                        </>
                      )}
                    </select>
                    <div className="absolute right-2.5 top-1/2 -translate-y-1/2 flex items-center gap-1.5">
                      {newForm.category && (
                        <button
                          type="button"
                          onClick={() => setNewForm({ ...newForm, category: '' })}
                          className="text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 p-0.5 cursor-pointer"
                          title="Clear category"
                        >
                          <X className="size-3.5" />
                        </button>
                      )}
                      <ChevronDown className="size-4 text-slate-400 pointer-events-none" />
                    </div>
                  </div>
                </div>
              </div>

              {/* Asset Section (Dedicated Dropdown for Assets from Registry + Multi-Asset Addable) */}
              <div className="space-y-1.5 pt-1">
                <div className="flex items-center justify-between">
                  <label className="font-semibold text-slate-800 dark:text-slate-200 block text-xs">
                    Impacted Assets / CIs
                  </label>
                  <span className="text-xs text-muted-foreground">Select multiple assets to attach</span>
                </div>

                <div className="relative">
                  <select
                    value=""
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      if (!selectedId) return;
                      const targetAsset = assets.find((a) => String(a.id) === String(selectedId) || a.asset_code === selectedId);
                      if (targetAsset) {
                        const assetName = targetAsset.asset_code || targetAsset.name;
                        if (!newForm.ciList.includes(assetName)) {
                          setNewForm((prev) => ({
                            ...prev,
                            ciList: [...prev.ciList, assetName],
                            assetId: prev.assetId || String(targetAsset.id),
                            assetTag: prev.assetTag || targetAsset.asset_code || targetAsset.name,
                          }));
                        }
                      }
                    }}
                    className="h-10 w-full appearance-none rounded-md border border-slate-200 bg-white px-3 pr-8 text-xs text-slate-900 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary dark:border-slate-700 dark:bg-slate-800 dark:text-white cursor-pointer shadow-2xs"
                  >
                    <option value="">+ Select asset to add...</option>
                    {assets && assets.length > 0 ? (
                      assets.map((ast) => {
                        const isAdded = newForm.ciList.includes(ast.asset_code || ast.name);
                        return (
                          <option key={ast.id} value={ast.id} disabled={isAdded}>
                            {isAdded ? '✓ ' : ''}{ast.name} {ast.asset_code ? `(${ast.asset_code})` : ''} {ast.category ? `• ${ast.category}` : ''}
                          </option>
                        );
                      })
                    ) : (
                      <option value="" disabled>No assets available in registry</option>
                    )}
                  </select>
                  <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 size-4 text-slate-400 pointer-events-none" />
                </div>

                {/* Display added Assets as removable chips (Multi-Asset Addable) */}
                {newForm.ciList.length > 0 && (
                  <div className="flex flex-wrap items-center gap-1.5 pt-1.5">
                    {newForm.ciList.map((assetItem, idx) => {
                      const matchingAsset = assets.find((a) => a.asset_code === assetItem || a.name === assetItem);
                      const isPrimary = idx === 0;
                      return (
                        <span
                          key={idx}
                          className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-semibold border transition-all ${isPrimary
                              ? 'bg-blue-50 text-blue-800 border-blue-200 dark:bg-blue-950/40 dark:text-blue-300 dark:border-blue-800'
                              : 'bg-emerald-50 text-emerald-800 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-800'
                            }`}
                        >
                          <span className="truncate max-w-[200px]">
                            {matchingAsset ? `${matchingAsset.name} (${matchingAsset.asset_code || assetItem})` : assetItem}
                          </span>
                          {isPrimary && (
                            <span className="text-xs px-1 py-0.5 rounded bg-blue-200/70 text-blue-900 font-semibold uppercase tracking-wider dark:bg-blue-800 dark:text-blue-100">
                              Primary
                            </span>
                          )}
                          <button
                            type="button"
                            onClick={() => {
                              const nextList = newForm.ciList.filter((_, i) => i !== idx);
                              const nextPrimary = nextList.length > 0 ? assets.find((a) => a.asset_code === nextList[0] || a.name === nextList[0]) : null;
                              setNewForm((prev) => ({
                                ...prev,
                                ciList: nextList,
                                assetId: nextPrimary ? String(nextPrimary.id) : '',
                                assetTag: nextPrimary ? (nextPrimary.asset_code || nextPrimary.name) : '',
                              }));
                            }}
                            className="hover:text-rose-600 dark:hover:text-rose-400 cursor-pointer p-0.5"
                            title="Remove asset"
                          >
                            <X className="size-3" />
                          </button>
                        </span>
                      );
                    })}
                  </div>
                )}
              </div>

              {/* Footer Buttons */}
              <div className="flex items-center justify-end gap-3 pt-4 border-t border-slate-200 dark:border-slate-800">
                <button
                  type="button"
                  onClick={handleCloseCreateModal}
                  className="h-9 rounded-md border border-slate-300 bg-white px-5 text-xs font-semibold text-slate-800 hover:bg-slate-100 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700 transition-colors cursor-pointer"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="h-9 rounded-md bg-primary px-6 text-xs font-semibold text-primary-foreground shadow-xs hover:bg-primary/90 transition-colors cursor-pointer flex items-center gap-1.5"
                >
                  Create Ticket
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* 1. MEDIA IMAGE LIGHTBOX MODAL */}
      {mediaLightbox && mediaLightbox.isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-md p-4 animate-in fade-in">
          <div className="relative max-w-4xl w-full max-h-[90vh] flex flex-col items-center">
            <button
              onClick={() => setMediaLightbox(null)}
              className="absolute -top-10 right-0 text-white hover:text-rose-400 p-1"
            >
              <X className="size-6" />
            </button>

            <img
              src={mediaLightbox.url}
              alt={mediaLightbox.name}
              className="max-h-[75vh] w-auto rounded-xl border border-white/20 object-contain shadow-2xl"
            />

            <div className="flex items-center justify-between w-full mt-4 px-2 text-white text-xs">
              <span className="font-mono truncate max-w-md">
                {mediaLightbox.name} • Attached to Ticket [{selectedTicket?.ticketId}]
              </span>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => handleShareAttachment({ name: mediaLightbox.name, fileUrl: mediaLightbox.url })}
                  className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-md bg-white/20 hover:bg-white/30 text-white font-semibold"
                >
                  <Share2 className="size-3.5" /> Share Link
                </button>
                <button
                  onClick={() => downloadMediaFile(mediaLightbox.url, mediaLightbox.name)}
                  className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-md bg-white text-black font-semibold hover:bg-slate-200"
                >
                  <Download className="size-3.5" /> Download
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 2. VIDEO PLAYER MODAL */}
      {videoModal && videoModal.isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-md p-4 animate-in fade-in">
          <div className="relative max-w-3xl w-full max-h-[90vh] flex flex-col items-center bg-card rounded-2xl border border-border overflow-hidden shadow-2xl p-4">
            <div className="flex items-center justify-between w-full pb-3 border-b border-border text-foreground">
              <div className="flex items-center gap-2">
                <Film className="size-4 text-purple-500" />
                <span className="font-semibold text-sm truncate max-w-md">{videoModal.name}</span>
              </div>
              <button
                onClick={() => setVideoModal(null)}
                className="p-1 rounded text-muted-foreground hover:text-foreground"
              >
                <X className="size-5" />
              </button>
            </div>

            <div className="w-full my-3 bg-black rounded-xl overflow-hidden flex items-center justify-center max-h-[60vh]">
              <video
                controls
                autoPlay
                src={videoModal.url}
                className="max-h-[58vh] w-full object-contain"
              >
                Your browser does not support HTML5 video playback.
              </video>
            </div>

            <div className="flex items-center justify-between w-full pt-2 border-t border-border text-xs">
              <span className="text-xs font-mono text-muted-foreground truncate max-w-sm">
                {videoModal.name} • Video Attachment
              </span>
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  onClick={() => downloadMediaFile(videoModal.url, videoModal.name)}
                  className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-md bg-black text-white dark:bg-white dark:text-black font-semibold shadow hover:opacity-90 cursor-pointer"
                >
                  <Download className="size-3.5" /> Download Video
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 3. DOCUMENT & TICKET JSON VIEWER MODAL */}
      {docModal && docModal.isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm p-4 animate-in fade-in">
          <div className="w-full max-w-3xl rounded-2xl border border-border bg-card p-5 shadow-2xl space-y-4 max-h-[90vh] flex flex-col">
            <div className="flex items-center justify-between border-b border-border pb-2.5">
              <div className="flex items-center gap-2">
                <FileText className="size-5 text-blue-500" />
                <div>
                  <h3 className="font-display text-card-title text-foreground truncate max-w-md">{docModal.name}</h3>
                  <p className="text-xs font-mono text-muted-foreground">Attached Document • Ticket [{selectedTicket?.ticketId}]</p>
                </div>
              </div>
              <button onClick={() => setDocModal(null)} className="text-muted-foreground hover:text-foreground p-1 cursor-pointer">
                <X className="size-5" />
              </button>
            </div>

            <div className="flex-1 min-h-[50vh] rounded-xl border border-border bg-muted/20 overflow-hidden">
              {docModal.isPdf ? (
                <iframe
                  src={docModal.url}
                  title="PDF Preview"
                  className="w-full h-[55vh] border-0"
                />
              ) : (docModal.name.endsWith('.json') || (docModal as any).isJson) ? (
                <iframe
                  src={docModal.url}
                  title="Ticket JSON Preview"
                  className="w-full h-[55vh] border-0 bg-background font-mono text-xs"
                />
              ) : (
                <div className="p-8 text-center space-y-3 flex flex-col items-center justify-center h-full">
                  <FileIcon className="size-16 text-primary opacity-60" />
                  <div>
                    <p className="font-semibold text-sm text-foreground">{docModal.name}</p>
                    <p className="text-xs text-muted-foreground mt-1">Attachment stored in secure vault</p>
                  </div>
                  <button
                    type="button"
                    onClick={() => downloadMediaFile(docModal.url, docModal.name)}
                    className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-primary text-primary-foreground font-semibold text-xs shadow cursor-pointer"
                  >
                    <Download className="size-4" /> Download to Open
                  </button>
                </div>
              )}
            </div>

            <div className="flex items-center justify-between pt-2 border-t border-border text-xs">
              <span className="text-xs font-mono text-muted-foreground truncate max-w-sm">
                {docModal.name} • Attachment Record
              </span>
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  onClick={() => downloadMediaFile(docModal.url, docModal.name)}
                  className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-md bg-black text-white dark:bg-white dark:text-black font-semibold shadow hover:opacity-90 cursor-pointer"
                >
                  <Download className="size-3.5" /> Download Document
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export const ITSMTicketsView = TicketView;
export default TicketView;
